var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all2) => {
  for (var name2 in all2)
    __defProp(target, name2, { get: all2[name2], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/assertString.js
var require_assertString = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/assertString.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = assertString;
    function _typeof(o2) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
        return typeof o3;
      } : function(o3) {
        return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
      }, _typeof(o2);
    }
    __name(_typeof, "_typeof");
    function assertString(input) {
      var isString3 = typeof input === "string" || input instanceof String;
      if (!isString3) {
        var invalidType = _typeof(input);
        if (input === null) invalidType = "null";
        else if (invalidType === "object") invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
      }
    }
    __name(assertString, "assertString");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/toDate.js
var require_toDate = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/toDate.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = toDate;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function toDate(date) {
      (0, _assertString.default)(date);
      date = Date.parse(date);
      return !isNaN(date) ? new Date(date) : null;
    }
    __name(toDate, "toDate");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/alpha.js
var require_alpha = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/alpha.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.farsiLocales = exports.englishLocales = exports.dotDecimal = exports.decimal = exports.commaDecimal = exports.bengaliLocales = exports.arabicLocales = exports.alphanumeric = exports.alpha = void 0;
    var alpha = exports.alpha = {
      "en-US": /^[A-Z]+$/i,
      "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
      "bg-BG": /^[А-Я]+$/i,
      "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
      "da-DK": /^[A-ZÆØÅ]+$/i,
      "de-DE": /^[A-ZÄÖÜß]+$/i,
      "el-GR": /^[Α-ώ]+$/i,
      "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
      "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
      "fi-FI": /^[A-ZÅÄÖ]+$/i,
      "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
      "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
      "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
      "nb-NO": /^[A-ZÆØÅ]+$/i,
      "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
      "nn-NO": /^[A-ZÆØÅ]+$/i,
      "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
      "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
      "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
      "ru-RU": /^[А-ЯЁ]+$/i,
      "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
      "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
      "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
      "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
      "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
      "sv-SE": /^[A-ZÅÄÖ]+$/i,
      "th-TH": /^[ก-๐\s]+$/i,
      "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
      "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
      "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
      "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
      "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
      ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
      he: /^[א-ת]+$/,
      fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
      bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
      eo: /^[ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
      "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
      "si-LK": /^[\u0D80-\u0DFF]+$/
    };
    var alphanumeric = exports.alphanumeric = {
      "en-US": /^[0-9A-Z]+$/i,
      "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
      "bg-BG": /^[0-9А-Я]+$/i,
      "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
      "da-DK": /^[0-9A-ZÆØÅ]+$/i,
      "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
      "el-GR": /^[0-9Α-ω]+$/i,
      "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
      "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
      "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
      "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
      "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
      "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
      "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
      "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
      "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
      "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
      "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
      "ru-RU": /^[0-9А-ЯЁ]+$/i,
      "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
      "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
      "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
      "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
      "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
      "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
      "th-TH": /^[ก-๙\s]+$/i,
      "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
      "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
      "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
      "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
      "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
      ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
      he: /^[0-9א-ת]+$/,
      fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
      bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
      eo: /^[0-9ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
      "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
      "si-LK": /^[0-9\u0D80-\u0DFF]+$/
    };
    var decimal = exports.decimal = {
      "en-US": ".",
      ar: "\u066B"
    };
    var englishLocales = exports.englishLocales = [
      "AU",
      "GB",
      "HK",
      "IN",
      "NZ",
      "ZA",
      "ZM"
    ];
    for (i = 0; i < englishLocales.length; i++) {
      locale = "en-".concat(englishLocales[i]);
      alpha[locale] = alpha["en-US"];
      alphanumeric[locale] = alphanumeric["en-US"];
      decimal[locale] = decimal["en-US"];
    }
    var locale;
    var i;
    var arabicLocales = exports.arabicLocales = [
      "AE",
      "BH",
      "DZ",
      "EG",
      "IQ",
      "JO",
      "KW",
      "LB",
      "LY",
      "MA",
      "QM",
      "QA",
      "SA",
      "SD",
      "SY",
      "TN",
      "YE"
    ];
    for (_i = 0; _i < arabicLocales.length; _i++) {
      _locale = "ar-".concat(arabicLocales[_i]);
      alpha[_locale] = alpha.ar;
      alphanumeric[_locale] = alphanumeric.ar;
      decimal[_locale] = decimal.ar;
    }
    var _locale;
    var _i;
    var farsiLocales = exports.farsiLocales = [
      "IR",
      "AF"
    ];
    for (_i2 = 0; _i2 < farsiLocales.length; _i2++) {
      _locale2 = "fa-".concat(farsiLocales[_i2]);
      alphanumeric[_locale2] = alphanumeric.fa;
      decimal[_locale2] = decimal.ar;
    }
    var _locale2;
    var _i2;
    var bengaliLocales = exports.bengaliLocales = [
      "BD",
      "IN"
    ];
    for (_i3 = 0; _i3 < bengaliLocales.length; _i3++) {
      _locale3 = "bn-".concat(bengaliLocales[_i3]);
      alpha[_locale3] = alpha.bn;
      alphanumeric[_locale3] = alphanumeric.bn;
      decimal[_locale3] = decimal["en-US"];
    }
    var _locale3;
    var _i3;
    var dotDecimal = exports.dotDecimal = [
      "ar-EG",
      "ar-LB",
      "ar-LY"
    ];
    var commaDecimal = exports.commaDecimal = [
      "bg-BG",
      "cs-CZ",
      "da-DK",
      "de-DE",
      "el-GR",
      "en-ZM",
      "eo",
      "es-ES",
      "fr-CA",
      "fr-FR",
      "id-ID",
      "it-IT",
      "ku-IQ",
      "hi-IN",
      "hu-HU",
      "nb-NO",
      "nn-NO",
      "nl-NL",
      "pl-PL",
      "pt-PT",
      "ru-RU",
      "kk-KZ",
      "si-LK",
      "sl-SI",
      "sr-RS@latin",
      "sr-RS",
      "sv-SE",
      "tr-TR",
      "uk-UA",
      "vi-VN"
    ];
    for (_i4 = 0; _i4 < dotDecimal.length; _i4++) {
      decimal[dotDecimal[_i4]] = decimal["en-US"];
    }
    var _i4;
    for (_i5 = 0; _i5 < commaDecimal.length; _i5++) {
      decimal[commaDecimal[_i5]] = ",";
    }
    var _i5;
    alpha["fr-CA"] = alpha["fr-FR"];
    alphanumeric["fr-CA"] = alphanumeric["fr-FR"];
    alpha["pt-BR"] = alpha["pt-PT"];
    alphanumeric["pt-BR"] = alphanumeric["pt-PT"];
    decimal["pt-BR"] = decimal["pt-PT"];
    alpha["pl-Pl"] = alpha["pl-PL"];
    alphanumeric["pl-Pl"] = alphanumeric["pl-PL"];
    decimal["pl-Pl"] = decimal["pl-PL"];
    alpha["fa-AF"] = alpha.fa;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isFloat.js
var require_isFloat = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isFloat.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isFloat;
    exports.locales = void 0;
    var _assertString = _interopRequireDefault(require_assertString());
    var _alpha = require_alpha();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isFloat(str, options) {
      (0, _assertString.default)(str);
      options = options || {};
      var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha.decimal[options.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
      if (str === "" || str === "." || str === "," || str === "-" || str === "+") {
        return false;
      }
      var value = parseFloat(str.replace(",", "."));
      return float.test(str) && (!options.hasOwnProperty("min") || value >= options.min) && (!options.hasOwnProperty("max") || value <= options.max) && (!options.hasOwnProperty("lt") || value < options.lt) && (!options.hasOwnProperty("gt") || value > options.gt);
    }
    __name(isFloat, "isFloat");
    var locales = exports.locales = Object.keys(_alpha.decimal);
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/toFloat.js
var require_toFloat = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/toFloat.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = toFloat;
    var _isFloat = _interopRequireDefault(require_isFloat());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function toFloat(str) {
      if (!(0, _isFloat.default)(str)) return NaN;
      return parseFloat(str);
    }
    __name(toFloat, "toFloat");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/toInt.js
var require_toInt = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/toInt.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = toInt;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function toInt(str, radix) {
      (0, _assertString.default)(str);
      return parseInt(str, radix || 10);
    }
    __name(toInt, "toInt");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/toBoolean.js
var require_toBoolean = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/toBoolean.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = toBoolean;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function toBoolean(str, strict) {
      (0, _assertString.default)(str);
      if (strict) {
        return str === "1" || /^true$/i.test(str);
      }
      return str !== "0" && !/^false$/i.test(str) && str !== "";
    }
    __name(toBoolean, "toBoolean");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/equals.js
var require_equals = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/equals.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = equals;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function equals(str, comparison) {
      (0, _assertString.default)(str);
      return str === comparison;
    }
    __name(equals, "equals");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/toString.js
var require_toString = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/toString.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = toString2;
    function _typeof(o2) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
        return typeof o3;
      } : function(o3) {
        return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
      }, _typeof(o2);
    }
    __name(_typeof, "_typeof");
    function toString2(input) {
      if (_typeof(input) === "object" && input !== null) {
        if (typeof input.toString === "function") {
          input = input.toString();
        } else {
          input = "[object Object]";
        }
      } else if (input === null || typeof input === "undefined" || isNaN(input) && !input.length) {
        input = "";
      }
      return String(input);
    }
    __name(toString2, "toString");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/merge.js
var require_merge = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/merge.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = merge2;
    function merge2() {
      var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var defaults = arguments.length > 1 ? arguments[1] : void 0;
      for (var key in defaults) {
        if (typeof obj[key] === "undefined") {
          obj[key] = defaults[key];
        }
      }
      return obj;
    }
    __name(merge2, "merge");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/contains.js
var require_contains = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/contains.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = contains;
    var _assertString = _interopRequireDefault(require_assertString());
    var _toString = _interopRequireDefault(require_toString());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var defaulContainsOptions = {
      ignoreCase: false,
      minOccurrences: 1
    };
    function contains(str, elem, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, defaulContainsOptions);
      if (options.ignoreCase) {
        return str.toLowerCase().split((0, _toString.default)(elem).toLowerCase()).length > options.minOccurrences;
      }
      return str.split((0, _toString.default)(elem)).length > options.minOccurrences;
    }
    __name(contains, "contains");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/matches.js
var require_matches = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/matches.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = matches;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function matches(str, pattern, modifiers) {
      (0, _assertString.default)(str);
      if (Object.prototype.toString.call(pattern) !== "[object RegExp]") {
        pattern = new RegExp(pattern, modifiers);
      }
      return !!str.match(pattern);
    }
    __name(matches, "matches");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isByteLength.js
var require_isByteLength = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isByteLength.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isByteLength;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function _typeof(o2) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
        return typeof o3;
      } : function(o3) {
        return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
      }, _typeof(o2);
    }
    __name(_typeof, "_typeof");
    function isByteLength(str, options) {
      (0, _assertString.default)(str);
      var min;
      var max;
      if (_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
      } else {
        min = arguments[1];
        max = arguments[2];
      }
      var len = encodeURI(str).split(/%..|./).length - 1;
      return len >= min && (typeof max === "undefined" || len <= max);
    }
    __name(isByteLength, "isByteLength");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isFQDN.js
var require_isFQDN = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isFQDN.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isFQDN2;
    var _assertString = _interopRequireDefault(require_assertString());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var default_fqdn_options = {
      require_tld: true,
      allow_underscores: false,
      allow_trailing_dot: false,
      allow_numeric_tld: false,
      allow_wildcard: false,
      ignore_max_length: false
    };
    function isFQDN2(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_fqdn_options);
      if (options.allow_trailing_dot && str[str.length - 1] === ".") {
        str = str.substring(0, str.length - 1);
      }
      if (options.allow_wildcard === true && str.indexOf("*.") === 0) {
        str = str.substring(2);
      }
      var parts = str.split(".");
      var tld = parts[parts.length - 1];
      if (options.require_tld) {
        if (parts.length < 2) {
          return false;
        }
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
          return false;
        }
        if (/\s/.test(tld)) {
          return false;
        }
      }
      if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
        return false;
      }
      return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) {
          return false;
        }
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
          return false;
        }
        if (/[\uff01-\uff5e]/.test(part)) {
          return false;
        }
        if (/^-|-$/.test(part)) {
          return false;
        }
        if (!options.allow_underscores && /_/.test(part)) {
          return false;
        }
        return true;
      });
    }
    __name(isFQDN2, "isFQDN");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIP.js
var require_isIP = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIP.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isIP;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
    var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
    var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
    var IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
    var IPv6AddressRegExp = new RegExp("^(" + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
    function isIP(str) {
      var version = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      (0, _assertString.default)(str);
      version = String(version);
      if (!version) {
        return isIP(str, 4) || isIP(str, 6);
      }
      if (version === "4") {
        return IPv4AddressRegExp.test(str);
      }
      if (version === "6") {
        return IPv6AddressRegExp.test(str);
      }
      return false;
    }
    __name(isIP, "isIP");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isEmail.js
var require_isEmail = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isEmail.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isEmail;
    var _assertString = _interopRequireDefault(require_assertString());
    var _isByteLength = _interopRequireDefault(require_isByteLength());
    var _isFQDN = _interopRequireDefault(require_isFQDN());
    var _isIP = _interopRequireDefault(require_isIP());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var default_email_options = {
      allow_display_name: false,
      allow_underscores: false,
      require_display_name: false,
      allow_utf8_local_part: true,
      require_tld: true,
      blacklisted_chars: "",
      ignore_max_length: false,
      host_blacklist: [],
      host_whitelist: []
    };
    var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
    var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
    var gmailUserPart = /^[a-z\d]+$/;
    var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
    var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
    var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
    var defaultMaxEmailLength = 254;
    function validateDisplayName(display_name) {
      var display_name_without_quotes = display_name.replace(/^"(.+)"$/, "$1");
      if (!display_name_without_quotes.trim()) {
        return false;
      }
      var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
      if (contains_illegal) {
        if (display_name_without_quotes === display_name) {
          return false;
        }
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) {
          return false;
        }
      }
      return true;
    }
    __name(validateDisplayName, "validateDisplayName");
    function isEmail(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_email_options);
      if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match(splitNameAddress);
        if (display_email) {
          var display_name = display_email[1];
          str = str.replace(display_name, "").replace(/(^<|>$)/g, "");
          if (display_name.endsWith(" ")) {
            display_name = display_name.slice(0, -1);
          }
          if (!validateDisplayName(display_name)) {
            return false;
          }
        } else if (options.require_display_name) {
          return false;
        }
      }
      if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
        return false;
      }
      var parts = str.split("@");
      var domain = parts.pop();
      var lower_domain = domain.toLowerCase();
      if (options.host_blacklist.includes(lower_domain)) {
        return false;
      }
      if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) {
        return false;
      }
      var user = parts.join("@");
      if (options.domain_specific_validation && (lower_domain === "gmail.com" || lower_domain === "googlemail.com")) {
        user = user.toLowerCase();
        var username = user.split("+")[0];
        if (!(0, _isByteLength.default)(username.replace(/\./g, ""), {
          min: 6,
          max: 30
        })) {
          return false;
        }
        var _user_parts = username.split(".");
        for (var i = 0; i < _user_parts.length; i++) {
          if (!gmailUserPart.test(_user_parts[i])) {
            return false;
          }
        }
      }
      if (options.ignore_max_length === false && (!(0, _isByteLength.default)(user, {
        max: 64
      }) || !(0, _isByteLength.default)(domain, {
        max: 254
      }))) {
        return false;
      }
      if (!(0, _isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
      })) {
        if (!options.allow_ip_domain) {
          return false;
        }
        if (!(0, _isIP.default)(domain)) {
          if (!domain.startsWith("[") || !domain.endsWith("]")) {
            return false;
          }
          var noBracketdomain = domain.slice(1, -1);
          if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
            return false;
          }
        }
      }
      if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
      }
      var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
      var user_parts = user.split(".");
      for (var _i = 0; _i < user_parts.length; _i++) {
        if (!pattern.test(user_parts[_i])) {
          return false;
        }
      }
      if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), "g")) !== -1) return false;
      }
      return true;
    }
    __name(isEmail, "isEmail");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isURL.js
var require_isURL = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isURL.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isURL2;
    var _assertString = _interopRequireDefault(require_assertString());
    var _isFQDN = _interopRequireDefault(require_isFQDN());
    var _isIP = _interopRequireDefault(require_isIP());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    __name(_slicedToArray, "_slicedToArray");
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    __name(_nonIterableRest, "_nonIterableRest");
    function _unsupportedIterableToArray(o2, minLen) {
      if (!o2) return;
      if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
      var n3 = Object.prototype.toString.call(o2).slice(8, -1);
      if (n3 === "Object" && o2.constructor) n3 = o2.constructor.name;
      if (n3 === "Map" || n3 === "Set") return Array.from(o2);
      if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3)) return _arrayLikeToArray(o2, minLen);
    }
    __name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    __name(_arrayLikeToArray, "_arrayLikeToArray");
    function _iterableToArrayLimit(r2, l3) {
      var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
      if (null != t2) {
        var e2, n3, i, u, a = [], f = true, o2 = false;
        try {
          if (i = (t2 = t2.call(r2)).next, 0 === l3) {
            if (Object(t2) !== t2) return;
            f = false;
          } else for (; !(f = (e2 = i.call(t2)).done) && (a.push(e2.value), a.length !== l3); f = true) ;
        } catch (r3) {
          o2 = true, n3 = r3;
        } finally {
          try {
            if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
          } finally {
            if (o2) throw n3;
          }
        }
        return a;
      }
    }
    __name(_iterableToArrayLimit, "_iterableToArrayLimit");
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) return arr;
    }
    __name(_arrayWithHoles, "_arrayWithHoles");
    var default_url_options = {
      protocols: [
        "http",
        "https",
        "ftp"
      ],
      require_tld: true,
      require_protocol: false,
      require_host: true,
      require_port: false,
      require_valid_protocol: true,
      allow_underscores: false,
      allow_trailing_dot: false,
      allow_protocol_relative_urls: false,
      allow_fragments: true,
      allow_query_components: true,
      validate_length: true
    };
    var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
    function isRegExp(obj) {
      return Object.prototype.toString.call(obj) === "[object RegExp]";
    }
    __name(isRegExp, "isRegExp");
    function checkHost(host, matches) {
      for (var i = 0; i < matches.length; i++) {
        var match2 = matches[i];
        if (host === match2 || isRegExp(match2) && match2.test(host)) {
          return true;
        }
      }
      return false;
    }
    __name(checkHost, "checkHost");
    function isURL2(url, options) {
      (0, _assertString.default)(url);
      if (!url || /[\s<>]/.test(url)) {
        return false;
      }
      if (url.indexOf("mailto:") === 0) {
        return false;
      }
      options = (0, _merge.default)(options, default_url_options);
      if (options.validate_length && url.length >= 2083) {
        return false;
      }
      if (!options.allow_fragments && url.includes("#")) {
        return false;
      }
      if (!options.allow_query_components && (url.includes("?") || url.includes("&"))) {
        return false;
      }
      var protocol, auth, host, hostname, port, port_str, split, ipv6;
      split = url.split("#");
      url = split.shift();
      split = url.split("?");
      url = split.shift();
      split = url.split("://");
      if (split.length > 1) {
        protocol = split.shift().toLowerCase();
        if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
          return false;
        }
      } else if (options.require_protocol) {
        return false;
      } else if (url.slice(0, 2) === "//") {
        if (!options.allow_protocol_relative_urls) {
          return false;
        }
        split[0] = url.slice(2);
      }
      url = split.join("://");
      if (url === "") {
        return false;
      }
      split = url.split("/");
      url = split.shift();
      if (url === "" && !options.require_host) {
        return true;
      }
      split = url.split("@");
      if (split.length > 1) {
        if (options.disallow_auth) {
          return false;
        }
        if (split[0] === "") {
          return false;
        }
        auth = split.shift();
        if (auth.indexOf(":") >= 0 && auth.split(":").length > 2) {
          return false;
        }
        var _auth$split = auth.split(":"), _auth$split2 = _slicedToArray(_auth$split, 2), user = _auth$split2[0], password = _auth$split2[1];
        if (user === "" && password === "") {
          return false;
        }
      }
      hostname = split.join("@");
      port_str = null;
      ipv6 = null;
      var ipv6_match = hostname.match(wrapped_ipv6);
      if (ipv6_match) {
        host = "";
        ipv6 = ipv6_match[1];
        port_str = ipv6_match[2] || null;
      } else {
        split = hostname.split(":");
        host = split.shift();
        if (split.length) {
          port_str = split.join(":");
        }
      }
      if (port_str !== null && port_str.length > 0) {
        port = parseInt(port_str, 10);
        if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
          return false;
        }
      } else if (options.require_port) {
        return false;
      }
      if (options.host_whitelist) {
        return checkHost(host, options.host_whitelist);
      }
      if (host === "" && !options.require_host) {
        return true;
      }
      if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
        return false;
      }
      host = host || ipv6;
      if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
        return false;
      }
      return true;
    }
    __name(isURL2, "isURL");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMACAddress.js
var require_isMACAddress = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMACAddress.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isMACAddress;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var macAddress48 = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/;
    var macAddress48NoSeparators = /^([0-9a-fA-F]){12}$/;
    var macAddress48WithDots = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/;
    var macAddress64 = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/;
    var macAddress64NoSeparators = /^([0-9a-fA-F]){16}$/;
    var macAddress64WithDots = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
    function isMACAddress(str, options) {
      (0, _assertString.default)(str);
      if (options !== null && options !== void 0 && options.eui) {
        options.eui = String(options.eui);
      }
      if (options !== null && options !== void 0 && options.no_colons || options !== null && options !== void 0 && options.no_separators) {
        if (options.eui === "48") {
          return macAddress48NoSeparators.test(str);
        }
        if (options.eui === "64") {
          return macAddress64NoSeparators.test(str);
        }
        return macAddress48NoSeparators.test(str) || macAddress64NoSeparators.test(str);
      }
      if ((options === null || options === void 0 ? void 0 : options.eui) === "48") {
        return macAddress48.test(str) || macAddress48WithDots.test(str);
      }
      if ((options === null || options === void 0 ? void 0 : options.eui) === "64") {
        return macAddress64.test(str) || macAddress64WithDots.test(str);
      }
      return isMACAddress(str, {
        eui: "48"
      }) || isMACAddress(str, {
        eui: "64"
      });
    }
    __name(isMACAddress, "isMACAddress");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIPRange.js
var require_isIPRange = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIPRange.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isIPRange;
    var _assertString = _interopRequireDefault(require_assertString());
    var _isIP = _interopRequireDefault(require_isIP());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var subnetMaybe = /^\d{1,3}$/;
    var v4Subnet = 32;
    var v6Subnet = 128;
    function isIPRange(str) {
      var version = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      (0, _assertString.default)(str);
      var parts = str.split("/");
      if (parts.length !== 2) {
        return false;
      }
      if (!subnetMaybe.test(parts[1])) {
        return false;
      }
      if (parts[1].length > 1 && parts[1].startsWith("0")) {
        return false;
      }
      var isValidIP = (0, _isIP.default)(parts[0], version);
      if (!isValidIP) {
        return false;
      }
      var expectedSubnet = null;
      switch (String(version)) {
        case "4":
          expectedSubnet = v4Subnet;
          break;
        case "6":
          expectedSubnet = v6Subnet;
          break;
        default:
          expectedSubnet = (0, _isIP.default)(parts[0], "6") ? v6Subnet : v4Subnet;
      }
      return parts[1] <= expectedSubnet && parts[1] >= 0;
    }
    __name(isIPRange, "isIPRange");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isDate.js
var require_isDate = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isDate.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isDate2;
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    __name(_slicedToArray, "_slicedToArray");
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    __name(_nonIterableRest, "_nonIterableRest");
    function _iterableToArrayLimit(r2, l3) {
      var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
      if (null != t2) {
        var e2, n3, i, u, a = [], f = true, o2 = false;
        try {
          if (i = (t2 = t2.call(r2)).next, 0 === l3) {
            if (Object(t2) !== t2) return;
            f = false;
          } else for (; !(f = (e2 = i.call(t2)).done) && (a.push(e2.value), a.length !== l3); f = true) ;
        } catch (r3) {
          o2 = true, n3 = r3;
        } finally {
          try {
            if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
          } finally {
            if (o2) throw n3;
          }
        }
        return a;
      }
    }
    __name(_iterableToArrayLimit, "_iterableToArrayLimit");
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) return arr;
    }
    __name(_arrayWithHoles, "_arrayWithHoles");
    function _createForOfIteratorHelper(o2, allowArrayLike) {
      var it = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
      if (!it) {
        if (Array.isArray(o2) || (it = _unsupportedIterableToArray(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
          if (it) o2 = it;
          var i = 0;
          var F = /* @__PURE__ */ __name(function F2() {
          }, "F");
          return {
            s: F,
            n: /* @__PURE__ */ __name(function n3() {
              if (i >= o2.length) return {
                done: true
              };
              return {
                done: false,
                value: o2[i++]
              };
            }, "n"),
            e: /* @__PURE__ */ __name(function e2(_e) {
              throw _e;
            }, "e"),
            f: F
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var normalCompletion = true, didErr = false, err;
      return {
        s: /* @__PURE__ */ __name(function s3() {
          it = it.call(o2);
        }, "s"),
        n: /* @__PURE__ */ __name(function n3() {
          var step = it.next();
          normalCompletion = step.done;
          return step;
        }, "n"),
        e: /* @__PURE__ */ __name(function e2(_e2) {
          didErr = true;
          err = _e2;
        }, "e"),
        f: /* @__PURE__ */ __name(function f() {
          try {
            if (!normalCompletion && it.return != null) it.return();
          } finally {
            if (didErr) throw err;
          }
        }, "f")
      };
    }
    __name(_createForOfIteratorHelper, "_createForOfIteratorHelper");
    function _unsupportedIterableToArray(o2, minLen) {
      if (!o2) return;
      if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
      var n3 = Object.prototype.toString.call(o2).slice(8, -1);
      if (n3 === "Object" && o2.constructor) n3 = o2.constructor.name;
      if (n3 === "Map" || n3 === "Set") return Array.from(o2);
      if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3)) return _arrayLikeToArray(o2, minLen);
    }
    __name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    __name(_arrayLikeToArray, "_arrayLikeToArray");
    var default_date_options = {
      format: "YYYY/MM/DD",
      delimiters: [
        "/",
        "-"
      ],
      strictMode: false
    };
    function isValidFormat(format) {
      return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(format);
    }
    __name(isValidFormat, "isValidFormat");
    function zip(date, format) {
      var zippedArr = [], len = Math.min(date.length, format.length);
      for (var i = 0; i < len; i++) {
        zippedArr.push([
          date[i],
          format[i]
        ]);
      }
      return zippedArr;
    }
    __name(zip, "zip");
    function isDate2(input, options) {
      if (typeof options === "string") {
        options = (0, _merge.default)({
          format: options
        }, default_date_options);
      } else {
        options = (0, _merge.default)(options, default_date_options);
      }
      if (typeof input === "string" && isValidFormat(options.format)) {
        var formatDelimiter = options.delimiters.find(function(delimiter) {
          return options.format.indexOf(delimiter) !== -1;
        });
        var dateDelimiter = options.strictMode ? formatDelimiter : options.delimiters.find(function(delimiter) {
          return input.indexOf(delimiter) !== -1;
        });
        var dateAndFormat = zip(input.split(dateDelimiter), options.format.toLowerCase().split(formatDelimiter));
        var dateObj = {};
        var _iterator = _createForOfIteratorHelper(dateAndFormat), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var _step$value = _slicedToArray(_step.value, 2), dateWord = _step$value[0], formatWord = _step$value[1];
            if (dateWord.length !== formatWord.length) {
              return false;
            }
            dateObj[formatWord.charAt(0)] = dateWord;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var fullYear = dateObj.y;
        if (fullYear.startsWith("-")) {
          return false;
        }
        if (dateObj.y.length === 2) {
          var parsedYear = parseInt(dateObj.y, 10);
          if (isNaN(parsedYear)) {
            return false;
          }
          var currentYearLastTwoDigits = (/* @__PURE__ */ new Date()).getFullYear() % 100;
          if (parsedYear < currentYearLastTwoDigits) {
            fullYear = "20".concat(dateObj.y);
          } else {
            fullYear = "19".concat(dateObj.y);
          }
        }
        var month = dateObj.m;
        if (dateObj.m.length === 1) {
          month = "0".concat(dateObj.m);
        }
        var day = dateObj.d;
        if (dateObj.d.length === 1) {
          day = "0".concat(dateObj.d);
        }
        return new Date("".concat(fullYear, "-").concat(month, "-").concat(day, "T00:00:00.000Z")).getUTCDate() === +dateObj.d;
      }
      if (!options.strictMode) {
        return Object.prototype.toString.call(input) === "[object Date]" && isFinite(input);
      }
      return false;
    }
    __name(isDate2, "isDate");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isTime.js
var require_isTime = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isTime.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isTime;
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var default_time_options = {
      hourFormat: "hour24",
      mode: "default"
    };
    var formats = {
      hour24: {
        default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
        withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
      },
      hour12: {
        default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
        withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
      }
    };
    function isTime(input, options) {
      options = (0, _merge.default)(options, default_time_options);
      if (typeof input !== "string") return false;
      return formats[options.hourFormat][options.mode].test(input);
    }
    __name(isTime, "isTime");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBoolean.js
var require_isBoolean = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBoolean.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isBoolean;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var defaultOptions = {
      loose: false
    };
    var strictBooleans = [
      "true",
      "false",
      "1",
      "0"
    ];
    var looseBooleans = [].concat(strictBooleans, [
      "yes",
      "no"
    ]);
    function isBoolean(str) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      (0, _assertString.default)(str);
      if (options.loose) {
        return looseBooleans.includes(str.toLowerCase());
      }
      return strictBooleans.includes(str);
    }
    __name(isBoolean, "isBoolean");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLocale.js
var require_isLocale = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLocale.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isLocale;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var extlang = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})";
    var language = "(([a-zA-Z]{2,3}(-".concat(extlang, ")?)|([a-zA-Z]{5,8}))");
    var script = "([A-Za-z]{4})";
    var region = "([A-Za-z]{2}|\\d{3})";
    var variant = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))";
    var singleton3 = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])";
    var extension = "(".concat(singleton3, "(-[A-Za-z0-9]{2,8})+)");
    var privateuse = "(x(-[A-Za-z0-9]{1,8})+)";
    var irregular = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))";
    var regular = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))";
    var grandfathered = "(".concat(irregular, "|").concat(regular, ")");
    var delimiter = "(-|_)";
    var langtag = "".concat(language, "(").concat(delimiter).concat(script, ")?(").concat(delimiter).concat(region, ")?(").concat(delimiter).concat(variant, ")*(").concat(delimiter).concat(extension, ")*(").concat(delimiter).concat(privateuse, ")?");
    var languageTagRegex = new RegExp("(^".concat(privateuse, "$)|(^").concat(grandfathered, "$)|(^").concat(langtag, "$)"));
    function isLocale(str) {
      (0, _assertString.default)(str);
      return languageTagRegex.test(str);
    }
    __name(isLocale, "isLocale");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAbaRouting.js
var require_isAbaRouting = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAbaRouting.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isAbaRouting;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var isRoutingReg = /^(?!(1[3-9])|(20)|(3[3-9])|(4[0-9])|(5[0-9])|(60)|(7[3-9])|(8[1-9])|(9[0-2])|(9[3-9]))[0-9]{9}$/;
    function isAbaRouting(str) {
      (0, _assertString.default)(str);
      if (!isRoutingReg.test(str)) return false;
      var checkSumVal = 0;
      for (var i = 0; i < str.length; i++) {
        if (i % 3 === 0) checkSumVal += str[i] * 3;
        else if (i % 3 === 1) checkSumVal += str[i] * 7;
        else checkSumVal += str[i] * 1;
      }
      return checkSumVal % 10 === 0;
    }
    __name(isAbaRouting, "isAbaRouting");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAlpha.js
var require_isAlpha = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAlpha.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isAlpha;
    exports.locales = void 0;
    var _assertString = _interopRequireDefault(require_assertString());
    var _alpha = require_alpha();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isAlpha(_str) {
      var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      (0, _assertString.default)(_str);
      var str = _str;
      var ignore = options.ignore;
      if (ignore) {
        if (ignore instanceof RegExp) {
          str = str.replace(ignore, "");
        } else if (typeof ignore === "string") {
          str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
        } else {
          throw new Error("ignore should be instance of a String or RegExp");
        }
      }
      if (locale in _alpha.alpha) {
        return _alpha.alpha[locale].test(str);
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    __name(isAlpha, "isAlpha");
    var locales = exports.locales = Object.keys(_alpha.alpha);
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAlphanumeric.js
var require_isAlphanumeric = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAlphanumeric.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isAlphanumeric;
    exports.locales = void 0;
    var _assertString = _interopRequireDefault(require_assertString());
    var _alpha = require_alpha();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isAlphanumeric(_str) {
      var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      (0, _assertString.default)(_str);
      var str = _str;
      var ignore = options.ignore;
      if (ignore) {
        if (ignore instanceof RegExp) {
          str = str.replace(ignore, "");
        } else if (typeof ignore === "string") {
          str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
        } else {
          throw new Error("ignore should be instance of a String or RegExp");
        }
      }
      if (locale in _alpha.alphanumeric) {
        return _alpha.alphanumeric[locale].test(str);
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    __name(isAlphanumeric, "isAlphanumeric");
    var locales = exports.locales = Object.keys(_alpha.alphanumeric);
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isNumeric.js
var require_isNumeric = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isNumeric.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isNumeric;
    var _assertString = _interopRequireDefault(require_assertString());
    var _alpha = require_alpha();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var numericNoSymbols = /^[0-9]+$/;
    function isNumeric(str, options) {
      (0, _assertString.default)(str);
      if (options && options.no_symbols) {
        return numericNoSymbols.test(str);
      }
      return new RegExp("^[+-]?([0-9]*[".concat((options || {}).locale ? _alpha.decimal[options.locale] : ".", "])?[0-9]+$")).test(str);
    }
    __name(isNumeric, "isNumeric");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isPassportNumber.js
var require_isPassportNumber = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isPassportNumber.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isPassportNumber;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var passportRegexByCountryCode = {
      AM: /^[A-Z]{2}\d{7}$/,
      // ARMENIA
      AR: /^[A-Z]{3}\d{6}$/,
      // ARGENTINA
      AT: /^[A-Z]\d{7}$/,
      // AUSTRIA
      AU: /^[A-Z]\d{7}$/,
      // AUSTRALIA
      AZ: /^[A-Z]{1}\d{8}$/,
      // AZERBAIJAN
      BE: /^[A-Z]{2}\d{6}$/,
      // BELGIUM
      BG: /^\d{9}$/,
      // BULGARIA
      BR: /^[A-Z]{2}\d{6}$/,
      // BRAZIL
      BY: /^[A-Z]{2}\d{7}$/,
      // BELARUS
      CA: /^[A-Z]{2}\d{6}$/,
      // CANADA
      CH: /^[A-Z]\d{7}$/,
      // SWITZERLAND
      CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
      // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
      CY: /^[A-Z](\d{6}|\d{8})$/,
      // CYPRUS
      CZ: /^\d{8}$/,
      // CZECH REPUBLIC
      DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
      // GERMANY
      DK: /^\d{9}$/,
      // DENMARK
      DZ: /^\d{9}$/,
      // ALGERIA
      EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
      // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
      ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
      // SPAIN
      FI: /^[A-Z]{2}\d{7}$/,
      // FINLAND
      FR: /^\d{2}[A-Z]{2}\d{5}$/,
      // FRANCE
      GB: /^\d{9}$/,
      // UNITED KINGDOM
      GR: /^[A-Z]{2}\d{7}$/,
      // GREECE
      HR: /^\d{9}$/,
      // CROATIA
      HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
      // HUNGARY
      IE: /^[A-Z0-9]{2}\d{7}$/,
      // IRELAND
      IN: /^[A-Z]{1}-?\d{7}$/,
      // INDIA
      ID: /^[A-C]\d{7}$/,
      // INDONESIA
      IR: /^[A-Z]\d{8}$/,
      // IRAN
      IS: /^(A)\d{7}$/,
      // ICELAND
      IT: /^[A-Z0-9]{2}\d{7}$/,
      // ITALY
      JM: /^[Aa]\d{7}$/,
      // JAMAICA
      JP: /^[A-Z]{2}\d{7}$/,
      // JAPAN
      KR: /^[MS]\d{8}$/,
      // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
      KZ: /^[a-zA-Z]\d{7}$/,
      // KAZAKHSTAN
      LI: /^[a-zA-Z]\d{5}$/,
      // LIECHTENSTEIN
      LT: /^[A-Z0-9]{8}$/,
      // LITHUANIA
      LU: /^[A-Z0-9]{8}$/,
      // LUXEMBURG
      LV: /^[A-Z0-9]{2}\d{7}$/,
      // LATVIA
      LY: /^[A-Z0-9]{8}$/,
      // LIBYA
      MT: /^\d{7}$/,
      // MALTA
      MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
      // MOZAMBIQUE
      MY: /^[AHK]\d{8}$/,
      // MALAYSIA
      MX: /^\d{10,11}$/,
      // MEXICO
      NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
      // NETHERLANDS
      NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
      // NEW ZEALAND
      PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
      // PHILIPPINES
      PK: /^[A-Z]{2}\d{7}$/,
      // PAKISTAN
      PL: /^[A-Z]{2}\d{7}$/,
      // POLAND
      PT: /^[A-Z]\d{6}$/,
      // PORTUGAL
      RO: /^\d{8,9}$/,
      // ROMANIA
      RU: /^\d{9}$/,
      // RUSSIAN FEDERATION
      SE: /^\d{8}$/,
      // SWEDEN
      SL: /^(P)[A-Z]\d{7}$/,
      // SLOVENIA
      SK: /^[0-9A-Z]\d{7}$/,
      // SLOVAKIA
      TH: /^[A-Z]{1,2}\d{6,7}$/,
      // THAILAND
      TR: /^[A-Z]\d{8}$/,
      // TURKEY
      UA: /^[A-Z]{2}\d{6}$/,
      // UKRAINE
      US: /^\d{9}$/,
      // UNITED STATES
      ZA: /^[TAMD]\d{8}$/
      // SOUTH AFRICA
    };
    function isPassportNumber(str, countryCode) {
      (0, _assertString.default)(str);
      var normalizedStr = str.replace(/\s/g, "").toUpperCase();
      return countryCode.toUpperCase() in passportRegexByCountryCode && passportRegexByCountryCode[countryCode].test(normalizedStr);
    }
    __name(isPassportNumber, "isPassportNumber");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isInt.js
var require_isInt = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isInt.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isInt;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var int2 = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
    var intLeadingZeroes = /^[-+]?[0-9]+$/;
    function isInt(str, options) {
      (0, _assertString.default)(str);
      options = options || {};
      var regex = options.allow_leading_zeroes === false ? int2 : intLeadingZeroes;
      var minCheckPassed = !options.hasOwnProperty("min") || str >= options.min;
      var maxCheckPassed = !options.hasOwnProperty("max") || str <= options.max;
      var ltCheckPassed = !options.hasOwnProperty("lt") || str < options.lt;
      var gtCheckPassed = !options.hasOwnProperty("gt") || str > options.gt;
      return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
    }
    __name(isInt, "isInt");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isPort.js
var require_isPort = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isPort.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isPort;
    var _isInt = _interopRequireDefault(require_isInt());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isPort(str) {
      return (0, _isInt.default)(str, {
        allow_leading_zeroes: false,
        min: 0,
        max: 65535
      });
    }
    __name(isPort, "isPort");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLowercase.js
var require_isLowercase = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLowercase.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isLowercase;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isLowercase(str) {
      (0, _assertString.default)(str);
      return str === str.toLowerCase();
    }
    __name(isLowercase, "isLowercase");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isUppercase.js
var require_isUppercase = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isUppercase.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isUppercase;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isUppercase(str) {
      (0, _assertString.default)(str);
      return str === str.toUpperCase();
    }
    __name(isUppercase, "isUppercase");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIMEI.js
var require_isIMEI = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIMEI.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isIMEI;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var imeiRegexWithoutHypens = /^[0-9]{15}$/;
    var imeiRegexWithHypens = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
    function isIMEI(str, options) {
      (0, _assertString.default)(str);
      options = options || {};
      var imeiRegex = imeiRegexWithoutHypens;
      if (options.allow_hyphens) {
        imeiRegex = imeiRegexWithHypens;
      }
      if (!imeiRegex.test(str)) {
        return false;
      }
      str = str.replace(/-/g, "");
      var sum = 0, mul = 2, l3 = 14;
      for (var i = 0; i < l3; i++) {
        var digit = str.substring(l3 - i - 1, l3 - i);
        var tp = parseInt(digit, 10) * mul;
        if (tp >= 10) {
          sum += tp % 10 + 1;
        } else {
          sum += tp;
        }
        if (mul === 1) {
          mul += 1;
        } else {
          mul -= 1;
        }
      }
      var chk = (10 - sum % 10) % 10;
      if (chk !== parseInt(str.substring(14, 15), 10)) {
        return false;
      }
      return true;
    }
    __name(isIMEI, "isIMEI");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAscii.js
var require_isAscii = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAscii.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isAscii;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var ascii2 = /^[\x00-\x7F]+$/;
    function isAscii(str) {
      (0, _assertString.default)(str);
      return ascii2.test(str);
    }
    __name(isAscii, "isAscii");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isFullWidth.js
var require_isFullWidth = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isFullWidth.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isFullWidth;
    exports.fullWidth = void 0;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var fullWidth = exports.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
    function isFullWidth(str) {
      (0, _assertString.default)(str);
      return fullWidth.test(str);
    }
    __name(isFullWidth, "isFullWidth");
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHalfWidth.js
var require_isHalfWidth = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHalfWidth.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isHalfWidth;
    exports.halfWidth = void 0;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var halfWidth = exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
    function isHalfWidth(str) {
      (0, _assertString.default)(str);
      return halfWidth.test(str);
    }
    __name(isHalfWidth, "isHalfWidth");
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isVariableWidth.js
var require_isVariableWidth = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isVariableWidth.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isVariableWidth;
    var _assertString = _interopRequireDefault(require_assertString());
    var _isFullWidth = require_isFullWidth();
    var _isHalfWidth = require_isHalfWidth();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isVariableWidth(str) {
      (0, _assertString.default)(str);
      return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
    }
    __name(isVariableWidth, "isVariableWidth");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMultibyte.js
var require_isMultibyte = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMultibyte.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isMultibyte;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var multibyte = /[^\x00-\x7F]/;
    function isMultibyte(str) {
      (0, _assertString.default)(str);
      return multibyte.test(str);
    }
    __name(isMultibyte, "isMultibyte");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/multilineRegex.js
var require_multilineRegex = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/multilineRegex.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = multilineRegexp;
    function multilineRegexp(parts, flags) {
      var regexpAsStringLiteral = parts.join("");
      return new RegExp(regexpAsStringLiteral, flags);
    }
    __name(multilineRegexp, "multilineRegexp");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isSemVer.js
var require_isSemVer = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isSemVer.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isSemVer;
    var _assertString = _interopRequireDefault(require_assertString());
    var _multilineRegex = _interopRequireDefault(require_multilineRegex());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var semanticVersioningRegex = (0, _multilineRegex.default)([
      "^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)",
      "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))",
      "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"
    ], "i");
    function isSemVer(str) {
      (0, _assertString.default)(str);
      return semanticVersioningRegex.test(str);
    }
    __name(isSemVer, "isSemVer");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isSurrogatePair.js
var require_isSurrogatePair = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isSurrogatePair.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isSurrogatePair;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
    function isSurrogatePair(str) {
      (0, _assertString.default)(str);
      return surrogatePair.test(str);
    }
    __name(isSurrogatePair, "isSurrogatePair");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/includes.js
var require_includes = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/includes.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var includes = /* @__PURE__ */ __name(function includes2(arr, val) {
      return arr.some(function(arrVal) {
        return val === arrVal;
      });
    }, "includes");
    var _default = exports.default = includes;
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isDecimal.js
var require_isDecimal = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isDecimal.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isDecimal;
    var _merge = _interopRequireDefault(require_merge());
    var _assertString = _interopRequireDefault(require_assertString());
    var _includes = _interopRequireDefault(require_includes());
    var _alpha = require_alpha();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function decimalRegExp(options) {
      var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? "" : "?", "$"));
      return regExp;
    }
    __name(decimalRegExp, "decimalRegExp");
    var default_decimal_options = {
      force_decimal: false,
      decimal_digits: "1,",
      locale: "en-US"
    };
    var blacklist = [
      "",
      "-",
      "+"
    ];
    function isDecimal(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_decimal_options);
      if (options.locale in _alpha.decimal) {
        return !(0, _includes.default)(blacklist, str.replace(/ /g, "")) && decimalRegExp(options).test(str);
      }
      throw new Error("Invalid locale '".concat(options.locale, "'"));
    }
    __name(isDecimal, "isDecimal");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHexadecimal.js
var require_isHexadecimal = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHexadecimal.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isHexadecimal;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;
    function isHexadecimal(str) {
      (0, _assertString.default)(str);
      return hexadecimal.test(str);
    }
    __name(isHexadecimal, "isHexadecimal");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isOctal.js
var require_isOctal = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isOctal.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isOctal;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var octal = /^(0o)?[0-7]+$/i;
    function isOctal(str) {
      (0, _assertString.default)(str);
      return octal.test(str);
    }
    __name(isOctal, "isOctal");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isDivisibleBy.js
var require_isDivisibleBy = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isDivisibleBy.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isDivisibleBy;
    var _assertString = _interopRequireDefault(require_assertString());
    var _toFloat = _interopRequireDefault(require_toFloat());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isDivisibleBy(str, num) {
      (0, _assertString.default)(str);
      return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
    }
    __name(isDivisibleBy, "isDivisibleBy");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHexColor.js
var require_isHexColor = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHexColor.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isHexColor;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
    function isHexColor(str) {
      (0, _assertString.default)(str);
      return hexcolor.test(str);
    }
    __name(isHexColor, "isHexColor");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isRgbColor.js
var require_isRgbColor = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isRgbColor.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isRgbColor;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var rgbColor = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
    var rgbaColor = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
    var rgbColorPercent = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/;
    var rgbaColorPercent = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
    function isRgbColor(str) {
      var includePercentValues = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
      (0, _assertString.default)(str);
      if (!includePercentValues) {
        return rgbColor.test(str) || rgbaColor.test(str);
      }
      return rgbColor.test(str) || rgbaColor.test(str) || rgbColorPercent.test(str) || rgbaColorPercent.test(str);
    }
    __name(isRgbColor, "isRgbColor");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHSL.js
var require_isHSL = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHSL.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isHSL;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var hslComma = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i;
    var hslSpace = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
    function isHSL(str) {
      (0, _assertString.default)(str);
      var strippedStr = str.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
      if (strippedStr.indexOf(",") !== -1) {
        return hslComma.test(strippedStr);
      }
      return hslSpace.test(strippedStr);
    }
    __name(isHSL, "isHSL");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISRC.js
var require_isISRC = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISRC.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isISRC;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
    function isISRC(str) {
      (0, _assertString.default)(str);
      return isrc.test(str);
    }
    __name(isISRC, "isISRC");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIBAN.js
var require_isIBAN = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIBAN.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isIBAN;
    exports.locales = void 0;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var ibanRegexThroughCountryCode = {
      AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
      AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
      AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
      AT: /^(AT[0-9]{2})\d{16}$/,
      AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
      BA: /^(BA[0-9]{2})\d{16}$/,
      BE: /^(BE[0-9]{2})\d{12}$/,
      BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
      BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
      BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
      BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
      CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
      CR: /^(CR[0-9]{2})\d{18}$/,
      CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
      CZ: /^(CZ[0-9]{2})\d{20}$/,
      DE: /^(DE[0-9]{2})\d{18}$/,
      DK: /^(DK[0-9]{2})\d{14}$/,
      DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
      DZ: /^(DZ\d{24})$/,
      EE: /^(EE[0-9]{2})\d{16}$/,
      EG: /^(EG[0-9]{2})\d{25}$/,
      ES: /^(ES[0-9]{2})\d{20}$/,
      FI: /^(FI[0-9]{2})\d{14}$/,
      FO: /^(FO[0-9]{2})\d{14}$/,
      FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
      GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
      GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
      GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
      GL: /^(GL[0-9]{2})\d{14}$/,
      GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
      GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
      HR: /^(HR[0-9]{2})\d{17}$/,
      HU: /^(HU[0-9]{2})\d{24}$/,
      IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
      IL: /^(IL[0-9]{2})\d{19}$/,
      IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
      IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
      IS: /^(IS[0-9]{2})\d{22}$/,
      IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
      JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
      KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
      KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
      LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
      LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
      LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
      LT: /^(LT[0-9]{2})\d{16}$/,
      LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
      LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
      MA: /^(MA[0-9]{26})$/,
      MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
      MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
      ME: /^(ME[0-9]{2})\d{18}$/,
      MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
      MR: /^(MR[0-9]{2})\d{23}$/,
      MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
      MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
      MZ: /^(MZ[0-9]{2})\d{21}$/,
      NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
      NO: /^(NO[0-9]{2})\d{11}$/,
      PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
      PL: /^(PL[0-9]{2})\d{24}$/,
      PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
      PT: /^(PT[0-9]{2})\d{21}$/,
      QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
      RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
      RS: /^(RS[0-9]{2})\d{18}$/,
      SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
      SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
      SE: /^(SE[0-9]{2})\d{20}$/,
      SI: /^(SI[0-9]{2})\d{15}$/,
      SK: /^(SK[0-9]{2})\d{20}$/,
      SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
      SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
      TL: /^(TL[0-9]{2})\d{19}$/,
      TN: /^(TN[0-9]{2})\d{20}$/,
      TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
      UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
      VA: /^(VA[0-9]{2})\d{18}$/,
      VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
      XK: /^(XK[0-9]{2})\d{16}$/
    };
    function hasOnlyValidCountryCodes(countryCodeArray) {
      var countryCodeArrayFilteredWithObjectIbanCode = countryCodeArray.filter(function(countryCode) {
        return !(countryCode in ibanRegexThroughCountryCode);
      });
      if (countryCodeArrayFilteredWithObjectIbanCode.length > 0) {
        return false;
      }
      return true;
    }
    __name(hasOnlyValidCountryCodes, "hasOnlyValidCountryCodes");
    function hasValidIbanFormat(str, options) {
      var strippedStr = str.replace(/[\s\-]+/gi, "").toUpperCase();
      var isoCountryCode = strippedStr.slice(0, 2).toUpperCase();
      var isoCountryCodeInIbanRegexCodeObject = isoCountryCode in ibanRegexThroughCountryCode;
      if (options.whitelist) {
        if (!hasOnlyValidCountryCodes(options.whitelist)) {
          return false;
        }
        var isoCountryCodeInWhiteList = options.whitelist.includes(isoCountryCode);
        if (!isoCountryCodeInWhiteList) {
          return false;
        }
      }
      if (options.blacklist) {
        var isoCountryCodeInBlackList = options.blacklist.includes(isoCountryCode);
        if (isoCountryCodeInBlackList) {
          return false;
        }
      }
      return isoCountryCodeInIbanRegexCodeObject && ibanRegexThroughCountryCode[isoCountryCode].test(strippedStr);
    }
    __name(hasValidIbanFormat, "hasValidIbanFormat");
    function hasValidIbanChecksum(str) {
      var strippedStr = str.replace(/[^A-Z0-9]+/gi, "").toUpperCase();
      var rearranged = strippedStr.slice(4) + strippedStr.slice(0, 4);
      var alphaCapsReplacedWithDigits = rearranged.replace(/[A-Z]/g, function(char) {
        return char.charCodeAt(0) - 55;
      });
      var remainder = alphaCapsReplacedWithDigits.match(/\d{1,7}/g).reduce(function(acc, value) {
        return Number(acc + value) % 97;
      }, "");
      return remainder === 1;
    }
    __name(hasValidIbanChecksum, "hasValidIbanChecksum");
    function isIBAN(str) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, _assertString.default)(str);
      return hasValidIbanFormat(str, options) && hasValidIbanChecksum(str);
    }
    __name(isIBAN, "isIBAN");
    var locales = exports.locales = Object.keys(ibanRegexThroughCountryCode);
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO31661Alpha2.js
var require_isISO31661Alpha2 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO31661Alpha2.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.CountryCodes = void 0;
    exports.default = isISO31661Alpha2;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var validISO31661Alpha2CountriesCodes = /* @__PURE__ */ new Set([
      "AD",
      "AE",
      "AF",
      "AG",
      "AI",
      "AL",
      "AM",
      "AO",
      "AQ",
      "AR",
      "AS",
      "AT",
      "AU",
      "AW",
      "AX",
      "AZ",
      "BA",
      "BB",
      "BD",
      "BE",
      "BF",
      "BG",
      "BH",
      "BI",
      "BJ",
      "BL",
      "BM",
      "BN",
      "BO",
      "BQ",
      "BR",
      "BS",
      "BT",
      "BV",
      "BW",
      "BY",
      "BZ",
      "CA",
      "CC",
      "CD",
      "CF",
      "CG",
      "CH",
      "CI",
      "CK",
      "CL",
      "CM",
      "CN",
      "CO",
      "CR",
      "CU",
      "CV",
      "CW",
      "CX",
      "CY",
      "CZ",
      "DE",
      "DJ",
      "DK",
      "DM",
      "DO",
      "DZ",
      "EC",
      "EE",
      "EG",
      "EH",
      "ER",
      "ES",
      "ET",
      "FI",
      "FJ",
      "FK",
      "FM",
      "FO",
      "FR",
      "GA",
      "GB",
      "GD",
      "GE",
      "GF",
      "GG",
      "GH",
      "GI",
      "GL",
      "GM",
      "GN",
      "GP",
      "GQ",
      "GR",
      "GS",
      "GT",
      "GU",
      "GW",
      "GY",
      "HK",
      "HM",
      "HN",
      "HR",
      "HT",
      "HU",
      "ID",
      "IE",
      "IL",
      "IM",
      "IN",
      "IO",
      "IQ",
      "IR",
      "IS",
      "IT",
      "JE",
      "JM",
      "JO",
      "JP",
      "KE",
      "KG",
      "KH",
      "KI",
      "KM",
      "KN",
      "KP",
      "KR",
      "KW",
      "KY",
      "KZ",
      "LA",
      "LB",
      "LC",
      "LI",
      "LK",
      "LR",
      "LS",
      "LT",
      "LU",
      "LV",
      "LY",
      "MA",
      "MC",
      "MD",
      "ME",
      "MF",
      "MG",
      "MH",
      "MK",
      "ML",
      "MM",
      "MN",
      "MO",
      "MP",
      "MQ",
      "MR",
      "MS",
      "MT",
      "MU",
      "MV",
      "MW",
      "MX",
      "MY",
      "MZ",
      "NA",
      "NC",
      "NE",
      "NF",
      "NG",
      "NI",
      "NL",
      "NO",
      "NP",
      "NR",
      "NU",
      "NZ",
      "OM",
      "PA",
      "PE",
      "PF",
      "PG",
      "PH",
      "PK",
      "PL",
      "PM",
      "PN",
      "PR",
      "PS",
      "PT",
      "PW",
      "PY",
      "QA",
      "RE",
      "RO",
      "RS",
      "RU",
      "RW",
      "SA",
      "SB",
      "SC",
      "SD",
      "SE",
      "SG",
      "SH",
      "SI",
      "SJ",
      "SK",
      "SL",
      "SM",
      "SN",
      "SO",
      "SR",
      "SS",
      "ST",
      "SV",
      "SX",
      "SY",
      "SZ",
      "TC",
      "TD",
      "TF",
      "TG",
      "TH",
      "TJ",
      "TK",
      "TL",
      "TM",
      "TN",
      "TO",
      "TR",
      "TT",
      "TV",
      "TW",
      "TZ",
      "UA",
      "UG",
      "UM",
      "US",
      "UY",
      "UZ",
      "VA",
      "VC",
      "VE",
      "VG",
      "VI",
      "VN",
      "VU",
      "WF",
      "WS",
      "YE",
      "YT",
      "ZA",
      "ZM",
      "ZW"
    ]);
    function isISO31661Alpha2(str) {
      (0, _assertString.default)(str);
      return validISO31661Alpha2CountriesCodes.has(str.toUpperCase());
    }
    __name(isISO31661Alpha2, "isISO31661Alpha2");
    var CountryCodes = exports.CountryCodes = validISO31661Alpha2CountriesCodes;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBIC.js
var require_isBIC = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBIC.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isBIC;
    var _assertString = _interopRequireDefault(require_assertString());
    var _isISO31661Alpha = require_isISO31661Alpha2();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var isBICReg = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    function isBIC(str) {
      (0, _assertString.default)(str);
      var countryCode = str.slice(4, 6).toUpperCase();
      if (!_isISO31661Alpha.CountryCodes.has(countryCode) && countryCode !== "XK") {
        return false;
      }
      return isBICReg.test(str);
    }
    __name(isBIC, "isBIC");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMD5.js
var require_isMD5 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMD5.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isMD5;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var md5 = /^[a-f0-9]{32}$/;
    function isMD5(str) {
      (0, _assertString.default)(str);
      return md5.test(str);
    }
    __name(isMD5, "isMD5");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHash.js
var require_isHash = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isHash.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isHash;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var lengths = {
      md5: 32,
      md4: 32,
      sha1: 40,
      sha256: 64,
      sha384: 96,
      sha512: 128,
      ripemd128: 32,
      ripemd160: 40,
      tiger128: 32,
      tiger160: 40,
      tiger192: 48,
      crc32: 8,
      crc32b: 8
    };
    function isHash(str, algorithm) {
      (0, _assertString.default)(str);
      var hash = new RegExp("^[a-fA-F0-9]{".concat(lengths[algorithm], "}$"));
      return hash.test(str);
    }
    __name(isHash, "isHash");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBase64.js
var require_isBase64 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBase64.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isBase64;
    var _assertString = _interopRequireDefault(require_assertString());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var notBase64 = /[^A-Z0-9+\/=]/i;
    var urlSafeBase64 = /^[A-Z0-9_\-]*$/i;
    var defaultBase64Options = {
      urlSafe: false
    };
    function isBase64(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, defaultBase64Options);
      var len = str.length;
      if (options.urlSafe) {
        return urlSafeBase64.test(str);
      }
      if (len % 4 !== 0 || notBase64.test(str)) {
        return false;
      }
      var firstPaddingChar = str.indexOf("=");
      return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === "=";
    }
    __name(isBase64, "isBase64");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isJWT.js
var require_isJWT = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isJWT.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isJWT;
    var _assertString = _interopRequireDefault(require_assertString());
    var _isBase = _interopRequireDefault(require_isBase64());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isJWT(str) {
      (0, _assertString.default)(str);
      var dotSplit = str.split(".");
      var len = dotSplit.length;
      if (len !== 3) {
        return false;
      }
      return dotSplit.reduce(function(acc, currElem) {
        return acc && (0, _isBase.default)(currElem, {
          urlSafe: true
        });
      }, true);
    }
    __name(isJWT, "isJWT");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isJSON.js
var require_isJSON = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isJSON.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isJSON;
    var _assertString = _interopRequireDefault(require_assertString());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function _typeof(o2) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
        return typeof o3;
      } : function(o3) {
        return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
      }, _typeof(o2);
    }
    __name(_typeof, "_typeof");
    var default_json_options = {
      allow_primitives: false
    };
    function isJSON(str, options) {
      (0, _assertString.default)(str);
      try {
        options = (0, _merge.default)(options, default_json_options);
        var primitives = [];
        if (options.allow_primitives) {
          primitives = [
            null,
            false,
            true
          ];
        }
        var obj = JSON.parse(str);
        return primitives.includes(obj) || !!obj && _typeof(obj) === "object";
      } catch (e2) {
      }
      return false;
    }
    __name(isJSON, "isJSON");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isEmpty.js
var require_isEmpty = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isEmpty.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isEmpty;
    var _assertString = _interopRequireDefault(require_assertString());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var default_is_empty_options = {
      ignore_whitespace: false
    };
    function isEmpty(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_is_empty_options);
      return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
    }
    __name(isEmpty, "isEmpty");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLength.js
var require_isLength = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLength.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isLength;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function _typeof(o2) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
        return typeof o3;
      } : function(o3) {
        return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
      }, _typeof(o2);
    }
    __name(_typeof, "_typeof");
    function isLength(str, options) {
      (0, _assertString.default)(str);
      var min;
      var max;
      if (_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
      } else {
        min = arguments[1] || 0;
        max = arguments[2];
      }
      var presentationSequences = str.match(/(\uFE0F|\uFE0E)/g) || [];
      var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
      var len = str.length - presentationSequences.length - surrogatePairs.length;
      return len >= min && (typeof max === "undefined" || len <= max);
    }
    __name(isLength, "isLength");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isUUID.js
var require_isUUID = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isUUID.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isUUID;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var uuid = {
      1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
      2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
      3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
      4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
    };
    function isUUID(str, version) {
      (0, _assertString.default)(str);
      var pattern = uuid[![
        void 0,
        null
      ].includes(version) ? version : "all"];
      return !!pattern && pattern.test(str);
    }
    __name(isUUID, "isUUID");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMongoId.js
var require_isMongoId = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMongoId.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isMongoId;
    var _assertString = _interopRequireDefault(require_assertString());
    var _isHexadecimal = _interopRequireDefault(require_isHexadecimal());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isMongoId(str) {
      (0, _assertString.default)(str);
      return (0, _isHexadecimal.default)(str) && str.length === 24;
    }
    __name(isMongoId, "isMongoId");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAfter.js
var require_isAfter = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isAfter.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isAfter;
    var _toDate = _interopRequireDefault(require_toDate());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isAfter(date, options) {
      var comparisonDate = (options === null || options === void 0 ? void 0 : options.comparisonDate) || options || Date().toString();
      var comparison = (0, _toDate.default)(comparisonDate);
      var original = (0, _toDate.default)(date);
      return !!(original && comparison && original > comparison);
    }
    __name(isAfter, "isAfter");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBefore.js
var require_isBefore = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBefore.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isBefore;
    var _assertString = _interopRequireDefault(require_assertString());
    var _toDate = _interopRequireDefault(require_toDate());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isBefore(str) {
      var date = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : String(/* @__PURE__ */ new Date());
      (0, _assertString.default)(str);
      var comparison = (0, _toDate.default)(date);
      var original = (0, _toDate.default)(str);
      return !!(original && comparison && original < comparison);
    }
    __name(isBefore, "isBefore");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIn.js
var require_isIn = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIn.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isIn;
    var _assertString = _interopRequireDefault(require_assertString());
    var _toString = _interopRequireDefault(require_toString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function _typeof(o2) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
        return typeof o3;
      } : function(o3) {
        return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
      }, _typeof(o2);
    }
    __name(_typeof, "_typeof");
    function isIn(str, options) {
      (0, _assertString.default)(str);
      var i;
      if (Object.prototype.toString.call(options) === "[object Array]") {
        var array2 = [];
        for (i in options) {
          if ({}.hasOwnProperty.call(options, i)) {
            array2[i] = (0, _toString.default)(options[i]);
          }
        }
        return array2.indexOf(str) >= 0;
      } else if (_typeof(options) === "object") {
        return options.hasOwnProperty(str);
      } else if (options && typeof options.indexOf === "function") {
        return options.indexOf(str) >= 0;
      }
      return false;
    }
    __name(isIn, "isIn");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLuhnNumber.js
var require_isLuhnNumber = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLuhnNumber.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isLuhnNumber;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isLuhnNumber(str) {
      (0, _assertString.default)(str);
      var sanitized = str.replace(/[- ]+/g, "");
      var sum = 0;
      var digit;
      var tmpNum;
      var shouldDouble;
      for (var i = sanitized.length - 1; i >= 0; i--) {
        digit = sanitized.substring(i, i + 1);
        tmpNum = parseInt(digit, 10);
        if (shouldDouble) {
          tmpNum *= 2;
          if (tmpNum >= 10) {
            sum += tmpNum % 10 + 1;
          } else {
            sum += tmpNum;
          }
        } else {
          sum += tmpNum;
        }
        shouldDouble = !shouldDouble;
      }
      return !!(sum % 10 === 0 ? sanitized : false);
    }
    __name(isLuhnNumber, "isLuhnNumber");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isCreditCard.js
var require_isCreditCard = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isCreditCard.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isCreditCard;
    var _assertString = _interopRequireDefault(require_assertString());
    var _isLuhnNumber = _interopRequireDefault(require_isLuhnNumber());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var cards = {
      amex: /^3[47][0-9]{13}$/,
      dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
      // /^[25][1-7][0-9]{14}$/;
      unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
      visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
    };
    var allCards = function() {
      var tmpCardsArray = [];
      for (var cardProvider in cards) {
        if (cards.hasOwnProperty(cardProvider)) {
          tmpCardsArray.push(cards[cardProvider]);
        }
      }
      return tmpCardsArray;
    }();
    function isCreditCard(card) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, _assertString.default)(card);
      var provider = options.provider;
      var sanitized = card.replace(/[- ]+/g, "");
      if (provider && provider.toLowerCase() in cards) {
        if (!cards[provider.toLowerCase()].test(sanitized)) {
          return false;
        }
      } else if (provider && !(provider.toLowerCase() in cards)) {
        throw new Error("".concat(provider, " is not a valid credit card provider."));
      } else if (!allCards.some(function(cardProvider) {
        return cardProvider.test(sanitized);
      })) {
        return false;
      }
      return (0, _isLuhnNumber.default)(card);
    }
    __name(isCreditCard, "isCreditCard");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIdentityCard.js
var require_isIdentityCard = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isIdentityCard.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isIdentityCard;
    var _assertString = _interopRequireDefault(require_assertString());
    var _isInt = _interopRequireDefault(require_isInt());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var validators = {
      PL: /* @__PURE__ */ __name(function PL(str) {
        (0, _assertString.default)(str);
        var weightOfDigits = {
          1: 1,
          2: 3,
          3: 7,
          4: 9,
          5: 1,
          6: 3,
          7: 7,
          8: 9,
          9: 1,
          10: 3,
          11: 0
        };
        if (str != null && str.length === 11 && (0, _isInt.default)(str, {
          allow_leading_zeroes: true
        })) {
          var digits = str.split("").slice(0, -1);
          var sum = digits.reduce(function(acc, digit, index) {
            return acc + Number(digit) * weightOfDigits[index + 1];
          }, 0);
          var modulo = sum % 10;
          var lastDigit = Number(str.charAt(str.length - 1));
          if (modulo === 0 && lastDigit === 0 || lastDigit === 10 - modulo) {
            return true;
          }
        }
        return false;
      }, "PL"),
      ES: /* @__PURE__ */ __name(function ES(str) {
        (0, _assertString.default)(str);
        var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
        var charsValue = {
          X: 0,
          Y: 1,
          Z: 2
        };
        var controlDigits = [
          "T",
          "R",
          "W",
          "A",
          "G",
          "M",
          "Y",
          "F",
          "P",
          "D",
          "X",
          "B",
          "N",
          "J",
          "Z",
          "S",
          "Q",
          "V",
          "H",
          "L",
          "C",
          "K",
          "E"
        ];
        var sanitized = str.trim().toUpperCase();
        if (!DNI.test(sanitized)) {
          return false;
        }
        var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function(char) {
          return charsValue[char];
        });
        return sanitized.endsWith(controlDigits[number % 23]);
      }, "ES"),
      FI: /* @__PURE__ */ __name(function FI(str) {
        (0, _assertString.default)(str);
        if (str.length !== 11) {
          return false;
        }
        if (!str.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/)) {
          return false;
        }
        var checkDigits = "0123456789ABCDEFHJKLMNPRSTUVWXY";
        var idAsNumber = parseInt(str.slice(0, 6), 10) * 1e3 + parseInt(str.slice(7, 10), 10);
        var remainder = idAsNumber % 31;
        var checkDigit = checkDigits[remainder];
        return checkDigit === str.slice(10, 11);
      }, "FI"),
      IN: /* @__PURE__ */ __name(function IN(str) {
        var DNI = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/;
        var d = [
          [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
          ],
          [
            1,
            2,
            3,
            4,
            0,
            6,
            7,
            8,
            9,
            5
          ],
          [
            2,
            3,
            4,
            0,
            1,
            7,
            8,
            9,
            5,
            6
          ],
          [
            3,
            4,
            0,
            1,
            2,
            8,
            9,
            5,
            6,
            7
          ],
          [
            4,
            0,
            1,
            2,
            3,
            9,
            5,
            6,
            7,
            8
          ],
          [
            5,
            9,
            8,
            7,
            6,
            0,
            4,
            3,
            2,
            1
          ],
          [
            6,
            5,
            9,
            8,
            7,
            1,
            0,
            4,
            3,
            2
          ],
          [
            7,
            6,
            5,
            9,
            8,
            2,
            1,
            0,
            4,
            3
          ],
          [
            8,
            7,
            6,
            5,
            9,
            3,
            2,
            1,
            0,
            4
          ],
          [
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1,
            0
          ]
        ];
        var p = [
          [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
          ],
          [
            1,
            5,
            7,
            6,
            2,
            8,
            3,
            0,
            9,
            4
          ],
          [
            5,
            8,
            0,
            3,
            7,
            9,
            6,
            1,
            4,
            2
          ],
          [
            8,
            9,
            1,
            6,
            0,
            4,
            3,
            5,
            2,
            7
          ],
          [
            9,
            4,
            5,
            3,
            1,
            2,
            6,
            8,
            7,
            0
          ],
          [
            4,
            2,
            8,
            6,
            5,
            7,
            3,
            9,
            0,
            1
          ],
          [
            2,
            7,
            9,
            3,
            8,
            0,
            6,
            4,
            1,
            5
          ],
          [
            7,
            0,
            4,
            6,
            9,
            1,
            3,
            2,
            5,
            8
          ]
        ];
        var sanitized = str.trim();
        if (!DNI.test(sanitized)) {
          return false;
        }
        var c2 = 0;
        var invertedArray = sanitized.replace(/\s/g, "").split("").map(Number).reverse();
        invertedArray.forEach(function(val, i) {
          c2 = d[c2][p[i % 8][val]];
        });
        return c2 === 0;
      }, "IN"),
      IR: /* @__PURE__ */ __name(function IR(str) {
        if (!str.match(/^\d{10}$/)) return false;
        str = "0000".concat(str).slice(str.length - 6);
        if (parseInt(str.slice(3, 9), 10) === 0) return false;
        var lastNumber = parseInt(str.slice(9, 10), 10);
        var sum = 0;
        for (var i = 0; i < 9; i++) {
          sum += parseInt(str.slice(i, i + 1), 10) * (10 - i);
        }
        sum %= 11;
        return sum < 2 && lastNumber === sum || sum >= 2 && lastNumber === 11 - sum;
      }, "IR"),
      IT: /* @__PURE__ */ __name(function IT(str) {
        if (str.length !== 9) return false;
        if (str === "CA00000AA") return false;
        return str.search(/C[A-Z]\d{5}[A-Z]{2}/i) > -1;
      }, "IT"),
      NO: /* @__PURE__ */ __name(function NO(str) {
        var sanitized = str.trim();
        if (isNaN(Number(sanitized))) return false;
        if (sanitized.length !== 11) return false;
        if (sanitized === "00000000000") return false;
        var f = sanitized.split("").map(Number);
        var k1 = (11 - (3 * f[0] + 7 * f[1] + 6 * f[2] + 1 * f[3] + 8 * f[4] + 9 * f[5] + 4 * f[6] + 5 * f[7] + 2 * f[8]) % 11) % 11;
        var k2 = (11 - (5 * f[0] + 4 * f[1] + 3 * f[2] + 2 * f[3] + 7 * f[4] + 6 * f[5] + 5 * f[6] + 4 * f[7] + 3 * f[8] + 2 * k1) % 11) % 11;
        if (k1 !== f[9] || k2 !== f[10]) return false;
        return true;
      }, "NO"),
      TH: /* @__PURE__ */ __name(function TH(str) {
        if (!str.match(/^[1-8]\d{12}$/)) return false;
        var sum = 0;
        for (var i = 0; i < 12; i++) {
          sum += parseInt(str[i], 10) * (13 - i);
        }
        return str[12] === ((11 - sum % 11) % 10).toString();
      }, "TH"),
      LK: /* @__PURE__ */ __name(function LK(str) {
        var old_nic = /^[1-9]\d{8}[vx]$/i;
        var new_nic = /^[1-9]\d{11}$/i;
        if (str.length === 10 && old_nic.test(str)) return true;
        else if (str.length === 12 && new_nic.test(str)) return true;
        return false;
      }, "LK"),
      "he-IL": /* @__PURE__ */ __name(function heIL(str) {
        var DNI = /^\d{9}$/;
        var sanitized = str.trim();
        if (!DNI.test(sanitized)) {
          return false;
        }
        var id = sanitized;
        var sum = 0, incNum;
        for (var i = 0; i < id.length; i++) {
          incNum = Number(id[i]) * (i % 2 + 1);
          sum += incNum > 9 ? incNum - 9 : incNum;
        }
        return sum % 10 === 0;
      }, "heIL"),
      "ar-LY": /* @__PURE__ */ __name(function arLY(str) {
        var NIN = /^(1|2)\d{11}$/;
        var sanitized = str.trim();
        if (!NIN.test(sanitized)) {
          return false;
        }
        return true;
      }, "arLY"),
      "ar-TN": /* @__PURE__ */ __name(function arTN(str) {
        var DNI = /^\d{8}$/;
        var sanitized = str.trim();
        if (!DNI.test(sanitized)) {
          return false;
        }
        return true;
      }, "arTN"),
      "zh-CN": /* @__PURE__ */ __name(function zhCN(str) {
        var provincesAndCities = [
          "11",
          // 北京
          "12",
          // 天津
          "13",
          // 河北
          "14",
          // 山西
          "15",
          // 内蒙古
          "21",
          // 辽宁
          "22",
          // 吉林
          "23",
          // 黑龙江
          "31",
          // 上海
          "32",
          // 江苏
          "33",
          // 浙江
          "34",
          // 安徽
          "35",
          // 福建
          "36",
          // 江西
          "37",
          // 山东
          "41",
          // 河南
          "42",
          // 湖北
          "43",
          // 湖南
          "44",
          // 广东
          "45",
          // 广西
          "46",
          // 海南
          "50",
          // 重庆
          "51",
          // 四川
          "52",
          // 贵州
          "53",
          // 云南
          "54",
          // 西藏
          "61",
          // 陕西
          "62",
          // 甘肃
          "63",
          // 青海
          "64",
          // 宁夏
          "65",
          // 新疆
          "71",
          // 台湾
          "81",
          // 香港
          "82",
          // 澳门
          "91"
          // 国外
        ];
        var powers = [
          "7",
          "9",
          "10",
          "5",
          "8",
          "4",
          "2",
          "1",
          "6",
          "3",
          "7",
          "9",
          "10",
          "5",
          "8",
          "4",
          "2"
        ];
        var parityBit = [
          "1",
          "0",
          "X",
          "9",
          "8",
          "7",
          "6",
          "5",
          "4",
          "3",
          "2"
        ];
        var checkAddressCode = /* @__PURE__ */ __name(function checkAddressCode2(addressCode) {
          return provincesAndCities.includes(addressCode);
        }, "checkAddressCode");
        var checkBirthDayCode = /* @__PURE__ */ __name(function checkBirthDayCode2(birDayCode) {
          var yyyy = parseInt(birDayCode.substring(0, 4), 10);
          var mm = parseInt(birDayCode.substring(4, 6), 10);
          var dd = parseInt(birDayCode.substring(6), 10);
          var xdata = new Date(yyyy, mm - 1, dd);
          if (xdata > /* @__PURE__ */ new Date()) {
            return false;
          } else if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) {
            return true;
          }
          return false;
        }, "checkBirthDayCode");
        var getParityBit = /* @__PURE__ */ __name(function getParityBit2(idCardNo) {
          var id17 = idCardNo.substring(0, 17);
          var power = 0;
          for (var i = 0; i < 17; i++) {
            power += parseInt(id17.charAt(i), 10) * parseInt(powers[i], 10);
          }
          var mod = power % 11;
          return parityBit[mod];
        }, "getParityBit");
        var checkParityBit = /* @__PURE__ */ __name(function checkParityBit2(idCardNo) {
          return getParityBit(idCardNo) === idCardNo.charAt(17).toUpperCase();
        }, "checkParityBit");
        var check15IdCardNo = /* @__PURE__ */ __name(function check15IdCardNo2(idCardNo) {
          var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
          if (!check) return false;
          var addressCode = idCardNo.substring(0, 2);
          check = checkAddressCode(addressCode);
          if (!check) return false;
          var birDayCode = "19".concat(idCardNo.substring(6, 12));
          check = checkBirthDayCode(birDayCode);
          if (!check) return false;
          return true;
        }, "check15IdCardNo");
        var check18IdCardNo = /* @__PURE__ */ __name(function check18IdCardNo2(idCardNo) {
          var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
          if (!check) return false;
          var addressCode = idCardNo.substring(0, 2);
          check = checkAddressCode(addressCode);
          if (!check) return false;
          var birDayCode = idCardNo.substring(6, 14);
          check = checkBirthDayCode(birDayCode);
          if (!check) return false;
          return checkParityBit(idCardNo);
        }, "check18IdCardNo");
        var checkIdCardNo = /* @__PURE__ */ __name(function checkIdCardNo2(idCardNo) {
          var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
          if (!check) return false;
          if (idCardNo.length === 15) {
            return check15IdCardNo(idCardNo);
          }
          return check18IdCardNo(idCardNo);
        }, "checkIdCardNo");
        return checkIdCardNo(str);
      }, "zhCN"),
      "zh-HK": /* @__PURE__ */ __name(function zhHK(str) {
        str = str.trim();
        var regexHKID = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/;
        var regexIsDigit = /^[0-9]$/;
        str = str.toUpperCase();
        if (!regexHKID.test(str)) return false;
        str = str.replace(/\[|\]|\(|\)/g, "");
        if (str.length === 8) str = "3".concat(str);
        var checkSumVal = 0;
        for (var i = 0; i <= 7; i++) {
          var convertedChar = void 0;
          if (!regexIsDigit.test(str[i])) convertedChar = (str[i].charCodeAt(0) - 55) % 11;
          else convertedChar = str[i];
          checkSumVal += convertedChar * (9 - i);
        }
        checkSumVal %= 11;
        var checkSumConverted;
        if (checkSumVal === 0) checkSumConverted = "0";
        else if (checkSumVal === 1) checkSumConverted = "A";
        else checkSumConverted = String(11 - checkSumVal);
        if (checkSumConverted === str[str.length - 1]) return true;
        return false;
      }, "zhHK"),
      "zh-TW": /* @__PURE__ */ __name(function zhTW(str) {
        var ALPHABET_CODES = {
          A: 10,
          B: 11,
          C: 12,
          D: 13,
          E: 14,
          F: 15,
          G: 16,
          H: 17,
          I: 34,
          J: 18,
          K: 19,
          L: 20,
          M: 21,
          N: 22,
          O: 35,
          P: 23,
          Q: 24,
          R: 25,
          S: 26,
          T: 27,
          U: 28,
          V: 29,
          W: 32,
          X: 30,
          Y: 31,
          Z: 33
        };
        var sanitized = str.trim().toUpperCase();
        if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
        return Array.from(sanitized).reduce(function(sum, number, index) {
          if (index === 0) {
            var code = ALPHABET_CODES[number];
            return code % 10 * 9 + Math.floor(code / 10);
          }
          if (index === 9) {
            return (10 - sum % 10 - Number(number)) % 10 === 0;
          }
          return sum + Number(number) * (9 - index);
        }, 0);
      }, "zhTW")
    };
    function isIdentityCard(str, locale) {
      (0, _assertString.default)(str);
      if (locale in validators) {
        return validators[locale](str);
      } else if (locale === "any") {
        for (var key in validators) {
          if (validators.hasOwnProperty(key)) {
            var validator = validators[key];
            if (validator(str)) {
              return true;
            }
          }
        }
        return false;
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    __name(isIdentityCard, "isIdentityCard");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isEAN.js
var require_isEAN = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isEAN.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isEAN;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var LENGTH_EAN_8 = 8;
    var LENGTH_EAN_14 = 14;
    var validEanRegex = /^(\d{8}|\d{13}|\d{14})$/;
    function getPositionWeightThroughLengthAndIndex(length, index) {
      if (length === LENGTH_EAN_8 || length === LENGTH_EAN_14) {
        return index % 2 === 0 ? 3 : 1;
      }
      return index % 2 === 0 ? 1 : 3;
    }
    __name(getPositionWeightThroughLengthAndIndex, "getPositionWeightThroughLengthAndIndex");
    function calculateCheckDigit(ean) {
      var checksum = ean.slice(0, -1).split("").map(function(char, index) {
        return Number(char) * getPositionWeightThroughLengthAndIndex(ean.length, index);
      }).reduce(function(acc, partialSum) {
        return acc + partialSum;
      }, 0);
      var remainder = 10 - checksum % 10;
      return remainder < 10 ? remainder : 0;
    }
    __name(calculateCheckDigit, "calculateCheckDigit");
    function isEAN(str) {
      (0, _assertString.default)(str);
      var actualCheckDigit = Number(str.slice(-1));
      return validEanRegex.test(str) && actualCheckDigit === calculateCheckDigit(str);
    }
    __name(isEAN, "isEAN");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISIN.js
var require_isISIN = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISIN.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isISIN;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
    function isISIN(str) {
      (0, _assertString.default)(str);
      if (!isin.test(str)) {
        return false;
      }
      var double = true;
      var sum = 0;
      for (var i = str.length - 2; i >= 0; i--) {
        if (str[i] >= "A" && str[i] <= "Z") {
          var value = str[i].charCodeAt(0) - 55;
          var lo = value % 10;
          var hi = Math.trunc(value / 10);
          for (var _i = 0, _arr = [
            lo,
            hi
          ]; _i < _arr.length; _i++) {
            var digit = _arr[_i];
            if (double) {
              if (digit >= 5) {
                sum += 1 + (digit - 5) * 2;
              } else {
                sum += digit * 2;
              }
            } else {
              sum += digit;
            }
            double = !double;
          }
        } else {
          var _digit = str[i].charCodeAt(0) - "0".charCodeAt(0);
          if (double) {
            if (_digit >= 5) {
              sum += 1 + (_digit - 5) * 2;
            } else {
              sum += _digit * 2;
            }
          } else {
            sum += _digit;
          }
          double = !double;
        }
      }
      var check = Math.trunc((sum + 9) / 10) * 10 - sum;
      return +str[str.length - 1] === check;
    }
    __name(isISIN, "isISIN");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISBN.js
var require_isISBN = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISBN.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isISBN;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var possibleIsbn10 = /^(?:[0-9]{9}X|[0-9]{10})$/;
    var possibleIsbn13 = /^(?:[0-9]{13})$/;
    var factor = [
      1,
      3
    ];
    function isISBN(isbn, options) {
      (0, _assertString.default)(isbn);
      var version = String((options === null || options === void 0 ? void 0 : options.version) || options);
      if (!(options !== null && options !== void 0 && options.version || options)) {
        return isISBN(isbn, {
          version: 10
        }) || isISBN(isbn, {
          version: 13
        });
      }
      var sanitizedIsbn = isbn.replace(/[\s-]+/g, "");
      var checksum = 0;
      if (version === "10") {
        if (!possibleIsbn10.test(sanitizedIsbn)) {
          return false;
        }
        for (var i = 0; i < version - 1; i++) {
          checksum += (i + 1) * sanitizedIsbn.charAt(i);
        }
        if (sanitizedIsbn.charAt(9) === "X") {
          checksum += 10 * 10;
        } else {
          checksum += 10 * sanitizedIsbn.charAt(9);
        }
        if (checksum % 11 === 0) {
          return true;
        }
      } else if (version === "13") {
        if (!possibleIsbn13.test(sanitizedIsbn)) {
          return false;
        }
        for (var _i = 0; _i < 12; _i++) {
          checksum += factor[_i % 2] * sanitizedIsbn.charAt(_i);
        }
        if (sanitizedIsbn.charAt(12) - (10 - checksum % 10) % 10 === 0) {
          return true;
        }
      }
      return false;
    }
    __name(isISBN, "isISBN");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISSN.js
var require_isISSN = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISSN.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isISSN;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var issn = "^\\d{4}-?\\d{3}[\\dX]$";
    function isISSN(str) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, _assertString.default)(str);
      var testIssn = issn;
      testIssn = options.require_hyphen ? testIssn.replace("?", "") : testIssn;
      testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, "i");
      if (!testIssn.test(str)) {
        return false;
      }
      var digits = str.replace("-", "").toUpperCase();
      var checksum = 0;
      for (var i = 0; i < digits.length; i++) {
        var digit = digits[i];
        checksum += (digit === "X" ? 10 : +digit) * (8 - i);
      }
      return checksum % 11 === 0;
    }
    __name(isISSN, "isISSN");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/algorithms.js
var require_algorithms = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/util/algorithms.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.iso7064Check = iso7064Check;
    exports.luhnCheck = luhnCheck;
    exports.reverseMultiplyAndSum = reverseMultiplyAndSum;
    exports.verhoeffCheck = verhoeffCheck;
    function iso7064Check(str) {
      var checkvalue = 10;
      for (var i = 0; i < str.length - 1; i++) {
        checkvalue = (parseInt(str[i], 10) + checkvalue) % 10 === 0 ? 10 * 2 % 11 : (parseInt(str[i], 10) + checkvalue) % 10 * 2 % 11;
      }
      checkvalue = checkvalue === 1 ? 0 : 11 - checkvalue;
      return checkvalue === parseInt(str[10], 10);
    }
    __name(iso7064Check, "iso7064Check");
    function luhnCheck(str) {
      var checksum = 0;
      var second = false;
      for (var i = str.length - 1; i >= 0; i--) {
        if (second) {
          var product = parseInt(str[i], 10) * 2;
          if (product > 9) {
            checksum += product.toString().split("").map(function(a) {
              return parseInt(a, 10);
            }).reduce(function(a, b) {
              return a + b;
            }, 0);
          } else {
            checksum += product;
          }
        } else {
          checksum += parseInt(str[i], 10);
        }
        second = !second;
      }
      return checksum % 10 === 0;
    }
    __name(luhnCheck, "luhnCheck");
    function reverseMultiplyAndSum(digits, base) {
      var total = 0;
      for (var i = 0; i < digits.length; i++) {
        total += digits[i] * (base - i);
      }
      return total;
    }
    __name(reverseMultiplyAndSum, "reverseMultiplyAndSum");
    function verhoeffCheck(str) {
      var d_table = [
        [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        [
          1,
          2,
          3,
          4,
          0,
          6,
          7,
          8,
          9,
          5
        ],
        [
          2,
          3,
          4,
          0,
          1,
          7,
          8,
          9,
          5,
          6
        ],
        [
          3,
          4,
          0,
          1,
          2,
          8,
          9,
          5,
          6,
          7
        ],
        [
          4,
          0,
          1,
          2,
          3,
          9,
          5,
          6,
          7,
          8
        ],
        [
          5,
          9,
          8,
          7,
          6,
          0,
          4,
          3,
          2,
          1
        ],
        [
          6,
          5,
          9,
          8,
          7,
          1,
          0,
          4,
          3,
          2
        ],
        [
          7,
          6,
          5,
          9,
          8,
          2,
          1,
          0,
          4,
          3
        ],
        [
          8,
          7,
          6,
          5,
          9,
          3,
          2,
          1,
          0,
          4
        ],
        [
          9,
          8,
          7,
          6,
          5,
          4,
          3,
          2,
          1,
          0
        ]
      ];
      var p_table = [
        [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        [
          1,
          5,
          7,
          6,
          2,
          8,
          3,
          0,
          9,
          4
        ],
        [
          5,
          8,
          0,
          3,
          7,
          9,
          6,
          1,
          4,
          2
        ],
        [
          8,
          9,
          1,
          6,
          0,
          4,
          3,
          5,
          2,
          7
        ],
        [
          9,
          4,
          5,
          3,
          1,
          2,
          6,
          8,
          7,
          0
        ],
        [
          4,
          2,
          8,
          6,
          5,
          7,
          3,
          9,
          0,
          1
        ],
        [
          2,
          7,
          9,
          3,
          8,
          0,
          6,
          4,
          1,
          5
        ],
        [
          7,
          0,
          4,
          6,
          9,
          1,
          3,
          2,
          5,
          8
        ]
      ];
      var str_copy = str.split("").reverse().join("");
      var checksum = 0;
      for (var i = 0; i < str_copy.length; i++) {
        checksum = d_table[checksum][p_table[i % 8][parseInt(str_copy[i], 10)]];
      }
      return checksum === 0;
    }
    __name(verhoeffCheck, "verhoeffCheck");
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isTaxID.js
var require_isTaxID = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isTaxID.js"(exports, module) {
    "use strict";
    function _typeof(o2) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
        return typeof o3;
      } : function(o3) {
        return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
      }, _typeof(o2);
    }
    __name(_typeof, "_typeof");
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isTaxID;
    var _assertString = _interopRequireDefault(require_assertString());
    var algorithms = _interopRequireWildcard(require_algorithms());
    var _isDate = _interopRequireDefault(require_isDate());
    function _getRequireWildcardCache(e2) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = /* @__PURE__ */ __name(function _getRequireWildcardCache2(e3) {
        return e3 ? t2 : r2;
      }, "_getRequireWildcardCache"))(e2);
    }
    __name(_getRequireWildcardCache, "_getRequireWildcardCache");
    function _interopRequireWildcard(e2, r2) {
      if (!r2 && e2 && e2.__esModule) return e2;
      if (null === e2 || "object" != _typeof(e2) && "function" != typeof e2) return {
        default: e2
      };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e2)) return t2.get(e2);
      var n3 = {
        __proto__: null
      }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e2) if ("default" !== u && {}.hasOwnProperty.call(e2, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e2, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n3, u, i) : n3[u] = e2[u];
      }
      return n3.default = e2, t2 && t2.set(e2, n3), n3;
    }
    __name(_interopRequireWildcard, "_interopRequireWildcard");
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    __name(_toConsumableArray, "_toConsumableArray");
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    __name(_nonIterableSpread, "_nonIterableSpread");
    function _unsupportedIterableToArray(o2, minLen) {
      if (!o2) return;
      if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
      var n3 = Object.prototype.toString.call(o2).slice(8, -1);
      if (n3 === "Object" && o2.constructor) n3 = o2.constructor.name;
      if (n3 === "Map" || n3 === "Set") return Array.from(o2);
      if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3)) return _arrayLikeToArray(o2, minLen);
    }
    __name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    __name(_iterableToArray, "_iterableToArray");
    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    __name(_arrayWithoutHoles, "_arrayWithoutHoles");
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    __name(_arrayLikeToArray, "_arrayLikeToArray");
    function bgBgCheck(tin) {
      var century_year = tin.slice(0, 2);
      var month = parseInt(tin.slice(2, 4), 10);
      if (month > 40) {
        month -= 40;
        century_year = "20".concat(century_year);
      } else if (month > 20) {
        month -= 20;
        century_year = "18".concat(century_year);
      } else {
        century_year = "19".concat(century_year);
      }
      if (month < 10) {
        month = "0".concat(month);
      }
      var date = "".concat(century_year, "/").concat(month, "/").concat(tin.slice(4, 6));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var multip_lookup = [
        2,
        4,
        8,
        5,
        10,
        9,
        7,
        3,
        6
      ];
      var checksum = 0;
      for (var i = 0; i < multip_lookup.length; i++) {
        checksum += digits[i] * multip_lookup[i];
      }
      checksum = checksum % 11 === 10 ? 0 : checksum % 11;
      return checksum === digits[9];
    }
    __name(bgBgCheck, "bgBgCheck");
    function isCanadianSIN(input) {
      var digitsArray = input.split("");
      var even = digitsArray.filter(function(_, idx) {
        return idx % 2;
      }).map(function(i) {
        return Number(i) * 2;
      }).join("").split("");
      var total = digitsArray.filter(function(_, idx) {
        return !(idx % 2);
      }).concat(even).map(function(i) {
        return Number(i);
      }).reduce(function(acc, cur) {
        return acc + cur;
      });
      return total % 10 === 0;
    }
    __name(isCanadianSIN, "isCanadianSIN");
    function csCzCheck(tin) {
      tin = tin.replace(/\W/, "");
      var full_year = parseInt(tin.slice(0, 2), 10);
      if (tin.length === 10) {
        if (full_year < 54) {
          full_year = "20".concat(full_year);
        } else {
          full_year = "19".concat(full_year);
        }
      } else {
        if (tin.slice(6) === "000") {
          return false;
        }
        if (full_year < 54) {
          full_year = "19".concat(full_year);
        } else {
          return false;
        }
      }
      if (full_year.length === 3) {
        full_year = [
          full_year.slice(0, 2),
          "0",
          full_year.slice(2)
        ].join("");
      }
      var month = parseInt(tin.slice(2, 4), 10);
      if (month > 50) {
        month -= 50;
      }
      if (month > 20) {
        if (parseInt(full_year, 10) < 2004) {
          return false;
        }
        month -= 20;
      }
      if (month < 10) {
        month = "0".concat(month);
      }
      var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      if (tin.length === 10) {
        if (parseInt(tin, 10) % 11 !== 0) {
          var checkdigit = parseInt(tin.slice(0, 9), 10) % 11;
          if (parseInt(full_year, 10) < 1986 && checkdigit === 10) {
            if (parseInt(tin.slice(9), 10) !== 0) {
              return false;
            }
          } else {
            return false;
          }
        }
      }
      return true;
    }
    __name(csCzCheck, "csCzCheck");
    function deAtCheck(tin) {
      return algorithms.luhnCheck(tin);
    }
    __name(deAtCheck, "deAtCheck");
    function deDeCheck(tin) {
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var occurences = [];
      for (var i = 0; i < digits.length - 1; i++) {
        occurences.push("");
        for (var j = 0; j < digits.length - 1; j++) {
          if (digits[i] === digits[j]) {
            occurences[i] += j;
          }
        }
      }
      occurences = occurences.filter(function(a) {
        return a.length > 1;
      });
      if (occurences.length !== 2 && occurences.length !== 3) {
        return false;
      }
      if (occurences[0].length === 3) {
        var trip_locations = occurences[0].split("").map(function(a) {
          return parseInt(a, 10);
        });
        var recurrent = 0;
        for (var _i = 0; _i < trip_locations.length - 1; _i++) {
          if (trip_locations[_i] + 1 === trip_locations[_i + 1]) {
            recurrent += 1;
          }
        }
        if (recurrent === 2) {
          return false;
        }
      }
      return algorithms.iso7064Check(tin);
    }
    __name(deDeCheck, "deDeCheck");
    function dkDkCheck(tin) {
      tin = tin.replace(/\W/, "");
      var year = parseInt(tin.slice(4, 6), 10);
      var century_digit = tin.slice(6, 7);
      switch (century_digit) {
        case "0":
        case "1":
        case "2":
        case "3":
          year = "19".concat(year);
          break;
        case "4":
        case "9":
          if (year < 37) {
            year = "20".concat(year);
          } else {
            year = "19".concat(year);
          }
          break;
        default:
          if (year < 37) {
            year = "20".concat(year);
          } else if (year > 58) {
            year = "18".concat(year);
          } else {
            return false;
          }
          break;
      }
      if (year.length === 3) {
        year = [
          year.slice(0, 2),
          "0",
          year.slice(2)
        ].join("");
      }
      var date = "".concat(year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 0;
      var weight = 4;
      for (var i = 0; i < 9; i++) {
        checksum += digits[i] * weight;
        weight -= 1;
        if (weight === 1) {
          weight = 7;
        }
      }
      checksum %= 11;
      if (checksum === 1) {
        return false;
      }
      return checksum === 0 ? digits[9] === 0 : digits[9] === 11 - checksum;
    }
    __name(dkDkCheck, "dkDkCheck");
    function elCyCheck(tin) {
      var digits = tin.slice(0, 8).split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 0;
      for (var i = 1; i < digits.length; i += 2) {
        checksum += digits[i];
      }
      for (var _i2 = 0; _i2 < digits.length; _i2 += 2) {
        if (digits[_i2] < 2) {
          checksum += 1 - digits[_i2];
        } else {
          checksum += 2 * (digits[_i2] - 2) + 5;
          if (digits[_i2] > 4) {
            checksum += 2;
          }
        }
      }
      return String.fromCharCode(checksum % 26 + 65) === tin.charAt(8);
    }
    __name(elCyCheck, "elCyCheck");
    function elGrCheck(tin) {
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 0;
      for (var i = 0; i < 8; i++) {
        checksum += digits[i] * Math.pow(2, 8 - i);
      }
      return checksum % 11 % 10 === digits[8];
    }
    __name(elGrCheck, "elGrCheck");
    function enIeCheck(tin) {
      var checksum = algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 7).map(function(a) {
        return parseInt(a, 10);
      }), 8);
      if (tin.length === 9 && tin[8] !== "W") {
        checksum += (tin[8].charCodeAt(0) - 64) * 9;
      }
      checksum %= 23;
      if (checksum === 0) {
        return tin[7].toUpperCase() === "W";
      }
      return tin[7].toUpperCase() === String.fromCharCode(64 + checksum);
    }
    __name(enIeCheck, "enIeCheck");
    var enUsCampusPrefix = {
      andover: [
        "10",
        "12"
      ],
      atlanta: [
        "60",
        "67"
      ],
      austin: [
        "50",
        "53"
      ],
      brookhaven: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "11",
        "13",
        "14",
        "16",
        "21",
        "22",
        "23",
        "25",
        "34",
        "51",
        "52",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
        "65"
      ],
      cincinnati: [
        "30",
        "32",
        "35",
        "36",
        "37",
        "38",
        "61"
      ],
      fresno: [
        "15",
        "24"
      ],
      internet: [
        "20",
        "26",
        "27",
        "45",
        "46",
        "47"
      ],
      kansas: [
        "40",
        "44"
      ],
      memphis: [
        "94",
        "95"
      ],
      ogden: [
        "80",
        "90"
      ],
      philadelphia: [
        "33",
        "39",
        "41",
        "42",
        "43",
        "46",
        "48",
        "62",
        "63",
        "64",
        "66",
        "68",
        "71",
        "72",
        "73",
        "74",
        "75",
        "76",
        "77",
        "81",
        "82",
        "83",
        "84",
        "85",
        "86",
        "87",
        "88",
        "91",
        "92",
        "93",
        "98",
        "99"
      ],
      sba: [
        "31"
      ]
    };
    function enUsGetPrefixes() {
      var prefixes = [];
      for (var location in enUsCampusPrefix) {
        if (enUsCampusPrefix.hasOwnProperty(location)) {
          prefixes.push.apply(prefixes, _toConsumableArray(enUsCampusPrefix[location]));
        }
      }
      return prefixes;
    }
    __name(enUsGetPrefixes, "enUsGetPrefixes");
    function enUsCheck(tin) {
      return enUsGetPrefixes().indexOf(tin.slice(0, 2)) !== -1;
    }
    __name(enUsCheck, "enUsCheck");
    function esArCheck(tin) {
      var accum = 0;
      var digits = tin.split("");
      var digit = parseInt(digits.pop(), 10);
      for (var i = 0; i < digits.length; i++) {
        accum += digits[9 - i] * (2 + i % 6);
      }
      var verif = 11 - accum % 11;
      if (verif === 11) {
        verif = 0;
      } else if (verif === 10) {
        verif = 9;
      }
      return digit === verif;
    }
    __name(esArCheck, "esArCheck");
    function esEsCheck(tin) {
      var chars = tin.toUpperCase().split("");
      if (isNaN(parseInt(chars[0], 10)) && chars.length > 1) {
        var lead_replace = 0;
        switch (chars[0]) {
          case "Y":
            lead_replace = 1;
            break;
          case "Z":
            lead_replace = 2;
            break;
          default:
        }
        chars.splice(0, 1, lead_replace);
      } else {
        while (chars.length < 9) {
          chars.unshift(0);
        }
      }
      var lookup = [
        "T",
        "R",
        "W",
        "A",
        "G",
        "M",
        "Y",
        "F",
        "P",
        "D",
        "X",
        "B",
        "N",
        "J",
        "Z",
        "S",
        "Q",
        "V",
        "H",
        "L",
        "C",
        "K",
        "E"
      ];
      chars = chars.join("");
      var checksum = parseInt(chars.slice(0, 8), 10) % 23;
      return chars[8] === lookup[checksum];
    }
    __name(esEsCheck, "esEsCheck");
    function etEeCheck(tin) {
      var full_year = tin.slice(1, 3);
      var century_digit = tin.slice(0, 1);
      switch (century_digit) {
        case "1":
        case "2":
          full_year = "18".concat(full_year);
          break;
        case "3":
        case "4":
          full_year = "19".concat(full_year);
          break;
        default:
          full_year = "20".concat(full_year);
          break;
      }
      var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 0;
      var weight = 1;
      for (var i = 0; i < 10; i++) {
        checksum += digits[i] * weight;
        weight += 1;
        if (weight === 10) {
          weight = 1;
        }
      }
      if (checksum % 11 === 10) {
        checksum = 0;
        weight = 3;
        for (var _i3 = 0; _i3 < 10; _i3++) {
          checksum += digits[_i3] * weight;
          weight += 1;
          if (weight === 10) {
            weight = 1;
          }
        }
        if (checksum % 11 === 10) {
          return digits[10] === 0;
        }
      }
      return checksum % 11 === digits[10];
    }
    __name(etEeCheck, "etEeCheck");
    function fiFiCheck(tin) {
      var full_year = tin.slice(4, 6);
      var century_symbol = tin.slice(6, 7);
      switch (century_symbol) {
        case "+":
          full_year = "18".concat(full_year);
          break;
        case "-":
          full_year = "19".concat(full_year);
          break;
        default:
          full_year = "20".concat(full_year);
          break;
      }
      var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var checksum = parseInt(tin.slice(0, 6) + tin.slice(7, 10), 10) % 31;
      if (checksum < 10) {
        return checksum === parseInt(tin.slice(10), 10);
      }
      checksum -= 10;
      var letters_lookup = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "H",
        "J",
        "K",
        "L",
        "M",
        "N",
        "P",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y"
      ];
      return letters_lookup[checksum] === tin.slice(10);
    }
    __name(fiFiCheck, "fiFiCheck");
    function frBeCheck(tin) {
      if (tin.slice(2, 4) !== "00" || tin.slice(4, 6) !== "00") {
        var date = "".concat(tin.slice(0, 2), "/").concat(tin.slice(2, 4), "/").concat(tin.slice(4, 6));
        if (!(0, _isDate.default)(date, "YY/MM/DD")) {
          return false;
        }
      }
      var checksum = 97 - parseInt(tin.slice(0, 9), 10) % 97;
      var checkdigits = parseInt(tin.slice(9, 11), 10);
      if (checksum !== checkdigits) {
        checksum = 97 - parseInt("2".concat(tin.slice(0, 9)), 10) % 97;
        if (checksum !== checkdigits) {
          return false;
        }
      }
      return true;
    }
    __name(frBeCheck, "frBeCheck");
    function frFrCheck(tin) {
      tin = tin.replace(/\s/g, "");
      var checksum = parseInt(tin.slice(0, 10), 10) % 511;
      var checkdigits = parseInt(tin.slice(10, 13), 10);
      return checksum === checkdigits;
    }
    __name(frFrCheck, "frFrCheck");
    function frLuCheck(tin) {
      var date = "".concat(tin.slice(0, 4), "/").concat(tin.slice(4, 6), "/").concat(tin.slice(6, 8));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      if (!algorithms.luhnCheck(tin.slice(0, 12))) {
        return false;
      }
      return algorithms.verhoeffCheck("".concat(tin.slice(0, 11)).concat(tin[12]));
    }
    __name(frLuCheck, "frLuCheck");
    function hrHrCheck(tin) {
      return algorithms.iso7064Check(tin);
    }
    __name(hrHrCheck, "hrHrCheck");
    function huHuCheck(tin) {
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 8;
      for (var i = 1; i < 9; i++) {
        checksum += digits[i] * (i + 1);
      }
      return checksum % 11 === digits[9];
    }
    __name(huHuCheck, "huHuCheck");
    function itItNameCheck(name2) {
      var vowelflag = false;
      var xflag = false;
      for (var i = 0; i < 3; i++) {
        if (!vowelflag && /[AEIOU]/.test(name2[i])) {
          vowelflag = true;
        } else if (!xflag && vowelflag && name2[i] === "X") {
          xflag = true;
        } else if (i > 0) {
          if (vowelflag && !xflag) {
            if (!/[AEIOU]/.test(name2[i])) {
              return false;
            }
          }
          if (xflag) {
            if (!/X/.test(name2[i])) {
              return false;
            }
          }
        }
      }
      return true;
    }
    __name(itItNameCheck, "itItNameCheck");
    function itItCheck(tin) {
      var chars = tin.toUpperCase().split("");
      if (!itItNameCheck(chars.slice(0, 3))) {
        return false;
      }
      if (!itItNameCheck(chars.slice(3, 6))) {
        return false;
      }
      var number_locations = [
        6,
        7,
        9,
        10,
        12,
        13,
        14
      ];
      var number_replace = {
        L: "0",
        M: "1",
        N: "2",
        P: "3",
        Q: "4",
        R: "5",
        S: "6",
        T: "7",
        U: "8",
        V: "9"
      };
      for (var _i4 = 0, _number_locations = number_locations; _i4 < _number_locations.length; _i4++) {
        var i = _number_locations[_i4];
        if (chars[i] in number_replace) {
          chars.splice(i, 1, number_replace[chars[i]]);
        }
      }
      var month_replace = {
        A: "01",
        B: "02",
        C: "03",
        D: "04",
        E: "05",
        H: "06",
        L: "07",
        M: "08",
        P: "09",
        R: "10",
        S: "11",
        T: "12"
      };
      var month = month_replace[chars[8]];
      var day = parseInt(chars[9] + chars[10], 10);
      if (day > 40) {
        day -= 40;
      }
      if (day < 10) {
        day = "0".concat(day);
      }
      var date = "".concat(chars[6]).concat(chars[7], "/").concat(month, "/").concat(day);
      if (!(0, _isDate.default)(date, "YY/MM/DD")) {
        return false;
      }
      var checksum = 0;
      for (var _i5 = 1; _i5 < chars.length - 1; _i5 += 2) {
        var char_to_int = parseInt(chars[_i5], 10);
        if (isNaN(char_to_int)) {
          char_to_int = chars[_i5].charCodeAt(0) - 65;
        }
        checksum += char_to_int;
      }
      var odd_convert = {
        // Maps of characters at odd places
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
        0: 1,
        1: 0
      };
      for (var _i6 = 0; _i6 < chars.length - 1; _i6 += 2) {
        var _char_to_int = 0;
        if (chars[_i6] in odd_convert) {
          _char_to_int = odd_convert[chars[_i6]];
        } else {
          var multiplier = parseInt(chars[_i6], 10);
          _char_to_int = 2 * multiplier + 1;
          if (multiplier > 4) {
            _char_to_int += 2;
          }
        }
        checksum += _char_to_int;
      }
      if (String.fromCharCode(65 + checksum % 26) !== chars[15]) {
        return false;
      }
      return true;
    }
    __name(itItCheck, "itItCheck");
    function lvLvCheck(tin) {
      tin = tin.replace(/\W/, "");
      var day = tin.slice(0, 2);
      if (day !== "32") {
        var month = tin.slice(2, 4);
        if (month !== "00") {
          var full_year = tin.slice(4, 6);
          switch (tin[6]) {
            case "0":
              full_year = "18".concat(full_year);
              break;
            case "1":
              full_year = "19".concat(full_year);
              break;
            default:
              full_year = "20".concat(full_year);
              break;
          }
          var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(day);
          if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
            return false;
          }
        }
        var checksum = 1101;
        var multip_lookup = [
          1,
          6,
          3,
          7,
          9,
          10,
          5,
          8,
          4,
          2
        ];
        for (var i = 0; i < tin.length - 1; i++) {
          checksum -= parseInt(tin[i], 10) * multip_lookup[i];
        }
        return parseInt(tin[10], 10) === checksum % 11;
      }
      return true;
    }
    __name(lvLvCheck, "lvLvCheck");
    function mtMtCheck(tin) {
      if (tin.length !== 9) {
        var chars = tin.toUpperCase().split("");
        while (chars.length < 8) {
          chars.unshift(0);
        }
        switch (tin[7]) {
          case "A":
          case "P":
            if (parseInt(chars[6], 10) === 0) {
              return false;
            }
            break;
          default: {
            var first_part = parseInt(chars.join("").slice(0, 5), 10);
            if (first_part > 32e3) {
              return false;
            }
            var second_part = parseInt(chars.join("").slice(5, 7), 10);
            if (first_part === second_part) {
              return false;
            }
          }
        }
      }
      return true;
    }
    __name(mtMtCheck, "mtMtCheck");
    function nlNlCheck(tin) {
      return algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 8).map(function(a) {
        return parseInt(a, 10);
      }), 9) % 11 === parseInt(tin[8], 10);
    }
    __name(nlNlCheck, "nlNlCheck");
    function plPlCheck(tin) {
      if (tin.length === 10) {
        var lookup = [
          6,
          5,
          7,
          2,
          3,
          4,
          5,
          6,
          7
        ];
        var _checksum = 0;
        for (var i = 0; i < lookup.length; i++) {
          _checksum += parseInt(tin[i], 10) * lookup[i];
        }
        _checksum %= 11;
        if (_checksum === 10) {
          return false;
        }
        return _checksum === parseInt(tin[9], 10);
      }
      var full_year = tin.slice(0, 2);
      var month = parseInt(tin.slice(2, 4), 10);
      if (month > 80) {
        full_year = "18".concat(full_year);
        month -= 80;
      } else if (month > 60) {
        full_year = "22".concat(full_year);
        month -= 60;
      } else if (month > 40) {
        full_year = "21".concat(full_year);
        month -= 40;
      } else if (month > 20) {
        full_year = "20".concat(full_year);
        month -= 20;
      } else {
        full_year = "19".concat(full_year);
      }
      if (month < 10) {
        month = "0".concat(month);
      }
      var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var checksum = 0;
      var multiplier = 1;
      for (var _i7 = 0; _i7 < tin.length - 1; _i7++) {
        checksum += parseInt(tin[_i7], 10) * multiplier % 10;
        multiplier += 2;
        if (multiplier > 10) {
          multiplier = 1;
        } else if (multiplier === 5) {
          multiplier += 2;
        }
      }
      checksum = 10 - checksum % 10;
      return checksum === parseInt(tin[10], 10);
    }
    __name(plPlCheck, "plPlCheck");
    function ptBrCheck(tin) {
      if (tin.length === 11) {
        var _sum;
        var remainder;
        _sum = 0;
        if (
          // Reject known invalid CPFs
          tin === "11111111111" || tin === "22222222222" || tin === "33333333333" || tin === "44444444444" || tin === "55555555555" || tin === "66666666666" || tin === "77777777777" || tin === "88888888888" || tin === "99999999999" || tin === "00000000000"
        ) return false;
        for (var i = 1; i <= 9; i++) _sum += parseInt(tin.substring(i - 1, i), 10) * (11 - i);
        remainder = _sum * 10 % 11;
        if (remainder === 10) remainder = 0;
        if (remainder !== parseInt(tin.substring(9, 10), 10)) return false;
        _sum = 0;
        for (var _i8 = 1; _i8 <= 10; _i8++) _sum += parseInt(tin.substring(_i8 - 1, _i8), 10) * (12 - _i8);
        remainder = _sum * 10 % 11;
        if (remainder === 10) remainder = 0;
        if (remainder !== parseInt(tin.substring(10, 11), 10)) return false;
        return true;
      }
      if (
        // Reject know invalid CNPJs
        tin === "00000000000000" || tin === "11111111111111" || tin === "22222222222222" || tin === "33333333333333" || tin === "44444444444444" || tin === "55555555555555" || tin === "66666666666666" || tin === "77777777777777" || tin === "88888888888888" || tin === "99999999999999"
      ) {
        return false;
      }
      var length = tin.length - 2;
      var identifiers = tin.substring(0, length);
      var verificators = tin.substring(length);
      var sum = 0;
      var pos = length - 7;
      for (var _i9 = length; _i9 >= 1; _i9--) {
        sum += identifiers.charAt(length - _i9) * pos;
        pos -= 1;
        if (pos < 2) {
          pos = 9;
        }
      }
      var result = sum % 11 < 2 ? 0 : 11 - sum % 11;
      if (result !== parseInt(verificators.charAt(0), 10)) {
        return false;
      }
      length += 1;
      identifiers = tin.substring(0, length);
      sum = 0;
      pos = length - 7;
      for (var _i10 = length; _i10 >= 1; _i10--) {
        sum += identifiers.charAt(length - _i10) * pos;
        pos -= 1;
        if (pos < 2) {
          pos = 9;
        }
      }
      result = sum % 11 < 2 ? 0 : 11 - sum % 11;
      if (result !== parseInt(verificators.charAt(1), 10)) {
        return false;
      }
      return true;
    }
    __name(ptBrCheck, "ptBrCheck");
    function ptPtCheck(tin) {
      var checksum = 11 - algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 8).map(function(a) {
        return parseInt(a, 10);
      }), 9) % 11;
      if (checksum > 9) {
        return parseInt(tin[8], 10) === 0;
      }
      return checksum === parseInt(tin[8], 10);
    }
    __name(ptPtCheck, "ptPtCheck");
    function roRoCheck(tin) {
      if (tin.slice(0, 4) !== "9000") {
        var full_year = tin.slice(1, 3);
        switch (tin[0]) {
          case "1":
          case "2":
            full_year = "19".concat(full_year);
            break;
          case "3":
          case "4":
            full_year = "18".concat(full_year);
            break;
          case "5":
          case "6":
            full_year = "20".concat(full_year);
            break;
          default:
        }
        var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
        if (date.length === 8) {
          if (!(0, _isDate.default)(date, "YY/MM/DD")) {
            return false;
          }
        } else if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
          return false;
        }
        var digits = tin.split("").map(function(a) {
          return parseInt(a, 10);
        });
        var multipliers = [
          2,
          7,
          9,
          1,
          4,
          6,
          3,
          5,
          8,
          2,
          7,
          9
        ];
        var checksum = 0;
        for (var i = 0; i < multipliers.length; i++) {
          checksum += digits[i] * multipliers[i];
        }
        if (checksum % 11 === 10) {
          return digits[12] === 1;
        }
        return digits[12] === checksum % 11;
      }
      return true;
    }
    __name(roRoCheck, "roRoCheck");
    function skSkCheck(tin) {
      if (tin.length === 9) {
        tin = tin.replace(/\W/, "");
        if (tin.slice(6) === "000") {
          return false;
        }
        var full_year = parseInt(tin.slice(0, 2), 10);
        if (full_year > 53) {
          return false;
        }
        if (full_year < 10) {
          full_year = "190".concat(full_year);
        } else {
          full_year = "19".concat(full_year);
        }
        var month = parseInt(tin.slice(2, 4), 10);
        if (month > 50) {
          month -= 50;
        }
        if (month < 10) {
          month = "0".concat(month);
        }
        var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
        if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
          return false;
        }
      }
      return true;
    }
    __name(skSkCheck, "skSkCheck");
    function slSiCheck(tin) {
      var checksum = 11 - algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 7).map(function(a) {
        return parseInt(a, 10);
      }), 8) % 11;
      if (checksum === 10) {
        return parseInt(tin[7], 10) === 0;
      }
      return checksum === parseInt(tin[7], 10);
    }
    __name(slSiCheck, "slSiCheck");
    function svSeCheck(tin) {
      var tin_copy = tin.slice(0);
      if (tin.length > 11) {
        tin_copy = tin_copy.slice(2);
      }
      var full_year = "";
      var month = tin_copy.slice(2, 4);
      var day = parseInt(tin_copy.slice(4, 6), 10);
      if (tin.length > 11) {
        full_year = tin.slice(0, 4);
      } else {
        full_year = tin.slice(0, 2);
        if (tin.length === 11 && day < 60) {
          var current_year = (/* @__PURE__ */ new Date()).getFullYear().toString();
          var current_century = parseInt(current_year.slice(0, 2), 10);
          current_year = parseInt(current_year, 10);
          if (tin[6] === "-") {
            if (parseInt("".concat(current_century).concat(full_year), 10) > current_year) {
              full_year = "".concat(current_century - 1).concat(full_year);
            } else {
              full_year = "".concat(current_century).concat(full_year);
            }
          } else {
            full_year = "".concat(current_century - 1).concat(full_year);
            if (current_year - parseInt(full_year, 10) < 100) {
              return false;
            }
          }
        }
      }
      if (day > 60) {
        day -= 60;
      }
      if (day < 10) {
        day = "0".concat(day);
      }
      var date = "".concat(full_year, "/").concat(month, "/").concat(day);
      if (date.length === 8) {
        if (!(0, _isDate.default)(date, "YY/MM/DD")) {
          return false;
        }
      } else if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      return algorithms.luhnCheck(tin.replace(/\W/, ""));
    }
    __name(svSeCheck, "svSeCheck");
    function ukUaCheck(tin) {
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var multipliers = [
        -1,
        5,
        7,
        9,
        4,
        6,
        10,
        5,
        7
      ];
      var checksum = 0;
      for (var i = 0; i < multipliers.length; i++) {
        checksum += digits[i] * multipliers[i];
      }
      return checksum % 11 === 10 ? digits[9] === 0 : digits[9] === checksum % 11;
    }
    __name(ukUaCheck, "ukUaCheck");
    var taxIdFormat = {
      "bg-BG": /^\d{10}$/,
      "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
      "de-AT": /^\d{9}$/,
      "de-DE": /^[1-9]\d{10}$/,
      "dk-DK": /^\d{6}-{0,1}\d{4}$/,
      "el-CY": /^[09]\d{7}[A-Z]$/,
      "el-GR": /^([0-4]|[7-9])\d{8}$/,
      "en-CA": /^\d{9}$/,
      "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
      "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
      "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
      "es-AR": /(20|23|24|27|30|33|34)[0-9]{8}[0-9]/,
      "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
      "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
      "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
      "fr-BE": /^\d{11}$/,
      "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
      // Conforms both to official spec and provided example
      "fr-LU": /^\d{13}$/,
      "hr-HR": /^\d{11}$/,
      "hu-HU": /^8\d{9}$/,
      "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
      "lv-LV": /^\d{6}-{0,1}\d{5}$/,
      // Conforms both to DG TAXUD spec and original research
      "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
      "nl-NL": /^\d{9}$/,
      "pl-PL": /^\d{10,11}$/,
      "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
      "pt-PT": /^\d{9}$/,
      "ro-RO": /^\d{13}$/,
      "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
      "sl-SI": /^[1-9]\d{7}$/,
      "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/,
      "uk-UA": /^\d{10}$/
    };
    taxIdFormat["lb-LU"] = taxIdFormat["fr-LU"];
    taxIdFormat["lt-LT"] = taxIdFormat["et-EE"];
    taxIdFormat["nl-BE"] = taxIdFormat["fr-BE"];
    taxIdFormat["fr-CA"] = taxIdFormat["en-CA"];
    var taxIdCheck = {
      "bg-BG": bgBgCheck,
      "cs-CZ": csCzCheck,
      "de-AT": deAtCheck,
      "de-DE": deDeCheck,
      "dk-DK": dkDkCheck,
      "el-CY": elCyCheck,
      "el-GR": elGrCheck,
      "en-CA": isCanadianSIN,
      "en-IE": enIeCheck,
      "en-US": enUsCheck,
      "es-AR": esArCheck,
      "es-ES": esEsCheck,
      "et-EE": etEeCheck,
      "fi-FI": fiFiCheck,
      "fr-BE": frBeCheck,
      "fr-FR": frFrCheck,
      "fr-LU": frLuCheck,
      "hr-HR": hrHrCheck,
      "hu-HU": huHuCheck,
      "it-IT": itItCheck,
      "lv-LV": lvLvCheck,
      "mt-MT": mtMtCheck,
      "nl-NL": nlNlCheck,
      "pl-PL": plPlCheck,
      "pt-BR": ptBrCheck,
      "pt-PT": ptPtCheck,
      "ro-RO": roRoCheck,
      "sk-SK": skSkCheck,
      "sl-SI": slSiCheck,
      "sv-SE": svSeCheck,
      "uk-UA": ukUaCheck
    };
    taxIdCheck["lb-LU"] = taxIdCheck["fr-LU"];
    taxIdCheck["lt-LT"] = taxIdCheck["et-EE"];
    taxIdCheck["nl-BE"] = taxIdCheck["fr-BE"];
    taxIdCheck["fr-CA"] = taxIdCheck["en-CA"];
    var allsymbols = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g;
    var sanitizeRegexes = {
      "de-AT": allsymbols,
      "de-DE": /[\/\\]/g,
      "fr-BE": allsymbols
    };
    sanitizeRegexes["nl-BE"] = sanitizeRegexes["fr-BE"];
    function isTaxID(str) {
      var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
      (0, _assertString.default)(str);
      var strcopy = str.slice(0);
      if (locale in taxIdFormat) {
        if (locale in sanitizeRegexes) {
          strcopy = strcopy.replace(sanitizeRegexes[locale], "");
        }
        if (!taxIdFormat[locale].test(strcopy)) {
          return false;
        }
        if (locale in taxIdCheck) {
          return taxIdCheck[locale](strcopy);
        }
        return true;
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    __name(isTaxID, "isTaxID");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMobilePhone.js
var require_isMobilePhone = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMobilePhone.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isMobilePhone;
    exports.locales = void 0;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var phones = {
      "am-AM": /^(\+?374|0)(33|4[134]|55|77|88|9[13-689])\d{6}$/,
      "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
      "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
      "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
      "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
      "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
      "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
      "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
      "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
      "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
      "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
      "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
      "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
      "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
      "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
      "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
      "ar-TN": /^(\+?216)?[2459]\d{7}$/,
      "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
      "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
      "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
      "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
      "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
      "ca-AD": /^(\+376)?[346]\d{5}$/,
      "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
      "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
      "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
      "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
      "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
      "de-LU": /^(\+352)?((6\d1)\d{6})$/,
      "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
      "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
      "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
      "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
      "en-AU": /^(\+?61|0)4\d{8}$/,
      "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
      "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
      "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
      "en-GB": /^(\+?44|0)7\d{9}$/,
      "en-GG": /^(\+?44|0)1481\d{6}$/,
      "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
      "en-GY": /^(\+592|0)6\d{6}$/,
      "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
      "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
      "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
      "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
      "en-JM": /^(\+?876)?\d{7}$/,
      "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
      "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
      "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
      "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
      "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
      "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
      "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
      "en-MU": /^(\+?230|0)?\d{8}$/,
      "en-MW": /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
      "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
      "en-NG": /^(\+?234|0)?[789]\d{9}$/,
      "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
      "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
      "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
      "en-PH": /^(09|\+639)\d{9}$/,
      "en-RW": /^(\+?250|0)?[7]\d{8}$/,
      "en-SG": /^(\+65)?[3689]\d{7}$/,
      "en-SL": /^(\+?232|0)\d{8}$/,
      "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
      "en-UG": /^(\+?256|0)?[7]\d{8}$/,
      "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
      "en-ZA": /^(\+?27|0)\d{9}$/,
      "en-ZM": /^(\+?26)?09[567]\d{7}$/,
      "en-ZW": /^(\+263)[0-9]{9}$/,
      "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
      "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
      "es-BO": /^(\+?591)?(6|7)\d{7}$/,
      "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
      "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
      "es-CR": /^(\+506)?[2-8]\d{7}$/,
      "es-CU": /^(\+53|0053)?5\d{7}$/,
      "es-DO": /^(\+?1)?8[024]9\d{7}$/,
      "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
      "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
      "es-ES": /^(\+?34)?[6|7]\d{8}$/,
      "es-PE": /^(\+?51)?9\d{8}$/,
      "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
      "es-NI": /^(\+?505)\d{7,8}$/,
      "es-PA": /^(\+?507)\d{7,8}$/,
      "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
      "es-SV": /^(\+?503)?[67]\d{7}$/,
      "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
      "es-VE": /^(\+?58)?(2|4)\d{9}$/,
      "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
      "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
      "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
      "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
      "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
      "fr-BF": /^(\+226|0)[67]\d{7}$/,
      "fr-BJ": /^(\+229)\d{8}$/,
      "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
      "fr-CM": /^(\+?237)6[0-9]{8}$/,
      "fr-FR": /^(\+?33|0)[67]\d{8}$/,
      "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
      "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
      "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
      "fr-PF": /^(\+?689)?8[789]\d{6}$/,
      "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
      "fr-WF": /^(\+681)?\d{6}$/,
      "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
      "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
      "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
      "ir-IR": /^(\+98|0)?9\d{9}$/,
      "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
      "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
      "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
      "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
      "kk-KZ": /^(\+?7|8)?7\d{9}$/,
      "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
      "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
      "ky-KG": /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
      "lt-LT": /^(\+370|8)\d{8}$/,
      "lv-LV": /^(\+?371)2\d{7}$/,
      "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
      "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
      "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
      "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
      "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
      "nb-NO": /^(\+?47)?[49]\d{7}$/,
      "ne-NP": /^(\+?977)?9[78]\d{8}$/,
      "nl-BE": /^(\+?32|0)4\d{8}$/,
      "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
      "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
      "nn-NO": /^(\+?47)?[49]\d{7}$/,
      "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
      "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
      "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
      "pt-AO": /^(\+244)\d{9}$/,
      "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
      "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
      "ru-RU": /^(\+?7|8)?9\d{9}$/,
      "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
      "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
      "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
      "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
      "sq-AL": /^(\+355|0)6[789]\d{6}$/,
      "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
      "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
      "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
      "th-TH": /^(\+66|66|0)\d{9}$/,
      "tr-TR": /^(\+?90|0)?5\d{9}$/,
      "tk-TM": /^(\+993|993|8)\d{8}$/,
      "uk-UA": /^(\+?38|8)?0\d{9}$/,
      "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
      "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
      "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
      "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
      "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
      "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
      "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
      "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
    };
    phones["en-CA"] = phones["en-US"];
    phones["fr-CA"] = phones["en-CA"];
    phones["fr-BE"] = phones["nl-BE"];
    phones["zh-HK"] = phones["en-HK"];
    phones["zh-MO"] = phones["en-MO"];
    phones["ga-IE"] = phones["en-IE"];
    phones["fr-CH"] = phones["de-CH"];
    phones["it-CH"] = phones["fr-CH"];
    function isMobilePhone(str, locale, options) {
      (0, _assertString.default)(str);
      if (options && options.strictMode && !str.startsWith("+")) {
        return false;
      }
      if (Array.isArray(locale)) {
        return locale.some(function(key2) {
          if (phones.hasOwnProperty(key2)) {
            var phone2 = phones[key2];
            if (phone2.test(str)) {
              return true;
            }
          }
          return false;
        });
      } else if (locale in phones) {
        return phones[locale].test(str);
      } else if (!locale || locale === "any") {
        for (var key in phones) {
          if (phones.hasOwnProperty(key)) {
            var phone = phones[key];
            if (phone.test(str)) {
              return true;
            }
          }
        }
        return false;
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    __name(isMobilePhone, "isMobilePhone");
    var locales = exports.locales = Object.keys(phones);
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isEthereumAddress.js
var require_isEthereumAddress = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isEthereumAddress.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isEthereumAddress;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var eth = /^(0x)[0-9a-f]{40}$/i;
    function isEthereumAddress(str) {
      (0, _assertString.default)(str);
      return eth.test(str);
    }
    __name(isEthereumAddress, "isEthereumAddress");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isCurrency.js
var require_isCurrency = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isCurrency.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isCurrency;
    var _merge = _interopRequireDefault(require_merge());
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function currencyRegex(options) {
      var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
      options.digits_after_decimal.forEach(function(digit, index) {
        if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
      });
      var symbol = "(".concat(options.symbol.replace(/\W/, function(m) {
        return "\\".concat(m);
      }), ")").concat(options.require_symbol ? "" : "?"), negative = "-?", whole_dollar_amount_without_sep = "[1-9]\\d*", whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"), valid_whole_dollar_amounts = [
        "0",
        whole_dollar_amount_without_sep,
        whole_dollar_amount_with_sep
      ], whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join("|"), ")?"), decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? "" : "?");
      var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : "");
      if (options.allow_negatives && !options.parens_for_negatives) {
        if (options.negative_sign_after_digits) {
          pattern += negative;
        } else if (options.negative_sign_before_digits) {
          pattern = negative + pattern;
        }
      }
      if (options.allow_negative_sign_placeholder) {
        pattern = "( (?!\\-))?".concat(pattern);
      } else if (options.allow_space_after_symbol) {
        pattern = " ?".concat(pattern);
      } else if (options.allow_space_after_digits) {
        pattern += "( (?!$))?";
      }
      if (options.symbol_after_digits) {
        pattern += symbol;
      } else {
        pattern = symbol + pattern;
      }
      if (options.allow_negatives) {
        if (options.parens_for_negatives) {
          pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
        } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
          pattern = negative + pattern;
        }
      }
      return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
    }
    __name(currencyRegex, "currencyRegex");
    var default_currency_options = {
      symbol: "$",
      require_symbol: false,
      allow_space_after_symbol: false,
      symbol_after_digits: false,
      allow_negatives: true,
      parens_for_negatives: false,
      negative_sign_before_digits: false,
      negative_sign_after_digits: false,
      allow_negative_sign_placeholder: false,
      thousands_separator: ",",
      decimal_separator: ".",
      allow_decimal: true,
      require_decimal: false,
      digits_after_decimal: [
        2
      ],
      allow_space_after_digits: false
    };
    function isCurrency(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_currency_options);
      return currencyRegex(options).test(str);
    }
    __name(isCurrency, "isCurrency");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBtcAddress.js
var require_isBtcAddress = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBtcAddress.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isBtcAddress;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var bech32 = /^(bc1)[a-z0-9]{25,39}$/;
    var base58 = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
    function isBtcAddress(str) {
      (0, _assertString.default)(str);
      return bech32.test(str) || base58.test(str);
    }
    __name(isBtcAddress, "isBtcAddress");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO6346.js
var require_isISO6346 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO6346.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.isFreightContainerID = void 0;
    exports.isISO6346 = isISO6346;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var isISO6346Str = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/;
    var isDigit = /^[0-9]$/;
    function isISO6346(str) {
      (0, _assertString.default)(str);
      str = str.toUpperCase();
      if (!isISO6346Str.test(str)) return false;
      if (str.length === 11) {
        var sum = 0;
        for (var i = 0; i < str.length - 1; i++) {
          if (!isDigit.test(str[i])) {
            var convertedCode = void 0;
            var letterCode = str.charCodeAt(i) - 55;
            if (letterCode < 11) convertedCode = letterCode;
            else if (letterCode >= 11 && letterCode <= 20) convertedCode = 12 + letterCode % 11;
            else if (letterCode >= 21 && letterCode <= 30) convertedCode = 23 + letterCode % 21;
            else convertedCode = 34 + letterCode % 31;
            sum += convertedCode * Math.pow(2, i);
          } else sum += str[i] * Math.pow(2, i);
        }
        var checkSumDigit = sum % 11;
        return Number(str[str.length - 1]) === checkSumDigit;
      }
      return true;
    }
    __name(isISO6346, "isISO6346");
    var isFreightContainerID = exports.isFreightContainerID = isISO6346;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO6391.js
var require_isISO6391 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO6391.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isISO6391;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var isISO6391Set = /* @__PURE__ */ new Set([
      "aa",
      "ab",
      "ae",
      "af",
      "ak",
      "am",
      "an",
      "ar",
      "as",
      "av",
      "ay",
      "az",
      "az",
      "ba",
      "be",
      "bg",
      "bh",
      "bi",
      "bm",
      "bn",
      "bo",
      "br",
      "bs",
      "ca",
      "ce",
      "ch",
      "co",
      "cr",
      "cs",
      "cu",
      "cv",
      "cy",
      "da",
      "de",
      "dv",
      "dz",
      "ee",
      "el",
      "en",
      "eo",
      "es",
      "et",
      "eu",
      "fa",
      "ff",
      "fi",
      "fj",
      "fo",
      "fr",
      "fy",
      "ga",
      "gd",
      "gl",
      "gn",
      "gu",
      "gv",
      "ha",
      "he",
      "hi",
      "ho",
      "hr",
      "ht",
      "hu",
      "hy",
      "hz",
      "ia",
      "id",
      "ie",
      "ig",
      "ii",
      "ik",
      "io",
      "is",
      "it",
      "iu",
      "ja",
      "jv",
      "ka",
      "kg",
      "ki",
      "kj",
      "kk",
      "kl",
      "km",
      "kn",
      "ko",
      "kr",
      "ks",
      "ku",
      "kv",
      "kw",
      "ky",
      "la",
      "lb",
      "lg",
      "li",
      "ln",
      "lo",
      "lt",
      "lu",
      "lv",
      "mg",
      "mh",
      "mi",
      "mk",
      "ml",
      "mn",
      "mr",
      "ms",
      "mt",
      "my",
      "na",
      "nb",
      "nd",
      "ne",
      "ng",
      "nl",
      "nn",
      "no",
      "nr",
      "nv",
      "ny",
      "oc",
      "oj",
      "om",
      "or",
      "os",
      "pa",
      "pi",
      "pl",
      "ps",
      "pt",
      "qu",
      "rm",
      "rn",
      "ro",
      "ru",
      "rw",
      "sa",
      "sc",
      "sd",
      "se",
      "sg",
      "si",
      "sk",
      "sl",
      "sm",
      "sn",
      "so",
      "sq",
      "sr",
      "ss",
      "st",
      "su",
      "sv",
      "sw",
      "ta",
      "te",
      "tg",
      "th",
      "ti",
      "tk",
      "tl",
      "tn",
      "to",
      "tr",
      "ts",
      "tt",
      "tw",
      "ty",
      "ug",
      "uk",
      "ur",
      "uz",
      "ve",
      "vi",
      "vo",
      "wa",
      "wo",
      "xh",
      "yi",
      "yo",
      "za",
      "zh",
      "zu"
    ]);
    function isISO6391(str) {
      (0, _assertString.default)(str);
      return isISO6391Set.has(str);
    }
    __name(isISO6391, "isISO6391");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO8601.js
var require_isISO8601 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO8601.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isISO8601;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
    var iso8601StrictSeparator = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
    var isValidDate = /* @__PURE__ */ __name(function isValidDate2(str) {
      var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
      if (ordinalMatch) {
        var oYear = Number(ordinalMatch[1]);
        var oDay = Number(ordinalMatch[2]);
        if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
        return oDay <= 365;
      }
      var match2 = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
      var year = match2[1];
      var month = match2[2];
      var day = match2[3];
      var monthString = month ? "0".concat(month).slice(-2) : month;
      var dayString = day ? "0".concat(day).slice(-2) : day;
      var d = new Date("".concat(year, "-").concat(monthString || "01", "-").concat(dayString || "01"));
      if (month && day) {
        return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
      }
      return true;
    }, "isValidDate");
    function isISO8601(str) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, _assertString.default)(str);
      var check = options.strictSeparator ? iso8601StrictSeparator.test(str) : iso8601.test(str);
      if (check && options.strict) return isValidDate(str);
      return check;
    }
    __name(isISO8601, "isISO8601");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isRFC3339.js
var require_isRFC3339 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isRFC3339.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isRFC3339;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var dateFullYear = /[0-9]{4}/;
    var dateMonth = /(0[1-9]|1[0-2])/;
    var dateMDay = /([12]\d|0[1-9]|3[01])/;
    var timeHour = /([01][0-9]|2[0-3])/;
    var timeMinute = /[0-5][0-9]/;
    var timeSecond = /([0-5][0-9]|60)/;
    var timeSecFrac = /(\.[0-9]+)?/;
    var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
    var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
    var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
    var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
    var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
    var rfc3339 = new RegExp("^".concat(fullDate.source, "[ tT]").concat(fullTime.source, "$"));
    function isRFC3339(str) {
      (0, _assertString.default)(str);
      return rfc3339.test(str);
    }
    __name(isRFC3339, "isRFC3339");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO31661Alpha3.js
var require_isISO31661Alpha3 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO31661Alpha3.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isISO31661Alpha3;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var validISO31661Alpha3CountriesCodes = /* @__PURE__ */ new Set([
      "AFG",
      "ALA",
      "ALB",
      "DZA",
      "ASM",
      "AND",
      "AGO",
      "AIA",
      "ATA",
      "ATG",
      "ARG",
      "ARM",
      "ABW",
      "AUS",
      "AUT",
      "AZE",
      "BHS",
      "BHR",
      "BGD",
      "BRB",
      "BLR",
      "BEL",
      "BLZ",
      "BEN",
      "BMU",
      "BTN",
      "BOL",
      "BES",
      "BIH",
      "BWA",
      "BVT",
      "BRA",
      "IOT",
      "BRN",
      "BGR",
      "BFA",
      "BDI",
      "KHM",
      "CMR",
      "CAN",
      "CPV",
      "CYM",
      "CAF",
      "TCD",
      "CHL",
      "CHN",
      "CXR",
      "CCK",
      "COL",
      "COM",
      "COG",
      "COD",
      "COK",
      "CRI",
      "CIV",
      "HRV",
      "CUB",
      "CUW",
      "CYP",
      "CZE",
      "DNK",
      "DJI",
      "DMA",
      "DOM",
      "ECU",
      "EGY",
      "SLV",
      "GNQ",
      "ERI",
      "EST",
      "ETH",
      "FLK",
      "FRO",
      "FJI",
      "FIN",
      "FRA",
      "GUF",
      "PYF",
      "ATF",
      "GAB",
      "GMB",
      "GEO",
      "DEU",
      "GHA",
      "GIB",
      "GRC",
      "GRL",
      "GRD",
      "GLP",
      "GUM",
      "GTM",
      "GGY",
      "GIN",
      "GNB",
      "GUY",
      "HTI",
      "HMD",
      "VAT",
      "HND",
      "HKG",
      "HUN",
      "ISL",
      "IND",
      "IDN",
      "IRN",
      "IRQ",
      "IRL",
      "IMN",
      "ISR",
      "ITA",
      "JAM",
      "JPN",
      "JEY",
      "JOR",
      "KAZ",
      "KEN",
      "KIR",
      "PRK",
      "KOR",
      "KWT",
      "KGZ",
      "LAO",
      "LVA",
      "LBN",
      "LSO",
      "LBR",
      "LBY",
      "LIE",
      "LTU",
      "LUX",
      "MAC",
      "MKD",
      "MDG",
      "MWI",
      "MYS",
      "MDV",
      "MLI",
      "MLT",
      "MHL",
      "MTQ",
      "MRT",
      "MUS",
      "MYT",
      "MEX",
      "FSM",
      "MDA",
      "MCO",
      "MNG",
      "MNE",
      "MSR",
      "MAR",
      "MOZ",
      "MMR",
      "NAM",
      "NRU",
      "NPL",
      "NLD",
      "NCL",
      "NZL",
      "NIC",
      "NER",
      "NGA",
      "NIU",
      "NFK",
      "MNP",
      "NOR",
      "OMN",
      "PAK",
      "PLW",
      "PSE",
      "PAN",
      "PNG",
      "PRY",
      "PER",
      "PHL",
      "PCN",
      "POL",
      "PRT",
      "PRI",
      "QAT",
      "REU",
      "ROU",
      "RUS",
      "RWA",
      "BLM",
      "SHN",
      "KNA",
      "LCA",
      "MAF",
      "SPM",
      "VCT",
      "WSM",
      "SMR",
      "STP",
      "SAU",
      "SEN",
      "SRB",
      "SYC",
      "SLE",
      "SGP",
      "SXM",
      "SVK",
      "SVN",
      "SLB",
      "SOM",
      "ZAF",
      "SGS",
      "SSD",
      "ESP",
      "LKA",
      "SDN",
      "SUR",
      "SJM",
      "SWZ",
      "SWE",
      "CHE",
      "SYR",
      "TWN",
      "TJK",
      "TZA",
      "THA",
      "TLS",
      "TGO",
      "TKL",
      "TON",
      "TTO",
      "TUN",
      "TUR",
      "TKM",
      "TCA",
      "TUV",
      "UGA",
      "UKR",
      "ARE",
      "GBR",
      "USA",
      "UMI",
      "URY",
      "UZB",
      "VUT",
      "VEN",
      "VNM",
      "VGB",
      "VIR",
      "WLF",
      "ESH",
      "YEM",
      "ZMB",
      "ZWE"
    ]);
    function isISO31661Alpha3(str) {
      (0, _assertString.default)(str);
      return validISO31661Alpha3CountriesCodes.has(str.toUpperCase());
    }
    __name(isISO31661Alpha3, "isISO31661Alpha3");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO4217.js
var require_isISO4217 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isISO4217.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.CurrencyCodes = void 0;
    exports.default = isISO4217;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var validISO4217CurrencyCodes = /* @__PURE__ */ new Set([
      "AED",
      "AFN",
      "ALL",
      "AMD",
      "ANG",
      "AOA",
      "ARS",
      "AUD",
      "AWG",
      "AZN",
      "BAM",
      "BBD",
      "BDT",
      "BGN",
      "BHD",
      "BIF",
      "BMD",
      "BND",
      "BOB",
      "BOV",
      "BRL",
      "BSD",
      "BTN",
      "BWP",
      "BYN",
      "BZD",
      "CAD",
      "CDF",
      "CHE",
      "CHF",
      "CHW",
      "CLF",
      "CLP",
      "CNY",
      "COP",
      "COU",
      "CRC",
      "CUC",
      "CUP",
      "CVE",
      "CZK",
      "DJF",
      "DKK",
      "DOP",
      "DZD",
      "EGP",
      "ERN",
      "ETB",
      "EUR",
      "FJD",
      "FKP",
      "GBP",
      "GEL",
      "GHS",
      "GIP",
      "GMD",
      "GNF",
      "GTQ",
      "GYD",
      "HKD",
      "HNL",
      "HRK",
      "HTG",
      "HUF",
      "IDR",
      "ILS",
      "INR",
      "IQD",
      "IRR",
      "ISK",
      "JMD",
      "JOD",
      "JPY",
      "KES",
      "KGS",
      "KHR",
      "KMF",
      "KPW",
      "KRW",
      "KWD",
      "KYD",
      "KZT",
      "LAK",
      "LBP",
      "LKR",
      "LRD",
      "LSL",
      "LYD",
      "MAD",
      "MDL",
      "MGA",
      "MKD",
      "MMK",
      "MNT",
      "MOP",
      "MRU",
      "MUR",
      "MVR",
      "MWK",
      "MXN",
      "MXV",
      "MYR",
      "MZN",
      "NAD",
      "NGN",
      "NIO",
      "NOK",
      "NPR",
      "NZD",
      "OMR",
      "PAB",
      "PEN",
      "PGK",
      "PHP",
      "PKR",
      "PLN",
      "PYG",
      "QAR",
      "RON",
      "RSD",
      "RUB",
      "RWF",
      "SAR",
      "SBD",
      "SCR",
      "SDG",
      "SEK",
      "SGD",
      "SHP",
      "SLE",
      "SLL",
      "SOS",
      "SRD",
      "SSP",
      "STN",
      "SVC",
      "SYP",
      "SZL",
      "THB",
      "TJS",
      "TMT",
      "TND",
      "TOP",
      "TRY",
      "TTD",
      "TWD",
      "TZS",
      "UAH",
      "UGX",
      "USD",
      "USN",
      "UYI",
      "UYU",
      "UYW",
      "UZS",
      "VES",
      "VND",
      "VUV",
      "WST",
      "XAF",
      "XAG",
      "XAU",
      "XBA",
      "XBB",
      "XBC",
      "XBD",
      "XCD",
      "XDR",
      "XOF",
      "XPD",
      "XPF",
      "XPT",
      "XSU",
      "XTS",
      "XUA",
      "XXX",
      "YER",
      "ZAR",
      "ZMW",
      "ZWL"
    ]);
    function isISO4217(str) {
      (0, _assertString.default)(str);
      return validISO4217CurrencyCodes.has(str.toUpperCase());
    }
    __name(isISO4217, "isISO4217");
    var CurrencyCodes = exports.CurrencyCodes = validISO4217CurrencyCodes;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBase32.js
var require_isBase32 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBase32.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isBase32;
    var _assertString = _interopRequireDefault(require_assertString());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var base32 = /^[A-Z2-7]+=*$/;
    var crockfordBase32 = /^[A-HJKMNP-TV-Z0-9]+$/;
    var defaultBase32Options = {
      crockford: false
    };
    function isBase32(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, defaultBase32Options);
      if (options.crockford) {
        return crockfordBase32.test(str);
      }
      var len = str.length;
      if (len % 8 === 0 && base32.test(str)) {
        return true;
      }
      return false;
    }
    __name(isBase32, "isBase32");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBase58.js
var require_isBase58 = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isBase58.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isBase58;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var base58Reg = /^[A-HJ-NP-Za-km-z1-9]*$/;
    function isBase58(str) {
      (0, _assertString.default)(str);
      if (base58Reg.test(str)) {
        return true;
      }
      return false;
    }
    __name(isBase58, "isBase58");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isDataURI.js
var require_isDataURI = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isDataURI.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isDataURI;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var validMediaType = /^[a-z]+\/[a-z0-9\-\+\._]+$/i;
    var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
    var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
    function isDataURI(str) {
      (0, _assertString.default)(str);
      var data = str.split(",");
      if (data.length < 2) {
        return false;
      }
      var attributes = data.shift().trim().split(";");
      var schemeAndMediaType = attributes.shift();
      if (schemeAndMediaType.slice(0, 5) !== "data:") {
        return false;
      }
      var mediaType = schemeAndMediaType.slice(5);
      if (mediaType !== "" && !validMediaType.test(mediaType)) {
        return false;
      }
      for (var i = 0; i < attributes.length; i++) {
        if (!(i === attributes.length - 1 && attributes[i].toLowerCase() === "base64") && !validAttribute.test(attributes[i])) {
          return false;
        }
      }
      for (var _i = 0; _i < data.length; _i++) {
        if (!validData.test(data[_i])) {
          return false;
        }
      }
      return true;
    }
    __name(isDataURI, "isDataURI");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMagnetURI.js
var require_isMagnetURI = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMagnetURI.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isMagnetURI;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var magnetURIComponent = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
    function isMagnetURI(url) {
      (0, _assertString.default)(url);
      if (url.indexOf("magnet:?") !== 0) {
        return false;
      }
      return magnetURIComponent.test(url);
    }
    __name(isMagnetURI, "isMagnetURI");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/rtrim.js
var require_rtrim = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/rtrim.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = rtrim;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function rtrim(str, chars) {
      (0, _assertString.default)(str);
      if (chars) {
        var pattern = new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
        return str.replace(pattern, "");
      }
      var strIndex = str.length - 1;
      while (/\s/.test(str.charAt(strIndex))) {
        strIndex -= 1;
      }
      return str.slice(0, strIndex + 1);
    }
    __name(rtrim, "rtrim");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/ltrim.js
var require_ltrim = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/ltrim.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = ltrim;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function ltrim(str, chars) {
      (0, _assertString.default)(str);
      var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
      return str.replace(pattern, "");
    }
    __name(ltrim, "ltrim");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/trim.js
var require_trim = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/trim.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = trim;
    var _rtrim = _interopRequireDefault(require_rtrim());
    var _ltrim = _interopRequireDefault(require_ltrim());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function trim(str, chars) {
      return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
    }
    __name(trim, "trim");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMailtoURI.js
var require_isMailtoURI = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMailtoURI.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isMailtoURI;
    var _trim = _interopRequireDefault(require_trim());
    var _isEmail = _interopRequireDefault(require_isEmail());
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    __name(_slicedToArray, "_slicedToArray");
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    __name(_nonIterableRest, "_nonIterableRest");
    function _iterableToArrayLimit(r2, l3) {
      var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
      if (null != t2) {
        var e2, n3, i, u, a = [], f = true, o2 = false;
        try {
          if (i = (t2 = t2.call(r2)).next, 0 === l3) {
            if (Object(t2) !== t2) return;
            f = false;
          } else for (; !(f = (e2 = i.call(t2)).done) && (a.push(e2.value), a.length !== l3); f = true) ;
        } catch (r3) {
          o2 = true, n3 = r3;
        } finally {
          try {
            if (!f && null != t2.return && (u = t2.return(), Object(u) !== u)) return;
          } finally {
            if (o2) throw n3;
          }
        }
        return a;
      }
    }
    __name(_iterableToArrayLimit, "_iterableToArrayLimit");
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) return arr;
    }
    __name(_arrayWithHoles, "_arrayWithHoles");
    function _createForOfIteratorHelper(o2, allowArrayLike) {
      var it = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
      if (!it) {
        if (Array.isArray(o2) || (it = _unsupportedIterableToArray(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
          if (it) o2 = it;
          var i = 0;
          var F = /* @__PURE__ */ __name(function F2() {
          }, "F");
          return {
            s: F,
            n: /* @__PURE__ */ __name(function n3() {
              if (i >= o2.length) return {
                done: true
              };
              return {
                done: false,
                value: o2[i++]
              };
            }, "n"),
            e: /* @__PURE__ */ __name(function e2(_e) {
              throw _e;
            }, "e"),
            f: F
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var normalCompletion = true, didErr = false, err;
      return {
        s: /* @__PURE__ */ __name(function s3() {
          it = it.call(o2);
        }, "s"),
        n: /* @__PURE__ */ __name(function n3() {
          var step = it.next();
          normalCompletion = step.done;
          return step;
        }, "n"),
        e: /* @__PURE__ */ __name(function e2(_e2) {
          didErr = true;
          err = _e2;
        }, "e"),
        f: /* @__PURE__ */ __name(function f() {
          try {
            if (!normalCompletion && it.return != null) it.return();
          } finally {
            if (didErr) throw err;
          }
        }, "f")
      };
    }
    __name(_createForOfIteratorHelper, "_createForOfIteratorHelper");
    function _unsupportedIterableToArray(o2, minLen) {
      if (!o2) return;
      if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
      var n3 = Object.prototype.toString.call(o2).slice(8, -1);
      if (n3 === "Object" && o2.constructor) n3 = o2.constructor.name;
      if (n3 === "Map" || n3 === "Set") return Array.from(o2);
      if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3)) return _arrayLikeToArray(o2, minLen);
    }
    __name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    __name(_arrayLikeToArray, "_arrayLikeToArray");
    function parseMailtoQueryString(queryString) {
      var allowedParams = /* @__PURE__ */ new Set([
        "subject",
        "body",
        "cc",
        "bcc"
      ]), query = {
        cc: "",
        bcc: ""
      };
      var isParseFailed = false;
      var queryParams = queryString.split("&");
      if (queryParams.length > 4) {
        return false;
      }
      var _iterator = _createForOfIteratorHelper(queryParams), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var q = _step.value;
          var _q$split = q.split("="), _q$split2 = _slicedToArray(_q$split, 2), key = _q$split2[0], value = _q$split2[1];
          if (key && !allowedParams.has(key)) {
            isParseFailed = true;
            break;
          }
          if (value && (key === "cc" || key === "bcc")) {
            query[key] = value;
          }
          if (key) {
            allowedParams.delete(key);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return isParseFailed ? false : query;
    }
    __name(parseMailtoQueryString, "parseMailtoQueryString");
    function isMailtoURI(url, options) {
      (0, _assertString.default)(url);
      if (url.indexOf("mailto:") !== 0) {
        return false;
      }
      var _url$replace$split = url.replace("mailto:", "").split("?"), _url$replace$split2 = _slicedToArray(_url$replace$split, 2), to = _url$replace$split2[0], _url$replace$split2$ = _url$replace$split2[1], queryString = _url$replace$split2$ === void 0 ? "" : _url$replace$split2$;
      if (!to && !queryString) {
        return true;
      }
      var query = parseMailtoQueryString(queryString);
      if (!query) {
        return false;
      }
      return "".concat(to, ",").concat(query.cc, ",").concat(query.bcc).split(",").every(function(email) {
        email = (0, _trim.default)(email, " ");
        if (email) {
          return (0, _isEmail.default)(email, options);
        }
        return true;
      });
    }
    __name(isMailtoURI, "isMailtoURI");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMimeType.js
var require_isMimeType = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isMimeType.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isMimeType;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i;
    var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i;
    var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
    function isMimeType(str) {
      (0, _assertString.default)(str);
      return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
    }
    __name(isMimeType, "isMimeType");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLatLong.js
var require_isLatLong = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLatLong.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isLatLong;
    var _assertString = _interopRequireDefault(require_assertString());
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
    var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
    var latDMS = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
    var longDMS = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
    var defaultLatLongOptions = {
      checkDMS: false
    };
    function isLatLong(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, defaultLatLongOptions);
      if (!str.includes(",")) return false;
      var pair = str.split(",");
      if (pair[0].startsWith("(") && !pair[1].endsWith(")") || pair[1].endsWith(")") && !pair[0].startsWith("(")) return false;
      if (options.checkDMS) {
        return latDMS.test(pair[0]) && longDMS.test(pair[1]);
      }
      return lat.test(pair[0]) && long.test(pair[1]);
    }
    __name(isLatLong, "isLatLong");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isPostalCode.js
var require_isPostalCode = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isPostalCode.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isPostalCode;
    exports.locales = void 0;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var threeDigit = /^\d{3}$/;
    var fourDigit = /^\d{4}$/;
    var fiveDigit = /^\d{5}$/;
    var sixDigit = /^\d{6}$/;
    var patterns = {
      AD: /^AD\d{3}$/,
      AT: fourDigit,
      AU: fourDigit,
      AZ: /^AZ\d{4}$/,
      BA: /^([7-8]\d{4}$)/,
      BE: fourDigit,
      BG: fourDigit,
      BR: /^\d{5}-\d{3}$/,
      BY: /^2[1-4]\d{4}$/,
      CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
      CH: fourDigit,
      CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
      CZ: /^\d{3}\s?\d{2}$/,
      DE: fiveDigit,
      DK: fourDigit,
      DO: fiveDigit,
      DZ: fiveDigit,
      EE: fiveDigit,
      ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
      FI: fiveDigit,
      FR: /^\d{2}\s?\d{3}$/,
      GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
      GR: /^\d{3}\s?\d{2}$/,
      HR: /^([1-5]\d{4}$)/,
      HT: /^HT\d{4}$/,
      HU: fourDigit,
      ID: fiveDigit,
      IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
      IL: /^(\d{5}|\d{7})$/,
      IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
      IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
      IS: threeDigit,
      IT: fiveDigit,
      JP: /^\d{3}\-\d{4}$/,
      KE: fiveDigit,
      KR: /^(\d{5}|\d{6})$/,
      LI: /^(948[5-9]|949[0-7])$/,
      LT: /^LT\-\d{5}$/,
      LU: fourDigit,
      LV: /^LV\-\d{4}$/,
      LK: fiveDigit,
      MG: threeDigit,
      MX: fiveDigit,
      MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
      MY: fiveDigit,
      NL: /^[1-9]\d{3}\s?(?!sa|sd|ss)[a-z]{2}$/i,
      NO: fourDigit,
      NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
      NZ: fourDigit,
      PL: /^\d{2}\-\d{3}$/,
      PR: /^00[679]\d{2}([ -]\d{4})?$/,
      PT: /^\d{4}\-\d{3}?$/,
      RO: sixDigit,
      RU: sixDigit,
      SA: fiveDigit,
      SE: /^[1-9]\d{2}\s?\d{2}$/,
      SG: sixDigit,
      SI: fourDigit,
      SK: /^\d{3}\s?\d{2}$/,
      TH: fiveDigit,
      TN: fourDigit,
      TW: /^\d{3}(\d{2})?$/,
      UA: fiveDigit,
      US: /^\d{5}(-\d{4})?$/,
      ZA: fourDigit,
      ZM: fiveDigit
    };
    var locales = exports.locales = Object.keys(patterns);
    function isPostalCode(str, locale) {
      (0, _assertString.default)(str);
      if (locale in patterns) {
        return patterns[locale].test(str);
      } else if (locale === "any") {
        for (var key in patterns) {
          if (patterns.hasOwnProperty(key)) {
            var pattern = patterns[key];
            if (pattern.test(str)) {
              return true;
            }
          }
        }
        return false;
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    __name(isPostalCode, "isPostalCode");
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/escape.js
var require_escape = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/escape.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = escape3;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function escape3(str) {
      (0, _assertString.default)(str);
      return str.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
    }
    __name(escape3, "escape");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/unescape.js
var require_unescape = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/unescape.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = unescape2;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function unescape2(str) {
      (0, _assertString.default)(str);
      return str.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
    }
    __name(unescape2, "unescape");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/blacklist.js
var require_blacklist = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/blacklist.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = blacklist;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function blacklist(str, chars) {
      (0, _assertString.default)(str);
      return str.replace(new RegExp("[".concat(chars, "]+"), "g"), "");
    }
    __name(blacklist, "blacklist");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/stripLow.js
var require_stripLow = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/stripLow.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = stripLow;
    var _assertString = _interopRequireDefault(require_assertString());
    var _blacklist = _interopRequireDefault(require_blacklist());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function stripLow(str, keep_new_lines) {
      (0, _assertString.default)(str);
      var chars = keep_new_lines ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
      return (0, _blacklist.default)(str, chars);
    }
    __name(stripLow, "stripLow");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/whitelist.js
var require_whitelist = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/whitelist.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = whitelist;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function whitelist(str, chars) {
      (0, _assertString.default)(str);
      return str.replace(new RegExp("[^".concat(chars, "]+"), "g"), "");
    }
    __name(whitelist, "whitelist");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isWhitelisted.js
var require_isWhitelisted = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isWhitelisted.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isWhitelisted;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    function isWhitelisted(str, chars) {
      (0, _assertString.default)(str);
      for (var i = str.length - 1; i >= 0; i--) {
        if (chars.indexOf(str[i]) === -1) {
          return false;
        }
      }
      return true;
    }
    __name(isWhitelisted, "isWhitelisted");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/normalizeEmail.js
var require_normalizeEmail = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/normalizeEmail.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = normalizeEmail;
    var _merge = _interopRequireDefault(require_merge());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var default_normalize_email_options = {
      // The following options apply to all email addresses
      // Lowercases the local part of the email address.
      // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
      // The domain is always lowercased, as per RFC 1035
      all_lowercase: true,
      // The following conversions are specific to GMail
      // Lowercases the local part of the GMail address (known to be case-insensitive)
      gmail_lowercase: true,
      // Removes dots from the local part of the email address, as that's ignored by GMail
      gmail_remove_dots: true,
      // Removes the subaddress (e.g. "+foo") from the email address
      gmail_remove_subaddress: true,
      // Conversts the googlemail.com domain to gmail.com
      gmail_convert_googlemaildotcom: true,
      // The following conversions are specific to Outlook.com / Windows Live / Hotmail
      // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
      outlookdotcom_lowercase: true,
      // Removes the subaddress (e.g. "+foo") from the email address
      outlookdotcom_remove_subaddress: true,
      // The following conversions are specific to Yahoo
      // Lowercases the local part of the Yahoo address (known to be case-insensitive)
      yahoo_lowercase: true,
      // Removes the subaddress (e.g. "-foo") from the email address
      yahoo_remove_subaddress: true,
      // The following conversions are specific to Yandex
      // Lowercases the local part of the Yandex address (known to be case-insensitive)
      yandex_lowercase: true,
      // The following conversions are specific to iCloud
      // Lowercases the local part of the iCloud address (known to be case-insensitive)
      icloud_lowercase: true,
      // Removes the subaddress (e.g. "+foo") from the email address
      icloud_remove_subaddress: true
    };
    var icloud_domains = [
      "icloud.com",
      "me.com"
    ];
    var outlookdotcom_domains = [
      "hotmail.at",
      "hotmail.be",
      "hotmail.ca",
      "hotmail.cl",
      "hotmail.co.il",
      "hotmail.co.nz",
      "hotmail.co.th",
      "hotmail.co.uk",
      "hotmail.com",
      "hotmail.com.ar",
      "hotmail.com.au",
      "hotmail.com.br",
      "hotmail.com.gr",
      "hotmail.com.mx",
      "hotmail.com.pe",
      "hotmail.com.tr",
      "hotmail.com.vn",
      "hotmail.cz",
      "hotmail.de",
      "hotmail.dk",
      "hotmail.es",
      "hotmail.fr",
      "hotmail.hu",
      "hotmail.id",
      "hotmail.ie",
      "hotmail.in",
      "hotmail.it",
      "hotmail.jp",
      "hotmail.kr",
      "hotmail.lv",
      "hotmail.my",
      "hotmail.ph",
      "hotmail.pt",
      "hotmail.sa",
      "hotmail.sg",
      "hotmail.sk",
      "live.be",
      "live.co.uk",
      "live.com",
      "live.com.ar",
      "live.com.mx",
      "live.de",
      "live.es",
      "live.eu",
      "live.fr",
      "live.it",
      "live.nl",
      "msn.com",
      "outlook.at",
      "outlook.be",
      "outlook.cl",
      "outlook.co.il",
      "outlook.co.nz",
      "outlook.co.th",
      "outlook.com",
      "outlook.com.ar",
      "outlook.com.au",
      "outlook.com.br",
      "outlook.com.gr",
      "outlook.com.pe",
      "outlook.com.tr",
      "outlook.com.vn",
      "outlook.cz",
      "outlook.de",
      "outlook.dk",
      "outlook.es",
      "outlook.fr",
      "outlook.hu",
      "outlook.id",
      "outlook.ie",
      "outlook.in",
      "outlook.it",
      "outlook.jp",
      "outlook.kr",
      "outlook.lv",
      "outlook.my",
      "outlook.ph",
      "outlook.pt",
      "outlook.sa",
      "outlook.sg",
      "outlook.sk",
      "passport.com"
    ];
    var yahoo_domains = [
      "rocketmail.com",
      "yahoo.ca",
      "yahoo.co.uk",
      "yahoo.com",
      "yahoo.de",
      "yahoo.fr",
      "yahoo.in",
      "yahoo.it",
      "ymail.com"
    ];
    var yandex_domains = [
      "yandex.ru",
      "yandex.ua",
      "yandex.kz",
      "yandex.com",
      "yandex.by",
      "ya.ru"
    ];
    function dotsReplacer(match2) {
      if (match2.length > 1) {
        return match2;
      }
      return "";
    }
    __name(dotsReplacer, "dotsReplacer");
    function normalizeEmail(email, options) {
      options = (0, _merge.default)(options, default_normalize_email_options);
      var raw_parts = email.split("@");
      var domain = raw_parts.pop();
      var user = raw_parts.join("@");
      var parts = [
        user,
        domain
      ];
      parts[1] = parts[1].toLowerCase();
      if (parts[1] === "gmail.com" || parts[1] === "googlemail.com") {
        if (options.gmail_remove_subaddress) {
          parts[0] = parts[0].split("+")[0];
        }
        if (options.gmail_remove_dots) {
          parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
        }
        if (!parts[0].length) {
          return false;
        }
        if (options.all_lowercase || options.gmail_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
        parts[1] = options.gmail_convert_googlemaildotcom ? "gmail.com" : parts[1];
      } else if (icloud_domains.indexOf(parts[1]) >= 0) {
        if (options.icloud_remove_subaddress) {
          parts[0] = parts[0].split("+")[0];
        }
        if (!parts[0].length) {
          return false;
        }
        if (options.all_lowercase || options.icloud_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
      } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
        if (options.outlookdotcom_remove_subaddress) {
          parts[0] = parts[0].split("+")[0];
        }
        if (!parts[0].length) {
          return false;
        }
        if (options.all_lowercase || options.outlookdotcom_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
      } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
        if (options.yahoo_remove_subaddress) {
          var components = parts[0].split("-");
          parts[0] = components.length > 1 ? components.slice(0, -1).join("-") : components[0];
        }
        if (!parts[0].length) {
          return false;
        }
        if (options.all_lowercase || options.yahoo_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
      } else if (yandex_domains.indexOf(parts[1]) >= 0) {
        if (options.all_lowercase || options.yandex_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
        parts[1] = "yandex.ru";
      } else if (options.all_lowercase) {
        parts[0] = parts[0].toLowerCase();
      }
      return parts.join("@");
    }
    __name(normalizeEmail, "normalizeEmail");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isSlug.js
var require_isSlug = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isSlug.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isSlug;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var charsetRegex = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
    function isSlug(str) {
      (0, _assertString.default)(str);
      return charsetRegex.test(str);
    }
    __name(isSlug, "isSlug");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLicensePlate.js
var require_isLicensePlate = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isLicensePlate.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isLicensePlate;
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var validators = {
      "cs-CZ": /* @__PURE__ */ __name(function csCZ(str) {
        return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(str);
      }, "csCZ"),
      "de-DE": /* @__PURE__ */ __name(function deDE(str) {
        return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(str);
      }, "deDE"),
      "de-LI": /* @__PURE__ */ __name(function deLI(str) {
        return /^FL[- ]?\d{1,5}[UZ]?$/.test(str);
      }, "deLI"),
      "en-IN": /* @__PURE__ */ __name(function enIN(str) {
        return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(str);
      }, "enIN"),
      "es-AR": /* @__PURE__ */ __name(function esAR(str) {
        return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(str);
      }, "esAR"),
      "fi-FI": /* @__PURE__ */ __name(function fiFI(str) {
        return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(str);
      }, "fiFI"),
      "hu-HU": /* @__PURE__ */ __name(function huHU(str) {
        return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(str);
      }, "huHU"),
      "pt-BR": /* @__PURE__ */ __name(function ptBR(str) {
        return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(str);
      }, "ptBR"),
      "pt-PT": /* @__PURE__ */ __name(function ptPT(str) {
        return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(str);
      }, "ptPT"),
      "sq-AL": /* @__PURE__ */ __name(function sqAL(str) {
        return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(str);
      }, "sqAL"),
      "sv-SE": /* @__PURE__ */ __name(function svSE(str) {
        return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(str.trim());
      }, "svSE"),
      "en-PK": /* @__PURE__ */ __name(function enPK(str) {
        return /(^[A-Z]{2}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{3}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{4}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]((\s|-){0,1})[0-9]{4}((\s|-)[0-9]{2}){0,1}$)/.test(str.trim());
      }, "enPK")
    };
    function isLicensePlate(str, locale) {
      (0, _assertString.default)(str);
      if (locale in validators) {
        return validators[locale](str);
      } else if (locale === "any") {
        for (var key in validators) {
          var validator = validators[key];
          if (validator(str)) {
            return true;
          }
        }
        return false;
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    __name(isLicensePlate, "isLicensePlate");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isStrongPassword.js
var require_isStrongPassword = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isStrongPassword.js"(exports, module) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isStrongPassword;
    var _merge = _interopRequireDefault(require_merge());
    var _assertString = _interopRequireDefault(require_assertString());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var upperCaseRegex = /^[A-Z]$/;
    var lowerCaseRegex = /^[a-z]$/;
    var numberRegex = /^[0-9]$/;
    var symbolRegex = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/\\ ]$/;
    var defaultOptions = {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
      returnScore: false,
      pointsPerUnique: 1,
      pointsPerRepeat: 0.5,
      pointsForContainingLower: 10,
      pointsForContainingUpper: 10,
      pointsForContainingNumber: 10,
      pointsForContainingSymbol: 10
    };
    function countChars(str) {
      var result = {};
      Array.from(str).forEach(function(char) {
        var curVal = result[char];
        if (curVal) {
          result[char] += 1;
        } else {
          result[char] = 1;
        }
      });
      return result;
    }
    __name(countChars, "countChars");
    function analyzePassword(password) {
      var charMap = countChars(password);
      var analysis = {
        length: password.length,
        uniqueChars: Object.keys(charMap).length,
        uppercaseCount: 0,
        lowercaseCount: 0,
        numberCount: 0,
        symbolCount: 0
      };
      Object.keys(charMap).forEach(function(char) {
        if (upperCaseRegex.test(char)) {
          analysis.uppercaseCount += charMap[char];
        } else if (lowerCaseRegex.test(char)) {
          analysis.lowercaseCount += charMap[char];
        } else if (numberRegex.test(char)) {
          analysis.numberCount += charMap[char];
        } else if (symbolRegex.test(char)) {
          analysis.symbolCount += charMap[char];
        }
      });
      return analysis;
    }
    __name(analyzePassword, "analyzePassword");
    function scorePassword(analysis, scoringOptions) {
      var points = 0;
      points += analysis.uniqueChars * scoringOptions.pointsPerUnique;
      points += (analysis.length - analysis.uniqueChars) * scoringOptions.pointsPerRepeat;
      if (analysis.lowercaseCount > 0) {
        points += scoringOptions.pointsForContainingLower;
      }
      if (analysis.uppercaseCount > 0) {
        points += scoringOptions.pointsForContainingUpper;
      }
      if (analysis.numberCount > 0) {
        points += scoringOptions.pointsForContainingNumber;
      }
      if (analysis.symbolCount > 0) {
        points += scoringOptions.pointsForContainingSymbol;
      }
      return points;
    }
    __name(scorePassword, "scorePassword");
    function isStrongPassword(str) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      (0, _assertString.default)(str);
      var analysis = analyzePassword(str);
      options = (0, _merge.default)(options || {}, defaultOptions);
      if (options.returnScore) {
        return scorePassword(analysis, options);
      }
      return analysis.length >= options.minLength && analysis.lowercaseCount >= options.minLowercase && analysis.uppercaseCount >= options.minUppercase && analysis.numberCount >= options.minNumbers && analysis.symbolCount >= options.minSymbols;
    }
    __name(isStrongPassword, "isStrongPassword");
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isVAT.js
var require_isVAT = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/lib/isVAT.js"(exports) {
    "use strict";
    function _typeof(o2) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
        return typeof o3;
      } : function(o3) {
        return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
      }, _typeof(o2);
    }
    __name(_typeof, "_typeof");
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isVAT;
    exports.vatMatchers = void 0;
    var _assertString = _interopRequireDefault(require_assertString());
    var algorithms = _interopRequireWildcard(require_algorithms());
    function _getRequireWildcardCache(e2) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = /* @__PURE__ */ __name(function _getRequireWildcardCache2(e3) {
        return e3 ? t2 : r2;
      }, "_getRequireWildcardCache"))(e2);
    }
    __name(_getRequireWildcardCache, "_getRequireWildcardCache");
    function _interopRequireWildcard(e2, r2) {
      if (!r2 && e2 && e2.__esModule) return e2;
      if (null === e2 || "object" != _typeof(e2) && "function" != typeof e2) return {
        default: e2
      };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e2)) return t2.get(e2);
      var n3 = {
        __proto__: null
      }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e2) if ("default" !== u && {}.hasOwnProperty.call(e2, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e2, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n3, u, i) : n3[u] = e2[u];
      }
      return n3.default = e2, t2 && t2.set(e2, n3), n3;
    }
    __name(_interopRequireWildcard, "_interopRequireWildcard");
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var AU = /* @__PURE__ */ __name(function AU2(str) {
      var match2 = str.match(/^(AU)?(\d{11})$/);
      if (!match2) {
        return false;
      }
      var weights = [
        10,
        1,
        3,
        5,
        7,
        9,
        11,
        13,
        15,
        17,
        19
      ];
      str = str.replace(/^AU/, "");
      var ABN = (parseInt(str.slice(0, 1), 10) - 1).toString() + str.slice(1);
      var total = 0;
      for (var i = 0; i < 11; i++) {
        total += weights[i] * ABN.charAt(i);
      }
      return total !== 0 && total % 89 === 0;
    }, "AU");
    var CH = /* @__PURE__ */ __name(function CH2(str) {
      var hasValidCheckNumber = /* @__PURE__ */ __name(function hasValidCheckNumber2(digits) {
        var lastDigit = digits.pop();
        var weights = [
          5,
          4,
          3,
          2,
          7,
          6,
          5,
          4
        ];
        var calculatedCheckNumber = (11 - digits.reduce(function(acc, el, idx) {
          return acc + el * weights[idx];
        }, 0) % 11) % 11;
        return lastDigit === calculatedCheckNumber;
      }, "hasValidCheckNumber");
      return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(str) && hasValidCheckNumber(str.match(/\d/g).map(function(el) {
        return +el;
      }));
    }, "CH");
    var PT = /* @__PURE__ */ __name(function PT2(str) {
      var match2 = str.match(/^(PT)?(\d{9})$/);
      if (!match2) {
        return false;
      }
      var tin = match2[2];
      var checksum = 11 - algorithms.reverseMultiplyAndSum(tin.split("").slice(0, 8).map(function(a) {
        return parseInt(a, 10);
      }), 9) % 11;
      if (checksum > 9) {
        return parseInt(tin[8], 10) === 0;
      }
      return checksum === parseInt(tin[8], 10);
    }, "PT");
    var vatMatchers = exports.vatMatchers = {
      /**
      * European Union VAT identification numbers
      */
      AT: /* @__PURE__ */ __name(function AT(str) {
        return /^(AT)?U\d{8}$/.test(str);
      }, "AT"),
      BE: /* @__PURE__ */ __name(function BE(str) {
        return /^(BE)?\d{10}$/.test(str);
      }, "BE"),
      BG: /* @__PURE__ */ __name(function BG(str) {
        return /^(BG)?\d{9,10}$/.test(str);
      }, "BG"),
      HR: /* @__PURE__ */ __name(function HR(str) {
        return /^(HR)?\d{11}$/.test(str);
      }, "HR"),
      CY: /* @__PURE__ */ __name(function CY(str) {
        return /^(CY)?\w{9}$/.test(str);
      }, "CY"),
      CZ: /* @__PURE__ */ __name(function CZ(str) {
        return /^(CZ)?\d{8,10}$/.test(str);
      }, "CZ"),
      DK: /* @__PURE__ */ __name(function DK(str) {
        return /^(DK)?\d{8}$/.test(str);
      }, "DK"),
      EE: /* @__PURE__ */ __name(function EE(str) {
        return /^(EE)?\d{9}$/.test(str);
      }, "EE"),
      FI: /* @__PURE__ */ __name(function FI(str) {
        return /^(FI)?\d{8}$/.test(str);
      }, "FI"),
      FR: /* @__PURE__ */ __name(function FR(str) {
        return /^(FR)?\w{2}\d{9}$/.test(str);
      }, "FR"),
      DE: /* @__PURE__ */ __name(function DE(str) {
        return /^(DE)?\d{9}$/.test(str);
      }, "DE"),
      EL: /* @__PURE__ */ __name(function EL(str) {
        return /^(EL)?\d{9}$/.test(str);
      }, "EL"),
      HU: /* @__PURE__ */ __name(function HU(str) {
        return /^(HU)?\d{8}$/.test(str);
      }, "HU"),
      IE: /* @__PURE__ */ __name(function IE(str) {
        return /^(IE)?\d{7}\w{1}(W)?$/.test(str);
      }, "IE"),
      IT: /* @__PURE__ */ __name(function IT(str) {
        return /^(IT)?\d{11}$/.test(str);
      }, "IT"),
      LV: /* @__PURE__ */ __name(function LV(str) {
        return /^(LV)?\d{11}$/.test(str);
      }, "LV"),
      LT: /* @__PURE__ */ __name(function LT(str) {
        return /^(LT)?\d{9,12}$/.test(str);
      }, "LT"),
      LU: /* @__PURE__ */ __name(function LU(str) {
        return /^(LU)?\d{8}$/.test(str);
      }, "LU"),
      MT: /* @__PURE__ */ __name(function MT(str) {
        return /^(MT)?\d{8}$/.test(str);
      }, "MT"),
      NL: /* @__PURE__ */ __name(function NL(str) {
        return /^(NL)?\d{9}B\d{2}$/.test(str);
      }, "NL"),
      PL: /* @__PURE__ */ __name(function PL(str) {
        return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(str);
      }, "PL"),
      PT,
      RO: /* @__PURE__ */ __name(function RO(str) {
        return /^(RO)?\d{2,10}$/.test(str);
      }, "RO"),
      SK: /* @__PURE__ */ __name(function SK(str) {
        return /^(SK)?\d{10}$/.test(str);
      }, "SK"),
      SI: /* @__PURE__ */ __name(function SI(str) {
        return /^(SI)?\d{8}$/.test(str);
      }, "SI"),
      ES: /* @__PURE__ */ __name(function ES(str) {
        return /^(ES)?\w\d{7}[A-Z]$/.test(str);
      }, "ES"),
      SE: /* @__PURE__ */ __name(function SE(str) {
        return /^(SE)?\d{12}$/.test(str);
      }, "SE"),
      /**
      * VAT numbers of non-EU countries
      */
      AL: /* @__PURE__ */ __name(function AL(str) {
        return /^(AL)?\w{9}[A-Z]$/.test(str);
      }, "AL"),
      MK: /* @__PURE__ */ __name(function MK(str) {
        return /^(MK)?\d{13}$/.test(str);
      }, "MK"),
      AU,
      BY: /* @__PURE__ */ __name(function BY(str) {
        return /^(УНП )?\d{9}$/.test(str);
      }, "BY"),
      CA: /* @__PURE__ */ __name(function CA(str) {
        return /^(CA)?\d{9}$/.test(str);
      }, "CA"),
      IS: /* @__PURE__ */ __name(function IS(str) {
        return /^(IS)?\d{5,6}$/.test(str);
      }, "IS"),
      IN: /* @__PURE__ */ __name(function IN(str) {
        return /^(IN)?\d{15}$/.test(str);
      }, "IN"),
      ID: /* @__PURE__ */ __name(function ID(str) {
        return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(str);
      }, "ID"),
      IL: /* @__PURE__ */ __name(function IL(str) {
        return /^(IL)?\d{9}$/.test(str);
      }, "IL"),
      KZ: /* @__PURE__ */ __name(function KZ(str) {
        return /^(KZ)?\d{12}$/.test(str);
      }, "KZ"),
      NZ: /* @__PURE__ */ __name(function NZ(str) {
        return /^(NZ)?\d{9}$/.test(str);
      }, "NZ"),
      NG: /* @__PURE__ */ __name(function NG(str) {
        return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(str);
      }, "NG"),
      NO: /* @__PURE__ */ __name(function NO(str) {
        return /^(NO)?\d{9}MVA$/.test(str);
      }, "NO"),
      PH: /* @__PURE__ */ __name(function PH(str) {
        return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(str);
      }, "PH"),
      RU: /* @__PURE__ */ __name(function RU(str) {
        return /^(RU)?(\d{10}|\d{12})$/.test(str);
      }, "RU"),
      SM: /* @__PURE__ */ __name(function SM(str) {
        return /^(SM)?\d{5}$/.test(str);
      }, "SM"),
      SA: /* @__PURE__ */ __name(function SA(str) {
        return /^(SA)?\d{15}$/.test(str);
      }, "SA"),
      RS: /* @__PURE__ */ __name(function RS(str) {
        return /^(RS)?\d{9}$/.test(str);
      }, "RS"),
      CH,
      TR: /* @__PURE__ */ __name(function TR(str) {
        return /^(TR)?\d{10}$/.test(str);
      }, "TR"),
      UA: /* @__PURE__ */ __name(function UA(str) {
        return /^(UA)?\d{12}$/.test(str);
      }, "UA"),
      GB: /* @__PURE__ */ __name(function GB(str) {
        return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(str);
      }, "GB"),
      UZ: /* @__PURE__ */ __name(function UZ(str) {
        return /^(UZ)?\d{9}$/.test(str);
      }, "UZ"),
      /**
      * VAT numbers of Latin American countries
      */
      AR: /* @__PURE__ */ __name(function AR(str) {
        return /^(AR)?\d{11}$/.test(str);
      }, "AR"),
      BO: /* @__PURE__ */ __name(function BO(str) {
        return /^(BO)?\d{7}$/.test(str);
      }, "BO"),
      BR: /* @__PURE__ */ __name(function BR(str) {
        return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(str);
      }, "BR"),
      CL: /* @__PURE__ */ __name(function CL(str) {
        return /^(CL)?\d{8}-\d{1}$/.test(str);
      }, "CL"),
      CO: /* @__PURE__ */ __name(function CO(str) {
        return /^(CO)?\d{10}$/.test(str);
      }, "CO"),
      CR: /* @__PURE__ */ __name(function CR(str) {
        return /^(CR)?\d{9,12}$/.test(str);
      }, "CR"),
      EC: /* @__PURE__ */ __name(function EC(str) {
        return /^(EC)?\d{13}$/.test(str);
      }, "EC"),
      SV: /* @__PURE__ */ __name(function SV(str) {
        return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(str);
      }, "SV"),
      GT: /* @__PURE__ */ __name(function GT(str) {
        return /^(GT)?\d{7}-\d{1}$/.test(str);
      }, "GT"),
      HN: /* @__PURE__ */ __name(function HN(str) {
        return /^(HN)?$/.test(str);
      }, "HN"),
      MX: /* @__PURE__ */ __name(function MX(str) {
        return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(str);
      }, "MX"),
      NI: /* @__PURE__ */ __name(function NI(str) {
        return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(str);
      }, "NI"),
      PA: /* @__PURE__ */ __name(function PA(str) {
        return /^(PA)?$/.test(str);
      }, "PA"),
      PY: /* @__PURE__ */ __name(function PY(str) {
        return /^(PY)?\d{6,8}-\d{1}$/.test(str);
      }, "PY"),
      PE: /* @__PURE__ */ __name(function PE(str) {
        return /^(PE)?\d{11}$/.test(str);
      }, "PE"),
      DO: /* @__PURE__ */ __name(function DO(str) {
        return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(str);
      }, "DO"),
      UY: /* @__PURE__ */ __name(function UY(str) {
        return /^(UY)?\d{12}$/.test(str);
      }, "UY"),
      VE: /* @__PURE__ */ __name(function VE(str) {
        return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(str);
      }, "VE")
    };
    function isVAT(str, countryCode) {
      (0, _assertString.default)(str);
      (0, _assertString.default)(countryCode);
      if (countryCode in vatMatchers) {
        return vatMatchers[countryCode](str);
      }
      throw new Error("Invalid country code: '".concat(countryCode, "'"));
    }
    __name(isVAT, "isVAT");
  }
});

// ../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/index.js
var require_validator = __commonJS({
  "../../node_modules/.pnpm/validator@13.12.0/node_modules/validator/index.js"(exports, module) {
    "use strict";
    function _typeof(o2) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
        return typeof o3;
      } : function(o3) {
        return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
      }, _typeof(o2);
    }
    __name(_typeof, "_typeof");
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _toDate = _interopRequireDefault(require_toDate());
    var _toFloat = _interopRequireDefault(require_toFloat());
    var _toInt = _interopRequireDefault(require_toInt());
    var _toBoolean = _interopRequireDefault(require_toBoolean());
    var _equals = _interopRequireDefault(require_equals());
    var _contains = _interopRequireDefault(require_contains());
    var _matches = _interopRequireDefault(require_matches());
    var _isEmail = _interopRequireDefault(require_isEmail());
    var _isURL = _interopRequireDefault(require_isURL());
    var _isMACAddress = _interopRequireDefault(require_isMACAddress());
    var _isIP = _interopRequireDefault(require_isIP());
    var _isIPRange = _interopRequireDefault(require_isIPRange());
    var _isFQDN = _interopRequireDefault(require_isFQDN());
    var _isDate = _interopRequireDefault(require_isDate());
    var _isTime = _interopRequireDefault(require_isTime());
    var _isBoolean = _interopRequireDefault(require_isBoolean());
    var _isLocale = _interopRequireDefault(require_isLocale());
    var _isAbaRouting = _interopRequireDefault(require_isAbaRouting());
    var _isAlpha = _interopRequireWildcard(require_isAlpha());
    var _isAlphanumeric = _interopRequireWildcard(require_isAlphanumeric());
    var _isNumeric = _interopRequireDefault(require_isNumeric());
    var _isPassportNumber = _interopRequireDefault(require_isPassportNumber());
    var _isPort = _interopRequireDefault(require_isPort());
    var _isLowercase = _interopRequireDefault(require_isLowercase());
    var _isUppercase = _interopRequireDefault(require_isUppercase());
    var _isIMEI = _interopRequireDefault(require_isIMEI());
    var _isAscii = _interopRequireDefault(require_isAscii());
    var _isFullWidth = _interopRequireDefault(require_isFullWidth());
    var _isHalfWidth = _interopRequireDefault(require_isHalfWidth());
    var _isVariableWidth = _interopRequireDefault(require_isVariableWidth());
    var _isMultibyte = _interopRequireDefault(require_isMultibyte());
    var _isSemVer = _interopRequireDefault(require_isSemVer());
    var _isSurrogatePair = _interopRequireDefault(require_isSurrogatePair());
    var _isInt = _interopRequireDefault(require_isInt());
    var _isFloat = _interopRequireWildcard(require_isFloat());
    var _isDecimal = _interopRequireDefault(require_isDecimal());
    var _isHexadecimal = _interopRequireDefault(require_isHexadecimal());
    var _isOctal = _interopRequireDefault(require_isOctal());
    var _isDivisibleBy = _interopRequireDefault(require_isDivisibleBy());
    var _isHexColor = _interopRequireDefault(require_isHexColor());
    var _isRgbColor = _interopRequireDefault(require_isRgbColor());
    var _isHSL = _interopRequireDefault(require_isHSL());
    var _isISRC = _interopRequireDefault(require_isISRC());
    var _isIBAN = _interopRequireWildcard(require_isIBAN());
    var _isBIC = _interopRequireDefault(require_isBIC());
    var _isMD = _interopRequireDefault(require_isMD5());
    var _isHash = _interopRequireDefault(require_isHash());
    var _isJWT = _interopRequireDefault(require_isJWT());
    var _isJSON = _interopRequireDefault(require_isJSON());
    var _isEmpty = _interopRequireDefault(require_isEmpty());
    var _isLength = _interopRequireDefault(require_isLength());
    var _isByteLength = _interopRequireDefault(require_isByteLength());
    var _isUUID = _interopRequireDefault(require_isUUID());
    var _isMongoId = _interopRequireDefault(require_isMongoId());
    var _isAfter = _interopRequireDefault(require_isAfter());
    var _isBefore = _interopRequireDefault(require_isBefore());
    var _isIn = _interopRequireDefault(require_isIn());
    var _isLuhnNumber = _interopRequireDefault(require_isLuhnNumber());
    var _isCreditCard = _interopRequireDefault(require_isCreditCard());
    var _isIdentityCard = _interopRequireDefault(require_isIdentityCard());
    var _isEAN = _interopRequireDefault(require_isEAN());
    var _isISIN = _interopRequireDefault(require_isISIN());
    var _isISBN = _interopRequireDefault(require_isISBN());
    var _isISSN = _interopRequireDefault(require_isISSN());
    var _isTaxID = _interopRequireDefault(require_isTaxID());
    var _isMobilePhone = _interopRequireWildcard(require_isMobilePhone());
    var _isEthereumAddress = _interopRequireDefault(require_isEthereumAddress());
    var _isCurrency = _interopRequireDefault(require_isCurrency());
    var _isBtcAddress = _interopRequireDefault(require_isBtcAddress());
    var _isISO = require_isISO6346();
    var _isISO2 = _interopRequireDefault(require_isISO6391());
    var _isISO3 = _interopRequireDefault(require_isISO8601());
    var _isRFC = _interopRequireDefault(require_isRFC3339());
    var _isISO31661Alpha = _interopRequireDefault(require_isISO31661Alpha2());
    var _isISO31661Alpha2 = _interopRequireDefault(require_isISO31661Alpha3());
    var _isISO4 = _interopRequireDefault(require_isISO4217());
    var _isBase = _interopRequireDefault(require_isBase32());
    var _isBase2 = _interopRequireDefault(require_isBase58());
    var _isBase3 = _interopRequireDefault(require_isBase64());
    var _isDataURI = _interopRequireDefault(require_isDataURI());
    var _isMagnetURI = _interopRequireDefault(require_isMagnetURI());
    var _isMailtoURI = _interopRequireDefault(require_isMailtoURI());
    var _isMimeType = _interopRequireDefault(require_isMimeType());
    var _isLatLong = _interopRequireDefault(require_isLatLong());
    var _isPostalCode = _interopRequireWildcard(require_isPostalCode());
    var _ltrim = _interopRequireDefault(require_ltrim());
    var _rtrim = _interopRequireDefault(require_rtrim());
    var _trim = _interopRequireDefault(require_trim());
    var _escape = _interopRequireDefault(require_escape());
    var _unescape = _interopRequireDefault(require_unescape());
    var _stripLow = _interopRequireDefault(require_stripLow());
    var _whitelist = _interopRequireDefault(require_whitelist());
    var _blacklist = _interopRequireDefault(require_blacklist());
    var _isWhitelisted = _interopRequireDefault(require_isWhitelisted());
    var _normalizeEmail = _interopRequireDefault(require_normalizeEmail());
    var _isSlug = _interopRequireDefault(require_isSlug());
    var _isLicensePlate = _interopRequireDefault(require_isLicensePlate());
    var _isStrongPassword = _interopRequireDefault(require_isStrongPassword());
    var _isVAT = _interopRequireDefault(require_isVAT());
    function _getRequireWildcardCache(e2) {
      if ("function" != typeof WeakMap) return null;
      var r2 = /* @__PURE__ */ new WeakMap(), t2 = /* @__PURE__ */ new WeakMap();
      return (_getRequireWildcardCache = /* @__PURE__ */ __name(function _getRequireWildcardCache2(e3) {
        return e3 ? t2 : r2;
      }, "_getRequireWildcardCache"))(e2);
    }
    __name(_getRequireWildcardCache, "_getRequireWildcardCache");
    function _interopRequireWildcard(e2, r2) {
      if (!r2 && e2 && e2.__esModule) return e2;
      if (null === e2 || "object" != _typeof(e2) && "function" != typeof e2) return {
        default: e2
      };
      var t2 = _getRequireWildcardCache(r2);
      if (t2 && t2.has(e2)) return t2.get(e2);
      var n3 = {
        __proto__: null
      }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in e2) if ("default" !== u && {}.hasOwnProperty.call(e2, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e2, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n3, u, i) : n3[u] = e2[u];
      }
      return n3.default = e2, t2 && t2.set(e2, n3), n3;
    }
    __name(_interopRequireWildcard, "_interopRequireWildcard");
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    __name(_interopRequireDefault, "_interopRequireDefault");
    var version = "13.12.0";
    var validator = {
      version,
      toDate: _toDate.default,
      toFloat: _toFloat.default,
      toInt: _toInt.default,
      toBoolean: _toBoolean.default,
      equals: _equals.default,
      contains: _contains.default,
      matches: _matches.default,
      isEmail: _isEmail.default,
      isURL: _isURL.default,
      isMACAddress: _isMACAddress.default,
      isIP: _isIP.default,
      isIPRange: _isIPRange.default,
      isFQDN: _isFQDN.default,
      isBoolean: _isBoolean.default,
      isIBAN: _isIBAN.default,
      isBIC: _isBIC.default,
      isAbaRouting: _isAbaRouting.default,
      isAlpha: _isAlpha.default,
      isAlphaLocales: _isAlpha.locales,
      isAlphanumeric: _isAlphanumeric.default,
      isAlphanumericLocales: _isAlphanumeric.locales,
      isNumeric: _isNumeric.default,
      isPassportNumber: _isPassportNumber.default,
      isPort: _isPort.default,
      isLowercase: _isLowercase.default,
      isUppercase: _isUppercase.default,
      isAscii: _isAscii.default,
      isFullWidth: _isFullWidth.default,
      isHalfWidth: _isHalfWidth.default,
      isVariableWidth: _isVariableWidth.default,
      isMultibyte: _isMultibyte.default,
      isSemVer: _isSemVer.default,
      isSurrogatePair: _isSurrogatePair.default,
      isInt: _isInt.default,
      isIMEI: _isIMEI.default,
      isFloat: _isFloat.default,
      isFloatLocales: _isFloat.locales,
      isDecimal: _isDecimal.default,
      isHexadecimal: _isHexadecimal.default,
      isOctal: _isOctal.default,
      isDivisibleBy: _isDivisibleBy.default,
      isHexColor: _isHexColor.default,
      isRgbColor: _isRgbColor.default,
      isHSL: _isHSL.default,
      isISRC: _isISRC.default,
      isMD5: _isMD.default,
      isHash: _isHash.default,
      isJWT: _isJWT.default,
      isJSON: _isJSON.default,
      isEmpty: _isEmpty.default,
      isLength: _isLength.default,
      isLocale: _isLocale.default,
      isByteLength: _isByteLength.default,
      isUUID: _isUUID.default,
      isMongoId: _isMongoId.default,
      isAfter: _isAfter.default,
      isBefore: _isBefore.default,
      isIn: _isIn.default,
      isLuhnNumber: _isLuhnNumber.default,
      isCreditCard: _isCreditCard.default,
      isIdentityCard: _isIdentityCard.default,
      isEAN: _isEAN.default,
      isISIN: _isISIN.default,
      isISBN: _isISBN.default,
      isISSN: _isISSN.default,
      isMobilePhone: _isMobilePhone.default,
      isMobilePhoneLocales: _isMobilePhone.locales,
      isPostalCode: _isPostalCode.default,
      isPostalCodeLocales: _isPostalCode.locales,
      isEthereumAddress: _isEthereumAddress.default,
      isCurrency: _isCurrency.default,
      isBtcAddress: _isBtcAddress.default,
      isISO6346: _isISO.isISO6346,
      isFreightContainerID: _isISO.isFreightContainerID,
      isISO6391: _isISO2.default,
      isISO8601: _isISO3.default,
      isRFC3339: _isRFC.default,
      isISO31661Alpha2: _isISO31661Alpha.default,
      isISO31661Alpha3: _isISO31661Alpha2.default,
      isISO4217: _isISO4.default,
      isBase32: _isBase.default,
      isBase58: _isBase2.default,
      isBase64: _isBase3.default,
      isDataURI: _isDataURI.default,
      isMagnetURI: _isMagnetURI.default,
      isMailtoURI: _isMailtoURI.default,
      isMimeType: _isMimeType.default,
      isLatLong: _isLatLong.default,
      ltrim: _ltrim.default,
      rtrim: _rtrim.default,
      trim: _trim.default,
      escape: _escape.default,
      unescape: _unescape.default,
      stripLow: _stripLow.default,
      whitelist: _whitelist.default,
      blacklist: _blacklist.default,
      isWhitelisted: _isWhitelisted.default,
      normalizeEmail: _normalizeEmail.default,
      toString,
      isSlug: _isSlug.default,
      isStrongPassword: _isStrongPassword.default,
      isTaxID: _isTaxID.default,
      isDate: _isDate.default,
      isTime: _isTime.default,
      isLicensePlate: _isLicensePlate.default,
      isVAT: _isVAT.default,
      ibanLocales: _isIBAN.locales
    };
    var _default = exports.default = validator;
    module.exports = exports.default;
    module.exports.default = exports.default;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/value-types.js
var require_value_types = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/value-types.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var NewLine = "\n";
    exports.NewLine = NewLine;
    var ListType;
    (function(ListType2) {
      ListType2["Ordered"] = "ordered";
      ListType2["Bullet"] = "bullet";
      ListType2["Checked"] = "checked";
      ListType2["Unchecked"] = "unchecked";
    })(ListType || (ListType = {}));
    exports.ListType = ListType;
    var ScriptType;
    (function(ScriptType2) {
      ScriptType2["Sub"] = "sub";
      ScriptType2["Super"] = "super";
    })(ScriptType || (ScriptType = {}));
    exports.ScriptType = ScriptType;
    var DirectionType;
    (function(DirectionType2) {
      DirectionType2["Rtl"] = "rtl";
    })(DirectionType || (DirectionType = {}));
    exports.DirectionType = DirectionType;
    var AlignType;
    (function(AlignType2) {
      AlignType2["Left"] = "left";
      AlignType2["Center"] = "center";
      AlignType2["Right"] = "right";
      AlignType2["Justify"] = "justify";
    })(AlignType || (AlignType = {}));
    exports.AlignType = AlignType;
    var DataType;
    (function(DataType2) {
      DataType2["Image"] = "image";
      DataType2["Video"] = "video";
      DataType2["Formula"] = "formula";
      DataType2["Text"] = "text";
    })(DataType || (DataType = {}));
    exports.DataType = DataType;
    var GroupType;
    (function(GroupType2) {
      GroupType2["Block"] = "block";
      GroupType2["InlineGroup"] = "inline-group";
      GroupType2["List"] = "list";
      GroupType2["Video"] = "video";
      GroupType2["Table"] = "table";
    })(GroupType || (GroupType = {}));
    exports.GroupType = GroupType;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/InsertData.js
var require_InsertData = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/InsertData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var InsertDataQuill = /* @__PURE__ */ function() {
      function InsertDataQuill2(type, value) {
        this.type = type;
        this.value = value;
      }
      __name(InsertDataQuill2, "InsertDataQuill");
      return InsertDataQuill2;
    }();
    exports.InsertDataQuill = InsertDataQuill;
    var InsertDataCustom = /* @__PURE__ */ function() {
      function InsertDataCustom2(type, value) {
        this.type = type;
        this.value = value;
      }
      __name(InsertDataCustom2, "InsertDataCustom");
      return InsertDataCustom2;
    }();
    exports.InsertDataCustom = InsertDataCustom;
  }
});

// ../../node_modules/.pnpm/lodash.isequal@4.5.0/node_modules/lodash.isequal/index.js
var require_lodash = __commonJS({
  "../../node_modules/.pnpm/lodash.isequal@4.5.0/node_modules/lodash.isequal/index.js"(exports, module) {
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var asyncTag = "[object AsyncFunction]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var nullTag = "[object Null]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var proxyTag = "[object Proxy]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var undefinedTag = "[object Undefined]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e2) {
      }
    }();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function arrayFilter(array2, predicate) {
      var index = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
      while (++index < length) {
        var value = array2[index];
        if (predicate(value, index, array2)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    __name(arrayFilter, "arrayFilter");
    function arrayPush(array2, values) {
      var index = -1, length = values.length, offset2 = array2.length;
      while (++index < length) {
        array2[offset2 + index] = values[index];
      }
      return array2;
    }
    __name(arrayPush, "arrayPush");
    function arraySome(array2, predicate) {
      var index = -1, length = array2 == null ? 0 : array2.length;
      while (++index < length) {
        if (predicate(array2[index], index, array2)) {
          return true;
        }
      }
      return false;
    }
    __name(arraySome, "arraySome");
    function baseTimes(n3, iteratee) {
      var index = -1, result = Array(n3);
      while (++index < n3) {
        result[index] = iteratee(index);
      }
      return result;
    }
    __name(baseTimes, "baseTimes");
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    __name(baseUnary, "baseUnary");
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    __name(cacheHas, "cacheHas");
    function getValue(object2, key) {
      return object2 == null ? void 0 : object2[key];
    }
    __name(getValue, "getValue");
    function mapToArray(map2) {
      var index = -1, result = Array(map2.size);
      map2.forEach(function(value, key) {
        result[++index] = [
          key,
          value
        ];
      });
      return result;
    }
    __name(mapToArray, "mapToArray");
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    __name(overArg, "overArg");
    function setToArray(set) {
      var index = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index] = value;
      });
      return result;
    }
    __name(setToArray, "setToArray");
    var arrayProto = Array.prototype;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var coreJsData = root["__core-js_shared__"];
    var funcToString = funcProto.toString;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    var nativeObjectToString = objectProto.toString;
    var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var Symbol2 = root.Symbol;
    var Uint8Array2 = root.Uint8Array;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var splice = arrayProto.splice;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var nativeKeys = overArg(Object.keys, Object);
    var DataView = getNative(root, "DataView");
    var Map2 = getNative(root, "Map");
    var Promise2 = getNative(root, "Promise");
    var Set2 = getNative(root, "Set");
    var WeakMap2 = getNative(root, "WeakMap");
    var nativeCreate = getNative(Object, "create");
    var dataViewCtorString = toSource(DataView);
    var mapCtorString = toSource(Map2);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set2);
    var weakMapCtorString = toSource(WeakMap2);
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function Hash(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    __name(Hash, "Hash");
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    __name(hashClear, "hashClear");
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    __name(hashDelete, "hashDelete");
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty2.call(data, key) ? data[key] : void 0;
    }
    __name(hashGet, "hashGet");
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
    }
    __name(hashHas, "hashHas");
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    __name(hashSet, "hashSet");
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    __name(ListCache, "ListCache");
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    __name(listCacheClear, "listCacheClear");
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    __name(listCacheDelete, "listCacheDelete");
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    __name(listCacheGet, "listCacheGet");
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    __name(listCacheHas, "listCacheHas");
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([
          key,
          value
        ]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    __name(listCacheSet, "listCacheSet");
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    __name(MapCache, "MapCache");
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    __name(mapCacheClear, "mapCacheClear");
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    __name(mapCacheDelete, "mapCacheDelete");
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    __name(mapCacheGet, "mapCacheGet");
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    __name(mapCacheHas, "mapCacheHas");
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    __name(mapCacheSet, "mapCacheSet");
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function SetCache(values) {
      var index = -1, length = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }
    __name(SetCache, "SetCache");
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    __name(setCacheAdd, "setCacheAdd");
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    __name(setCacheHas, "setCacheHas");
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    __name(Stack, "Stack");
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    __name(stackClear, "stackClear");
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    __name(stackDelete, "stackDelete");
    function stackGet(key) {
      return this.__data__.get(key);
    }
    __name(stackGet, "stackGet");
    function stackHas(key) {
      return this.__data__.has(key);
    }
    __name(stackHas, "stackHas");
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([
            key,
            value
          ]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    __name(stackSet, "stackSet");
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    __name(arrayLikeKeys, "arrayLikeKeys");
    function assocIndexOf(array2, key) {
      var length = array2.length;
      while (length--) {
        if (eq(array2[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    __name(assocIndexOf, "assocIndexOf");
    function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
      var result = keysFunc(object2);
      return isArray(object2) ? result : arrayPush(result, symbolsFunc(object2));
    }
    __name(baseGetAllKeys, "baseGetAllKeys");
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    __name(baseGetTag, "baseGetTag");
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    __name(baseIsArguments, "baseIsArguments");
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }
    __name(baseIsEqual, "baseIsEqual");
    function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object2), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object2), othTag = othIsArr ? arrayTag : getTag(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object2)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
    }
    __name(baseIsEqualDeep, "baseIsEqualDeep");
    function baseIsNative(value) {
      if (!isObject2(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    __name(baseIsNative, "baseIsNative");
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    __name(baseIsTypedArray, "baseIsTypedArray");
    function baseKeys(object2) {
      if (!isPrototype(object2)) {
        return nativeKeys(object2);
      }
      var result = [];
      for (var key in Object(object2)) {
        if (hasOwnProperty2.call(object2, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    __name(baseKeys, "baseKeys");
    function equalArrays(array2, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array2.length, othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var stacked = stack.get(array2);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
      stack.set(array2, other);
      stack.set(other, array2);
      while (++index < arrLength) {
        var arrValue = array2[index], othValue = other[index];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index, other, array2, stack) : customizer(arrValue, othValue, index, array2, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function(othValue2, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array2);
      stack["delete"](other);
      return result;
    }
    __name(equalArrays, "equalArrays");
    function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
            return false;
          }
          object2 = object2.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object2, +other);
        case errorTag:
          return object2.name == other.name && object2.message == other.message;
        case regexpTag:
        case stringTag:
          return object2 == other + "";
        case mapTag:
          var convert2 = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert2 || (convert2 = setToArray);
          if (object2.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object2);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;
          stack.set(object2, other);
          var result = equalArrays(convert2(object2), convert2(other), bitmask, customizer, equalFunc, stack);
          stack["delete"](object2);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object2) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    __name(equalByTag, "equalByTag");
    function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
          return false;
        }
      }
      var stacked = stack.get(object2);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object2, other);
      stack.set(other, object2);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object2[key], othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object2.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && "constructor" in object2 && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object2);
      stack["delete"](other);
      return result;
    }
    __name(equalObjects, "equalObjects");
    function getAllKeys(object2) {
      return baseGetAllKeys(object2, keys, getSymbols);
    }
    __name(getAllKeys, "getAllKeys");
    function getMapData(map2, key) {
      var data = map2.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    __name(getMapData, "getMapData");
    function getNative(object2, key) {
      var value = getValue(object2, key);
      return baseIsNative(value) ? value : void 0;
    }
    __name(getNative, "getNative");
    function getRawTag(value) {
      var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e2) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    __name(getRawTag, "getRawTag");
    var getSymbols = !nativeGetSymbols ? stubArray : function(object2) {
      if (object2 == null) {
        return [];
      }
      object2 = Object(object2);
      return arrayFilter(nativeGetSymbols(object2), function(symbol) {
        return propertyIsEnumerable.call(object2, symbol);
      });
    };
    var getTag = baseGetTag;
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
      getTag = /* @__PURE__ */ __name(function(value) {
        var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      }, "getTag");
    }
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    __name(isIndex, "isIndex");
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    __name(isKeyable, "isKeyable");
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    __name(isMasked, "isMasked");
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    __name(isPrototype, "isPrototype");
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    __name(objectToString, "objectToString");
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e2) {
        }
        try {
          return func + "";
        } catch (e2) {
        }
      }
      return "";
    }
    __name(toSource, "toSource");
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    __name(eq, "eq");
    var isArguments = baseIsArguments(/* @__PURE__ */ function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    var isArray = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    __name(isArrayLike, "isArrayLike");
    var isBuffer = nativeIsBuffer || stubFalse;
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }
    __name(isEqual, "isEqual");
    function isFunction(value) {
      if (!isObject2(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    __name(isFunction, "isFunction");
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    __name(isLength, "isLength");
    function isObject2(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    __name(isObject2, "isObject");
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    __name(isObjectLike, "isObjectLike");
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function keys(object2) {
      return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
    }
    __name(keys, "keys");
    function stubArray() {
      return [];
    }
    __name(stubArray, "stubArray");
    function stubFalse() {
      return false;
    }
    __name(stubFalse, "stubFalse");
    module.exports = isEqual;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/DeltaInsertOp.js
var require_DeltaInsertOp = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/DeltaInsertOp.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : {
        "default": mod
      };
    };
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var value_types_1 = require_value_types();
    var InsertData_1 = require_InsertData();
    var lodash_isequal_1 = __importDefault(require_lodash());
    var DeltaInsertOp = function() {
      function DeltaInsertOp2(insertVal, attrs) {
        if (typeof insertVal === "string") {
          insertVal = new InsertData_1.InsertDataQuill(value_types_1.DataType.Text, insertVal + "");
        }
        this.insert = insertVal;
        this.attributes = attrs || {};
      }
      __name(DeltaInsertOp2, "DeltaInsertOp");
      DeltaInsertOp2.createNewLineOp = function() {
        return new DeltaInsertOp2(value_types_1.NewLine);
      };
      DeltaInsertOp2.prototype.isContainerBlock = function() {
        return this.isBlockquote() || this.isList() || this.isTable() || this.isCodeBlock() || this.isHeader() || this.isBlockAttribute() || this.isCustomTextBlock();
      };
      DeltaInsertOp2.prototype.isBlockAttribute = function() {
        var attrs = this.attributes;
        return !!(attrs.align || attrs.direction || attrs.indent);
      };
      DeltaInsertOp2.prototype.isBlockquote = function() {
        return !!this.attributes.blockquote;
      };
      DeltaInsertOp2.prototype.isHeader = function() {
        return !!this.attributes.header;
      };
      DeltaInsertOp2.prototype.isTable = function() {
        return !!this.attributes.table;
      };
      DeltaInsertOp2.prototype.isSameHeaderAs = function(op) {
        return op.attributes.header === this.attributes.header && this.isHeader();
      };
      DeltaInsertOp2.prototype.hasSameAdiAs = function(op) {
        return this.attributes.align === op.attributes.align && this.attributes.direction === op.attributes.direction && this.attributes.indent === op.attributes.indent;
      };
      DeltaInsertOp2.prototype.hasSameIndentationAs = function(op) {
        return this.attributes.indent === op.attributes.indent;
      };
      DeltaInsertOp2.prototype.hasSameAttr = function(op) {
        return lodash_isequal_1.default(this.attributes, op.attributes);
      };
      DeltaInsertOp2.prototype.hasHigherIndentThan = function(op) {
        return (Number(this.attributes.indent) || 0) > (Number(op.attributes.indent) || 0);
      };
      DeltaInsertOp2.prototype.isInline = function() {
        return !(this.isContainerBlock() || this.isVideo() || this.isCustomEmbedBlock());
      };
      DeltaInsertOp2.prototype.isCodeBlock = function() {
        return !!this.attributes["code-block"];
      };
      DeltaInsertOp2.prototype.hasSameLangAs = function(op) {
        return this.attributes["code-block"] === op.attributes["code-block"];
      };
      DeltaInsertOp2.prototype.isJustNewline = function() {
        return this.insert.value === value_types_1.NewLine;
      };
      DeltaInsertOp2.prototype.isList = function() {
        return this.isOrderedList() || this.isBulletList() || this.isCheckedList() || this.isUncheckedList();
      };
      DeltaInsertOp2.prototype.isOrderedList = function() {
        return this.attributes.list === value_types_1.ListType.Ordered;
      };
      DeltaInsertOp2.prototype.isBulletList = function() {
        return this.attributes.list === value_types_1.ListType.Bullet;
      };
      DeltaInsertOp2.prototype.isCheckedList = function() {
        return this.attributes.list === value_types_1.ListType.Checked;
      };
      DeltaInsertOp2.prototype.isUncheckedList = function() {
        return this.attributes.list === value_types_1.ListType.Unchecked;
      };
      DeltaInsertOp2.prototype.isACheckList = function() {
        return this.attributes.list == value_types_1.ListType.Unchecked || this.attributes.list === value_types_1.ListType.Checked;
      };
      DeltaInsertOp2.prototype.isSameListAs = function(op) {
        return !!op.attributes.list && (this.attributes.list === op.attributes.list || op.isACheckList() && this.isACheckList());
      };
      DeltaInsertOp2.prototype.isSameTableRowAs = function(op) {
        return !!op.isTable() && this.isTable() && this.attributes.table === op.attributes.table;
      };
      DeltaInsertOp2.prototype.isText = function() {
        return this.insert.type === value_types_1.DataType.Text;
      };
      DeltaInsertOp2.prototype.isImage = function() {
        return this.insert.type === value_types_1.DataType.Image;
      };
      DeltaInsertOp2.prototype.isFormula = function() {
        return this.insert.type === value_types_1.DataType.Formula;
      };
      DeltaInsertOp2.prototype.isVideo = function() {
        return this.insert.type === value_types_1.DataType.Video;
      };
      DeltaInsertOp2.prototype.isLink = function() {
        return this.isText() && !!this.attributes.link;
      };
      DeltaInsertOp2.prototype.isCustomEmbed = function() {
        return this.insert instanceof InsertData_1.InsertDataCustom;
      };
      DeltaInsertOp2.prototype.isCustomEmbedBlock = function() {
        return this.isCustomEmbed() && !!this.attributes.renderAsBlock;
      };
      DeltaInsertOp2.prototype.isCustomTextBlock = function() {
        return this.isText() && !!this.attributes.renderAsBlock;
      };
      DeltaInsertOp2.prototype.isMentions = function() {
        return this.isText() && !!this.attributes.mentions;
      };
      return DeltaInsertOp2;
    }();
    exports.DeltaInsertOp = DeltaInsertOp;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/helpers/url.js
var require_url = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/helpers/url.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    function sanitize(str) {
      var val = str;
      val = val.replace(/^\s*/gm, "");
      var whiteList = /^((https?|s?ftp|file|blob|mailto|tel):|#|\/|data:image\/)/;
      if (whiteList.test(val)) {
        return val;
      }
      return "unsafe:" + val;
    }
    __name(sanitize, "sanitize");
    exports.sanitize = sanitize;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/funcs-html.js
var require_funcs_html = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/funcs-html.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var EncodeTarget;
    (function(EncodeTarget2) {
      EncodeTarget2[EncodeTarget2["Html"] = 0] = "Html";
      EncodeTarget2[EncodeTarget2["Url"] = 1] = "Url";
    })(EncodeTarget || (EncodeTarget = {}));
    function makeStartTag(tag, attrs) {
      if (attrs === void 0) {
        attrs = void 0;
      }
      if (!tag) {
        return "";
      }
      var attrsStr = "";
      if (attrs) {
        var arrAttrs = [].concat(attrs);
        attrsStr = arrAttrs.map(function(attr) {
          return attr.key + (attr.value ? '="' + attr.value + '"' : "");
        }).join(" ");
      }
      var closing = ">";
      if (tag === "img" || tag === "br") {
        closing = "/>";
      }
      return attrsStr ? "<" + tag + " " + attrsStr + closing : "<" + tag + closing;
    }
    __name(makeStartTag, "makeStartTag");
    exports.makeStartTag = makeStartTag;
    function makeEndTag(tag) {
      if (tag === void 0) {
        tag = "";
      }
      return tag && "</" + tag + ">" || "";
    }
    __name(makeEndTag, "makeEndTag");
    exports.makeEndTag = makeEndTag;
    function decodeHtml(str) {
      return encodeMappings(EncodeTarget.Html).reduce(decodeMapping, str);
    }
    __name(decodeHtml, "decodeHtml");
    exports.decodeHtml = decodeHtml;
    function encodeHtml(str, preventDoubleEncoding) {
      if (preventDoubleEncoding === void 0) {
        preventDoubleEncoding = true;
      }
      if (preventDoubleEncoding) {
        str = decodeHtml(str);
      }
      return encodeMappings(EncodeTarget.Html).reduce(encodeMapping, str);
    }
    __name(encodeHtml, "encodeHtml");
    exports.encodeHtml = encodeHtml;
    function encodeLink(str) {
      var linkMaps = encodeMappings(EncodeTarget.Url);
      var decoded = linkMaps.reduce(decodeMapping, str);
      return linkMaps.reduce(encodeMapping, decoded);
    }
    __name(encodeLink, "encodeLink");
    exports.encodeLink = encodeLink;
    function encodeMappings(mtype) {
      var maps = [
        [
          "&",
          "&amp;"
        ],
        [
          "<",
          "&lt;"
        ],
        [
          ">",
          "&gt;"
        ],
        [
          '"',
          "&quot;"
        ],
        [
          "'",
          "&#x27;"
        ],
        [
          "\\/",
          "&#x2F;"
        ],
        [
          "\\(",
          "&#40;"
        ],
        [
          "\\)",
          "&#41;"
        ]
      ];
      if (mtype === EncodeTarget.Html) {
        return maps.filter(function(_a6) {
          var v = _a6[0], _ = _a6[1];
          return v.indexOf("(") === -1 && v.indexOf(")") === -1;
        });
      } else {
        return maps.filter(function(_a6) {
          var v = _a6[0], _ = _a6[1];
          return v.indexOf("/") === -1;
        });
      }
    }
    __name(encodeMappings, "encodeMappings");
    function encodeMapping(str, mapping) {
      return str.replace(new RegExp(mapping[0], "g"), mapping[1]);
    }
    __name(encodeMapping, "encodeMapping");
    function decodeMapping(str, mapping) {
      return str.replace(new RegExp(mapping[1], "g"), mapping[0].replace("\\", ""));
    }
    __name(decodeMapping, "decodeMapping");
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/OpLinkSanitizer.js
var require_OpLinkSanitizer = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/OpLinkSanitizer.js"(exports) {
    "use strict";
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule) return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
      }
      result["default"] = mod;
      return result;
    };
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var url = __importStar(require_url());
    var funcs_html_1 = require_funcs_html();
    var OpLinkSanitizer = function() {
      function OpLinkSanitizer2() {
      }
      __name(OpLinkSanitizer2, "OpLinkSanitizer");
      OpLinkSanitizer2.sanitize = function(link, options) {
        var sanitizerFn = /* @__PURE__ */ __name(function() {
          return void 0;
        }, "sanitizerFn");
        if (options && typeof options.urlSanitizer === "function") {
          sanitizerFn = options.urlSanitizer;
        }
        var result = sanitizerFn(link);
        return typeof result === "string" ? result : funcs_html_1.encodeLink(url.sanitize(link));
      };
      return OpLinkSanitizer2;
    }();
    exports.OpLinkSanitizer = OpLinkSanitizer;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/mentions/MentionSanitizer.js
var require_MentionSanitizer = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/mentions/MentionSanitizer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var OpLinkSanitizer_1 = require_OpLinkSanitizer();
    var MentionSanitizer = function() {
      function MentionSanitizer2() {
      }
      __name(MentionSanitizer2, "MentionSanitizer");
      MentionSanitizer2.sanitize = function(dirtyObj, sanitizeOptions) {
        var cleanObj = {};
        if (!dirtyObj || typeof dirtyObj !== "object") {
          return cleanObj;
        }
        if (dirtyObj.class && MentionSanitizer2.IsValidClass(dirtyObj.class)) {
          cleanObj.class = dirtyObj.class;
        }
        if (dirtyObj.id && MentionSanitizer2.IsValidId(dirtyObj.id)) {
          cleanObj.id = dirtyObj.id;
        }
        if (MentionSanitizer2.IsValidTarget(dirtyObj.target + "")) {
          cleanObj.target = dirtyObj.target;
        }
        if (dirtyObj.avatar) {
          cleanObj.avatar = OpLinkSanitizer_1.OpLinkSanitizer.sanitize(dirtyObj.avatar + "", sanitizeOptions);
        }
        if (dirtyObj["end-point"]) {
          cleanObj["end-point"] = OpLinkSanitizer_1.OpLinkSanitizer.sanitize(dirtyObj["end-point"] + "", sanitizeOptions);
        }
        if (dirtyObj.slug) {
          cleanObj.slug = dirtyObj.slug + "";
        }
        return cleanObj;
      };
      MentionSanitizer2.IsValidClass = function(classAttr) {
        return !!classAttr.match(/^[a-zA-Z0-9_\-]{1,500}$/i);
      };
      MentionSanitizer2.IsValidId = function(idAttr) {
        return !!idAttr.match(/^[a-zA-Z0-9_\-\:\.]{1,500}$/i);
      };
      MentionSanitizer2.IsValidTarget = function(target) {
        return [
          "_self",
          "_blank",
          "_parent",
          "_top"
        ].indexOf(target) > -1;
      };
      return MentionSanitizer2;
    }();
    exports.MentionSanitizer = MentionSanitizer;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/helpers/array.js
var require_array = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/helpers/array.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    function preferSecond(arr) {
      if (arr.length === 0) {
        return null;
      }
      return arr.length >= 2 ? arr[1] : arr[0];
    }
    __name(preferSecond, "preferSecond");
    exports.preferSecond = preferSecond;
    function flatten2(arr) {
      return arr.reduce(function(pv, v) {
        return pv.concat(Array.isArray(v) ? flatten2(v) : v);
      }, []);
    }
    __name(flatten2, "flatten");
    exports.flatten = flatten2;
    function find2(arr, predicate) {
      if (Array.prototype.find) {
        return Array.prototype.find.call(arr, predicate);
      }
      for (var i = 0; i < arr.length; i++) {
        if (predicate(arr[i])) return arr[i];
      }
      return void 0;
    }
    __name(find2, "find");
    exports.find = find2;
    function groupConsecutiveElementsWhile(arr, predicate) {
      var groups = [];
      var currElm, currGroup;
      for (var i = 0; i < arr.length; i++) {
        currElm = arr[i];
        if (i > 0 && predicate(currElm, arr[i - 1])) {
          currGroup = groups[groups.length - 1];
          currGroup.push(currElm);
        } else {
          groups.push([
            currElm
          ]);
        }
      }
      return groups.map(function(g) {
        return g.length === 1 ? g[0] : g;
      });
    }
    __name(groupConsecutiveElementsWhile, "groupConsecutiveElementsWhile");
    exports.groupConsecutiveElementsWhile = groupConsecutiveElementsWhile;
    function sliceFromReverseWhile(arr, startIndex, predicate) {
      var result = {
        elements: [],
        sliceStartsAt: -1
      };
      for (var i = startIndex; i >= 0; i--) {
        if (!predicate(arr[i])) {
          break;
        }
        result.sliceStartsAt = i;
        result.elements.unshift(arr[i]);
      }
      return result;
    }
    __name(sliceFromReverseWhile, "sliceFromReverseWhile");
    exports.sliceFromReverseWhile = sliceFromReverseWhile;
    function intersperse(arr, item) {
      return arr.reduce(function(pv, v, index) {
        pv.push(v);
        if (index < arr.length - 1) {
          pv.push(item);
        }
        return pv;
      }, []);
    }
    __name(intersperse, "intersperse");
    exports.intersperse = intersperse;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/OpAttributeSanitizer.js
var require_OpAttributeSanitizer = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/OpAttributeSanitizer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var value_types_1 = require_value_types();
    var MentionSanitizer_1 = require_MentionSanitizer();
    var array_1 = require_array();
    var OpLinkSanitizer_1 = require_OpLinkSanitizer();
    var OpAttributeSanitizer = function() {
      function OpAttributeSanitizer2() {
      }
      __name(OpAttributeSanitizer2, "OpAttributeSanitizer");
      OpAttributeSanitizer2.sanitize = function(dirtyAttrs, sanitizeOptions) {
        var cleanAttrs = {};
        if (!dirtyAttrs || typeof dirtyAttrs !== "object") {
          return cleanAttrs;
        }
        var booleanAttrs = [
          "bold",
          "italic",
          "underline",
          "strike",
          "code",
          "blockquote",
          "code-block",
          "renderAsBlock"
        ];
        var colorAttrs = [
          "background",
          "color"
        ];
        var font = dirtyAttrs.font, size = dirtyAttrs.size, link = dirtyAttrs.link, script = dirtyAttrs.script, list = dirtyAttrs.list, header = dirtyAttrs.header, align = dirtyAttrs.align, direction = dirtyAttrs.direction, indent = dirtyAttrs.indent, mentions = dirtyAttrs.mentions, mention = dirtyAttrs.mention, width = dirtyAttrs.width, target = dirtyAttrs.target, rel = dirtyAttrs.rel;
        var codeBlock = dirtyAttrs["code-block"];
        var sanitizedAttrs = booleanAttrs.concat(colorAttrs, [
          "font",
          "size",
          "link",
          "script",
          "list",
          "header",
          "align",
          "direction",
          "indent",
          "mentions",
          "mention",
          "width",
          "target",
          "rel",
          "code-block"
        ]);
        booleanAttrs.forEach(function(prop) {
          var v = dirtyAttrs[prop];
          if (v) {
            cleanAttrs[prop] = !!v;
          }
        });
        colorAttrs.forEach(function(prop) {
          var val = dirtyAttrs[prop];
          if (val && (OpAttributeSanitizer2.IsValidHexColor(val + "") || OpAttributeSanitizer2.IsValidColorLiteral(val + "") || OpAttributeSanitizer2.IsValidRGBColor(val + ""))) {
            cleanAttrs[prop] = val;
          }
        });
        if (font && OpAttributeSanitizer2.IsValidFontName(font + "")) {
          cleanAttrs.font = font;
        }
        if (size && OpAttributeSanitizer2.IsValidSize(size + "")) {
          cleanAttrs.size = size;
        }
        if (width && OpAttributeSanitizer2.IsValidWidth(width + "")) {
          cleanAttrs.width = width;
        }
        if (link) {
          cleanAttrs.link = OpLinkSanitizer_1.OpLinkSanitizer.sanitize(link + "", sanitizeOptions);
        }
        if (target && OpAttributeSanitizer2.isValidTarget(target)) {
          cleanAttrs.target = target;
        }
        if (rel && OpAttributeSanitizer2.IsValidRel(rel)) {
          cleanAttrs.rel = rel;
        }
        if (codeBlock) {
          if (OpAttributeSanitizer2.IsValidLang(codeBlock)) {
            cleanAttrs["code-block"] = codeBlock;
          } else {
            cleanAttrs["code-block"] = !!codeBlock;
          }
        }
        if (script === value_types_1.ScriptType.Sub || value_types_1.ScriptType.Super === script) {
          cleanAttrs.script = script;
        }
        if (list === value_types_1.ListType.Bullet || list === value_types_1.ListType.Ordered || list === value_types_1.ListType.Checked || list === value_types_1.ListType.Unchecked) {
          cleanAttrs.list = list;
        }
        if (Number(header)) {
          cleanAttrs.header = Math.min(Number(header), 6);
        }
        if (array_1.find([
          value_types_1.AlignType.Center,
          value_types_1.AlignType.Right,
          value_types_1.AlignType.Justify,
          value_types_1.AlignType.Left
        ], function(a) {
          return a === align;
        })) {
          cleanAttrs.align = align;
        }
        if (direction === value_types_1.DirectionType.Rtl) {
          cleanAttrs.direction = direction;
        }
        if (indent && Number(indent)) {
          cleanAttrs.indent = Math.min(Number(indent), 30);
        }
        if (mentions && mention) {
          var sanitizedMention = MentionSanitizer_1.MentionSanitizer.sanitize(mention, sanitizeOptions);
          if (Object.keys(sanitizedMention).length > 0) {
            cleanAttrs.mentions = !!mentions;
            cleanAttrs.mention = mention;
          }
        }
        return Object.keys(dirtyAttrs).reduce(function(cleaned, k) {
          if (sanitizedAttrs.indexOf(k) === -1) {
            cleaned[k] = dirtyAttrs[k];
          }
          return cleaned;
        }, cleanAttrs);
      };
      OpAttributeSanitizer2.IsValidHexColor = function(colorStr) {
        return !!colorStr.match(/^#([0-9A-F]{6}|[0-9A-F]{3})$/i);
      };
      OpAttributeSanitizer2.IsValidColorLiteral = function(colorStr) {
        return !!colorStr.match(/^[a-z]{1,50}$/i);
      };
      OpAttributeSanitizer2.IsValidRGBColor = function(colorStr) {
        var re = /^rgb\(((0|25[0-5]|2[0-4]\d|1\d\d|0?\d?\d),\s*){2}(0|25[0-5]|2[0-4]\d|1\d\d|0?\d?\d)\)$/i;
        return !!colorStr.match(re);
      };
      OpAttributeSanitizer2.IsValidFontName = function(fontName) {
        return !!fontName.match(/^[a-z\s0-9\- ]{1,30}$/i);
      };
      OpAttributeSanitizer2.IsValidSize = function(size) {
        return !!size.match(/^[a-z0-9\-]{1,20}$/i);
      };
      OpAttributeSanitizer2.IsValidWidth = function(width) {
        return !!width.match(/^[0-9]*(px|em|%)?$/);
      };
      OpAttributeSanitizer2.isValidTarget = function(target) {
        return !!target.match(/^[_a-zA-Z0-9\-]{1,50}$/);
      };
      OpAttributeSanitizer2.IsValidRel = function(relStr) {
        return !!relStr.match(/^[a-zA-Z\s\-]{1,250}$/i);
      };
      OpAttributeSanitizer2.IsValidLang = function(lang) {
        if (typeof lang === "boolean") {
          return true;
        }
        return !!lang.match(/^[a-zA-Z\s\-\\\/\+]{1,50}$/i);
      };
      return OpAttributeSanitizer2;
    }();
    exports.OpAttributeSanitizer = OpAttributeSanitizer;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/helpers/string.js
var require_string = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/helpers/string.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    function tokenizeWithNewLines(str) {
      var NewLine = "\n";
      if (str === NewLine) {
        return [
          str
        ];
      }
      var lines = str.split(NewLine);
      if (lines.length === 1) {
        return lines;
      }
      var lastIndex = lines.length - 1;
      return lines.reduce(function(pv, line, ind) {
        if (ind !== lastIndex) {
          if (line !== "") {
            pv = pv.concat(line, NewLine);
          } else {
            pv.push(NewLine);
          }
        } else if (line !== "") {
          pv.push(line);
        }
        return pv;
      }, []);
    }
    __name(tokenizeWithNewLines, "tokenizeWithNewLines");
    exports.tokenizeWithNewLines = tokenizeWithNewLines;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/helpers/object.js
var require_object = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/helpers/object.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    function assign(target) {
      var sources = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
      }
      if (target == null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      var to = Object(target);
      for (var index = 0; index < sources.length; index++) {
        var nextSource = sources[index];
        if (nextSource != null) {
          for (var nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    }
    __name(assign, "assign");
    exports.assign = assign;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/InsertOpDenormalizer.js
var require_InsertOpDenormalizer = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/InsertOpDenormalizer.js"(exports) {
    "use strict";
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule) return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
      }
      result["default"] = mod;
      return result;
    };
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var value_types_1 = require_value_types();
    var str = __importStar(require_string());
    var obj = __importStar(require_object());
    var InsertOpDenormalizer = function() {
      function InsertOpDenormalizer2() {
      }
      __name(InsertOpDenormalizer2, "InsertOpDenormalizer");
      InsertOpDenormalizer2.denormalize = function(op) {
        if (!op || typeof op !== "object") {
          return [];
        }
        if (typeof op.insert === "object" || op.insert === value_types_1.NewLine) {
          return [
            op
          ];
        }
        var newlinedArray = str.tokenizeWithNewLines(op.insert + "");
        if (newlinedArray.length === 1) {
          return [
            op
          ];
        }
        var nlObj = obj.assign({}, op, {
          insert: value_types_1.NewLine
        });
        return newlinedArray.map(function(line) {
          if (line === value_types_1.NewLine) {
            return nlObj;
          }
          return obj.assign({}, op, {
            insert: line
          });
        });
      };
      return InsertOpDenormalizer2;
    }();
    exports.InsertOpDenormalizer = InsertOpDenormalizer;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/InsertOpsConverter.js
var require_InsertOpsConverter = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/InsertOpsConverter.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var DeltaInsertOp_1 = require_DeltaInsertOp();
    var value_types_1 = require_value_types();
    var InsertData_1 = require_InsertData();
    var OpAttributeSanitizer_1 = require_OpAttributeSanitizer();
    var InsertOpDenormalizer_1 = require_InsertOpDenormalizer();
    var OpLinkSanitizer_1 = require_OpLinkSanitizer();
    var InsertOpsConverter = function() {
      function InsertOpsConverter2() {
      }
      __name(InsertOpsConverter2, "InsertOpsConverter");
      InsertOpsConverter2.convert = function(deltaOps, options) {
        if (!Array.isArray(deltaOps)) {
          return [];
        }
        var denormalizedOps = [].concat.apply([], deltaOps.map(InsertOpDenormalizer_1.InsertOpDenormalizer.denormalize));
        var results = [];
        var insertVal, attributes;
        for (var _i = 0, denormalizedOps_1 = denormalizedOps; _i < denormalizedOps_1.length; _i++) {
          var op = denormalizedOps_1[_i];
          if (!op.insert) {
            continue;
          }
          insertVal = InsertOpsConverter2.convertInsertVal(op.insert, options);
          if (!insertVal) {
            continue;
          }
          attributes = OpAttributeSanitizer_1.OpAttributeSanitizer.sanitize(op.attributes, options);
          results.push(new DeltaInsertOp_1.DeltaInsertOp(insertVal, attributes));
        }
        return results;
      };
      InsertOpsConverter2.convertInsertVal = function(insertPropVal, sanitizeOptions) {
        if (typeof insertPropVal === "string") {
          return new InsertData_1.InsertDataQuill(value_types_1.DataType.Text, insertPropVal);
        }
        if (!insertPropVal || typeof insertPropVal !== "object") {
          return null;
        }
        var keys = Object.keys(insertPropVal);
        if (!keys.length) {
          return null;
        }
        return value_types_1.DataType.Image in insertPropVal ? new InsertData_1.InsertDataQuill(value_types_1.DataType.Image, OpLinkSanitizer_1.OpLinkSanitizer.sanitize(insertPropVal[value_types_1.DataType.Image] + "", sanitizeOptions)) : value_types_1.DataType.Video in insertPropVal ? new InsertData_1.InsertDataQuill(value_types_1.DataType.Video, OpLinkSanitizer_1.OpLinkSanitizer.sanitize(insertPropVal[value_types_1.DataType.Video] + "", sanitizeOptions)) : value_types_1.DataType.Formula in insertPropVal ? new InsertData_1.InsertDataQuill(value_types_1.DataType.Formula, insertPropVal[value_types_1.DataType.Formula]) : new InsertData_1.InsertDataCustom(keys[0], insertPropVal[keys[0]]);
      };
      return InsertOpsConverter2;
    }();
    exports.InsertOpsConverter = InsertOpsConverter;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/OpToHtmlConverter.js
var require_OpToHtmlConverter = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/OpToHtmlConverter.js"(exports) {
    "use strict";
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule) return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
      }
      result["default"] = mod;
      return result;
    };
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var funcs_html_1 = require_funcs_html();
    var value_types_1 = require_value_types();
    var obj = __importStar(require_object());
    var arr = __importStar(require_array());
    var OpAttributeSanitizer_1 = require_OpAttributeSanitizer();
    var DEFAULT_INLINE_FONTS = {
      serif: "font-family: Georgia, Times New Roman, serif",
      monospace: "font-family: Monaco, Courier New, monospace"
    };
    exports.DEFAULT_INLINE_STYLES = {
      font: /* @__PURE__ */ __name(function(value) {
        return DEFAULT_INLINE_FONTS[value] || "font-family:" + value;
      }, "font"),
      size: {
        small: "font-size: 0.75em",
        large: "font-size: 1.5em",
        huge: "font-size: 2.5em"
      },
      indent: /* @__PURE__ */ __name(function(value, op) {
        var indentSize = parseInt(value, 10) * 3;
        var side = op.attributes["direction"] === "rtl" ? "right" : "left";
        return "padding-" + side + ":" + indentSize + "em";
      }, "indent"),
      direction: /* @__PURE__ */ __name(function(value, op) {
        if (value === "rtl") {
          return "direction:rtl" + (op.attributes["align"] ? "" : "; text-align:inherit");
        } else {
          return void 0;
        }
      }, "direction")
    };
    var OpToHtmlConverter = function() {
      function OpToHtmlConverter2(op, options) {
        this.op = op;
        this.options = obj.assign({}, {
          classPrefix: "ql",
          inlineStyles: void 0,
          encodeHtml: true,
          listItemTag: "li",
          paragraphTag: "p"
        }, options);
      }
      __name(OpToHtmlConverter2, "OpToHtmlConverter");
      OpToHtmlConverter2.prototype.prefixClass = function(className) {
        if (!this.options.classPrefix) {
          return className + "";
        }
        return this.options.classPrefix + "-" + className;
      };
      OpToHtmlConverter2.prototype.getHtml = function() {
        var parts = this.getHtmlParts();
        return parts.openingTag + parts.content + parts.closingTag;
      };
      OpToHtmlConverter2.prototype.getHtmlParts = function() {
        var _this = this;
        if (this.op.isJustNewline() && !this.op.isContainerBlock()) {
          return {
            openingTag: "",
            closingTag: "",
            content: value_types_1.NewLine
          };
        }
        var tags = this.getTags(), attrs = this.getTagAttributes();
        if (!tags.length && attrs.length) {
          tags.push("span");
        }
        var beginTags = [], endTags = [];
        var imgTag = "img";
        var isImageLink = /* @__PURE__ */ __name(function(tag2) {
          return tag2 === imgTag && !!_this.op.attributes.link;
        }, "isImageLink");
        for (var _i = 0, tags_1 = tags; _i < tags_1.length; _i++) {
          var tag = tags_1[_i];
          if (isImageLink(tag)) {
            beginTags.push(funcs_html_1.makeStartTag("a", this.getLinkAttrs()));
          }
          beginTags.push(funcs_html_1.makeStartTag(tag, attrs));
          endTags.push(tag === "img" ? "" : funcs_html_1.makeEndTag(tag));
          if (isImageLink(tag)) {
            endTags.push(funcs_html_1.makeEndTag("a"));
          }
          attrs = [];
        }
        endTags.reverse();
        return {
          openingTag: beginTags.join(""),
          content: this.getContent(),
          closingTag: endTags.join("")
        };
      };
      OpToHtmlConverter2.prototype.getContent = function() {
        if (this.op.isContainerBlock()) {
          return "";
        }
        if (this.op.isMentions()) {
          return this.op.insert.value;
        }
        var content = this.op.isFormula() || this.op.isText() ? this.op.insert.value : "";
        return this.options.encodeHtml && funcs_html_1.encodeHtml(content) || content;
      };
      OpToHtmlConverter2.prototype.getCssClasses = function() {
        var attrs = this.op.attributes;
        if (this.options.inlineStyles) {
          return [];
        }
        var propsArr = [
          "indent",
          "align",
          "direction",
          "font",
          "size"
        ];
        if (this.options.allowBackgroundClasses) {
          propsArr.push("background");
        }
        return (this.getCustomCssClasses() || []).concat(propsArr.filter(function(prop) {
          return !!attrs[prop];
        }).filter(function(prop) {
          return prop === "background" ? OpAttributeSanitizer_1.OpAttributeSanitizer.IsValidColorLiteral(attrs[prop]) : true;
        }).map(function(prop) {
          return prop + "-" + attrs[prop];
        }).concat(this.op.isFormula() ? "formula" : []).concat(this.op.isVideo() ? "video" : []).concat(this.op.isImage() ? "image" : []).map(this.prefixClass.bind(this)));
      };
      OpToHtmlConverter2.prototype.getCssStyles = function() {
        var _this = this;
        var attrs = this.op.attributes;
        var propsArr = [
          [
            "color"
          ]
        ];
        if (!!this.options.inlineStyles || !this.options.allowBackgroundClasses) {
          propsArr.push([
            "background",
            "background-color"
          ]);
        }
        if (this.options.inlineStyles) {
          propsArr = propsArr.concat([
            [
              "indent"
            ],
            [
              "align",
              "text-align"
            ],
            [
              "direction"
            ],
            [
              "font",
              "font-family"
            ],
            [
              "size"
            ]
          ]);
        }
        return (this.getCustomCssStyles() || []).concat(propsArr.filter(function(item) {
          return !!attrs[item[0]];
        }).map(function(item) {
          var attribute = item[0];
          var attrValue = attrs[attribute];
          var attributeConverter = _this.options.inlineStyles && _this.options.inlineStyles[attribute] || exports.DEFAULT_INLINE_STYLES[attribute];
          if (typeof attributeConverter === "object") {
            return attributeConverter[attrValue];
          } else if (typeof attributeConverter === "function") {
            var converterFn = attributeConverter;
            return converterFn(attrValue, _this.op);
          } else {
            return arr.preferSecond(item) + ":" + attrValue;
          }
        })).filter(function(item) {
          return item !== void 0;
        });
      };
      OpToHtmlConverter2.prototype.getTagAttributes = function() {
        if (this.op.attributes.code && !this.op.isLink()) {
          return [];
        }
        var makeAttr = this.makeAttr.bind(this);
        var customTagAttributes = this.getCustomTagAttributes();
        var customAttr = customTagAttributes ? Object.keys(this.getCustomTagAttributes()).map(function(k) {
          return makeAttr(k, customTagAttributes[k]);
        }) : [];
        var classes = this.getCssClasses();
        var tagAttrs = classes.length ? customAttr.concat([
          makeAttr("class", classes.join(" "))
        ]) : customAttr;
        if (this.op.isImage()) {
          this.op.attributes.width && (tagAttrs = tagAttrs.concat(makeAttr("width", this.op.attributes.width)));
          return tagAttrs.concat(makeAttr("src", this.op.insert.value));
        }
        if (this.op.isACheckList()) {
          return tagAttrs.concat(makeAttr("data-checked", this.op.isCheckedList() ? "true" : "false"));
        }
        if (this.op.isFormula()) {
          return tagAttrs;
        }
        if (this.op.isVideo()) {
          return tagAttrs.concat(makeAttr("frameborder", "0"), makeAttr("allowfullscreen", "true"), makeAttr("src", this.op.insert.value));
        }
        if (this.op.isMentions()) {
          var mention = this.op.attributes.mention;
          if (mention.class) {
            tagAttrs = tagAttrs.concat(makeAttr("class", mention.class));
          }
          if (mention["end-point"] && mention.slug) {
            tagAttrs = tagAttrs.concat(makeAttr("href", mention["end-point"] + "/" + mention.slug));
          } else {
            tagAttrs = tagAttrs.concat(makeAttr("href", "about:blank"));
          }
          if (mention.target) {
            tagAttrs = tagAttrs.concat(makeAttr("target", mention.target));
          }
          return tagAttrs;
        }
        var styles = this.getCssStyles();
        if (styles.length) {
          tagAttrs.push(makeAttr("style", styles.join(";")));
        }
        if (this.op.isCodeBlock() && typeof this.op.attributes["code-block"] === "string") {
          return tagAttrs.concat(makeAttr("data-language", this.op.attributes["code-block"]));
        }
        if (this.op.isContainerBlock()) {
          return tagAttrs;
        }
        if (this.op.isLink()) {
          tagAttrs = tagAttrs.concat(this.getLinkAttrs());
        }
        return tagAttrs;
      };
      OpToHtmlConverter2.prototype.makeAttr = function(k, v) {
        return {
          key: k,
          value: v
        };
      };
      OpToHtmlConverter2.prototype.getLinkAttrs = function() {
        var tagAttrs = [];
        var targetForAll = OpAttributeSanitizer_1.OpAttributeSanitizer.isValidTarget(this.options.linkTarget || "") ? this.options.linkTarget : void 0;
        var relForAll = OpAttributeSanitizer_1.OpAttributeSanitizer.IsValidRel(this.options.linkRel || "") ? this.options.linkRel : void 0;
        var target = this.op.attributes.target || targetForAll;
        var rel = this.op.attributes.rel || relForAll;
        return tagAttrs.concat(this.makeAttr("href", this.op.attributes.link)).concat(target ? this.makeAttr("target", target) : []).concat(rel ? this.makeAttr("rel", rel) : []);
      };
      OpToHtmlConverter2.prototype.getCustomTag = function(format) {
        if (this.options.customTag && typeof this.options.customTag === "function") {
          return this.options.customTag.apply(null, [
            format,
            this.op
          ]);
        }
      };
      OpToHtmlConverter2.prototype.getCustomTagAttributes = function() {
        if (this.options.customTagAttributes && typeof this.options.customTagAttributes === "function") {
          return this.options.customTagAttributes.apply(null, [
            this.op
          ]);
        }
      };
      OpToHtmlConverter2.prototype.getCustomCssClasses = function() {
        if (this.options.customCssClasses && typeof this.options.customCssClasses === "function") {
          var res = this.options.customCssClasses.apply(null, [
            this.op
          ]);
          if (res) {
            return Array.isArray(res) ? res : [
              res
            ];
          }
        }
      };
      OpToHtmlConverter2.prototype.getCustomCssStyles = function() {
        if (this.options.customCssStyles && typeof this.options.customCssStyles === "function") {
          var res = this.options.customCssStyles.apply(null, [
            this.op
          ]);
          if (res) {
            return Array.isArray(res) ? res : [
              res
            ];
          }
        }
      };
      OpToHtmlConverter2.prototype.getTags = function() {
        var _this = this;
        var attrs = this.op.attributes;
        if (!this.op.isText()) {
          return [
            this.op.isVideo() ? "iframe" : this.op.isImage() ? "img" : "span"
          ];
        }
        var positionTag = this.options.paragraphTag || "p";
        var blocks = [
          [
            "blockquote"
          ],
          [
            "code-block",
            "pre"
          ],
          [
            "list",
            this.options.listItemTag
          ],
          [
            "header"
          ],
          [
            "align",
            positionTag
          ],
          [
            "direction",
            positionTag
          ],
          [
            "indent",
            positionTag
          ]
        ];
        for (var _i = 0, blocks_1 = blocks; _i < blocks_1.length; _i++) {
          var item = blocks_1[_i];
          var firstItem = item[0];
          if (attrs[firstItem]) {
            var customTag = this.getCustomTag(firstItem);
            return customTag ? [
              customTag
            ] : firstItem === "header" ? [
              "h" + attrs[firstItem]
            ] : [
              arr.preferSecond(item)
            ];
          }
        }
        if (this.op.isCustomTextBlock()) {
          var customTag = this.getCustomTag("renderAsBlock");
          return customTag ? [
            customTag
          ] : [
            positionTag
          ];
        }
        var customTagsMap = Object.keys(attrs).reduce(function(res, it) {
          var customTag2 = _this.getCustomTag(it);
          if (customTag2) {
            res[it] = customTag2;
          }
          return res;
        }, {});
        var inlineTags = [
          [
            "link",
            "a"
          ],
          [
            "mentions",
            "a"
          ],
          [
            "script"
          ],
          [
            "bold",
            "strong"
          ],
          [
            "italic",
            "em"
          ],
          [
            "strike",
            "s"
          ],
          [
            "underline",
            "u"
          ],
          [
            "code"
          ]
        ];
        return inlineTags.filter(function(item2) {
          return !!attrs[item2[0]];
        }).concat(Object.keys(customTagsMap).filter(function(t2) {
          return !inlineTags.some(function(it) {
            return it[0] == t2;
          });
        }).map(function(t2) {
          return [
            t2,
            customTagsMap[t2]
          ];
        })).map(function(item2) {
          return customTagsMap[item2[0]] ? customTagsMap[item2[0]] : item2[0] === "script" ? attrs[item2[0]] === value_types_1.ScriptType.Sub ? "sub" : "sup" : arr.preferSecond(item2);
        });
      };
      return OpToHtmlConverter2;
    }();
    exports.OpToHtmlConverter = OpToHtmlConverter;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/grouper/group-types.js
var require_group_types = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/grouper/group-types.js"(exports) {
    "use strict";
    var __extends = exports && exports.__extends || function() {
      var extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function(d, b) {
        d.__proto__ = b;
      } || function(d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        __name(__, "__");
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var InlineGroup = /* @__PURE__ */ function() {
      function InlineGroup2(ops) {
        this.ops = ops;
      }
      __name(InlineGroup2, "InlineGroup");
      return InlineGroup2;
    }();
    exports.InlineGroup = InlineGroup;
    var SingleItem = /* @__PURE__ */ function() {
      function SingleItem2(op) {
        this.op = op;
      }
      __name(SingleItem2, "SingleItem");
      return SingleItem2;
    }();
    var VideoItem = function(_super) {
      __extends(VideoItem2, _super);
      function VideoItem2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      __name(VideoItem2, "VideoItem");
      return VideoItem2;
    }(SingleItem);
    exports.VideoItem = VideoItem;
    var BlotBlock = function(_super) {
      __extends(BlotBlock2, _super);
      function BlotBlock2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      __name(BlotBlock2, "BlotBlock");
      return BlotBlock2;
    }(SingleItem);
    exports.BlotBlock = BlotBlock;
    var BlockGroup = /* @__PURE__ */ function() {
      function BlockGroup2(op, ops) {
        this.op = op;
        this.ops = ops;
      }
      __name(BlockGroup2, "BlockGroup");
      return BlockGroup2;
    }();
    exports.BlockGroup = BlockGroup;
    var ListGroup = /* @__PURE__ */ function() {
      function ListGroup2(items) {
        this.items = items;
      }
      __name(ListGroup2, "ListGroup");
      return ListGroup2;
    }();
    exports.ListGroup = ListGroup;
    var ListItem = /* @__PURE__ */ function() {
      function ListItem2(item, innerList) {
        if (innerList === void 0) {
          innerList = null;
        }
        this.item = item;
        this.innerList = innerList;
      }
      __name(ListItem2, "ListItem");
      return ListItem2;
    }();
    exports.ListItem = ListItem;
    var TableGroup = /* @__PURE__ */ function() {
      function TableGroup2(rows) {
        this.rows = rows;
      }
      __name(TableGroup2, "TableGroup");
      return TableGroup2;
    }();
    exports.TableGroup = TableGroup;
    var TableRow = /* @__PURE__ */ function() {
      function TableRow2(cells) {
        this.cells = cells;
      }
      __name(TableRow2, "TableRow");
      return TableRow2;
    }();
    exports.TableRow = TableRow;
    var TableCell = /* @__PURE__ */ function() {
      function TableCell2(item) {
        this.item = item;
      }
      __name(TableCell2, "TableCell");
      return TableCell2;
    }();
    exports.TableCell = TableCell;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/grouper/Grouper.js
var require_Grouper = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/grouper/Grouper.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var DeltaInsertOp_1 = require_DeltaInsertOp();
    var array_1 = require_array();
    var group_types_1 = require_group_types();
    var Grouper = function() {
      function Grouper2() {
      }
      __name(Grouper2, "Grouper");
      Grouper2.pairOpsWithTheirBlock = function(ops) {
        var result = [];
        var canBeInBlock = /* @__PURE__ */ __name(function(op2) {
          return !(op2.isJustNewline() || op2.isCustomEmbedBlock() || op2.isVideo() || op2.isContainerBlock());
        }, "canBeInBlock");
        var isInlineData = /* @__PURE__ */ __name(function(op2) {
          return op2.isInline();
        }, "isInlineData");
        var lastInd = ops.length - 1;
        var opsSlice;
        for (var i = lastInd; i >= 0; i--) {
          var op = ops[i];
          if (op.isVideo()) {
            result.push(new group_types_1.VideoItem(op));
          } else if (op.isCustomEmbedBlock()) {
            result.push(new group_types_1.BlotBlock(op));
          } else if (op.isContainerBlock()) {
            opsSlice = array_1.sliceFromReverseWhile(ops, i - 1, canBeInBlock);
            result.push(new group_types_1.BlockGroup(op, opsSlice.elements));
            i = opsSlice.sliceStartsAt > -1 ? opsSlice.sliceStartsAt : i;
          } else {
            opsSlice = array_1.sliceFromReverseWhile(ops, i - 1, isInlineData);
            result.push(new group_types_1.InlineGroup(opsSlice.elements.concat(op)));
            i = opsSlice.sliceStartsAt > -1 ? opsSlice.sliceStartsAt : i;
          }
        }
        result.reverse();
        return result;
      };
      Grouper2.groupConsecutiveSameStyleBlocks = function(groups, blocksOf) {
        if (blocksOf === void 0) {
          blocksOf = {
            header: true,
            codeBlocks: true,
            blockquotes: true,
            customBlocks: true
          };
        }
        return array_1.groupConsecutiveElementsWhile(groups, function(g, gPrev) {
          if (!(g instanceof group_types_1.BlockGroup) || !(gPrev instanceof group_types_1.BlockGroup)) {
            return false;
          }
          return blocksOf.codeBlocks && Grouper2.areBothCodeblocksWithSameLang(g, gPrev) || blocksOf.blockquotes && Grouper2.areBothBlockquotesWithSameAdi(g, gPrev) || blocksOf.header && Grouper2.areBothSameHeadersWithSameAdi(g, gPrev) || blocksOf.customBlocks && Grouper2.areBothCustomBlockWithSameAttr(g, gPrev);
        });
      };
      Grouper2.reduceConsecutiveSameStyleBlocksToOne = function(groups) {
        var newLineOp = DeltaInsertOp_1.DeltaInsertOp.createNewLineOp();
        return groups.map(function(elm) {
          if (!Array.isArray(elm)) {
            if (elm instanceof group_types_1.BlockGroup && !elm.ops.length) {
              elm.ops.push(newLineOp);
            }
            return elm;
          }
          var groupsLastInd = elm.length - 1;
          elm[0].ops = array_1.flatten(elm.map(function(g, i) {
            if (!g.ops.length) {
              return [
                newLineOp
              ];
            }
            return g.ops.concat(i < groupsLastInd ? [
              newLineOp
            ] : []);
          }));
          return elm[0];
        });
      };
      Grouper2.areBothCodeblocksWithSameLang = function(g1, gOther) {
        return g1.op.isCodeBlock() && gOther.op.isCodeBlock() && g1.op.hasSameLangAs(gOther.op);
      };
      Grouper2.areBothSameHeadersWithSameAdi = function(g1, gOther) {
        return g1.op.isSameHeaderAs(gOther.op) && g1.op.hasSameAdiAs(gOther.op);
      };
      Grouper2.areBothBlockquotesWithSameAdi = function(g, gOther) {
        return g.op.isBlockquote() && gOther.op.isBlockquote() && g.op.hasSameAdiAs(gOther.op);
      };
      Grouper2.areBothCustomBlockWithSameAttr = function(g, gOther) {
        return g.op.isCustomTextBlock() && gOther.op.isCustomTextBlock() && g.op.hasSameAttr(gOther.op);
      };
      return Grouper2;
    }();
    exports.Grouper = Grouper;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/grouper/ListNester.js
var require_ListNester = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/grouper/ListNester.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var group_types_1 = require_group_types();
    var array_1 = require_array();
    var ListNester = function() {
      function ListNester2() {
      }
      __name(ListNester2, "ListNester");
      ListNester2.prototype.nest = function(groups) {
        var _this = this;
        var listBlocked = this.convertListBlocksToListGroups(groups);
        var groupedByListGroups = this.groupConsecutiveListGroups(listBlocked);
        var nested = array_1.flatten(groupedByListGroups.map(function(group) {
          if (!Array.isArray(group)) {
            return group;
          }
          return _this.nestListSection(group);
        }));
        var groupRootLists = array_1.groupConsecutiveElementsWhile(nested, function(curr, prev) {
          if (!(curr instanceof group_types_1.ListGroup && prev instanceof group_types_1.ListGroup)) {
            return false;
          }
          return curr.items[0].item.op.isSameListAs(prev.items[0].item.op);
        });
        return groupRootLists.map(function(v) {
          if (!Array.isArray(v)) {
            return v;
          }
          var litems = v.map(function(g) {
            return g.items;
          });
          return new group_types_1.ListGroup(array_1.flatten(litems));
        });
      };
      ListNester2.prototype.convertListBlocksToListGroups = function(items) {
        var grouped = array_1.groupConsecutiveElementsWhile(items, function(g, gPrev) {
          return g instanceof group_types_1.BlockGroup && gPrev instanceof group_types_1.BlockGroup && g.op.isList() && gPrev.op.isList() && g.op.isSameListAs(gPrev.op) && g.op.hasSameIndentationAs(gPrev.op);
        });
        return grouped.map(function(item) {
          if (!Array.isArray(item)) {
            if (item instanceof group_types_1.BlockGroup && item.op.isList()) {
              return new group_types_1.ListGroup([
                new group_types_1.ListItem(item)
              ]);
            }
            return item;
          }
          return new group_types_1.ListGroup(item.map(function(g) {
            return new group_types_1.ListItem(g);
          }));
        });
      };
      ListNester2.prototype.groupConsecutiveListGroups = function(items) {
        return array_1.groupConsecutiveElementsWhile(items, function(curr, prev) {
          return curr instanceof group_types_1.ListGroup && prev instanceof group_types_1.ListGroup;
        });
      };
      ListNester2.prototype.nestListSection = function(sectionItems) {
        var _this = this;
        var indentGroups = this.groupByIndent(sectionItems);
        Object.keys(indentGroups).map(Number).sort().reverse().forEach(function(indent) {
          indentGroups[indent].forEach(function(lg) {
            var idx = sectionItems.indexOf(lg);
            if (_this.placeUnderParent(lg, sectionItems.slice(0, idx))) {
              sectionItems.splice(idx, 1);
            }
          });
        });
        return sectionItems;
      };
      ListNester2.prototype.groupByIndent = function(items) {
        return items.reduce(function(pv, cv) {
          var indent = cv.items[0].item.op.attributes.indent;
          if (indent) {
            pv[indent] = pv[indent] || [];
            pv[indent].push(cv);
          }
          return pv;
        }, {});
      };
      ListNester2.prototype.placeUnderParent = function(target, items) {
        for (var i = items.length - 1; i >= 0; i--) {
          var elm = items[i];
          if (target.items[0].item.op.hasHigherIndentThan(elm.items[0].item.op)) {
            var parent = elm.items[elm.items.length - 1];
            if (parent.innerList) {
              parent.innerList.items = parent.innerList.items.concat(target.items);
            } else {
              parent.innerList = target;
            }
            return true;
          }
        }
        return false;
      };
      return ListNester2;
    }();
    exports.ListNester = ListNester;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/grouper/TableGrouper.js
var require_TableGrouper = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/grouper/TableGrouper.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var group_types_1 = require_group_types();
    var array_1 = require_array();
    var TableGrouper = function() {
      function TableGrouper2() {
      }
      __name(TableGrouper2, "TableGrouper");
      TableGrouper2.prototype.group = function(groups) {
        var tableBlocked = this.convertTableBlocksToTableGroups(groups);
        return tableBlocked;
      };
      TableGrouper2.prototype.convertTableBlocksToTableGroups = function(items) {
        var _this = this;
        var grouped = array_1.groupConsecutiveElementsWhile(items, function(g, gPrev) {
          return g instanceof group_types_1.BlockGroup && gPrev instanceof group_types_1.BlockGroup && g.op.isTable() && gPrev.op.isTable();
        });
        return grouped.map(function(item) {
          if (!Array.isArray(item)) {
            if (item instanceof group_types_1.BlockGroup && item.op.isTable()) {
              return new group_types_1.TableGroup([
                new group_types_1.TableRow([
                  new group_types_1.TableCell(item)
                ])
              ]);
            }
            return item;
          }
          return new group_types_1.TableGroup(_this.convertTableBlocksToTableRows(item));
        });
      };
      TableGrouper2.prototype.convertTableBlocksToTableRows = function(items) {
        var grouped = array_1.groupConsecutiveElementsWhile(items, function(g, gPrev) {
          return g instanceof group_types_1.BlockGroup && gPrev instanceof group_types_1.BlockGroup && g.op.isTable() && gPrev.op.isTable() && g.op.isSameTableRowAs(gPrev.op);
        });
        return grouped.map(function(item) {
          return new group_types_1.TableRow(Array.isArray(item) ? item.map(function(it) {
            return new group_types_1.TableCell(it);
          }) : [
            new group_types_1.TableCell(item)
          ]);
        });
      };
      return TableGrouper2;
    }();
    exports.TableGrouper = TableGrouper;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/QuillDeltaToHtmlConverter.js
var require_QuillDeltaToHtmlConverter = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/QuillDeltaToHtmlConverter.js"(exports) {
    "use strict";
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule) return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
      }
      result["default"] = mod;
      return result;
    };
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var InsertOpsConverter_1 = require_InsertOpsConverter();
    var OpToHtmlConverter_1 = require_OpToHtmlConverter();
    var Grouper_1 = require_Grouper();
    var group_types_1 = require_group_types();
    var ListNester_1 = require_ListNester();
    var funcs_html_1 = require_funcs_html();
    var obj = __importStar(require_object());
    var value_types_1 = require_value_types();
    var TableGrouper_1 = require_TableGrouper();
    var BrTag = "<br/>";
    var QuillDeltaToHtmlConverter2 = function() {
      function QuillDeltaToHtmlConverter3(deltaOps, options) {
        this.rawDeltaOps = [];
        this.callbacks = {};
        this.options = obj.assign({
          paragraphTag: "p",
          encodeHtml: true,
          classPrefix: "ql",
          inlineStyles: false,
          multiLineBlockquote: true,
          multiLineHeader: true,
          multiLineCodeblock: true,
          multiLineParagraph: true,
          multiLineCustomBlock: true,
          allowBackgroundClasses: false,
          linkTarget: "_blank"
        }, options, {
          orderedListTag: "ol",
          bulletListTag: "ul",
          listItemTag: "li"
        });
        var inlineStyles;
        if (!this.options.inlineStyles) {
          inlineStyles = void 0;
        } else if (typeof this.options.inlineStyles === "object") {
          inlineStyles = this.options.inlineStyles;
        } else {
          inlineStyles = {};
        }
        this.converterOptions = {
          encodeHtml: this.options.encodeHtml,
          classPrefix: this.options.classPrefix,
          inlineStyles,
          listItemTag: this.options.listItemTag,
          paragraphTag: this.options.paragraphTag,
          linkRel: this.options.linkRel,
          linkTarget: this.options.linkTarget,
          allowBackgroundClasses: this.options.allowBackgroundClasses,
          customTag: this.options.customTag,
          customTagAttributes: this.options.customTagAttributes,
          customCssClasses: this.options.customCssClasses,
          customCssStyles: this.options.customCssStyles
        };
        this.rawDeltaOps = deltaOps;
      }
      __name(QuillDeltaToHtmlConverter3, "QuillDeltaToHtmlConverter");
      QuillDeltaToHtmlConverter3.prototype._getListTag = function(op) {
        return op.isOrderedList() ? this.options.orderedListTag + "" : op.isBulletList() ? this.options.bulletListTag + "" : op.isCheckedList() ? this.options.bulletListTag + "" : op.isUncheckedList() ? this.options.bulletListTag + "" : "";
      };
      QuillDeltaToHtmlConverter3.prototype.getGroupedOps = function() {
        var deltaOps = InsertOpsConverter_1.InsertOpsConverter.convert(this.rawDeltaOps, this.options);
        var pairedOps = Grouper_1.Grouper.pairOpsWithTheirBlock(deltaOps);
        var groupedSameStyleBlocks = Grouper_1.Grouper.groupConsecutiveSameStyleBlocks(pairedOps, {
          blockquotes: !!this.options.multiLineBlockquote,
          header: !!this.options.multiLineHeader,
          codeBlocks: !!this.options.multiLineCodeblock,
          customBlocks: !!this.options.multiLineCustomBlock
        });
        var groupedOps = Grouper_1.Grouper.reduceConsecutiveSameStyleBlocksToOne(groupedSameStyleBlocks);
        var tableGrouper = new TableGrouper_1.TableGrouper();
        groupedOps = tableGrouper.group(groupedOps);
        var listNester = new ListNester_1.ListNester();
        return listNester.nest(groupedOps);
      };
      QuillDeltaToHtmlConverter3.prototype.convert = function() {
        var _this = this;
        var groups = this.getGroupedOps();
        return groups.map(function(group) {
          if (group instanceof group_types_1.ListGroup) {
            return _this._renderWithCallbacks(value_types_1.GroupType.List, group, function() {
              return _this._renderList(group);
            });
          } else if (group instanceof group_types_1.TableGroup) {
            return _this._renderWithCallbacks(value_types_1.GroupType.Table, group, function() {
              return _this._renderTable(group);
            });
          } else if (group instanceof group_types_1.BlockGroup) {
            var g = group;
            return _this._renderWithCallbacks(value_types_1.GroupType.Block, group, function() {
              return _this._renderBlock(g.op, g.ops);
            });
          } else if (group instanceof group_types_1.BlotBlock) {
            return _this._renderCustom(group.op, null);
          } else if (group instanceof group_types_1.VideoItem) {
            return _this._renderWithCallbacks(value_types_1.GroupType.Video, group, function() {
              var g2 = group;
              var converter = new OpToHtmlConverter_1.OpToHtmlConverter(g2.op, _this.converterOptions);
              return converter.getHtml();
            });
          } else {
            return _this._renderWithCallbacks(value_types_1.GroupType.InlineGroup, group, function() {
              return _this._renderInlines(group.ops, true);
            });
          }
        }).join("");
      };
      QuillDeltaToHtmlConverter3.prototype._renderWithCallbacks = function(groupType, group, myRenderFn) {
        var html = "";
        var beforeCb = this.callbacks["beforeRender_cb"];
        html = typeof beforeCb === "function" ? beforeCb.apply(null, [
          groupType,
          group
        ]) : "";
        if (!html) {
          html = myRenderFn();
        }
        var afterCb = this.callbacks["afterRender_cb"];
        html = typeof afterCb === "function" ? afterCb.apply(null, [
          groupType,
          html
        ]) : html;
        return html;
      };
      QuillDeltaToHtmlConverter3.prototype._renderList = function(list) {
        var _this = this;
        var firstItem = list.items[0];
        return funcs_html_1.makeStartTag(this._getListTag(firstItem.item.op)) + list.items.map(function(li) {
          return _this._renderListItem(li);
        }).join("") + funcs_html_1.makeEndTag(this._getListTag(firstItem.item.op));
      };
      QuillDeltaToHtmlConverter3.prototype._renderListItem = function(li) {
        li.item.op.attributes.indent = 0;
        var converter = new OpToHtmlConverter_1.OpToHtmlConverter(li.item.op, this.converterOptions);
        var parts = converter.getHtmlParts();
        var liElementsHtml = this._renderInlines(li.item.ops, false);
        return parts.openingTag + liElementsHtml + (li.innerList ? this._renderList(li.innerList) : "") + parts.closingTag;
      };
      QuillDeltaToHtmlConverter3.prototype._renderTable = function(table) {
        var _this = this;
        return funcs_html_1.makeStartTag("table") + funcs_html_1.makeStartTag("tbody") + table.rows.map(function(row) {
          return _this._renderTableRow(row);
        }).join("") + funcs_html_1.makeEndTag("tbody") + funcs_html_1.makeEndTag("table");
      };
      QuillDeltaToHtmlConverter3.prototype._renderTableRow = function(row) {
        var _this = this;
        return funcs_html_1.makeStartTag("tr") + row.cells.map(function(cell) {
          return _this._renderTableCell(cell);
        }).join("") + funcs_html_1.makeEndTag("tr");
      };
      QuillDeltaToHtmlConverter3.prototype._renderTableCell = function(cell) {
        var converter = new OpToHtmlConverter_1.OpToHtmlConverter(cell.item.op, this.converterOptions);
        var parts = converter.getHtmlParts();
        var cellElementsHtml = this._renderInlines(cell.item.ops, false);
        return funcs_html_1.makeStartTag("td", {
          key: "data-row",
          value: cell.item.op.attributes.table
        }) + parts.openingTag + cellElementsHtml + parts.closingTag + funcs_html_1.makeEndTag("td");
      };
      QuillDeltaToHtmlConverter3.prototype._renderBlock = function(bop, ops) {
        var _this = this;
        var converter = new OpToHtmlConverter_1.OpToHtmlConverter(bop, this.converterOptions);
        var htmlParts = converter.getHtmlParts();
        if (bop.isCodeBlock()) {
          return htmlParts.openingTag + funcs_html_1.encodeHtml(ops.map(function(iop) {
            return iop.isCustomEmbed() ? _this._renderCustom(iop, bop) : iop.insert.value;
          }).join("")) + htmlParts.closingTag;
        }
        var inlines = ops.map(function(op) {
          return _this._renderInline(op, bop);
        }).join("");
        return htmlParts.openingTag + (inlines || BrTag) + htmlParts.closingTag;
      };
      QuillDeltaToHtmlConverter3.prototype._renderInlines = function(ops, isInlineGroup) {
        var _this = this;
        if (isInlineGroup === void 0) {
          isInlineGroup = true;
        }
        var opsLen = ops.length - 1;
        var html = ops.map(function(op, i) {
          if (i > 0 && i === opsLen && op.isJustNewline()) {
            return "";
          }
          return _this._renderInline(op, null);
        }).join("");
        if (!isInlineGroup) {
          return html;
        }
        var startParaTag = funcs_html_1.makeStartTag(this.options.paragraphTag);
        var endParaTag = funcs_html_1.makeEndTag(this.options.paragraphTag);
        if (html === BrTag || this.options.multiLineParagraph) {
          return startParaTag + html + endParaTag;
        }
        return startParaTag + html.split(BrTag).map(function(v) {
          return v === "" ? BrTag : v;
        }).join(endParaTag + startParaTag) + endParaTag;
      };
      QuillDeltaToHtmlConverter3.prototype._renderInline = function(op, contextOp) {
        if (op.isCustomEmbed()) {
          return this._renderCustom(op, contextOp);
        }
        var converter = new OpToHtmlConverter_1.OpToHtmlConverter(op, this.converterOptions);
        return converter.getHtml().replace(/\n/g, BrTag);
      };
      QuillDeltaToHtmlConverter3.prototype._renderCustom = function(op, contextOp) {
        var renderCb = this.callbacks["renderCustomOp_cb"];
        if (typeof renderCb === "function") {
          return renderCb.apply(null, [
            op,
            contextOp
          ]);
        }
        return "";
      };
      QuillDeltaToHtmlConverter3.prototype.beforeRender = function(cb) {
        if (typeof cb === "function") {
          this.callbacks["beforeRender_cb"] = cb;
        }
      };
      QuillDeltaToHtmlConverter3.prototype.afterRender = function(cb) {
        if (typeof cb === "function") {
          this.callbacks["afterRender_cb"] = cb;
        }
      };
      QuillDeltaToHtmlConverter3.prototype.renderCustomWith = function(cb) {
        this.callbacks["renderCustomOp_cb"] = cb;
      };
      return QuillDeltaToHtmlConverter3;
    }();
    exports.QuillDeltaToHtmlConverter = QuillDeltaToHtmlConverter2;
  }
});

// ../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/main.js
var require_main = __commonJS({
  "../../node_modules/.pnpm/quill-delta-to-html@0.12.1/node_modules/quill-delta-to-html/dist/commonjs/main.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var QuillDeltaToHtmlConverter_1 = require_QuillDeltaToHtmlConverter();
    exports.QuillDeltaToHtmlConverter = QuillDeltaToHtmlConverter_1.QuillDeltaToHtmlConverter;
    var OpToHtmlConverter_1 = require_OpToHtmlConverter();
    exports.OpToHtmlConverter = OpToHtmlConverter_1.OpToHtmlConverter;
    var group_types_1 = require_group_types();
    exports.InlineGroup = group_types_1.InlineGroup;
    exports.VideoItem = group_types_1.VideoItem;
    exports.BlockGroup = group_types_1.BlockGroup;
    exports.ListGroup = group_types_1.ListGroup;
    exports.ListItem = group_types_1.ListItem;
    exports.BlotBlock = group_types_1.BlotBlock;
    var DeltaInsertOp_1 = require_DeltaInsertOp();
    exports.DeltaInsertOp = DeltaInsertOp_1.DeltaInsertOp;
    var InsertData_1 = require_InsertData();
    exports.InsertDataQuill = InsertData_1.InsertDataQuill;
    exports.InsertDataCustom = InsertData_1.InsertDataCustom;
    var value_types_1 = require_value_types();
    exports.NewLine = value_types_1.NewLine;
    exports.ListType = value_types_1.ListType;
    exports.ScriptType = value_types_1.ScriptType;
    exports.DirectionType = value_types_1.DirectionType;
    exports.AlignType = value_types_1.AlignType;
    exports.DataType = value_types_1.DataType;
    exports.GroupType = value_types_1.GroupType;
  }
});

// ../../node_modules/.pnpm/deepmerge@4.3.1/node_modules/deepmerge/dist/cjs.js
var require_cjs = __commonJS({
  "../../node_modules/.pnpm/deepmerge@4.3.1/node_modules/deepmerge/dist/cjs.js"(exports, module) {
    "use strict";
    var isMergeableObject = /* @__PURE__ */ __name(function isMergeableObject2(value) {
      return isNonNullObject(value) && !isSpecial(value);
    }, "isMergeableObject");
    function isNonNullObject(value) {
      return !!value && typeof value === "object";
    }
    __name(isNonNullObject, "isNonNullObject");
    function isSpecial(value) {
      var stringValue = Object.prototype.toString.call(value);
      return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
    }
    __name(isSpecial, "isSpecial");
    var canUseSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
    function isReactElement(value) {
      return value.$$typeof === REACT_ELEMENT_TYPE;
    }
    __name(isReactElement, "isReactElement");
    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }
    __name(emptyTarget, "emptyTarget");
    function cloneUnlessOtherwiseSpecified(value, options) {
      return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
    }
    __name(cloneUnlessOtherwiseSpecified, "cloneUnlessOtherwiseSpecified");
    function defaultArrayMerge(target, source, options) {
      return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
      });
    }
    __name(defaultArrayMerge, "defaultArrayMerge");
    function getMergeFunction(key, options) {
      if (!options.customMerge) {
        return deepmerge;
      }
      var customMerge = options.customMerge(key);
      return typeof customMerge === "function" ? customMerge : deepmerge;
    }
    __name(getMergeFunction, "getMergeFunction");
    function getEnumerableOwnPropertySymbols(target) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
      }) : [];
    }
    __name(getEnumerableOwnPropertySymbols, "getEnumerableOwnPropertySymbols");
    function getKeys(target) {
      return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
    }
    __name(getKeys, "getKeys");
    function propertyIsOnObject(object2, property) {
      try {
        return property in object2;
      } catch (_) {
        return false;
      }
    }
    __name(propertyIsOnObject, "propertyIsOnObject");
    function propertyIsUnsafe(target, key) {
      return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
    }
    __name(propertyIsUnsafe, "propertyIsUnsafe");
    function mergeObject(target, source, options) {
      var destination = {};
      if (options.isMergeableObject(target)) {
        getKeys(target).forEach(function(key) {
          destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
        });
      }
      getKeys(source).forEach(function(key) {
        if (propertyIsUnsafe(target, key)) {
          return;
        }
        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
          destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        } else {
          destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        }
      });
      return destination;
    }
    __name(mergeObject, "mergeObject");
    function deepmerge(target, source, options) {
      options = options || {};
      options.arrayMerge = options.arrayMerge || defaultArrayMerge;
      options.isMergeableObject = options.isMergeableObject || isMergeableObject;
      options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
      var sourceIsArray = Array.isArray(source);
      var targetIsArray = Array.isArray(target);
      var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
      if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options);
      } else if (sourceIsArray) {
        return options.arrayMerge(target, source, options);
      } else {
        return mergeObject(target, source, options);
      }
    }
    __name(deepmerge, "deepmerge");
    deepmerge.all = /* @__PURE__ */ __name(function deepmergeAll(array2, options) {
      if (!Array.isArray(array2)) {
        throw new Error("first argument should be an array");
      }
      return array2.reduce(function(prev, next) {
        return deepmerge(prev, next, options);
      }, {});
    }, "deepmergeAll");
    var deepmerge_1 = deepmerge;
    module.exports = deepmerge_1;
  }
});

// src/action-plans/action-plan-analytics.types.ts
import { z } from "zod";

// src/helpers/preprocessors.ts
function booleanQueryParamToBoolean(val) {
  return !val ? val : (
    // If it is truthy, send on all values as true except for the strings 'false' or '0'
    typeof val === "string" && (val === "0" || val.toLowerCase() === "false") ? false : true
  );
}
__name(booleanQueryParamToBoolean, "booleanQueryParamToBoolean");
function commaSeparatedArrayParamToArray(val) {
  if (typeof val === "string") {
    return val.split(",");
  }
  return val;
}
__name(commaSeparatedArrayParamToArray, "commaSeparatedArrayParamToArray");

// src/action-plans/action-plan-analytics.types.ts
var baseAnalyticsQuerySchema = z.object({
  templateIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  actionPlanIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  milestoneIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  search: z.string().optional(),
  spaceCreatedAfter: z.coerce.date().optional(),
  spaceCreatedBefore: z.coerce.date().optional(),
  ownerIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  includeArchivedTemplates: z.preprocess(booleanQueryParamToBoolean, z.boolean()).optional().default(false),
  includeArchivedSpaces: z.preprocess(booleanQueryParamToBoolean, z.boolean()).optional().default(true)
});
var ActionPlanAnalyticsGroupingPeriod = {
  Week: "week",
  Month: "month"
};
var tasksCompletedOverTimeGroupBySchema = z.enum([
  ActionPlanAnalyticsGroupingPeriod.Week,
  ActionPlanAnalyticsGroupingPeriod.Month
]);
var ActionPlanAnalyticsGroupingLevel = {
  Template: "template",
  ActionPlan: "action plan",
  Milestone: "milestone",
  Task: "task"
};
var actionPlanAnalyticsGroupingLevelSchema = z.enum([
  ActionPlanAnalyticsGroupingLevel.Template,
  ActionPlanAnalyticsGroupingLevel.ActionPlan,
  ActionPlanAnalyticsGroupingLevel.Milestone,
  ActionPlanAnalyticsGroupingLevel.Task
]);
var tasksCompletedOverTimeQuerySchema = baseAnalyticsQuerySchema.extend({
  groupBy: tasksCompletedOverTimeGroupBySchema.optional(),
  groupingLevel: actionPlanAnalyticsGroupingLevelSchema.optional().default("template")
});
var templateSummaryQuerySchema = baseAnalyticsQuerySchema.extend({
  groupingLevel: actionPlanAnalyticsGroupingLevelSchema.optional()
});
var templateSummarySpacesGroupTypeSchema = z.enum([
  "space count",
  "completed",
  "days to completion",
  "quickest",
  "slowest"
]);
var spaceSummaryQuerySchema = z.object({
  originNodeId: z.string(),
  groupingLevel: actionPlanAnalyticsGroupingLevelSchema,
  groupType: templateSummarySpacesGroupTypeSchema,
  spaceCreatedAfter: z.coerce.date().optional(),
  spaceCreatedBefore: z.coerce.date().optional(),
  ownerIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  actionPlanIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  milestoneIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  includeArchivedSpaces: z.preprocess(booleanQueryParamToBoolean, z.boolean()).optional().default(true)
});
var actionPlanTaskAnalyticsRecordSchema = z.object({
  originNodeId: z.string(),
  title: z.string(),
  removed: z.boolean(),
  spaceCount: z.number(),
  completedCount: z.number(),
  avgCompletionDays: z.number().nullable(),
  lowerQuartileDays: z.number().nullable(),
  upperQuartileDays: z.number().nullable()
});
var actionPlanMilestoneAnalyticsRecordSchema = actionPlanTaskAnalyticsRecordSchema.pick({
  originNodeId: true,
  title: true,
  removed: true
}).extend({
  tasks: z.array(actionPlanTaskAnalyticsRecordSchema),
  spaceCount: z.number().optional(),
  completedCount: z.number().optional(),
  avgCompletionDays: z.number().nullable().optional(),
  lowerQuartileDays: z.number().nullable().optional(),
  upperQuartileDays: z.number().nullable().optional()
});
var actionPlanAnalyticsRecordSchema = actionPlanMilestoneAnalyticsRecordSchema.pick({
  originNodeId: true,
  title: true,
  removed: true,
  spaceCount: true,
  completedCount: true,
  avgCompletionDays: true,
  lowerQuartileDays: true,
  upperQuartileDays: true
}).extend({
  milestones: z.array(actionPlanMilestoneAnalyticsRecordSchema)
});
var templateActionPlansAnalyticRecordSchema = actionPlanAnalyticsRecordSchema.pick({
  title: true,
  spaceCount: true,
  completedCount: true,
  avgCompletionDays: true,
  lowerQuartileDays: true,
  upperQuartileDays: true
}).extend({
  templateId: z.string(),
  templateNodeId: z.string(),
  actionPlans: z.array(actionPlanAnalyticsRecordSchema)
});
var actionPlanTasksAggregatedByTemplateSchema = z.array(templateActionPlansAnalyticRecordSchema);
var actionPlanAnalyticsResponseSchema = z.object({
  items: actionPlanTasksAggregatedByTemplateSchema,
  meta: z.object({
    lastRefreshed: z.string().nullish()
  })
});
var tasksCompletedOverTimeRecordSchema = z.object({
  date: z.coerce.date(),
  count: z.number()
});
var tasksCompletedOverTimeResponseSchema = z.array(tasksCompletedOverTimeRecordSchema);
var spaceSummaryRecordSchema = z.object({
  spaceId: z.string(),
  spaceRootNodeId: z.string(),
  spaceName: z.string(),
  spaceAuthToken: z.string(),
  daysToComplete: z.number().nullable(),
  actionPlanNodeId: z.string().optional()
});
var spaceSummaryResponseSchema = z.array(spaceSummaryRecordSchema);
var ActionPlanAnalyticsTimeRangePeriod = {
  LastWeek: "Last week",
  LastTwoWeeks: "Last 2 weeks",
  ThisMonth: "This month",
  LastMonth: "Last month",
  LastThreeMonths: "Last 3 months",
  ThisQuarter: "This quarter",
  LastQuarter: "Last quarter",
  LastTwelveMonths: "Last 12 months",
  Custom: "custom"
};
var timeRangePeriodSchema = z.enum([
  ActionPlanAnalyticsTimeRangePeriod.LastWeek,
  ActionPlanAnalyticsTimeRangePeriod.LastTwoWeeks,
  ActionPlanAnalyticsTimeRangePeriod.ThisMonth,
  ActionPlanAnalyticsTimeRangePeriod.LastMonth,
  ActionPlanAnalyticsTimeRangePeriod.LastThreeMonths,
  ActionPlanAnalyticsTimeRangePeriod.ThisQuarter,
  ActionPlanAnalyticsTimeRangePeriod.LastQuarter,
  ActionPlanAnalyticsTimeRangePeriod.LastTwelveMonths,
  ActionPlanAnalyticsTimeRangePeriod.Custom
]);
var taskAnalyticsSearchSchema = z.object({
  search: z.string().optional(),
  timeRangePeriod: timeRangePeriodSchema.optional(),
  spaceCreatedAfter: z.string().refine((value) => !value || !isNaN(Date.parse(value)), {
    message: "Invalid date string"
  }).optional(),
  spaceCreatedBefore: z.string().refine((value) => !value || !isNaN(Date.parse(value)), {
    message: "Invalid date string"
  }).optional(),
  groupBy: tasksCompletedOverTimeGroupBySchema.optional(),
  includeArchivedSpaces: z.preprocess(booleanQueryParamToBoolean, z.boolean()).optional(),
  includeArchivedTemplates: z.preprocess(booleanQueryParamToBoolean, z.boolean()).optional(),
  ownerIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  templateIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  actionPlanIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  milestoneIds: z.preprocess(commaSeparatedArrayParamToArray, z.array(z.string())).optional(),
  groupingLevel: actionPlanAnalyticsGroupingLevelSchema.optional()
});
var isTaskAnalyticsSearch = /* @__PURE__ */ __name((prev) => {
  return taskAnalyticsSearchSchema.safeParse(prev).success;
}, "isTaskAnalyticsSearch");

// src/action-plans/action-plans.types.ts
import { z as z13 } from "zod";

// src/pagination.ts
import { z as z2 } from "zod";
function createPaginationSchema(itemSchema, metaSchema) {
  const baseSchema = z2.object({
    // Items returned (if a filter applies, only items that match the filter are returned).
    items: z2.array(itemSchema),
    // Total number of items (if a filter applies, this is the total number of items that match the filter).
    totalItems: z2.number(),
    // The current page number.
    currentPage: z2.number(),
    // The total number of pages (if a filter applies, this is the total number of pages that match the filter).
    totalPages: z2.number(),
    // The number of items per page.
    itemsPerPage: z2.number(),
    // Whether any items exist, ignoring the current filter.
    itemsExist: z2.boolean(),
    // Any metadata to attach to the pagination response.
    meta: metaSchema
  });
  return baseSchema;
}
__name(createPaginationSchema, "createPaginationSchema");
function createPaginationQuerySchema(filtersSchema) {
  if (filtersSchema.shape.page || filtersSchema.shape.itemsPerPage) {
    throw new Error("page and itemsPerPage are reserved keys createPaginationQuerySchema");
  }
  return filtersSchema.extend({
    page: z2.coerce.number().min(1).optional(),
    itemsPerPage: z2.coerce.number().min(1).max(100).optional()
  });
}
__name(createPaginationQuerySchema, "createPaginationQuerySchema");
function validatePaginatedQueryParams(querySchema, queryObject) {
  const validationResult = querySchema.safeParse(queryObject);
  if (!validationResult.success) {
    return validationResult;
  }
  return __spreadProps(__spreadValues({}, validationResult), {
    data: __spreadProps(__spreadValues({}, validationResult.data), {
      page: validationResult.data.page || 1,
      itemsPerPage: validationResult.data.itemsPerPage || 10
    })
  });
}
__name(validatePaginatedQueryParams, "validatePaginatedQueryParams");

// src/types/billing.ts
import { z as z3 } from "zod";
var billingDetailsSchema = z3.object({
  stripeCustomerId: z3.string().nullish(),
  trialDays: z3.number().nullish()
});
var subscriptionInfoSchema = z3.object({
  seatLimit: z3.coerce.number().nullable(),
  nextBillDate: z3.coerce.date().nullable(),
  planInterval: z3.string().nullable()
});

// src/types/custom-property.ts
import { z as z4 } from "zod";

// src/cardinal-value/cardinal-value.ts
var ValueCardinality = /* @__PURE__ */ function(ValueCardinality2) {
  ValueCardinality2["SingleValue"] = "SINGLE_VALUE";
  ValueCardinality2["MultiValue"] = "MULTI_VALUE";
  return ValueCardinality2;
}({});
function readCardinalValue(cv) {
  if (cv.type === "MULTI_VALUE") {
    return cv.value;
  }
  if (cv.type === "SINGLE_VALUE") {
    return cv.value;
  }
  throw new Error("TCardinalValue has unknown type");
}
__name(readCardinalValue, "readCardinalValue");
function isCardinalValue(arg) {
  if (typeof arg !== "object" || arg === null) {
    return false;
  }
  const potentialCv = arg;
  if (!("type" in potentialCv) || !("value" in potentialCv)) {
    return false;
  }
  if (potentialCv.type === "SINGLE_VALUE") {
    return true;
  }
  if (potentialCv.type === "MULTI_VALUE") {
    return Array.isArray(potentialCv.value);
  }
  return false;
}
__name(isCardinalValue, "isCardinalValue");

// src/types/custom-property.ts
var customPropertyType = z4.enum([
  ValueCardinality.SingleValue,
  ValueCardinality.MultiValue
]);
var customPropertySchema = z4.object({
  id: z4.string(),
  tenantId: z4.string(),
  key: z4.string(),
  displayName: z4.string(),
  gptPrompt: z4.string(),
  createdAt: z4.string(),
  updatedAt: z4.string(),
  options: z4.array(z4.string()),
  isOptional: z4.boolean().optional(),
  type: customPropertyType
});
var customPropertiesResponseSchema = z4.array(customPropertySchema);

// src/types/digest.ts
import { z as z5 } from "zod";
var topSpaceItemSchema = z5.object({
  rootNodeId: z5.string(),
  companyName: z5.string(),
  sessions: z5.number(),
  activities: z5.number(),
  spaceUrl: z5.string()
});
var dueTaskItemSchema = z5.object({
  taskName: z5.string(),
  milestoneName: z5.string(),
  spaceName: z5.string(),
  actionPlanName: z5.string(),
  dueDate: z5.string(),
  taskUrl: z5.string()
});
var digestNotificationSchema = z5.object({
  type: z5.enum([
    "DAILY",
    "WEEKLY"
  ]),
  email: z5.string().email(),
  visits: z5.number(),
  activities: z5.number(),
  createdSpaces: z5.number(),
  topSpaces: z5.array(topSpaceItemSchema),
  dueTasks: z5.array(dueTaskItemSchema),
  overdueTasks: z5.array(dueTaskItemSchema),
  unsubscribeURL: z5.string().url(),
  taskManagerURL: z5.string().url(),
  showingAllOverdueTasks: z5.boolean()
});

// src/types/expect.ts
var expectNonNullable = /* @__PURE__ */ __name((value) => {
  if (value === null || value === void 0) {
    throw new Error("expected non-nullable value");
  }
  return value;
}, "expectNonNullable");

// src/types/htmlEmbedAI.ts
import { z as z6 } from "zod";
var HtmlEmbedAIResponseSchema = z6.object({
  htmlContent: z6.string(),
  refinementPredictions: z6.array(z6.string()).optional(),
  suggestionsCreatedAt: z6.number().optional()
});

// src/types/seller.ts
import { z as z7 } from "zod";
var sellerNotificationsSettingsSchema = z7.object({
  id: z7.string(),
  newComments: z7.boolean(),
  firstVisit: z7.boolean(),
  actionPlanActivities: z7.boolean(),
  buyerFilesBlockUpload: z7.boolean(),
  buyerCompletedForm: z7.boolean()
});
var sellerBaseSchema = z7.object({
  title: z7.string().nullish(),
  firstName: z7.string(),
  lastName: z7.string(),
  email: z7.string(),
  contactEmail: z7.string().nullish(),
  phoneNumber: z7.string().nullish(),
  meetingLink: z7.string().nullish(),
  photo_s3ObjectKey: z7.string().nullish()
});
var sellerSchema = sellerBaseSchema.extend({
  id: z7.string(),
  tenantId: z7.string(),
  notificationsSettingsId: z7.string().nullish(),
  NotificationsSettings: sellerNotificationsSettingsSchema.nullish()
});
var sellersResponseSchema = z7.array(sellerSchema);
var sellerQueueBaseSchema = z7.object({
  sellerId: z7.string(),
  tenantId: z7.string()
});
var sellerQueueUpsertSchema = sellerQueueBaseSchema.extend({
  update: sellerBaseSchema
});
var sellerQueueDeleteSchema = sellerQueueBaseSchema.extend({
  jwtToken: z7.string()
});

// src/types/spaces.ts
import { z as z9 } from "zod";

// src/teams/teams.ts
import * as z8 from "zod";
var createTeamSchema = z8.object({
  name: z8.string()
});
var updateTeamSchema = createTeamSchema.extend({
  id: z8.string()
});
var teamSchema = updateTeamSchema.extend({
  tenantId: z8.string(),
  updatedById: z8.string(),
  createdById: z8.string(),
  createdAt: z8.coerce.date()
});
var teamListSchema = z8.array(teamSchema);
var memberIds = z8.array(z8.string());
var createTeamWithMembersSchema = createTeamSchema.extend({
  memberIds
});
var updateTeamWithMembersSchema = updateTeamSchema.extend({
  memberIds
});
var teamWithMembersSchema = teamSchema.extend({
  memberIds
});
var teamWithMembersListSchema = z8.array(teamWithMembersSchema);

// src/types/spaces.ts
var spaceActionPlanStatusSchema = z9.enum([
  "notCreated",
  "notStarted",
  "inProgress",
  "stalled",
  "overdue",
  "completed"
]);
var SpaceScoringInputSchema = z9.object({
  spaceId: z9.string(),
  nonSessionActivityCount: z9.number(),
  allActivityCount: z9.number(),
  sessionCount: z9.number(),
  commentCount: z9.number(),
  mapActivityCount: z9.number(),
  activityStakeholders: z9.number(),
  nonSessionOrViewActivityCount: z9.number()
});
var EngagementScoreSummarySchema = z9.object({
  score: z9.number(),
  scoreBreakdown: z9.object({
    sessionScore: z9.number(),
    activitiesPerVisitScore: z9.number(),
    activitiesScore: z9.number(),
    stakeholdersScore: z9.number()
  }),
  inputs: SpaceScoringInputSchema.nullable()
});
var spaceSchema = z9.object({
  id: z9.string(),
  url: z9.string(),
  companyName: z9.string(),
  actionPlans: z9.array(actionPlanSchema).optional(),
  createdAt: z9.string(),
  updatedAt: z9.string(),
  companyLogoUrl: z9.string().optional(),
  companyLogo: z9.string().optional(),
  lastVisit: z9.string().nullable(),
  firstContactId: z9.string(),
  visits: z9.number(),
  ownerId: z9.string().optional(),
  completedTasksCount: z9.number(),
  collaboratorIds: z9.array(z9.string()).optional(),
  authToken: z9.string().optional(),
  parentTemplateName: z9.string().optional(),
  tenantId: z9.string(),
  archived: z9.boolean(),
  disableShareSpace: z9.boolean(),
  owner: z9.any(),
  overdueTasksCount: z9.number(),
  mostRecentCompletedTaskDate: z9.string().nullable(),
  tasksCount: z9.number(),
  rootNodeId: z9.string(),
  modifiedBy: z9.string(),
  templateId: z9.string(),
  template: z9.any(),
  contactLastName: z9.string(),
  language: z9.string(),
  slug: z9.string(),
  extraData: z9.any(),
  contactEmail: z9.string().nullable(),
  companyWebsite: z9.string(),
  contactFirstName: z9.string(),
  activitiesCount: z9.number(),
  teams: z9.union([
    z9.array(teamSchema),
    z9.array(z9.any())
  ]),
  createdBy: z9.string(),
  actionPlanSummary: z9.object({
    status: spaceActionPlanStatusSchema,
    progress: z9.number()
  }),
  engagementSummary: EngagementScoreSummarySchema,
  password: z9.string().nullable()
});
var createSpaceSchema = z9.object({
  templateId: z9.string(),
  ownerId: z9.string(),
  teamIds: z9.array(z9.string()),
  customProperties: z9.array(z9.object({
    name: z9.string(),
    value: z9.string()
  })).optional(),
  data: z9.object({
    companyName: z9.string(),
    companyWebsite: z9.string().optional(),
    contactFirstName: z9.string(),
    contactLastName: z9.string(),
    language: z9.string().optional()
  })
});

// src/types/utils.ts
var import_validator = __toESM(require_validator());
import { z as z10 } from "zod";
var dateOrDateString = z10.custom((val) => {
  if (typeof val === "string") {
    return true;
  } else if (val instanceof Date && !isNaN(val.getTime())) {
    return true;
  }
  return false;
}, "Date must be date or valid date string").transform((val, ctx) => {
  if (typeof val === "string") {
    return new Date(val);
  } else if (!(val instanceof Date)) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      message: "Value must be a string or a Date object"
    });
    return z10.NEVER;
  } else if (isNaN(val.getTime())) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      message: "Value must be a valid date"
    });
    return z10.NEVER;
  }
  return val;
});
var urlSchema = z10.string().refine((value) => (0, import_validator.isURL)(value, {
  require_protocol: true,
  protocols: [
    "http",
    "https"
  ]
}), {
  message: "Invalid URL. URL must include a valid protocol (http or https)."
});

// src/types/whitelisted-users.ts
import { z as z11 } from "zod";
var WhitelistedUserDealSide = {
  BUYER: "BUYER",
  SELLER: "SELLER"
};
var whitelistingUserDealSideEnum = z11.enum([
  WhitelistedUserDealSide.BUYER,
  WhitelistedUserDealSide.SELLER
]);
var WhitelistingMethod = {
  INTERNAL: "INTERNAL",
  DOMAIN: "DOMAIN",
  EMAIL: "EMAIL",
  ASSIGNEE_FLOW: "ASSIGNEE_FLOW",
  SPACE_CREATION: "SPACE_CREATION",
  SPACE_AUTH: "SPACE_AUTH",
  ANONYMOUS: "ANONYMOUS"
};
var whitelistingMethodEnum = z11.enum([
  WhitelistingMethod.INTERNAL,
  WhitelistingMethod.DOMAIN,
  WhitelistingMethod.EMAIL,
  WhitelistingMethod.ASSIGNEE_FLOW,
  WhitelistingMethod.SPACE_CREATION,
  WhitelistingMethod.SPACE_AUTH,
  WhitelistingMethod.ANONYMOUS
]);
var whitelistedUserNotificationsSettingsSchema = z11.object({
  id: z11.string(),
  whitelistedUserId: z11.string(),
  milestoneDone: z11.boolean().default(false),
  dueToday: z11.boolean().default(false),
  taskAssigned: z11.boolean().default(false),
  allComments: z11.boolean().default(false),
  unsubscribed: z11.boolean().default(false)
});
var whitelistedUserSchema = z11.object({
  id: z11.string(),
  tenantId: z11.string(),
  spaceId: z11.string(),
  firstName: z11.string().nullish(),
  lastName: z11.string().nullish(),
  email: z11.string().nullish(),
  dealSide: whitelistingUserDealSideEnum,
  whitelistingMethod: whitelistingMethodEnum.optional(),
  WhitelistedUserNotificationsSettings: whitelistedUserNotificationsSettingsSchema.nullish(),
  sellerId: z11.string().optional().nullish(),
  metadata: z11.object({
    anonymousUserSequence: z11.number().optional()
  }).nullish().nullable().optional()
});
var whitelistedUsersResponseSchema = z11.array(whitelistedUserSchema);

// src/types/writingAssistant.ts
import { z as z12 } from "zod";
var WritingAssistantDtoSchema = z12.object({
  selectedText: z12.string(),
  fullContext: z12.string(),
  messageHistory: z12.array(z12.object({
    role: z12.union([
      z12.literal("system"),
      z12.literal("user"),
      z12.literal("assistant")
    ]),
    content: z12.string()
  })),
  userMessage: z12.string()
});

// src/action-plans/action-plans.types.ts
var RELATIVE_TO_MAP_START_DATE = "relativeToMAPStartDate";
var RELATIVE_TO_MAP_TARGET_DATE = "relativeToMAPTargetDate";
var START_DATE_REFERENCE_TYPE = "START_DATE";
var TARGET_DATE_REFERENCE_TYPE = "TARGET_DATE";
var relativeDateSchema = z13.object({
  type: z13.enum([
    RELATIVE_TO_MAP_START_DATE,
    RELATIVE_TO_MAP_TARGET_DATE
  ]),
  deltaDays: z13.number()
});
var actionPlanTaskSchema = z13.object({
  id: z13.string(),
  title: z13.string(),
  description: z13.string().nullable(),
  nodeId: z13.string(),
  parentMilestoneId: z13.string(),
  dueDate: z13.coerce.date().nullable(),
  completedAt: z13.coerce.date().nullable(),
  checked: z13.boolean(),
  updatedAt: z13.coerce.date(),
  createdAt: z13.coerce.date(),
  relativeDueDate: relativeDateSchema.nullish(),
  startDate: z13.coerce.date().nullable(),
  relativeStartDate: relativeDateSchema.nullish(),
  aiInstructions: z13.string().nullish()
});
var actionPlanTaskSchemaWithAssignedUsers = actionPlanTaskSchema.extend({
  assignedUsers: z13.array(whitelistedUserSchema).nullish()
});
var actionPlanTaskUpdateSchema = z13.object({
  // Only checked field updates are supported (all other updates are made via node system).
  checked: z13.boolean().optional()
});
var actionPlanTaskExpandedSchema = actionPlanTaskSchema.extend({
  blockId: z13.string(),
  milestoneTitle: z13.string(),
  spaceCompanyName: z13.string(),
  spaceId: z13.string(),
  spaceLastVisit: z13.coerce.date().nullable(),
  spaceLogoUrl: z13.string().nullable(),
  spaceToken: z13.string(),
  assignedUsers: z13.array(whitelistedUserSchema).nullish()
});
var actionPlanMilestoneSchema = z13.object({
  id: z13.string(),
  title: z13.string(),
  actionPlanId: z13.string(),
  createdAt: z13.coerce.date(),
  updatedAt: z13.coerce.date(),
  hidden: z13.boolean(),
  checked: z13.boolean(),
  completedAt: z13.coerce.date().nullable(),
  nodeId: z13.string(),
  tasks: z13.array(actionPlanTaskSchema)
});
var actionPlanSchema = z13.object({
  id: z13.string(),
  title: z13.string(),
  description: z13.string(),
  spaceId: z13.string().nullish(),
  templateId: z13.string().nullish(),
  nodeId: z13.string(),
  createdAt: z13.coerce.date(),
  updatedAt: z13.coerce.date(),
  milestones: z13.array(actionPlanMilestoneSchema),
  startDate: z13.coerce.date().nullable(),
  dueDateMode: z13.enum([
    "ABSOLUTE",
    "RELATIVE"
  ])
});
var actionPlanQuerySchema = createPaginationQuerySchema(z13.object({
  spaceIds: z13.array(z13.string()).nullish(),
  spaceCreatedAfter: z13.coerce.date().optional(),
  spaceUpdatedAfter: z13.coerce.date().optional(),
  searchTerm: z13.string().optional()
}));
var actionPlanPaginatedListSchema = createPaginationSchema(actionPlanSchema, z13.undefined());
var actionPlanTasksQuerySchema = createPaginationQuerySchema(z13.object({
  includeTaskStatusMetadata: z13.preprocess(booleanQueryParamToBoolean, z13.boolean()).optional(),
  search: z13.string().optional(),
  sortBy: z13.enum([
    "dueDate",
    "actionPlanLastTaskCompletedAt",
    "spaceLastVisit",
    "order",
    "completedAt"
  ]).optional(),
  sortOrder: z13.enum([
    "asc",
    "desc"
  ]).optional(),
  taskStatus: z13.enum([
    "upcoming",
    "overdue",
    "nextUnscheduled",
    "completed",
    "includeCompleted"
  ]).optional(),
  spaceCreatedAfter: z13.coerce.date().optional(),
  spaceUpdatedAfter: z13.coerce.date().optional(),
  spaceIds: z13.preprocess(commaSeparatedArrayParamToArray, z13.array(z13.string())).optional(),
  ownerIds: z13.preprocess(commaSeparatedArrayParamToArray, z13.array(z13.string())).optional()
}));
var actionPlanTaskPaginatedListSchema = createPaginationSchema(actionPlanTaskExpandedSchema, z13.undefined());
var actionPlanTasksMetaSchema = z13.object({
  scheduledTasksCount: z13.number(),
  overdueTasksCount: z13.number(),
  nextUnscheduledTasksCount: z13.number(),
  allTasksCount: z13.number(),
  completedTasksCount: z13.number(),
  openTasksCount: z13.number()
});
var actionPlanTaskPaginatedListWithMetaSchema = createPaginationSchema(actionPlanTaskExpandedSchema, actionPlanTasksMetaSchema);

// src/activities/activity.types.ts
import { z as z14 } from "zod";
var legacyMetadataSchema = z14.object({
  firstName: z14.string().nullish(),
  lastName: z14.string().nullish(),
  creatorEmail: z14.string().nullish(),
  buyerEmail: z14.string().nullish(),
  emailAuthor: z14.string().nullish()
});
var activityTypes = z14.enum([
  "SESSION",
  "CLICK",
  "VIEW",
  "ARCHIVED_VIEW",
  "COMMENT",
  "SPACE_COMMENT",
  "MAP_MILESTONE_COMPLETED",
  "MAP_MILESTONE_ADDED",
  "MAP_MILESTONE_DELETED",
  "MAP_MILESTONE_TASK_CHANGED",
  "MAP_MILESTONE_TASK_DELETED",
  "MAP_MILESTONE_TASK_ADDED",
  "MAP_MILESTONE_TASK_ASSIGNEE_ADDED",
  "MAP_MILESTONE_TASK_ASSIGNEE_DELETED",
  "MAP_MILESTONE_TASK_ASSIGNEE_CHANGED",
  "MAP_MILESTONE_TASK_COMPLETED",
  "MAP_MILESTONE_TASK_DETAILS_OPENED",
  "MAP_MILESTONE_TASK_QUICK_ACTION_CLICK",
  "MAP_MILESTONE_TASK_DUE_DATE_ADDED",
  "MAP_MILESTONE_TASK_DUE_DATE_CHANGED",
  "MAP_MILESTONE_TASK_DUE_DATE_DELETED",
  "MAP_MILESTONE_TASK_ATTACHMENT_UPLOADED",
  "MAP_MILESTONE_TASK_DOWNLOAD_FILE",
  "MAP_MILESTONE_TASK_DELETE_FILE",
  "MAP_MILESTONE_TASK_DESCRIPTION_ADDED",
  "MAP_MILESTONE_TASK_DESCRIPTION_CHANGED",
  "MAP_MILESTONE_TASK_DESCRIPTION_DELETED",
  "ATTACHMENT_PREVIEW",
  "ATTACHMENT_DOWNLOAD",
  "ATTACHMENT_PREVIEW_FULLSCREEN",
  "ATTACHMENT_LINK_COPIED",
  "BLOCK_LINK_COPIED",
  "TASK_LINK_COPIED",
  "SPACE_LINK_COPIED",
  "PDF_CONTENT_VIEW",
  "INLINE_VIDEO_PLAY",
  "BLOCK_INTRO_VIDEO_PLAY",
  "TESTIMONIAL_VIEW",
  "INTERACTIVE_LIST_ITEM_OPENED",
  "BUSINESS_CASE_RECALCULATED",
  "COLLABORATIVE_BLOCK_EDITED",
  "BUYER_NOTIFICATION_SENT_MILESTONE_DONE",
  "BUYER_NOTIFICATION_SENT_TASK_ASSIGNED",
  "BUYER_NOTIFICATION_SENT_COMMENT",
  "BUYER_NOTIFICATION_SENT_TASK_DUE_TODAY",
  "BUYER_NOTIFICATION_SENT_SPACE_COMMENT",
  "DIRECT_LINK_TO_FILE_CLICKED",
  "LINK_CLICKED",
  "BLOCK_FILE_UPLOADED",
  "BUYER_NOTIFICATION_SENT_TASK_DUE_X_DAYS_AGO",
  "BUYER_NOTIFICATION_SENT_TASK_DUE_IN_X_DAYS",
  "FORM_QUESTION_ANSWERED",
  "FORM_QUESTION_EDITED",
  "FORM_COMPLETED"
]);
var activityCreatorMetadataSchema = z14.object({
  creatorEmail: z14.string().optional(),
  creatorFirstName: z14.string().optional(),
  creatorLastName: z14.string().optional()
});
var nodeSchema = z14.lazy(() => z14.object({
  id: z14.string(),
  versionId: z14.string().nullish(),
  rootNode: z14.string().nullish(),
  type: z14.string().nullish(),
  data: z14.object({
    title: z14.string().nullish()
  }).passthrough().nullish(),
  unversionedData: z14.record(z14.any()).nullish(),
  metadata: z14.record(z14.any()).nullish(),
  children: z14.array(z14.lazy(() => nodeSchema)).nullish(),
  childrenIds: z14.array(z14.string()).nullish(),
  createdAt: z14.string().nullish(),
  parentIds: z14.array(z14.string()).nullish(),
  virtualData: z14.record(z14.any()).nullish()
}).passthrough());
var baseActivitySchema = z14.object({
  id: z14.string(),
  nodeId: z14.string(),
  createdAt: z14.string(),
  updatedAt: z14.string(),
  createdBy: z14.string(),
  creatorType: z14.union([
    z14.literal("BUYER"),
    z14.literal("SELLER"),
    z14.literal("SYSTEM")
  ]),
  rootNodeId: z14.string(),
  tenant: z14.string(),
  pageId: z14.string().nullish(),
  blockId: z14.string().nullish(),
  name: z14.string().optional(),
  email: z14.string().optional(),
  sessionId: z14.string().optional(),
  /**
  * The props below were not added compared to the old WeaklyTypedActivity. I added them as I moved more components to the new Activity type since they're still existing in the data,
  * but out of scope for me to now figure out all the types here. Would be great to add the proper types when soemone touches the activity more intimately  @Ronald
  */
  node: z14.record(z14.any()).nullable().optional(),
  block: z14.record(z14.any()).nullable().optional(),
  page: z14.record(z14.any()).nullable().optional(),
  rootNode: z14.record(z14.any()).nullable().optional(),
  relatedUserId: z14.string().nullable().optional(),
  relatedUser: z14.record(z14.any()).nullable().optional()
});
var commentActivityMetadataSchema = activityCreatorMetadataSchema.extend({
  commentId: z14.string(),
  creatorEmail: z14.string()
});
var sessionActivitySchema = baseActivitySchema.extend({
  type: z14.literal("SESSION"),
  metadata: activityCreatorMetadataSchema.optional()
});
var clickActivitySchema = baseActivitySchema.extend({
  type: z14.literal("CLICK"),
  metadata: activityCreatorMetadataSchema.optional()
});
var viewActivitySchema = baseActivitySchema.extend({
  type: z14.literal("VIEW"),
  metadata: activityCreatorMetadataSchema.optional()
});
var archivedViewActivitySchema = baseActivitySchema.extend({
  type: z14.literal("ARCHIVED_VIEW"),
  metadata: activityCreatorMetadataSchema.optional()
});
var commentActivitySchema = baseActivitySchema.extend({
  type: z14.literal("COMMENT"),
  metadata: commentActivityMetadataSchema.extend({
    commentMessage: z14.string(),
    taskTitle: z14.string().optional(),
    taskId: z14.string().optional()
  })
});
var spaceCommentActivitySchema = baseActivitySchema.extend({
  type: z14.literal("SPACE_COMMENT"),
  metadata: commentActivityMetadataSchema.extend({
    comment: z14.string()
  })
});
var milestoneCompletedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_COMPLETED"),
  metadata: activityCreatorMetadataSchema.extend({
    milestoneName: z14.string()
  })
});
var milestoneAddedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_ADDED"),
  metadata: activityCreatorMetadataSchema.extend({
    milestoneName: z14.string()
  })
});
var milestoneDeletedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_DELETED"),
  metadata: activityCreatorMetadataSchema.extend({
    milestoneName: z14.string()
  })
});
var milestoneTaskChangedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_CHANGED"),
  metadata: activityCreatorMetadataSchema.extend({
    taskName: z14.string()
  })
});
var milestoneTaskDeletedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DELETED"),
  metadata: activityCreatorMetadataSchema.extend({
    taskName: z14.string()
  })
});
var milestoneTaskAddedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_ADDED"),
  metadata: activityCreatorMetadataSchema.extend({
    taskName: z14.string()
  })
});
var milestoneTaskAssigneeMetadataSchema = activityCreatorMetadataSchema.extend({
  taskId: z14.string().optional(),
  taskName: z14.string(),
  assigneeName: z14.string(),
  assigneeEmail: z14.string().nullable().optional()
});
var milestoneTaskAssigneeAddedSchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_ASSIGNEE_ADDED"),
  metadata: milestoneTaskAssigneeMetadataSchema
});
var milestoneTaskAssigneeDeletedSchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_ASSIGNEE_DELETED"),
  metadata: milestoneTaskAssigneeMetadataSchema
});
var milestoneTaskAssigneeChangedSchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_ASSIGNEE_CHANGED"),
  metadata: milestoneTaskAssigneeMetadataSchema
});
var milestoneTaskDetailsMetadataSchema = activityCreatorMetadataSchema.extend({
  taskId: z14.string(),
  taskName: z14.string(),
  milestoneId: z14.string()
});
var milestoneTaskCompletedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_COMPLETED"),
  metadata: milestoneTaskDetailsMetadataSchema
});
var milestoneTaskDetailsOpenedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DETAILS_OPENED"),
  metadata: milestoneTaskDetailsMetadataSchema
});
var milestoneTaskQuickActionClickActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_QUICK_ACTION_CLICK"),
  metadata: activityCreatorMetadataSchema.extend({
    taskName: z14.string(),
    quickActionName: z14.string()
  })
});
var milestoneTaskDueDateActivityMetadataSchema = activityCreatorMetadataSchema.extend({
  taskName: z14.string(),
  dueDate: z14.string()
});
var milestoneTaskDueDateAddedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DUE_DATE_ADDED"),
  metadata: milestoneTaskDueDateActivityMetadataSchema
});
var milestoneTaskDueDateChangedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DUE_DATE_CHANGED"),
  metadata: milestoneTaskDueDateActivityMetadataSchema
});
var milestoneTaskDueDateDeletedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DUE_DATE_DELETED"),
  metadata: milestoneTaskDueDateActivityMetadataSchema
});
var milestoneTaskAttachmentMetadataSchema = activityCreatorMetadataSchema.extend({
  taskName: z14.string(),
  fileName: z14.string()
});
var milestoneTaskAttachmentUploadedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_ATTACHMENT_UPLOADED"),
  metadata: milestoneTaskAttachmentMetadataSchema
});
var milestoneTaskDownloadFileActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DOWNLOAD_FILE"),
  metadata: milestoneTaskAttachmentMetadataSchema
});
var milestoneTaskDeleteFileActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DELETE_FILE"),
  metadata: milestoneTaskAttachmentMetadataSchema
});
var milestoneTaskDescriptionActivityMetadataSchema = activityCreatorMetadataSchema.extend({
  taskName: z14.string(),
  description: z14.string()
});
var milestoneTaskDescriptionAddedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DESCRIPTION_ADDED"),
  metadata: milestoneTaskDescriptionActivityMetadataSchema
});
var milestoneTaskDescriptionChangedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DESCRIPTION_CHANGED"),
  metadata: milestoneTaskDescriptionActivityMetadataSchema
});
var milestoneTaskDescriptionDeletedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("MAP_MILESTONE_TASK_DESCRIPTION_DELETED"),
  metadata: milestoneTaskDescriptionActivityMetadataSchema
});
var attachmentActivityMetadataSchema = activityCreatorMetadataSchema.extend({
  fileName: z14.string()
});
var attachmentActivityPreviewSchema = baseActivitySchema.extend({
  type: z14.literal("ATTACHMENT_PREVIEW"),
  metadata: attachmentActivityMetadataSchema
});
var attachmentActivityDownloadSchema = baseActivitySchema.extend({
  type: z14.literal("ATTACHMENT_DOWNLOAD"),
  metadata: attachmentActivityMetadataSchema
});
var attachmentActivityPreviewFullscreenSchema = baseActivitySchema.extend({
  type: z14.literal("ATTACHMENT_PREVIEW_FULLSCREEN"),
  metadata: attachmentActivityMetadataSchema
});
var attachmentLinkCopiedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("ATTACHMENT_LINK_COPIED"),
  metadata: activityCreatorMetadataSchema.optional()
});
var blockLinkCopiedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BLOCK_LINK_COPIED"),
  metadata: activityCreatorMetadataSchema.optional()
});
var taskLinkCopiedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("TASK_LINK_COPIED"),
  metadata: activityCreatorMetadataSchema.extend({
    taskId: z14.string(),
    taskName: z14.string()
  })
});
var spaceLinkCopiedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("SPACE_LINK_COPIED"),
  metadata: activityCreatorMetadataSchema.optional()
});
var pdfContentViewActivitySchema = baseActivitySchema.extend({
  type: z14.literal("PDF_CONTENT_VIEW"),
  metadata: activityCreatorMetadataSchema.extend({
    fileName: z14.string(),
    maxPageRead: z14.number(),
    method: z14.union([
      z14.literal("unmount"),
      z14.literal("timeout")
    ])
  })
});
var inlineVideoPlayActivitySchema = baseActivitySchema.extend({
  type: z14.literal("INLINE_VIDEO_PLAY"),
  metadata: activityCreatorMetadataSchema.extend({
    fileName: z14.string(),
    interactions: z14.number(),
    method: z14.union([
      z14.literal("unmount"),
      z14.literal("timeout")
    ])
  })
});
var introBlockVideoPlayActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BLOCK_INTRO_VIDEO_PLAY"),
  metadata: activityCreatorMetadataSchema.extend({
    interactions: z14.number(),
    method: z14.union([
      z14.literal("unmount"),
      z14.literal("timeout")
    ])
  })
});
var directLinkToFileClickedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("DIRECT_LINK_TO_FILE_CLICKED"),
  metadata: attachmentActivityMetadataSchema
});
var testimonialViewActivitySchema = baseActivitySchema.extend({
  type: z14.literal("TESTIMONIAL_VIEW"),
  metadata: activityCreatorMetadataSchema.extend({
    interactions: z14.number(),
    method: z14.union([
      z14.literal("unmount"),
      z14.literal("timeout")
    ])
  })
});
var interactiveListItemOpenedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("INTERACTIVE_LIST_ITEM_OPENED"),
  metadata: activityCreatorMetadataSchema.extend({
    listItemTitle: z14.string()
  })
});
var businessCaseRecalculatedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BUSINESS_CASE_RECALCULATED"),
  metadata: activityCreatorMetadataSchema.optional()
});
var collaborativeBlockEditedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("COLLABORATIVE_BLOCK_EDITED"),
  metadata: activityCreatorMetadataSchema.optional()
});
var buyerNotificationSentActivityMetadataSchema = activityCreatorMetadataSchema.extend({
  notifiedUserFirstName: z14.string(),
  notifiedUserLastName: z14.string(),
  notifiedUserEmail: z14.string()
});
var buyerNotificationSentMilestoneDoneActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BUYER_NOTIFICATION_SENT_MILESTONE_DONE"),
  metadata: buyerNotificationSentActivityMetadataSchema
});
var buyerNotificationSentTaskAssignedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BUYER_NOTIFICATION_SENT_TASK_ASSIGNED"),
  metadata: buyerNotificationSentActivityMetadataSchema
});
var buyerNotificationSentCommentActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BUYER_NOTIFICATION_SENT_COMMENT"),
  metadata: buyerNotificationSentActivityMetadataSchema
});
var buyerNotificationSentTaskDueTodayActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BUYER_NOTIFICATION_SENT_TASK_DUE_TODAY"),
  metadata: buyerNotificationSentActivityMetadataSchema
});
var buyerNotificationSentTaskDueXDaysAgoActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BUYER_NOTIFICATION_SENT_TASK_DUE_X_DAYS_AGO"),
  metadata: buyerNotificationSentActivityMetadataSchema.extend({
    daysOffset: z14.number().int().positive()
  })
});
var buyerNotificationSentTaskDueInXDaysActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BUYER_NOTIFICATION_SENT_TASK_DUE_IN_X_DAYS"),
  metadata: buyerNotificationSentActivityMetadataSchema.extend({
    daysOffset: z14.number().int().negative()
  })
});
var buyerNotificationSentSpaceCommentActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BUYER_NOTIFICATION_SENT_SPACE_COMMENT"),
  metadata: buyerNotificationSentActivityMetadataSchema
});
var linkClickActivitySchema = baseActivitySchema.extend({
  type: z14.literal("LINK_CLICKED"),
  metadata: activityCreatorMetadataSchema.extend({
    link: z14.string()
  })
});
var blockFileUploadedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("BLOCK_FILE_UPLOADED"),
  metadata: attachmentActivityMetadataSchema
});
var formAnswerActivitySchema = baseActivitySchema.extend({
  type: z14.literal("FORM_QUESTION_ANSWERED"),
  metadata: activityCreatorMetadataSchema.extend({
    questionText: z14.string(),
    answer: z14.string()
  })
});
var formQuestionEditedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("FORM_QUESTION_EDITED"),
  metadata: activityCreatorMetadataSchema.extend({
    questionText: z14.string(),
    answer: z14.string()
  })
});
var formCompletedActivitySchema = baseActivitySchema.extend({
  type: z14.literal("FORM_COMPLETED"),
  metadata: activityCreatorMetadataSchema.extend({
    formTitle: z14.string()
  })
});
var activitySchema = z14.discriminatedUnion("type", [
  sessionActivitySchema,
  clickActivitySchema,
  viewActivitySchema,
  archivedViewActivitySchema,
  commentActivitySchema,
  spaceCommentActivitySchema,
  milestoneCompletedActivitySchema,
  milestoneAddedActivitySchema,
  milestoneDeletedActivitySchema,
  milestoneTaskChangedActivitySchema,
  milestoneTaskDeletedActivitySchema,
  milestoneTaskAddedActivitySchema,
  milestoneTaskAssigneeAddedSchema,
  milestoneTaskAssigneeDeletedSchema,
  milestoneTaskAssigneeChangedSchema,
  milestoneTaskCompletedActivitySchema,
  milestoneTaskDetailsOpenedActivitySchema,
  milestoneTaskQuickActionClickActivitySchema,
  milestoneTaskDueDateAddedActivitySchema,
  milestoneTaskDueDateChangedActivitySchema,
  milestoneTaskDueDateDeletedActivitySchema,
  milestoneTaskAttachmentUploadedActivitySchema,
  milestoneTaskDownloadFileActivitySchema,
  milestoneTaskDeleteFileActivitySchema,
  milestoneTaskDescriptionAddedActivitySchema,
  milestoneTaskDescriptionChangedActivitySchema,
  milestoneTaskDescriptionDeletedActivitySchema,
  attachmentActivityPreviewSchema,
  attachmentActivityDownloadSchema,
  attachmentActivityPreviewFullscreenSchema,
  attachmentLinkCopiedActivitySchema,
  blockLinkCopiedActivitySchema,
  taskLinkCopiedActivitySchema,
  spaceLinkCopiedActivitySchema,
  pdfContentViewActivitySchema,
  inlineVideoPlayActivitySchema,
  introBlockVideoPlayActivitySchema,
  testimonialViewActivitySchema,
  interactiveListItemOpenedActivitySchema,
  businessCaseRecalculatedActivitySchema,
  collaborativeBlockEditedActivitySchema,
  buyerNotificationSentMilestoneDoneActivitySchema,
  buyerNotificationSentTaskAssignedActivitySchema,
  buyerNotificationSentCommentActivitySchema,
  buyerNotificationSentTaskDueTodayActivitySchema,
  buyerNotificationSentSpaceCommentActivitySchema,
  directLinkToFileClickedActivitySchema,
  linkClickActivitySchema,
  blockFileUploadedActivitySchema,
  buyerNotificationSentTaskDueXDaysAgoActivitySchema,
  buyerNotificationSentTaskDueInXDaysActivitySchema,
  formAnswerActivitySchema,
  formQuestionEditedActivitySchema,
  formCompletedActivitySchema
]);
var activitySchemaArray = z14.array(activitySchema);
var DateSchema = z14.preprocess((arg) => {
  if (typeof arg === "string") {
    const parsedDate = new Date(arg);
    return isNaN(parsedDate.getTime()) ? void 0 : parsedDate;
  }
  return arg;
}, z14.date());
var sessionSchema = z14.object({
  id: z14.string(),
  activityCount: z14.number(),
  createdBy: z14.string(),
  name: z14.string().optional(),
  email: z14.string().optional(),
  startTime: DateSchema,
  duration: z14.object({
    hours: z14.number().optional(),
    minutes: z14.number().optional(),
    seconds: z14.number()
  })
});
var sessionsArray = z14.array(sessionSchema);
var activitiesAcrossTenantQuerySchema = createPaginationQuerySchema(z14.object({
  ownerIds: z14.preprocess(commaSeparatedArrayParamToArray, z14.array(z14.string())).optional(),
  activityTypes: z14.preprocess(commaSeparatedArrayParamToArray, z14.array(activityTypes)).optional()
}));
var activitesAcrossTenantPaginatedListSchema = createPaginationSchema(activitySchema, z14.undefined());

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/errors.js
var _a;
var LuxonError = (_a = class extends Error {
}, __name(_a, "LuxonError"), _a);
var _InvalidDateTimeError = class _InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
};
__name(_InvalidDateTimeError, "InvalidDateTimeError");
var InvalidDateTimeError = _InvalidDateTimeError;
var _InvalidIntervalError = class _InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
};
__name(_InvalidIntervalError, "InvalidIntervalError");
var InvalidIntervalError = _InvalidIntervalError;
var _InvalidDurationError = class _InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
};
__name(_InvalidDurationError, "InvalidDurationError");
var InvalidDurationError = _InvalidDurationError;
var _ConflictingSpecificationError = class _ConflictingSpecificationError extends LuxonError {
};
__name(_ConflictingSpecificationError, "ConflictingSpecificationError");
var ConflictingSpecificationError = _ConflictingSpecificationError;
var _InvalidUnitError = class _InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
};
__name(_InvalidUnitError, "InvalidUnitError");
var InvalidUnitError = _InvalidUnitError;
var _InvalidArgumentError = class _InvalidArgumentError extends LuxonError {
};
__name(_InvalidArgumentError, "InvalidArgumentError");
var InvalidArgumentError = _InvalidArgumentError;
var _ZoneIsAbstractError = class _ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
};
__name(_ZoneIsAbstractError, "ZoneIsAbstractError");
var ZoneIsAbstractError = _ZoneIsAbstractError;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/formats.js
var n = "numeric";
var s = "short";
var l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zone.js
var _Zone = class _Zone {
  /**
  * The type of zone
  * @abstract
  * @type {string}
  */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
  * The name of this zone.
  * @abstract
  * @type {string}
  */
  get name() {
    throw new ZoneIsAbstractError();
  }
  /**
  * The IANA name of this zone.
  * Defaults to `name` if not overwritten by a subclass.
  * @abstract
  * @type {string}
  */
  get ianaName() {
    return this.name;
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year.
  * @abstract
  * @type {boolean}
  */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
  * Returns the offset's common name (such as EST) at the specified timestamp
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to get the name
  * @param {Object} opts - Options to affect the format
  * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
  * @param {string} opts.locale - What locale to return the offset name in.
  * @return {string}
  */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Returns the offset's value as a string
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  * @abstract
  * @param {number} ts - Epoch milliseconds for which to compute the offset
  * @return {number}
  */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return whether this Zone is equal to another zone
  * @abstract
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
  * Return whether this Zone is valid.
  * @abstract
  * @type {boolean}
  */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
};
__name(_Zone, "Zone");
var Zone = _Zone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/systemZone.js
var singleton = null;
var _SystemZone = class _SystemZone extends Zone {
  /**
  * Get a singleton instance of the local zone
  * @return {SystemZone}
  */
  static get instance() {
    if (singleton === null) {
      singleton = new _SystemZone();
    }
    return singleton;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
};
__name(_SystemZone, "SystemZone");
var SystemZone = _SystemZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/IANAZone.js
var dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
__name(makeDTF, "makeDTF");
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [
    fYear,
    fMonth,
    fDay,
    fadOrBc,
    fHour,
    fMinute,
    fSecond
  ];
}
__name(hackyOffset, "hackyOffset");
function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
__name(partsOffset, "partsOffset");
var ianaZoneCache = {};
var _IANAZone = class _IANAZone extends Zone {
  /**
  * @param {string} name - Zone name
  * @return {IANAZone}
  */
  static create(name2) {
    if (!ianaZoneCache[name2]) {
      ianaZoneCache[name2] = new _IANAZone(name2);
    }
    return ianaZoneCache[name2];
  }
  /**
  * Reset local caches. Should only be necessary in testing scenarios.
  * @return {void}
  */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
  * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
  * @param {string} s - The string to check validity on
  * @example IANAZone.isValidSpecifier("America/New_York") //=> true
  * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
  * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
  * @return {boolean}
  */
  static isValidSpecifier(s3) {
    return this.isValidZone(s3);
  }
  /**
  * Returns whether the provided string identifies a real zone
  * @param {string} zone - The string to check
  * @example IANAZone.isValidZone("America/New_York") //=> true
  * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
  * @example IANAZone.isValidZone("Sport~~blorp") //=> false
  * @return {boolean}
  */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e2) {
      return false;
    }
  }
  constructor(name2) {
    super();
    this.zoneName = name2;
    this.valid = _IANAZone.isValidZone(name2);
  }
  /**
  * The type of zone. `iana` for all instances of `IANAZone`.
  * @override
  * @type {string}
  */
  get type() {
    return "iana";
  }
  /**
  * The name of this zone (i.e. the IANA zone name).
  * @override
  * @type {string}
  */
  get name() {
    return this.zoneName;
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year:
  * Always returns false for all IANA zones.
  * @override
  * @type {boolean}
  */
  get isUniversal() {
    return false;
  }
  /**
  * Returns the offset's common name (such as EST) at the specified timestamp
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the name
  * @param {Object} opts - Options to affect the format
  * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
  * @param {string} opts.locale - What locale to return the offset name in.
  * @return {string}
  */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /**
  * Returns the offset's value as a string
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  * @override
  * @param {number} ts - Epoch milliseconds for which to compute the offset
  * @return {number}
  */
  offset(ts) {
    const date = new Date(ts);
    if (isNaN(date)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
  * Return whether this Zone is equal to another zone
  * @override
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
  * Return whether this Zone is valid.
  * @override
  * @type {boolean}
  */
  get isValid() {
    return this.valid;
  }
};
__name(_IANAZone, "IANAZone");
var IANAZone = _IANAZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/locale.js
var intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
__name(getCachedLF, "getCachedLF");
var intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
__name(getCachedDTF, "getCachedDTF");
var intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([
    locString,
    opts
  ]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
__name(getCachedINF, "getCachedINF");
var intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const _a6 = opts, { base } = _a6, cacheKeyOpts = __objRest(_a6, ["base"]);
  const key = JSON.stringify([
    locString,
    cacheKeyOpts
  ]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
__name(getCachedRTF, "getCachedRTF");
var sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
__name(systemLocale, "systemLocale");
var weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data = weekInfoCache[locString];
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}
__name(getCachedWeekInfo, "getCachedWeekInfo");
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [
      localeStr
    ];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e2) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [
      selectedStr,
      numberingSystem,
      calendar
    ];
  }
}
__name(parseLocaleString, "parseLocaleString");
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
__name(intlConfigString, "intlConfigString");
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
__name(mapMonths, "mapMonths");
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
__name(mapWeekdays, "mapWeekdays");
function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
__name(listStuff, "listStuff");
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
__name(supportsFastNumbers, "supportsFastNumbers");
var _a2;
var PolyNumberFormatter = (_a2 = class {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const _a6 = opts, { padTo, floor } = _a6, otherOpts = __objRest(_a6, ["padTo", "floor"]);
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = __spreadValues({
        useGrouping: false
      }, opts);
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}, __name(_a2, "PolyNumberFormatter"), _a2);
var _a3;
var PolyDateFormatter = (_a3 = class {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z55 = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z55 = offsetZ;
        this.dt = dt;
      } else {
        z55 = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
          minutes: dt.offset
        });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z55 = dt.zone.name;
    } else {
      z55 = "UTC";
      this.dt = dt.setZone("UTC").plus({
        minutes: dt.offset
      });
      this.originalZone = dt.zone;
    }
    const intlOpts = __spreadValues({}, this.opts);
    intlOpts.timeZone = intlOpts.timeZone || z55;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return __spreadProps(__spreadValues({}, part), {
            value: offsetName
          });
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}, __name(_a3, "PolyDateFormatter"), _a3);
var _a4;
var PolyRelFormatter = (_a4 = class {
  constructor(intl, isEnglish, opts) {
    this.opts = __spreadValues({
      style: "long"
    }, opts);
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}, __name(_a4, "PolyRelFormatter"), _a4);
var fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [
    6,
    7
  ]
};
var _Locale = class _Locale {
  static fromOpts(opts) {
    return _Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new _Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return _Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return _Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone(__spreadProps(__spreadValues({}, alts), {
      defaultToEN: true
    }));
  }
  redefaultToSystem(alts = {}) {
    return this.clone(__spreadProps(__spreadValues({}, alts), {
      defaultToEN: false
    }));
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const intl = format ? {
        month: length,
        day: "numeric"
      } : {
        month: length
      }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format ? {
        weekday: length,
        year: "numeric",
        month: "long",
        day: "numeric"
      } : {
        weekday: length
      }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) => this.extract(dt, intl, "weekday"));
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(this, void 0, () => meridiems, () => {
      if (!this.meridiemCache) {
        const intl = {
          hour: "numeric",
          hourCycle: "h12"
        };
        this.meridiemCache = [
          DateTime.utc(2016, 11, 13, 9),
          DateTime.utc(2016, 11, 13, 19)
        ].map((dt) => this.extract(dt, intl, "dayperiod"));
      }
      return this.meridiemCache;
    });
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = {
        era: length
      };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [
          DateTime.utc(-40, 1, 1),
          DateTime.utc(2017, 1, 1)
        ].map((dt) => this.extract(dt, intl, "era"));
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
};
__name(_Locale, "Locale");
var Locale = _Locale;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/fixedOffsetZone.js
var singleton2 = null;
var _FixedOffsetZone = class _FixedOffsetZone extends Zone {
  /**
  * Get a singleton instance of UTC
  * @return {FixedOffsetZone}
  */
  static get utcInstance() {
    if (singleton2 === null) {
      singleton2 = new _FixedOffsetZone(0);
    }
    return singleton2;
  }
  /**
  * Get an instance with a specified offset
  * @param {number} offset - The offset in minutes
  * @return {FixedOffsetZone}
  */
  static instance(offset2) {
    return offset2 === 0 ? _FixedOffsetZone.utcInstance : new _FixedOffsetZone(offset2);
  }
  /**
  * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
  * @param {string} s - The offset string to parse
  * @example FixedOffsetZone.parseSpecifier("UTC+6")
  * @example FixedOffsetZone.parseSpecifier("UTC+06")
  * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
  * @return {FixedOffsetZone}
  */
  static parseSpecifier(s3) {
    if (s3) {
      const r2 = s3.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r2) {
        return new _FixedOffsetZone(signedOffset(r2[1], r2[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
  * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
  * @override
  * @type {string}
  */
  get type() {
    return "fixed";
  }
  /**
  * The name of this zone.
  * All fixed zones' names always start with "UTC" (plus optional offset)
  * @override
  * @type {string}
  */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  /**
  * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
  *
  * @override
  * @type {string}
  */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /**
  * Returns the offset's common name at the specified timestamp.
  *
  * For fixed offset zones this equals to the zone name.
  * @override
  */
  offsetName() {
    return this.name;
  }
  /**
  * Returns the offset's value as a string
  * @override
  * @param {number} ts - Epoch milliseconds for which to get the offset
  * @param {string} format - What style of offset to return.
  *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
  * @return {string}
  */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /**
  * Returns whether the offset is known to be fixed for the whole year:
  * Always returns true for all fixed offset zones.
  * @override
  * @type {boolean}
  */
  get isUniversal() {
    return true;
  }
  /**
  * Return the offset in minutes for this zone at the specified timestamp.
  *
  * For fixed offset zones, this is constant and does not depend on a timestamp.
  * @override
  * @return {number}
  */
  offset() {
    return this.fixed;
  }
  /**
  * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
  * @override
  * @param {Zone} otherZone - the zone to compare
  * @return {boolean}
  */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
  * Return whether this Zone is valid:
  * All fixed offset zones are valid.
  * @override
  * @type {boolean}
  */
  get isValid() {
    return true;
  }
};
__name(_FixedOffsetZone, "FixedOffsetZone");
var FixedOffsetZone = _FixedOffsetZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/zones/invalidZone.js
var _InvalidZone = class _InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
};
__name(_InvalidZone, "InvalidZone");
var InvalidZone = _InvalidZone;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/zoneUtil.js
function normalizeZone(input, defaultZone2) {
  let offset2;
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone2;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
__name(normalizeZone, "normalizeZone");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/digits.js
var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [
    1632,
    1641
  ],
  arabext: [
    1776,
    1785
  ],
  bali: [
    6992,
    7001
  ],
  beng: [
    2534,
    2543
  ],
  deva: [
    2406,
    2415
  ],
  fullwide: [
    65296,
    65303
  ],
  gujr: [
    2790,
    2799
  ],
  khmr: [
    6112,
    6121
  ],
  knda: [
    3302,
    3311
  ],
  laoo: [
    3792,
    3801
  ],
  limb: [
    6470,
    6479
  ],
  mlym: [
    3430,
    3439
  ],
  mong: [
    6160,
    6169
  ],
  mymr: [
    4160,
    4169
  ],
  orya: [
    2918,
    2927
  ],
  tamldec: [
    3046,
    3055
  ],
  telu: [
    3174,
    3183
  ],
  thai: [
    3664,
    3673
  ],
  tibt: [
    3872,
    3881
  ]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
__name(parseDigits, "parseDigits");
var digitRegexCache = {};
function resetDigitRegexCache() {
  digitRegexCache = {};
}
__name(resetDigitRegexCache, "resetDigitRegexCache");
function digitRegex({ numberingSystem }, append2 = "") {
  const ns = numberingSystem || "latn";
  if (!digitRegexCache[ns]) {
    digitRegexCache[ns] = {};
  }
  if (!digitRegexCache[ns][append2]) {
    digitRegexCache[ns][append2] = new RegExp(`${numberingSystems[ns]}${append2}`);
  }
  return digitRegexCache[ns][append2];
}
__name(digitRegex, "digitRegex");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/settings.js
var now = /* @__PURE__ */ __name(() => Date.now(), "now");
var defaultZone = "system";
var defaultLocale = null;
var defaultNumberingSystem = null;
var defaultOutputCalendar = null;
var twoDigitCutoffYear = 60;
var throwOnInvalid;
var defaultWeekSettings = null;
var _Settings = class _Settings {
  /**
  * Get the callback for returning the current timestamp.
  * @type {function}
  */
  static get now() {
    return now;
  }
  /**
  * Set the callback for returning the current timestamp.
  * The function should return a number, which will be interpreted as an Epoch millisecond count
  * @type {function}
  * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
  * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
  */
  static set now(n3) {
    now = n3;
  }
  /**
  * Set the default time zone to create DateTimes in. Does not affect existing instances.
  * Use the value "system" to reset this value to the system's time zone.
  * @type {string}
  */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
  * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
  * The default value is the system's time zone (the one set on the machine that runs this code).
  * @type {Zone}
  */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
  * Get the default locale to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
  * Set the default locale to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
  * Get the default numbering system to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
  * Set the default numbering system to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
  * Get the default output calendar to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
  * Set the default output calendar to create DateTimes with. Does not affect existing instances.
  * @type {string}
  */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
  * @typedef {Object} WeekSettings
  * @property {number} firstDay
  * @property {number} minimalDays
  * @property {number[]} weekend
  */
  /**
  * @return {WeekSettings|null}
  */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
  * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
  * how many days are required in the first week of a year.
  * Does not affect existing instances.
  *
  * @param {WeekSettings|null} weekSettings
  */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
  * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
  * @type {number}
  */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
  * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
  * @type {number}
  * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
  * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
  * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
  * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
  * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
  */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
  * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
  * @type {boolean}
  */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
  * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
  * @type {boolean}
  */
  static set throwOnInvalid(t2) {
    throwOnInvalid = t2;
  }
  /**
  * Reset Luxon's global caches. Should only be necessary in testing scenarios.
  * @return {void}
  */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
};
__name(_Settings, "Settings");
var Settings = _Settings;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/invalid.js
var _Invalid = class _Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
};
__name(_Invalid, "Invalid");
var Invalid = _Invalid;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/conversions.js
var nonLeapLadder = [
  0,
  31,
  59,
  90,
  120,
  151,
  181,
  212,
  243,
  273,
  304,
  334
];
var leapLadder = [
  0,
  31,
  60,
  91,
  121,
  152,
  182,
  213,
  244,
  274,
  305,
  335
];
function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
__name(unitOutOfRange, "unitOutOfRange");
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
__name(dayOfWeek, "dayOfWeek");
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
__name(computeOrdinal, "computeOrdinal");
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal), day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day
  };
}
__name(uncomputeOrdinal, "uncomputeOrdinal");
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
__name(isoWeekdayToLocal, "isoWeekdayToLocal");
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return __spreadValues({
    weekYear,
    weekNumber,
    weekday
  }, timeObject(gregObj));
}
__name(gregorianToWeek, "gregorianToWeek");
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return __spreadValues({
    year,
    month,
    day
  }, timeObject(weekData));
}
__name(weekToGregorian, "weekToGregorian");
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return __spreadValues({
    year,
    ordinal
  }, timeObject(gregData));
}
__name(gregorianToOrdinal, "gregorianToOrdinal");
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return __spreadValues({
    year,
    month,
    day
  }, timeObject(ordinalData));
}
__name(ordinalToGregorian, "ordinalToGregorian");
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return {
      minDaysInFirstWeek: 4,
      startOfWeek: 1
    };
  }
}
__name(usesLocalWeekValues, "usesLocalWeekValues");
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
__name(hasInvalidWeekData, "hasInvalidWeekData");
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
__name(hasInvalidOrdinalData, "hasInvalidOrdinalData");
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
__name(hasInvalidGregorianData, "hasInvalidGregorianData");
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}
__name(hasInvalidTimeData, "hasInvalidTimeData");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/util.js
function isUndefined(o2) {
  return typeof o2 === "undefined";
}
__name(isUndefined, "isUndefined");
function isNumber(o2) {
  return typeof o2 === "number";
}
__name(isNumber, "isNumber");
function isInteger(o2) {
  return typeof o2 === "number" && o2 % 1 === 0;
}
__name(isInteger, "isInteger");
function isString(o2) {
  return typeof o2 === "string";
}
__name(isString, "isString");
function isDate(o2) {
  return Object.prototype.toString.call(o2) === "[object Date]";
}
__name(isDate, "isDate");
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e2) {
    return false;
  }
}
__name(hasRelative, "hasRelative");
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e2) {
    return false;
  }
}
__name(hasLocaleWeekInfo, "hasLocaleWeekInfo");
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [
    thing
  ];
}
__name(maybeArray, "maybeArray");
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next) => {
    const pair = [
      by(next),
      next
    ];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
__name(bestBy, "bestBy");
function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
__name(pick, "pick");
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
__name(hasOwnProperty, "hasOwnProperty");
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
__name(validateWeekSettings, "validateWeekSettings");
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
__name(integerBetween, "integerBetween");
function floorMod(x, n3) {
  return x - n3 * Math.floor(x / n3);
}
__name(floorMod, "floorMod");
function padStart(input, n3 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n3, "0");
  } else {
    padded = ("" + input).padStart(n3, "0");
  }
  return padded;
}
__name(padStart, "padStart");
function parseInteger(string3) {
  if (isUndefined(string3) || string3 === null || string3 === "") {
    return void 0;
  } else {
    return parseInt(string3, 10);
  }
}
__name(parseInteger, "parseInteger");
function parseFloating(string3) {
  if (isUndefined(string3) || string3 === null || string3 === "") {
    return void 0;
  } else {
    return parseFloat(string3);
  }
}
__name(parseFloating, "parseFloating");
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f);
  }
}
__name(parseMillis, "parseMillis");
function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits, rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}
__name(roundTo, "roundTo");
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
__name(isLeapYear, "isLeapYear");
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
__name(daysInYear, "daysInYear");
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [
      31,
      null,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31
    ][modMonth - 1];
  }
}
__name(daysInMonth, "daysInMonth");
function objToLocalTS(obj) {
  let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}
__name(objToLocalTS, "objToLocalTS");
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
__name(firstWeekOffset, "firstWeekOffset");
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
__name(weeksInWeekYear, "weeksInWeekYear");
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
__name(untruncateYear, "untruncateYear");
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = __spreadValues({
    timeZoneName: offsetFormat
  }, intlOpts);
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
__name(parseZoneInfo, "parseZoneInfo");
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
__name(signedOffset, "signedOffset");
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
__name(asNumber, "asNumber");
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
__name(normalizeObject, "normalizeObject");
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
__name(formatOffset, "formatOffset");
function timeObject(obj) {
  return pick(obj, [
    "hour",
    "minute",
    "second",
    "millisecond"
  ]);
}
__name(timeObject, "timeObject");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/english.js
var monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
var monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
var monthsNarrow = [
  "J",
  "F",
  "M",
  "A",
  "M",
  "J",
  "J",
  "A",
  "S",
  "O",
  "N",
  "D"
];
function months(length) {
  switch (length) {
    case "narrow":
      return [
        ...monthsNarrow
      ];
    case "short":
      return [
        ...monthsShort
      ];
    case "long":
      return [
        ...monthsLong
      ];
    case "numeric":
      return [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
      ];
    case "2-digit":
      return [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ];
    default:
      return null;
  }
}
__name(months, "months");
var weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
var weekdaysShort = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun"
];
var weekdaysNarrow = [
  "M",
  "T",
  "W",
  "T",
  "F",
  "S",
  "S"
];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [
        ...weekdaysNarrow
      ];
    case "short":
      return [
        ...weekdaysShort
      ];
    case "long":
      return [
        ...weekdaysLong
      ];
    case "numeric":
      return [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7"
      ];
    default:
      return null;
  }
}
__name(weekdays, "weekdays");
var meridiems = [
  "AM",
  "PM"
];
var erasLong = [
  "Before Christ",
  "Anno Domini"
];
var erasShort = [
  "BC",
  "AD"
];
var erasNarrow = [
  "B",
  "A"
];
function eras(length) {
  switch (length) {
    case "narrow":
      return [
        ...erasNarrow
      ];
    case "short":
      return [
        ...erasShort
      ];
    case "long":
      return [
        ...erasLong
      ];
    default:
      return null;
  }
}
__name(eras, "eras");
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
__name(meridiemForDateTime, "meridiemForDateTime");
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
__name(weekdayForDateTime, "weekdayForDateTime");
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
__name(monthForDateTime, "monthForDateTime");
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
__name(eraForDateTime, "eraForDateTime");
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: [
      "year",
      "yr."
    ],
    quarters: [
      "quarter",
      "qtr."
    ],
    months: [
      "month",
      "mo."
    ],
    weeks: [
      "week",
      "wk."
    ],
    days: [
      "day",
      "day",
      "days"
    ],
    hours: [
      "hour",
      "hr."
    ],
    minutes: [
      "minute",
      "min."
    ],
    seconds: [
      "second",
      "sec."
    ]
  };
  const lastable = [
    "hours",
    "minutes",
    "seconds"
  ].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
      default:
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
__name(formatRelativeTime, "formatRelativeTime");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/formatter.js
function stringifyTokens(splits, tokenToString) {
  let s3 = "";
  for (const token2 of splits) {
    if (token2.literal) {
      s3 += token2.val;
    } else {
      s3 += tokenToString(token2.val);
    }
  }
  return s3;
}
__name(stringifyTokens, "stringifyTokens");
var macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
var _Formatter = class _Formatter {
  static create(locale, opts = {}) {
    return new _Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c2 = fmt.charAt(i);
      if (c2 === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c2;
      } else if (c2 === current) {
        currentFull += c2;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        currentFull = c2;
        current = c2;
      }
    }
    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed || /^\s+$/.test(currentFull),
        val: currentFull
      });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token2) {
    return macroTokenToFormatOpts[token2];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, __spreadValues(__spreadValues({}, this.opts), opts));
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, __spreadValues(__spreadValues({}, this.opts), opts));
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n3, p = 0) {
    if (this.opts.forceSimple) {
      return padStart(n3, p);
    }
    const opts = __spreadValues({}, this.opts);
    if (p > 0) {
      opts.padTo = p;
    }
    return this.loc.numberFormatter(opts).format(n3);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string3 = /* @__PURE__ */ __name((opts, extract) => this.loc.extract(dt, opts, extract), "string"), formatOffset2 = /* @__PURE__ */ __name((opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, "formatOffset"), meridiem = /* @__PURE__ */ __name(() => knownEnglish ? meridiemForDateTime(dt) : string3({
      hour: "numeric",
      hourCycle: "h12"
    }, "dayperiod"), "meridiem"), month = /* @__PURE__ */ __name((length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string3(standalone ? {
      month: length
    } : {
      month: length,
      day: "numeric"
    }, "month"), "month"), weekday = /* @__PURE__ */ __name((length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string3(standalone ? {
      weekday: length
    } : {
      weekday: length,
      month: "long",
      day: "numeric"
    }, "weekday"), "weekday"), maybeMacro = /* @__PURE__ */ __name((token2) => {
      const formatOpts = _Formatter.macroTokenToFormatOpts(token2);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token2;
      }
    }, "maybeMacro"), era = /* @__PURE__ */ __name((length) => knownEnglish ? eraForDateTime(dt, length) : string3({
      era: length
    }, "era"), "era"), tokenToString = /* @__PURE__ */ __name((token2) => {
      switch (token2) {
        // ms
        case "S":
          return this.num(dt.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(dt.millisecond, 3);
        // seconds
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        // minutes
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        // hours
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        // offset
        case "Z":
          return formatOffset2({
            format: "narrow",
            allowZ: this.opts.allowZ
          });
        case "ZZ":
          return formatOffset2({
            format: "short",
            allowZ: this.opts.allowZ
          });
        case "ZZZ":
          return formatOffset2({
            format: "techie",
            allowZ: this.opts.allowZ
          });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, {
            format: "short",
            locale: this.loc.locale
          });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, {
            format: "long",
            locale: this.loc.locale
          });
        // zone
        case "z":
          return dt.zoneName;
        // meridiems
        case "a":
          return meridiem();
        // dates
        case "d":
          return useDateTimeFormatter ? string3({
            day: "numeric"
          }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string3({
            day: "2-digit"
          }, "day") : this.num(dt.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        // weekdays - format
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        // months - standalone
        case "L":
          return useDateTimeFormatter ? string3({
            month: "numeric",
            day: "numeric"
          }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string3({
            month: "2-digit",
            day: "numeric"
          }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        // months - format
        case "M":
          return useDateTimeFormatter ? string3({
            month: "numeric"
          }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string3({
            month: "2-digit"
          }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        // years
        case "y":
          return useDateTimeFormatter ? string3({
            year: "numeric"
          }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string3({
            year: "2-digit"
          }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string3({
            year: "numeric"
          }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string3({
            year: "numeric"
          }, "year") : this.num(dt.year, 6);
        // eras
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token2);
      }
    }, "tokenToString");
    return stringifyTokens(_Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const tokenToField = /* @__PURE__ */ __name((token2) => {
      switch (token2[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, "tokenToField"), tokenToString = /* @__PURE__ */ __name((lildur) => (token2) => {
      const mapped = tokenToField(token2);
      if (mapped) {
        return this.num(lildur.get(mapped), token2.length);
      } else {
        return token2;
      }
    }, "tokenToString"), tokens = _Formatter.parseFormat(fmt), realTokens = tokens.reduce((found, { literal: literal2, val }) => literal2 ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t2) => t2));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
};
__name(_Formatter, "Formatter");
var Formatter = _Formatter;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/regexParser.js
var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r2) => f + r2.source, "");
  return RegExp(`^${full}$`);
}
__name(combineRegexes, "combineRegexes");
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(([mergedVals, mergedZone, cursor], ex) => {
    const [val, zone, next] = ex(m, cursor);
    return [
      __spreadValues(__spreadValues({}, mergedVals), val),
      zone || mergedZone,
      next
    ];
  }, [
    {},
    null,
    1
  ]).slice(0, 2);
}
__name(combineExtractors, "combineExtractors");
function parse(s3, ...patterns) {
  if (s3 == null) {
    return [
      null,
      null
    ];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s3);
    if (m) {
      return extractor(m);
    }
  }
  return [
    null,
    null
  ];
}
__name(parse, "parse");
function simpleParse(...keys) {
  return (match2, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match2[cursor + i]);
    }
    return [
      ret,
      null,
      cursor + i
    ];
  };
}
__name(simpleParse, "simpleParse");
var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
var isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
var sqlTimeRegex = RegExp(`${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`);
var sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
__name(int, "int");
function extractISOYmd(match2, cursor) {
  const item = {
    year: int(match2, cursor),
    month: int(match2, cursor + 1, 1),
    day: int(match2, cursor + 2, 1)
  };
  return [
    item,
    null,
    cursor + 3
  ];
}
__name(extractISOYmd, "extractISOYmd");
function extractISOTime(match2, cursor) {
  const item = {
    hours: int(match2, cursor, 0),
    minutes: int(match2, cursor + 1, 0),
    seconds: int(match2, cursor + 2, 0),
    milliseconds: parseMillis(match2[cursor + 3])
  };
  return [
    item,
    null,
    cursor + 4
  ];
}
__name(extractISOTime, "extractISOTime");
function extractISOOffset(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [
    {},
    zone,
    cursor + 3
  ];
}
__name(extractISOOffset, "extractISOOffset");
function extractIANAZone(match2, cursor) {
  const zone = match2[cursor] ? IANAZone.create(match2[cursor]) : null;
  return [
    {},
    zone,
    cursor + 1
  ];
}
__name(extractIANAZone, "extractIANAZone");
var isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s3, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s3[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = /* @__PURE__ */ __name((num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num, "maybeNegate");
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
__name(extractISODuration, "extractISODuration");
var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
__name(fromStrings, "fromStrings");
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [
    result,
    new FixedOffsetZone(offset2)
  ];
}
__name(extractRFC2822, "extractRFC2822");
function preprocessRFC2822(s3) {
  return s3.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
__name(preprocessRFC2822, "preprocessRFC2822");
var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/;
var rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/;
var ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [
    result,
    FixedOffsetZone.utcInstance
  ];
}
__name(extractRFC1123Or850, "extractRFC1123Or850");
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [
    result,
    FixedOffsetZone.utcInstance
  ];
}
__name(extractASCII, "extractASCII");
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseISODate(s3) {
  return parse(s3, [
    isoYmdWithTimeExtensionRegex,
    extractISOYmdTimeAndOffset
  ], [
    isoWeekWithTimeExtensionRegex,
    extractISOWeekTimeAndOffset
  ], [
    isoOrdinalWithTimeExtensionRegex,
    extractISOOrdinalDateAndTime
  ], [
    isoTimeCombinedRegex,
    extractISOTimeAndOffset
  ]);
}
__name(parseISODate, "parseISODate");
function parseRFC2822Date(s3) {
  return parse(preprocessRFC2822(s3), [
    rfc2822,
    extractRFC2822
  ]);
}
__name(parseRFC2822Date, "parseRFC2822Date");
function parseHTTPDate(s3) {
  return parse(s3, [
    rfc1123,
    extractRFC1123Or850
  ], [
    rfc850,
    extractRFC1123Or850
  ], [
    ascii,
    extractASCII
  ]);
}
__name(parseHTTPDate, "parseHTTPDate");
function parseISODuration(s3) {
  return parse(s3, [
    isoDuration,
    extractISODuration
  ]);
}
__name(parseISODuration, "parseISODuration");
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s3) {
  return parse(s3, [
    isoTimeOnly,
    extractISOTimeOnly
  ]);
}
__name(parseISOTimeOnly, "parseISOTimeOnly");
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s3) {
  return parse(s3, [
    sqlYmdWithTimeExtensionRegex,
    extractISOYmdTimeAndOffset
  ], [
    sqlTimeCombinedRegex,
    extractISOTimeOffsetAndIANAZone
  ]);
}
__name(parseSQL, "parseSQL");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/duration.js
var INVALID = "Invalid Duration";
var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1e3
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1e3
  },
  seconds: {
    milliseconds: 1e3
  }
};
var casualMatrix = __spreadValues({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  }
}, lowOrderMatrix);
var daysInYearAccurate = 146097 / 400;
var daysInMonthAccurate = 146097 / 4800;
var accurateMatrix = __spreadValues({
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  }
}, lowOrderMatrix);
var orderedUnits = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
var reverseUnits = orderedUnits.slice(0).reverse();
function clone(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : __spreadValues(__spreadValues({}, dur.values), alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
__name(clone, "clone");
function durationToMillis(matrix, vals) {
  var _a6;
  let sum = (_a6 = vals.milliseconds) != null ? _a6 : 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
__name(durationToMillis, "durationToMillis");
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
__name(normalizeValues, "normalizeValues");
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
__name(removeZeroes, "removeZeroes");
var _Duration = class _Duration {
  /**
  * @private
  */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
  * Create Duration from a number of milliseconds.
  * @param {number} count of milliseconds
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @return {Duration}
  */
  static fromMillis(count, opts) {
    return _Duration.fromObject({
      milliseconds: count
    }, opts);
  }
  /**
  * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
  * If this object is empty then a zero milliseconds duration is returned.
  * @param {Object} obj - the object to create the DateTime from
  * @param {number} obj.years
  * @param {number} obj.quarters
  * @param {number} obj.months
  * @param {number} obj.weeks
  * @param {number} obj.days
  * @param {number} obj.hours
  * @param {number} obj.minutes
  * @param {number} obj.seconds
  * @param {number} obj.milliseconds
  * @param {Object} [opts=[]] - options for creating this Duration
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the custom conversion system to use
  * @return {Duration}
  */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
    }
    return new _Duration({
      values: normalizeObject(obj, _Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
  * Create a Duration from DurationLike.
  *
  * @param {Object | number | Duration} durationLike
  * One of:
  * - object with keys like 'years' and 'hours'.
  * - number representing milliseconds
  * - Duration instance
  * @return {Duration}
  */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return _Duration.fromMillis(durationLike);
    } else if (_Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return _Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
  }
  /**
  * Create a Duration from an ISO 8601 duration string.
  * @param {string} text - text to parse
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the preset conversion system to use
  * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
  * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
  * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
  * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
  * @return {Duration}
  */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
  * Create a Duration from an ISO 8601 time string.
  * @param {string} text - text to parse
  * @param {Object} opts - options for parsing
  * @param {string} [opts.locale='en-US'] - the locale to use
  * @param {string} opts.numberingSystem - the numbering system to use
  * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
  * @param {string} [opts.matrix=Object] - the conversion system to use
  * @see https://en.wikipedia.org/wiki/ISO_8601#Times
  * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
  * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
  * @return {Duration}
  */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
  * Create an invalid Duration.
  * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {Duration}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new _Duration({
        invalid
      });
    }
  }
  /**
  * @private
  */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
  * Check if an object is a Duration. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isDuration(o2) {
    return o2 && o2.isLuxonDuration || false;
  }
  /**
  * Get  the locale of a Duration, such 'en-GB'
  * @type {string}
  */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
  * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
  *
  * @type {string}
  */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
  * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
  * * `S` for milliseconds
  * * `s` for seconds
  * * `m` for minutes
  * * `h` for hours
  * * `d` for days
  * * `w` for weeks
  * * `M` for months
  * * `y` for years
  * Notes:
  * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
  * * Tokens can be escaped by wrapping with single quotes.
  * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
  * @param {string} fmt - the format string
  * @param {Object} opts - options
  * @param {boolean} [opts.floor=true] - floor numerical values
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
  * @return {string}
  */
  toFormat(fmt, opts = {}) {
    const fmtOpts = __spreadProps(__spreadValues({}, opts), {
      floor: opts.round !== false && opts.floor !== false
    });
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID;
  }
  /**
  * Returns a string representation of a Duration with all units included.
  * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
  * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
  * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
  * @example
  * ```js
  * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
  * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
  * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
  * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
  * ```
  */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID;
    const l3 = orderedUnits.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return this.loc.numberFormatter(__spreadProps(__spreadValues({
        style: "unit",
        unitDisplay: "long"
      }, opts), {
        unit: unit.slice(0, -1)
      })).format(val);
    }).filter((n3) => n3);
    return this.loc.listFormatter(__spreadValues({
      type: "conjunction",
      style: opts.listStyle || "narrow"
    }, opts)).format(l3);
  }
  /**
  * Returns a JavaScript object with this Duration's values.
  * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
  * @return {Object}
  */
  toObject() {
    if (!this.isValid) return {};
    return __spreadValues({}, this.values);
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Duration.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
  * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
  * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
  * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
  * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
  * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
  * @return {string}
  */
  toISO() {
    if (!this.isValid) return null;
    let s3 = "P";
    if (this.years !== 0) s3 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s3 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s3 += this.weeks + "W";
    if (this.days !== 0) s3 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s3 += "T";
    if (this.hours !== 0) s3 += this.hours + "H";
    if (this.minutes !== 0) s3 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s3 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s3 === "P") s3 += "T0S";
    return s3;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
  * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Times
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
  * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
  * @return {string}
  */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5) return null;
    opts = __spreadProps(__spreadValues({
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended"
    }, opts), {
      includeOffset: false
    });
    const dateTime = DateTime.fromMillis(millis, {
      zone: "UTC"
    });
    return dateTime.toISOTime(opts);
  }
  /**
  * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
  * @return {string}
  */
  toJSON() {
    return this.toISO();
  }
  /**
  * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
  * @return {string}
  */
  toString() {
    return this.toISO();
  }
  /**
  * Returns a string representation of this Duration appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns an milliseconds value of this Duration.
  * @return {number}
  */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
  * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
  * @return {number}
  */
  valueOf() {
    return this.toMillis();
  }
  /**
  * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
  * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @return {Duration}
  */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = _Duration.fromDurationLike(duration), result = {};
    for (const k of orderedUnits) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone(this, {
      values: result
    }, true);
  }
  /**
  * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
  * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @return {Duration}
  */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = _Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
  * Scale this Duration by the specified amount. Return a newly-constructed Duration.
  * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
  * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
  * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
  * @return {Duration}
  */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone(this, {
      values: result
    }, true);
  }
  /**
  * Get the value of unit.
  * @param {string} unit - a unit such as 'minute' or 'day'
  * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
  * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
  * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
  * @return {number}
  */
  get(unit) {
    return this[_Duration.normalizeUnit(unit)];
  }
  /**
  * "Set" the values of specified units. Return a newly-constructed Duration.
  * @param {Object} values - a mapping of units to numbers
  * @example dur.set({ years: 2017 })
  * @example dur.set({ hours: 8, minutes: 30 })
  * @return {Duration}
  */
  set(values) {
    if (!this.isValid) return this;
    const mixed = __spreadValues(__spreadValues({}, this.values), normalizeObject(values, _Duration.normalizeUnit));
    return clone(this, {
      values: mixed
    });
  }
  /**
  * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
  * @example dur.reconfigure({ locale: 'en-GB' })
  * @return {Duration}
  */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem
    });
    const opts = {
      loc,
      matrix,
      conversionAccuracy
    };
    return clone(this, opts);
  }
  /**
  * Return the length of the duration in the specified unit.
  * @param {string} unit - a unit such as 'minutes' or 'days'
  * @example Duration.fromObject({years: 1}).as('days') //=> 365
  * @example Duration.fromObject({years: 1}).as('months') //=> 12
  * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
  * @return {number}
  */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
  * Reduce this Duration to its canonical representation in its current units.
  * Assuming the overall value of the Duration is positive, this means:
  * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
  * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
  *   the overall value would be negative, see third example)
  * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
  *
  * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
  * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
  * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
  * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
  * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
  * @return {Duration}
  */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone(this, {
      values: vals
    }, true);
  }
  /**
  * Rescale units to its largest representation
  * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
  * @return {Duration}
  */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone(this, {
      values: vals
    }, true);
  }
  /**
  * Convert this Duration into its representation in a different set of units.
  * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
  * @return {Duration}
  */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => _Duration.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone(this, {
      values: built
    }, true);
  }
  /**
  * Shift this Duration to all available units.
  * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
  * @return {Duration}
  */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
  }
  /**
  * Return the negative of this Duration.
  * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
  * @return {Duration}
  */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone(this, {
      values: negated
    }, true);
  }
  /**
  * Get the years.
  * @type {number}
  */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
  * Get the quarters.
  * @type {number}
  */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
  * Get the months.
  * @type {number}
  */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
  * Get the weeks
  * @type {number}
  */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
  * Get the days.
  * @type {number}
  */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
  * Get the hours.
  * @type {number}
  */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
  * Get the minutes.
  * @type {number}
  */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
  * Get the seconds.
  * @return {number}
  */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
  * Get the milliseconds.
  * @return {number}
  */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
  * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
  * on invalid DateTimes or Intervals.
  * @return {boolean}
  */
  get isValid() {
    return this.invalid === null;
  }
  /**
  * Returns an error code if this Duration became invalid, or null if the Duration is valid
  * @return {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Equality check
  * Two Durations are equal iff they have the same units and the same values for each unit.
  * @param {Duration} other
  * @return {boolean}
  */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === void 0 || v1 === 0) return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    __name(eq, "eq");
    for (const u of orderedUnits) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
};
__name(_Duration, "Duration");
var Duration = _Duration;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/interval.js
var INVALID2 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
  } else {
    return null;
  }
}
__name(validateStartEnd, "validateStartEnd");
var _Interval = class _Interval {
  /**
  * @private
  */
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
  * Create an invalid Interval.
  * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {Interval}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new _Interval({
        invalid
      });
    }
  }
  /**
  * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
  * @param {DateTime|Date|Object} start
  * @param {DateTime|Date|Object} end
  * @return {Interval}
  */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new _Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
  * Create an Interval from a start DateTime and a Duration to extend to.
  * @param {DateTime|Date|Object} start
  * @param {Duration|Object|number} duration - the length of the Interval.
  * @return {Interval}
  */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return _Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
  * Create an Interval from an end DateTime and a Duration to extend backwards to.
  * @param {DateTime|Date|Object} end
  * @param {Duration|Object|number} duration - the length of the Interval.
  * @return {Interval}
  */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return _Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
  * Create an Interval from an ISO 8601 string.
  * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
  * @param {string} text - the ISO string to parse
  * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @return {Interval}
  */
  static fromISO(text, opts) {
    const [s3, e2] = (text || "").split("/", 2);
    if (s3 && e2) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s3, opts);
        startIsValid = start.isValid;
      } catch (e3) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e2, opts);
        endIsValid = end.isValid;
      } catch (e3) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return _Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e2, opts);
        if (dur.isValid) {
          return _Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s3, opts);
        if (dur.isValid) {
          return _Interval.before(end, dur);
        }
      }
    }
    return _Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
  * Check if an object is an Interval. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isInterval(o2) {
    return o2 && o2.isLuxonInterval || false;
  }
  /**
  * Returns the start of the Interval
  * @type {DateTime}
  */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
  * Returns the end of the Interval
  * @type {DateTime}
  */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
  * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
  * @type {boolean}
  */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
  * Returns an error code if this Interval is invalid, or null if the Interval is valid
  * @type {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Returns the length of the Interval in the specified unit.
  * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
  * @return {number}
  */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[
      unit
    ]).get(unit) : NaN;
  }
  /**
  * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
  * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
  * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
  * @param {string} [unit='milliseconds'] - the unit of time to count.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
  * @return {number}
  */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts == null ? void 0 : opts.useLocaleWeeks) {
      end = this.end.reconfigure({
        locale: start.locale
      });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
  * Returns whether this Interval's start and end are both in the same unit of time
  * @param {string} unit - the unit of time to check sameness on
  * @return {boolean}
  */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
  * Return whether this Interval has the same start and end DateTimes.
  * @return {boolean}
  */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
  * Return whether this Interval's start is after the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
  * Return whether this Interval's end is before the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
  * Return whether this Interval contains the specified DateTime.
  * @param {DateTime} dateTime
  * @return {boolean}
  */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
  * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
  * @param {Object} values - the values to set
  * @param {DateTime} values.start - the starting DateTime
  * @param {DateTime} values.end - the ending DateTime
  * @return {Interval}
  */
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return _Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
  * Split this Interval at each of the specified DateTimes
  * @param {...DateTime} dateTimes - the unit of time to count.
  * @return {Array}
  */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d) => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()), results = [];
    let { s: s3 } = this, i = 0;
    while (s3 < this.e) {
      const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s3, next));
      s3 = next;
      i += 1;
    }
    return results;
  }
  /**
  * Split this Interval into smaller Intervals, each of the specified length.
  * Left over time is grouped into a smaller interval
  * @param {Duration|Object|number} duration - The length of each resulting interval.
  * @return {Array}
  */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s3 } = this, idx = 1, next;
    const results = [];
    while (s3 < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s3, next));
      s3 = next;
      idx += 1;
    }
    return results;
  }
  /**
  * Split this Interval into the specified number of smaller intervals.
  * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
  * @return {Array}
  */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
  * Return whether this Interval overlaps with the specified Interval
  * @param {Interval} other
  * @return {boolean}
  */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
  * Return whether this Interval's end is adjacent to the specified Interval's start.
  * @param {Interval} other
  * @return {boolean}
  */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
  * Return whether this Interval's start is adjacent to the specified Interval's end.
  * @param {Interval} other
  * @return {boolean}
  */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
  * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
  * @param {Interval} other
  * @return {boolean}
  */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
  * Return whether this Interval has the same start and end as the specified Interval.
  * @param {Interval} other
  * @return {boolean}
  */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
  * Return an Interval representing the intersection of this Interval and the specified Interval.
  * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
  * Returns null if the intersection is empty, meaning, the intervals don't intersect.
  * @param {Interval} other
  * @return {Interval}
  */
  intersection(other) {
    if (!this.isValid) return this;
    const s3 = this.s > other.s ? this.s : other.s, e2 = this.e < other.e ? this.e : other.e;
    if (s3 >= e2) {
      return null;
    } else {
      return _Interval.fromDateTimes(s3, e2);
    }
  }
  /**
  * Return an Interval representing the union of this Interval and the specified Interval.
  * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
  * @param {Interval} other
  * @return {Interval}
  */
  union(other) {
    if (!this.isValid) return this;
    const s3 = this.s < other.s ? this.s : other.s, e2 = this.e > other.e ? this.e : other.e;
    return _Interval.fromDateTimes(s3, e2);
  }
  /**
  * Merge an array of Intervals into a equivalent minimal set of Intervals.
  * Combines overlapping and adjacent Intervals.
  * @param {Array} intervals
  * @return {Array}
  */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(([sofar, current], item) => {
      if (!current) {
        return [
          sofar,
          item
        ];
      } else if (current.overlaps(item) || current.abutsStart(item)) {
        return [
          sofar,
          current.union(item)
        ];
      } else {
        return [
          sofar.concat([
            current
          ]),
          item
        ];
      }
    }, [
      [],
      null
    ]);
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
  * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
  * @param {Array} intervals
  * @return {Array}
  */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      {
        time: i.s,
        type: "s"
      },
      {
        time: i.e,
        type: "e"
      }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(_Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return _Interval.merge(results);
  }
  /**
  * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
  * @param {...Interval} intervals
  * @return {Array}
  */
  difference(...intervals) {
    return _Interval.xor([
      this
    ].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
  * Returns a string representation of this Interval appropriate for debugging.
  * @return {string}
  */
  toString() {
    if (!this.isValid) return INVALID2;
    return `[${this.s.toISO()} \u2013 ${this.e.toISO()})`;
  }
  /**
  * Returns a string representation of this Interval appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns a localized string representing this Interval. Accepts the same options as the
  * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
  * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
  * is browser-specific, but in general it will return an appropriate representation of the
  * Interval in the assigned locale. Defaults to the system's locale if no locale has been
  * specified.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
  * Intl.DateTimeFormat constructor options.
  * @param {Object} opts - Options to override the configuration of the start DateTime.
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
  * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
  * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
  * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
  * @return {string}
  */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID2;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this Interval.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @param {Object} opts - The same options as {@link DateTime#toISO}
  * @return {string}
  */
  toISO(opts) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
  * Returns an ISO 8601-compliant string representation of date of this Interval.
  * The time components are ignored.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @return {string}
  */
  toISODate() {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
  * Returns an ISO 8601-compliant string representation of time of this Interval.
  * The date components are ignored.
  * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
  * @param {Object} opts - The same options as {@link DateTime#toISO}
  * @return {string}
  */
  toISOTime(opts) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
  * Returns a string representation of this Interval formatted according to the specified format
  * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
  * formatting tool.
  * @param {string} dateFormat - The format string. This string formats the start and end time.
  * See {@link DateTime#toFormat} for details.
  * @param {Object} opts - Options.
  * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
  * representations.
  * @return {string}
  */
  toFormat(dateFormat, { separator = " \u2013 " } = {}) {
    if (!this.isValid) return INVALID2;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
  * Return a Duration representing the time spanned by this interval.
  * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
  * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
  * @return {Duration}
  */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
  * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
  * @param {function} mapFn
  * @return {Interval}
  * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
  * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
  */
  mapEndpoints(mapFn) {
    return _Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
};
__name(_Interval, "Interval");
var Interval = _Interval;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/info.js
var _Info = class _Info {
  /**
  * Return whether the specified zone contains a DST.
  * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
  * @return {boolean}
  */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.isUniversal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }
  /**
  * Return whether the specified zone is a valid IANA specifier.
  * @param {string} zone - Zone to check
  * @return {boolean}
  */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
  * Converts the input into a {@link Zone} instance.
  *
  * * If `input` is already a Zone instance, it is returned unchanged.
  * * If `input` is a string containing a valid time zone name, a Zone instance
  *   with that name is returned.
  * * If `input` is a string that doesn't refer to a known time zone, a Zone
  *   instance with {@link Zone#isValid} == false is returned.
  * * If `input is a number, a Zone instance with the specified fixed offset
  *   in minutes is returned.
  * * If `input` is `null` or `undefined`, the default zone is returned.
  * @param {string|Zone|number} [input] - the value to be converted
  * @return {Zone}
  */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
  * Get the weekday on which the week starts according to the given locale.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
  */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
  * Get the minimum number of days necessary in a week before it is considered part of the next year according
  * to the given locale.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number}
  */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
  * Get the weekdays, which are considered the weekend according to the given locale
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
  */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
  * Return an array of standalone month names.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @param {string} [opts.outputCalendar='gregory'] - the calendar
  * @example Info.months()[0] //=> 'January'
  * @example Info.months('short')[0] //=> 'Jan'
  * @example Info.months('numeric')[0] //=> '1'
  * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
  * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
  * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
  * @return {Array}
  */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
  * Return an array of format month names.
  * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
  * changes the string.
  * See {@link Info#months}
  * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @param {string} [opts.outputCalendar='gregory'] - the calendar
  * @return {Array}
  */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
  * Return an array of standalone week names.
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @example Info.weekdays()[0] //=> 'Monday'
  * @example Info.weekdays('short')[0] //=> 'Mon'
  * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
  * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
  * @return {Array}
  */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
  * Return an array of format week names.
  * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
  * changes the string.
  * See {@link Info#weekdays}
  * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale=null] - the locale code
  * @param {string} [opts.numberingSystem=null] - the numbering system
  * @param {string} [opts.locObj=null] - an existing locale object to use
  * @return {Array}
  */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
  * Return an array of meridiems.
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @example Info.meridiems() //=> [ 'AM', 'PM' ]
  * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
  * @return {Array}
  */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
  * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
  * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
  * @param {Object} opts - options
  * @param {string} [opts.locale] - the locale code
  * @example Info.eras() //=> [ 'BC', 'AD' ]
  * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
  * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
  * @return {Array}
  */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
  * Return the set of available features in this environment.
  * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
  * Keys:
  * * `relative`: whether this environment supports relative time formatting
  * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
  * @example Info.features() //=> { relative: false, localeWeek: true }
  * @return {Object}
  */
  static features() {
    return {
      relative: hasRelative(),
      localeWeek: hasLocaleWeekInfo()
    };
  }
};
__name(_Info, "Info");
var Info = _Info;

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/diff.js
function dayDiff(earlier, later) {
  const utcDayStart = /* @__PURE__ */ __name((dt) => dt.toUTC(0, {
    keepLocalTime: true
  }).startOf("day").valueOf(), "utcDayStart"), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
__name(dayDiff, "dayDiff");
function highOrderDiffs(cursor, later, units) {
  const differs = [
    [
      "years",
      (a, b) => b.year - a.year
    ],
    [
      "quarters",
      (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4
    ],
    [
      "months",
      (a, b) => b.month - a.month + (b.year - a.year) * 12
    ],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    [
      "days",
      dayDiff
    ]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
        if (cursor > later) {
          highWater = cursor;
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [
    cursor,
    results,
    highWater,
    lowestOrder
  ];
}
__name(highOrderDiffs, "highOrderDiffs");
function diff_default(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter((u) => [
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ].indexOf(u) >= 0);
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({
        [lowestOrder]: 1
      });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
__name(diff_default, "default");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/impl/tokenParser.js
var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([s3]) => post(parseDigits(s3)), "deser")
  };
}
__name(intUnit, "intUnit");
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = `[ ${NBSP}]`;
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s3) {
  return s3.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
__name(fixListRegex, "fixListRegex");
function stripInsensitivities(s3) {
  return s3.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
__name(stripInsensitivities, "stripInsensitivities");
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: /* @__PURE__ */ __name(([s3]) => strings.findIndex((i) => stripInsensitivities(s3) === stripInsensitivities(i)) + startIndex, "deser")
    };
  }
}
__name(oneOf, "oneOf");
function offset(regex, groups) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([, h, m]) => signedOffset(h, m), "deser"),
    groups
  };
}
__name(offset, "offset");
function simple(regex) {
  return {
    regex,
    deser: /* @__PURE__ */ __name(([s3]) => s3, "deser")
  };
}
__name(simple, "simple");
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
__name(escapeToken, "escapeToken");
function unitForToken(token2, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal2 = /* @__PURE__ */ __name((t2) => ({
    regex: RegExp(escapeToken(t2.val)),
    deser: /* @__PURE__ */ __name(([s3]) => s3, "deser"),
    literal: true
  }), "literal"), unitate = /* @__PURE__ */ __name((t2) => {
    if (token2.literal) {
      return literal2(t2);
    }
    switch (t2.val) {
      // era
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      // years
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      // months
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      // dates
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      // ordinals
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      // time
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      // meridiem
      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      // weekdays
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal2(t2);
    }
  }, "unitate");
  const unit = unitate(token2) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token2;
  return unit;
}
__name(unitForToken, "unitForToken");
var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
__name(tokenForPart, "tokenForPart");
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r2) => `${f}(${r2.source})`, "");
  return [
    `^${re}$`,
    units
  ];
}
__name(buildRegex, "buildRegex");
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all2 = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all2[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [
      matches,
      all2
    ];
  } else {
    return [
      matches,
      {}
    ];
  }
}
__name(match, "match");
function dateTimeFromMatches(matches) {
  const toField = /* @__PURE__ */ __name((token2) => {
    switch (token2) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  }, "toField");
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r2, k) => {
    const f = toField(k);
    if (f) {
      r2[f] = matches[k];
    }
    return r2;
  }, {});
  return [
    vals,
    zone,
    specificOffset
  ];
}
__name(dateTimeFromMatches, "dateTimeFromMatches");
var dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
__name(getDummyDateTime, "getDummyDateTime");
function maybeExpandMacroToken(token2, locale) {
  if (token2.literal) {
    return token2;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token2.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token2;
  }
  return tokens;
}
__name(maybeExpandMacroToken, "maybeExpandMacroToken");
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t2) => maybeExpandMacroToken(t2, locale)));
}
__name(expandMacroTokens, "expandMacroTokens");
var _TokenParser = class _TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t2) => unitForToken(t2, locale));
    this.disqualifyingUnit = this.units.find((t2) => t2.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return {
        input,
        tokens: this.tokens,
        invalidReason: this.invalidReason
      };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [
        null,
        null,
        void 0
      ];
      if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
};
__name(_TokenParser, "TokenParser");
var TokenParser = _TokenParser;
function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
__name(explainFromTokens, "explainFromTokens");
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [
    result,
    zone,
    specificOffset,
    invalidReason
  ];
}
__name(parseFromTokens, "parseFromTokens");
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}
__name(formatOptsToTokens, "formatOptsToTokens");

// ../../node_modules/.pnpm/luxon@3.5.0/node_modules/luxon/src/datetime.js
var INVALID3 = "Invalid DateTime";
var MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
__name(unsupportedZone, "unsupportedZone");
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
__name(possiblyCachedWeekData, "possiblyCachedWeekData");
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
  }
  return dt.localWeekData;
}
__name(possiblyCachedLocalWeekData, "possiblyCachedLocalWeekData");
function clone2(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(__spreadProps(__spreadValues(__spreadValues({}, current), alts), {
    old: current
  }));
}
__name(clone2, "clone");
function fixOffset(localTS, o2, tz) {
  let utcGuess = localTS - o2 * 60 * 1e3;
  const o22 = tz.offset(utcGuess);
  if (o2 === o22) {
    return [
      utcGuess,
      o2
    ];
  }
  utcGuess -= (o22 - o2) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o22 === o3) {
    return [
      utcGuess,
      o22
    ];
  }
  return [
    localTS - Math.min(o22, o3) * 60 * 1e3,
    Math.max(o22, o3)
  ];
}
__name(fixOffset, "fixOffset");
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}
__name(tsToObj, "tsToObj");
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
__name(objToTS, "objToTS");
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c2 = __spreadProps(__spreadValues({}, inst.c), {
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }), millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c2);
  let [ts, o2] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o2 = inst.zone.offset(ts);
  }
  return {
    ts,
    o: o2
  };
}
__name(adjustTime, "adjustTime");
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, __spreadProps(__spreadValues({}, opts), {
      zone: interpretationZone,
      specificOffset
    }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`));
  }
}
__name(parseDataToDateTime, "parseDataToDateTime");
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
__name(toTechFormat, "toTechFormat");
function toISODate(o2, extended) {
  const longFormat = o2.c.year > 9999 || o2.c.year < 0;
  let c2 = "";
  if (longFormat && o2.c.year >= 0) c2 += "+";
  c2 += padStart(o2.c.year, longFormat ? 6 : 4);
  if (extended) {
    c2 += "-";
    c2 += padStart(o2.c.month);
    c2 += "-";
    c2 += padStart(o2.c.day);
  } else {
    c2 += padStart(o2.c.month);
    c2 += padStart(o2.c.day);
  }
  return c2;
}
__name(toISODate, "toISODate");
function toISOTime(o2, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  let c2 = padStart(o2.c.hour);
  if (extended) {
    c2 += ":";
    c2 += padStart(o2.c.minute);
    if (o2.c.millisecond !== 0 || o2.c.second !== 0 || !suppressSeconds) {
      c2 += ":";
    }
  } else {
    c2 += padStart(o2.c.minute);
  }
  if (o2.c.millisecond !== 0 || o2.c.second !== 0 || !suppressSeconds) {
    c2 += padStart(o2.c.second);
    if (o2.c.millisecond !== 0 || !suppressMilliseconds) {
      c2 += ".";
      c2 += padStart(o2.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o2.isOffsetFixed && o2.offset === 0 && !extendedZone) {
      c2 += "Z";
    } else if (o2.o < 0) {
      c2 += "-";
      c2 += padStart(Math.trunc(-o2.o / 60));
      c2 += ":";
      c2 += padStart(Math.trunc(-o2.o % 60));
    } else {
      c2 += "+";
      c2 += padStart(Math.trunc(o2.o / 60));
      c2 += ":";
      c2 += padStart(Math.trunc(o2.o % 60));
    }
  }
  if (extendedZone) {
    c2 += "[" + o2.zone.ianaName + "]";
  }
  return c2;
}
__name(toISOTime, "toISOTime");
var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var orderedUnits2 = [
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedOrdinalUnits = [
  "year",
  "ordinal",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
__name(normalizeUnit, "normalizeUnit");
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
__name(normalizeUnitWithLocalWeeks, "normalizeUnitWithLocalWeeks");
function guessOffsetForZone(zone) {
  if (!zoneOffsetGuessCache[zone]) {
    if (zoneOffsetTs === void 0) {
      zoneOffsetTs = Settings.now();
    }
    zoneOffsetGuessCache[zone] = zone.offset(zoneOffsetTs);
  }
  return zoneOffsetGuessCache[zone];
}
__name(guessOffsetForZone, "guessOffsetForZone");
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts, o2;
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits2) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts, o2] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }
  return new DateTime({
    ts,
    zone,
    loc,
    o: o2
  });
}
__name(quickDT, "quickDT");
function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round, format = /* @__PURE__ */ __name((c2, unit) => {
    c2 = roundTo(c2, round || opts.calendary ? 0 : 2, true);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c2, unit);
  }, "format"), differ = /* @__PURE__ */ __name((unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  }, "differ");
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
__name(diffRelative, "diffRelative");
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [
    opts,
    args
  ];
}
__name(lastOpts, "lastOpts");
var zoneOffsetTs;
var zoneOffsetGuessCache = {};
var _DateTime = class _DateTime {
  /**
  * @access private
  */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    let c2 = null, o2 = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c2, o2] = [
          config.old.c,
          config.old.o
        ];
      } else {
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c2 = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c2.year) ? new Invalid("invalid input") : null;
        c2 = invalid ? null : c2;
        o2 = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c2;
    this.o = o2;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
  * Create a DateTime for the current instant, in the system's time zone.
  *
  * Use Settings to override these default values if needed.
  * @example DateTime.now().toISO() //~> now in the ISO format
  * @return {DateTime}
  */
  static now() {
    return new _DateTime({});
  }
  /**
  * Create a local DateTime
  * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
  * @param {number} [month=1] - The month, 1-indexed
  * @param {number} [day=1] - The day of the month, 1-indexed
  * @param {number} [hour=0] - The hour of the day, in 24-hour time
  * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
  * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
  * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
  * @example DateTime.local()                                  //~> now
  * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
  * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
  * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
  * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
  * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
  * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
  * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
  * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
  * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
  * @return {DateTime}
  */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }
  /**
  * Create a DateTime in UTC
  * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
  * @param {number} [month=1] - The month, 1-indexed
  * @param {number} [day=1] - The day of the month
  * @param {number} [hour=0] - The hour of the day, in 24-hour time
  * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
  * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
  * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
  * @param {Object} options - configuration options for the DateTime
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
  * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
  * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
  * @example DateTime.utc()                                              //~> now
  * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
  * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
  * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
  * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
  * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
  * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
  * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
  * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
  * @return {DateTime}
  */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }
  /**
  * Create a DateTime from a JavaScript Date object. Uses the default zone.
  * @param {Date} date - a JavaScript Date object
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @return {DateTime}
  */
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return _DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new _DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
  * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
  * @param {number} milliseconds - a number of milliseconds since 1970 UTC
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return _DateTime.invalid("Timestamp out of range");
    } else {
      return new _DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
  * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
  * @param {number} seconds - a number of seconds since 1970 UTC
  * @param {Object} options - configuration options for the DateTime
  * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
  * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
  * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new _DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
  * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
  * @param {Object} obj - the object to create the DateTime from
  * @param {number} obj.year - a year, such as 1987
  * @param {number} obj.month - a month, 1-12
  * @param {number} obj.day - a day of the month, 1-31, depending on the month
  * @param {number} obj.ordinal - day of the year, 1-365 or 366
  * @param {number} obj.weekYear - an ISO week year
  * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
  * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
  * @param {number} obj.localWeekYear - a week year, according to the locale
  * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
  * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
  * @param {number} obj.hour - hour of the day, 0-23
  * @param {number} obj.minute - minute of the hour, 0-59
  * @param {number} obj.second - second of the minute, 0-59
  * @param {number} obj.millisecond - millisecond of the second, 0-999
  * @param {Object} opts - options for creating this DateTime
  * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
  * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
  * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
  * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
  * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
  * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
  * @return {DateTime}
  */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits2;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return _DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new _DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return _DateTime.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
    }
    if (!inst.isValid) {
      return _DateTime.invalid(inst.invalid);
    }
    return inst;
  }
  /**
  * Create a DateTime from an ISO 8601 string
  * @param {string} text - the ISO string
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
  * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
  * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromISO('2016-05-25T09:08:34.123')
  * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
  * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
  * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
  * @example DateTime.fromISO('2016-W05-4')
  * @return {DateTime}
  */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
  * Create a DateTime from an RFC 2822 string
  * @param {string} text - the RFC 2822 string
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
  * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
  * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
  * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
  * @return {DateTime}
  */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
  * Create a DateTime from an HTTP header date
  * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
  * @param {string} text - the HTTP header date
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
  * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
  * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
  * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
  * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
  * @return {DateTime}
  */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
  * Create a DateTime from an input string and format string.
  * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
  * @param {string} text - the string to parse
  * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
  * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @return {DateTime}
  */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return _DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
  * @deprecated use fromFormat instead
  */
  static fromString(text, fmt, opts = {}) {
    return _DateTime.fromFormat(text, fmt, opts);
  }
  /**
  * Create a DateTime from a SQL date, time, or datetime
  * Defaults to en-US if no locale has been specified, regardless of the system's locale
  * @param {string} text - the string to parse
  * @param {Object} opts - options to affect the creation
  * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
  * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
  * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
  * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
  * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
  * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
  * @example DateTime.fromSQL('2017-05-15')
  * @example DateTime.fromSQL('2017-05-15 09:12:34')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
  * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
  * @example DateTime.fromSQL('09:12:34.342')
  * @return {DateTime}
  */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
  * Create an invalid DateTime.
  * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
  * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
  * @return {DateTime}
  */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new _DateTime({
        invalid
      });
    }
  }
  /**
  * Check if an object is an instance of DateTime. Works across context boundaries
  * @param {object} o
  * @return {boolean}
  */
  static isDateTime(o2) {
    return o2 && o2.isLuxonDateTime || false;
  }
  /**
  * Produce the format string for a set of options
  * @param formatOpts
  * @param localeOpts
  * @returns {string}
  */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t2) => t2 ? t2.val : null).join("");
  }
  /**
  * Produce the the fully expanded format token for the locale
  * Does NOT quote characters, so quoted tokens will not round trip correctly
  * @param fmt
  * @param localeOpts
  * @returns {string}
  */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t2) => t2.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = void 0;
    zoneOffsetGuessCache = {};
  }
  // INFO
  /**
  * Get the value of unit.
  * @param {string} unit - a unit such as 'minute' or 'day'
  * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
  * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
  * @return {number}
  */
  get(unit) {
    return this[unit];
  }
  /**
  * Returns whether the DateTime is valid. Invalid DateTimes occur when:
  * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
  * * The DateTime was created by an operation on another invalid date
  * @type {boolean}
  */
  get isValid() {
    return this.invalid === null;
  }
  /**
  * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
  * @type {string}
  */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
  * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
  * @type {string}
  */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
  * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
  *
  * @type {string}
  */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
  * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
  *
  * @type {string}
  */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
  * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
  *
  * @type {string}
  */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
  * Get the time zone associated with this DateTime.
  * @type {Zone}
  */
  get zone() {
    return this._zone;
  }
  /**
  * Get the name of the time zone.
  * @type {string}
  */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
  * Get the year
  * @example DateTime.local(2017, 5, 25).year //=> 2017
  * @type {number}
  */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
  * Get the quarter
  * @example DateTime.local(2017, 5, 25).quarter //=> 2
  * @type {number}
  */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
  * Get the month (1-12).
  * @example DateTime.local(2017, 5, 25).month //=> 5
  * @type {number}
  */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
  * Get the day of the month (1-30ish).
  * @example DateTime.local(2017, 5, 25).day //=> 25
  * @type {number}
  */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
  * Get the hour of the day (0-23).
  * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
  * @type {number}
  */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
  * Get the minute of the hour (0-59).
  * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
  * @type {number}
  */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
  * Get the second of the minute (0-59).
  * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
  * @type {number}
  */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
  * Get the millisecond of the second (0-999).
  * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
  * @type {number}
  */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
  * Get the week year
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
  * @type {number}
  */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
  * Get the week number of the week year (1-52ish).
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
  * @type {number}
  */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
  * Get the day of the week.
  * 1 is Monday and 7 is Sunday
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2014, 11, 31).weekday //=> 4
  * @type {number}
  */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
  * Returns true if this date is on a weekend according to the locale, false otherwise
  * @returns {boolean}
  */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
  * Get the day of the week according to the locale.
  * 1 is the first day of the week and 7 is the last day of the week.
  * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
  * @returns {number}
  */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
  * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
  * because the week can start on different days of the week (see localWeekday) and because a different number of days
  * is required for a week to count as the first week of a year.
  * @returns {number}
  */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
  * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
  * differently, see localWeekNumber.
  * @returns {number}
  */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
  * Get the ordinal (meaning the day of the year)
  * @example DateTime.local(2017, 5, 25).ordinal //=> 145
  * @type {number|DateTime}
  */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
  * Get the human readable short month name, such as 'Oct'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
  * @type {string}
  */
  get monthShort() {
    return this.isValid ? Info.months("short", {
      locObj: this.loc
    })[this.month - 1] : null;
  }
  /**
  * Get the human readable long month name, such as 'October'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).monthLong //=> October
  * @type {string}
  */
  get monthLong() {
    return this.isValid ? Info.months("long", {
      locObj: this.loc
    })[this.month - 1] : null;
  }
  /**
  * Get the human readable short weekday, such as 'Mon'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
  * @type {string}
  */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }
  /**
  * Get the human readable long weekday, such as 'Monday'.
  * Defaults to the system's locale if no locale has been specified
  * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
  * @type {string}
  */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }
  /**
  * Get the UTC offset of this DateTime in minutes
  * @example DateTime.now().offset //=> -240
  * @example DateTime.utc().offset //=> 0
  * @type {number}
  */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
  * Get the short human name for the zone's current offset, for example "EST" or "EDT".
  * Defaults to the system's locale if no locale has been specified
  * @type {string}
  */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
  * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
  * Defaults to the system's locale if no locale has been specified
  * @type {string}
  */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
  * Get whether this zone's offset ever changes, as in a DST.
  * @type {boolean}
  */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
  * Get whether the DateTime is in a DST.
  * @type {boolean}
  */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({
        month: 1,
        day: 1
      }).offset || this.offset > this.set({
        month: 5
      }).offset;
    }
  }
  /**
  * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
  * in this DateTime's zone. During DST changes local time can be ambiguous, for example
  * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
  * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
  * @returns {DateTime[]}
  */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [
        this
      ];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [
        this
      ];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [
        clone2(this, {
          ts: ts1
        }),
        clone2(this, {
          ts: ts2
        })
      ];
    }
    return [
      this
    ];
  }
  /**
  * Returns true if this DateTime is in a leap year, false otherwise
  * @example DateTime.local(2016).isInLeapYear //=> true
  * @example DateTime.local(2013).isInLeapYear //=> false
  * @type {boolean}
  */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
  * Returns the number of days in this DateTime's month
  * @example DateTime.local(2016, 2).daysInMonth //=> 29
  * @example DateTime.local(2016, 3).daysInMonth //=> 31
  * @type {number}
  */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
  * Returns the number of days in this DateTime's year
  * @example DateTime.local(2016).daysInYear //=> 366
  * @example DateTime.local(2013).daysInYear //=> 365
  * @type {number}
  */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
  * Returns the number of weeks in this DateTime's year
  * @see https://en.wikipedia.org/wiki/ISO_week_date
  * @example DateTime.local(2004).weeksInWeekYear //=> 53
  * @example DateTime.local(2013).weeksInWeekYear //=> 52
  * @type {number}
  */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
  * Returns the number of weeks in this DateTime's local week year
  * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
  * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
  * @type {number}
  */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
  }
  /**
  * Returns the resolved Intl options for this DateTime.
  * This is useful in understanding the behavior of formatting methods
  * @param {Object} opts - the same options as toLocaleString
  * @return {Object}
  */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this);
    return {
      locale,
      numberingSystem,
      outputCalendar: calendar
    };
  }
  // TRANSFORM
  /**
  * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
  *
  * Equivalent to {@link DateTime#setZone}('utc')
  * @param {number} [offset=0] - optionally, an offset from UTC in minutes
  * @param {Object} [opts={}] - options to pass to `setZone()`
  * @return {DateTime}
  */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
  * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
  *
  * Equivalent to `setZone('local')`
  * @return {DateTime}
  */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
  * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
  *
  * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
  * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
  * @param {Object} opts - options
  * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
  * @return {DateTime}
  */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return _DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone2(this, {
        ts: newTS,
        zone
      });
    }
  }
  /**
  * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
  * @param {Object} properties - the properties to set
  * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
  * @return {DateTime}
  */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem,
      outputCalendar
    });
    return clone2(this, {
      loc
    });
  }
  /**
  * "Set" the locale. Returns a newly-constructed DateTime.
  * Just a convenient alias for reconfigure({ locale })
  * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
  * @return {DateTime}
  */
  setLocale(locale) {
    return this.reconfigure({
      locale
    });
  }
  /**
  * "Set" the values of specified units. Returns a newly-constructed DateTime.
  * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
  *
  * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
  * They cannot be mixed with ISO-week units like `weekday`.
  * @param {Object} values - a mapping of units to numbers
  * @example dt.set({ year: 2017 })
  * @example dt.set({ hour: 8, minute: 30 })
  * @example dt.set({ weekday: 5 })
  * @example dt.set({ year: 2005, ordinal: 234 })
  * @return {DateTime}
  */
  set(values) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(__spreadValues(__spreadValues({}, gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek)), normalized), minDaysInFirstWeek, startOfWeek);
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(__spreadValues(__spreadValues({}, gregorianToOrdinal(this.c)), normalized));
    } else {
      mixed = __spreadValues(__spreadValues({}, this.toObject()), normalized);
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o2] = objToTS(mixed, this.o, this.zone);
    return clone2(this, {
      ts,
      o: o2
    });
  }
  /**
  * Add a period of time to this DateTime and return the resulting DateTime
  *
  * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
  * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  * @example DateTime.now().plus(123) //~> in 123 milliseconds
  * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
  * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
  * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
  * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
  * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
  * @return {DateTime}
  */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone2(this, adjustTime(this, dur));
  }
  /**
  * Subtract a period of time to this DateTime and return the resulting DateTime
  * See {@link DateTime#plus}
  * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
  @return {DateTime}
  */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone2(this, adjustTime(this, dur));
  }
  /**
  * "Set" this DateTime to the beginning of a unit of time.
  * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
  * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
  * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
  * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
  * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
  * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
  * @return {DateTime}
  */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid) return this;
    const o2 = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o2.month = 1;
      // falls through
      case "quarters":
      case "months":
        o2.day = 1;
      // falls through
      case "weeks":
      case "days":
        o2.hour = 0;
      // falls through
      case "hours":
        o2.minute = 0;
      // falls through
      case "minutes":
        o2.second = 0;
      // falls through
      case "seconds":
        o2.millisecond = 0;
        break;
      case "milliseconds":
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o2.weekNumber = this.weekNumber - 1;
        }
        o2.weekday = startOfWeek;
      } else {
        o2.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o2.month = (q - 1) * 3 + 1;
    }
    return this.set(o2);
  }
  /**
  * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
  * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
  * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
  * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
  * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
  * @return {DateTime}
  */
  endOf(unit, opts) {
    return this.isValid ? this.plus({
      [unit]: 1
    }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
  * Returns a string representation of this DateTime formatted according to the specified format string.
  * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
  * Defaults to en-US if no locale has been specified, regardless of the system's locale.
  * @param {string} fmt - the format string
  * @param {Object} opts - opts to override the configuration options on this DateTime
  * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
  * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
  * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
  * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
  * @return {string}
  */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID3;
  }
  /**
  * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
  * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
  * of the DateTime in the assigned locale.
  * Defaults to the system's locale if no locale has been specified
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
  * @param {Object} opts - opts to override the configuration options on this DateTime
  * @example DateTime.now().toLocaleString(); //=> 4/20/2017
  * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
  * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
  * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
  * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
  * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
  * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
  * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
  * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
  * @return {string}
  */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID3;
  }
  /**
  * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
  * Defaults to the system's locale if no locale has been specified
  * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
  * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
  * @example DateTime.now().toLocaleParts(); //=> [
  *                                   //=>   { type: 'day', value: '25' },
  *                                   //=>   { type: 'literal', value: '/' },
  *                                   //=>   { type: 'month', value: '05' },
  *                                   //=>   { type: 'literal', value: '/' },
  *                                   //=>   { type: 'year', value: '1982' }
  *                                   //=> ]
  */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
  * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
  * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
  * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
  * @return {string}
  */
  toISO({ format = "extended", suppressSeconds = false, suppressMilliseconds = false, includeOffset = true, extendedZone = false } = {}) {
    if (!this.isValid) {
      return null;
    }
    const ext = format === "extended";
    let c2 = toISODate(this, ext);
    c2 += "T";
    c2 += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c2;
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's date component
  * @param {Object} opts - options
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
  * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
  * @return {string}
  */
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended");
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's week date
  * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
  * @return {string}
  */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
  * Returns an ISO 8601-compliant string representation of this DateTime's time component
  * @param {Object} opts - options
  * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
  * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
  * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
  * @param {string} [opts.format='extended'] - choose between the basic and extended format
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
  * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
  * @return {string}
  */
  toISOTime({ suppressMilliseconds = false, suppressSeconds = false, includeOffset = true, includePrefix = false, extendedZone = false, format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    let c2 = includePrefix ? "T" : "";
    return c2 + toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
  }
  /**
  * Returns an RFC 2822-compatible string representation of this DateTime
  * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
  * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
  * @return {string}
  */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
  * Specifically, the string conforms to RFC 1123.
  * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
  * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
  * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
  * @return {string}
  */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL Date
  * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
  * @return {string}
  */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL Time
  * @param {Object} opts - options
  * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
  * @example DateTime.utc().toSQL() //=> '05:15:16.345'
  * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
  * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
  * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
  * @return {string}
  */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
  * Returns a string representation of this DateTime appropriate for use in SQL DateTime
  * @param {Object} opts - options
  * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
  * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
  * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
  * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
  * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
  * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
  * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
  * @return {string}
  */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
  * Returns a string representation of this DateTime appropriate for debugging
  * @return {string}
  */
  toString() {
    return this.isValid ? this.toISO() : INVALID3;
  }
  /**
  * Returns a string representation of this DateTime appropriate for the REPL.
  * @return {string}
  */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
  * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
  * @return {number}
  */
  valueOf() {
    return this.toMillis();
  }
  /**
  * Returns the epoch milliseconds of this DateTime.
  * @return {number}
  */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
  * Returns the epoch seconds of this DateTime.
  * @return {number}
  */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
  * Returns the epoch seconds (as a whole number) of this DateTime.
  * @return {number}
  */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
  * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
  * @return {string}
  */
  toJSON() {
    return this.toISO();
  }
  /**
  * Returns a BSON serializable equivalent to this DateTime.
  * @return {Date}
  */
  toBSON() {
    return this.toJSDate();
  }
  /**
  * Returns a JavaScript object with this DateTime's year, month, day, and so on.
  * @param opts - options for generating the object
  * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
  * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
  * @return {Object}
  */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = __spreadValues({}, this.c);
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
  * Returns a JavaScript Date equivalent to this DateTime.
  * @return {Date}
  */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
  * Return the difference between two DateTimes as a Duration.
  * @param {DateTime} otherDateTime - the DateTime to compare this one to
  * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @example
  * var i1 = DateTime.fromISO('1982-05-25T09:45'),
  *     i2 = DateTime.fromISO('1983-10-14T10:30');
  * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
  * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
  * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
  * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
  * @return {Duration}
  */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = __spreadValues({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, opts);
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff_default(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
  * Return the difference between this DateTime and right now.
  * See {@link DateTime#diff}
  * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
  * @param {Object} opts - options that affect the creation of the Duration
  * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
  * @return {Duration}
  */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(_DateTime.now(), unit, opts);
  }
  /**
  * Return an Interval spanning between this DateTime and another DateTime
  * @param {DateTime} otherDateTime - the other end point of the Interval
  * @return {Interval}
  */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
  * Return whether this DateTime is in the same unit of time as another DateTime.
  * Higher-order units must also be identical for this function to return `true`.
  * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
  * @param {DateTime} otherDateTime - the other DateTime
  * @param {string} unit - the unit of time to check sameness on
  * @param {Object} opts - options
  * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
  * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
  * @return {boolean}
  */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
  * Equality check
  * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
  * To compare just the millisecond values, use `+dt1 === +dt2`.
  * @param {DateTime} other - the other DateTime
  * @return {boolean}
  */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
  * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
  * platform supports Intl.RelativeTimeFormat. Rounds down by default.
  * @param {Object} options - options that affect the output
  * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
  * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
  * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
  * @param {boolean} [options.round=true] - whether to round the numbers in the output.
  * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
  * @param {string} options.locale - override the locale of this DateTime
  * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
  * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
  * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
  * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
  * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
  * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
  * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
  */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || _DateTime.fromObject({}, {
      zone: this.zone
    }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = [
      "years",
      "months",
      "days",
      "hours",
      "minutes",
      "seconds"
    ];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), __spreadProps(__spreadValues({}, options), {
      numeric: "always",
      units,
      unit
    }));
  }
  /**
  * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
  * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
  * @param {Object} options - options that affect the output
  * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
  * @param {string} options.locale - override the locale of this DateTime
  * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
  * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
  * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
  * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
  * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
  * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
  */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative(options.base || _DateTime.fromObject({}, {
      zone: this.zone
    }), this, __spreadProps(__spreadValues({}, options), {
      numeric: "auto",
      units: [
        "years",
        "months",
        "days"
      ],
      calendary: true
    }));
  }
  /**
  * Return the min of several date times
  * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
  * @return {DateTime} the min DateTime, or undefined if called with no argument
  */
  static min(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
  * Return the max of several date times
  * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
  * @return {DateTime} the max DateTime, or undefined if called with no argument
  */
  static max(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
  * Explain how a string would be parsed by fromFormat()
  * @param {string} text - the string to parse
  * @param {string} fmt - the format the string is expected to be in (see description)
  * @param {Object} options - options taken by fromFormat()
  * @return {Object}
  */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
  * @deprecated use fromFormatExplain instead
  */
  static fromStringExplain(text, fmt, options = {}) {
    return _DateTime.fromFormatExplain(text, fmt, options);
  }
  /**
  * Build a parser for `fmt` using the given locale. This parser can be passed
  * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
  * can be used to optimize cases where many dates need to be parsed in a
  * specific format.
  *
  * @param {String} fmt - the format the string is expected to be in (see
  * description)
  * @param {Object} options - options used to set locale and numberingSystem
  * for parser
  * @returns {TokenParser} - opaque object to be used
  */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser(localeToUse, fmt);
  }
  /**
  * Create a DateTime from an input string and format parser.
  *
  * The format parser must have been created with the same locale as this call.
  *
  * @param {String} text - the string to parse
  * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
  * @param {Object} opts - options taken by fromFormat()
  * @returns {DateTime}
  */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(`fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`);
    }
    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return _DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
  }
  // FORMAT PRESETS
  /**
  * {@link DateTime#toLocaleString} format like 10/14/1983
  * @type {Object}
  */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
  * @type {Object}
  */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
  * @type {Object}
  */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983'
  * @type {Object}
  */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
  * @type {Object}
  */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
  * @type {Object}
  */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
  * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
  * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
  * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
  * @type {Object}
  */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
};
__name(_DateTime, "DateTime");
var DateTime = _DateTime;
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
  }
}
__name(friendlyDateTime, "friendlyDateTime");

// src/activities/groupActivitiesByDate.ts
function groupActivitiesByDate(activityList) {
  const groupedActivities = {};
  for (const activity of activityList) {
    const date = DateTime.fromISO(activity.createdAt).toISODate() || "";
    if (!groupedActivities[date]) {
      groupedActivities[date] = [];
    }
    groupedActivities[date].push(activity);
  }
  const orderedActivities = {};
  Object.keys(groupedActivities).sort((a, b) => DateTime.fromISO(b).toMillis() - DateTime.fromISO(a).toMillis()).forEach((date) => {
    orderedActivities[date] = groupedActivities[date].sort((a, b) => DateTime.fromISO(b.createdAt).toMillis() - DateTime.fromISO(a.createdAt).toMillis());
  });
  return orderedActivities;
}
__name(groupActivitiesByDate, "groupActivitiesByDate");

// src/activities/activityGroups.ts
var activityTypeFilterGroups = [
  {
    id: "pageView",
    label: "Page view",
    types: [
      "VIEW"
    ],
    icon: "browsers-outline"
  },
  {
    id: "contentFileInteractions",
    label: "Content & file interactions",
    types: [
      "ATTACHMENT_LINK_COPIED",
      "ATTACHMENT_PREVIEW",
      "ATTACHMENT_DOWNLOAD",
      "ATTACHMENT_PREVIEW_FULLSCREEN",
      "INLINE_VIDEO_PLAY",
      "BLOCK_INTRO_VIDEO_PLAY",
      "DIRECT_LINK_TO_FILE_CLICKED",
      "PDF_CONTENT_VIEW",
      "TESTIMONIAL_VIEW",
      "INTERACTIVE_LIST_ITEM_OPENED",
      "MAP_MILESTONE_TASK_ATTACHMENT_UPLOADED",
      "MAP_MILESTONE_TASK_DOWNLOAD_FILE",
      "MAP_MILESTONE_TASK_DELETE_FILE",
      "LINK_CLICKED",
      "BLOCK_FILE_UPLOADED"
    ],
    icon: "document-text-outline"
  },
  {
    id: "actionPlanUpdates",
    label: "Action plan updates",
    types: [
      "MAP_MILESTONE_TASK_DETAILS_OPENED",
      "MAP_MILESTONE_TASK_COMPLETED",
      "MAP_MILESTONE_TASK_ADDED",
      "MAP_MILESTONE_TASK_CHANGED",
      "MAP_MILESTONE_TASK_DELETED",
      "MAP_MILESTONE_TASK_DESCRIPTION_ADDED",
      "MAP_MILESTONE_TASK_DESCRIPTION_CHANGED",
      "MAP_MILESTONE_TASK_ASSIGNEE_ADDED",
      "MAP_MILESTONE_TASK_ASSIGNEE_DELETED",
      "MAP_MILESTONE_TASK_ASSIGNEE_CHANGED",
      "MAP_MILESTONE_TASK_DUE_DATE_ADDED",
      "MAP_MILESTONE_TASK_DUE_DATE_DELETED",
      "MAP_MILESTONE_TASK_DUE_DATE_CHANGED",
      "MAP_MILESTONE_TASK_ATTACHMENT_UPLOADED",
      "MAP_MILESTONE_TASK_DOWNLOAD_FILE",
      "MAP_MILESTONE_TASK_DELETE_FILE",
      "MAP_MILESTONE_TASK_QUICK_ACTION_CLICK",
      "MAP_MILESTONE_ADDED",
      "MAP_MILESTONE_DELETED",
      "MAP_MILESTONE_COMPLETED",
      "COMMENT"
    ],
    icon: "checkmark-circle-outline"
  },
  {
    id: "commentsFeedback",
    label: "Comments & Feedback",
    types: [
      "COMMENT",
      "SPACE_COMMENT",
      "COLLABORATIVE_BLOCK_EDITED"
    ],
    icon: "chatbubble-ellipses-outline"
  },
  {
    id: "interactiveCalculator",
    label: "Interactive calculator",
    types: [
      "BUSINESS_CASE_RECALCULATED"
    ],
    icon: "calculator-outline"
  },
  {
    id: "buyerNotifications",
    label: "Buyer notifications",
    types: [
      "BUYER_NOTIFICATION_SENT_MILESTONE_DONE",
      "BUYER_NOTIFICATION_SENT_TASK_ASSIGNED",
      "BUYER_NOTIFICATION_SENT_COMMENT",
      "BUYER_NOTIFICATION_SENT_SPACE_COMMENT",
      "BUYER_NOTIFICATION_SENT_TASK_DUE_TODAY",
      "BUYER_NOTIFICATION_SENT_TASK_DUE_IN_X_DAYS",
      "BUYER_NOTIFICATION_SENT_TASK_DUE_X_DAYS_AGO"
    ],
    icon: "notifications-outline"
  },
  {
    id: "sharing",
    label: "Sharing",
    types: [
      "BLOCK_LINK_COPIED",
      "SPACE_LINK_COPIED",
      "TASK_LINK_COPIED"
    ],
    icon: "share-outline"
  },
  {
    id: "formNotifications",
    label: "Form notifications",
    types: [
      "FORM_QUESTION_ANSWERED",
      "FORM_COMPLETED",
      "FORM_QUESTION_EDITED"
    ],
    icon: "document-text-outline"
  }
];
var iconForActivityType = /* @__PURE__ */ __name((activityType) => {
  const group = activityTypeFilterGroups.find((group2) => group2.types.includes(activityType));
  return group ? group.icon : "";
}, "iconForActivityType");

// src/asset-library/asset-library.types.ts
import { z as z15 } from "zod";
import mime from "mime";

// src/internalLink.ts
function isInternalLink(value) {
  if (!value.startsWith("#page=")) return false;
  const pattern = /^#page=[a-zA-Z0-9]+&block=[a-zA-Z0-9]+(?:&task=[a-zA-Z0-9]+)?$/;
  return pattern.test(value);
}
__name(isInternalLink, "isInternalLink");

// src/asset-library/asset-library.types.ts
var assetLibraryEntryAssetTypes = [
  "FILE",
  "LINK",
  "EMBED",
  "EMBEDDABLE_LINK",
  "AI_EMBED"
];
var cloudflareStatuses = [
  "processing",
  "ready",
  "error"
];
var cloudflareStatusSchema = z15.enum(cloudflareStatuses);
var embeddableLinkTypes = [
  "youtube",
  "loom",
  "calendly",
  "hubspot",
  "zoom",
  "vimeo",
  "vidyard",
  "gong",
  "meet",
  "drive",
  "wistia",
  "microsoftStream"
];
var embedTypes = [
  ...embeddableLinkTypes,
  "html"
];
var fileDataSchema = z15.object({
  fileName: z15.string(),
  s3ObjectKey: z15.string().optional(),
  s3ObjectUrl: z15.string().optional(),
  preview_s3ObjectKey: z15.string().optional(),
  preview_s3ObjectUrl: z15.string().optional(),
  mimeType: z15.string().nullish().refine((val) => {
    if (!val) {
      return true;
    }
    return mime.getExtension(val) !== null;
  }, {
    message: "Invalid MIME type"
  }),
  thumbnail_s3ObjectKey: z15.string().optional(),
  thumbnail_s3ObjectUrl: z15.string().optional(),
  customThumbnail_s3ObjectKey: z15.string().optional(),
  customThumbnail_s3ObjectUrl: z15.string().optional(),
  video_cloudflareStatus: cloudflareStatusSchema.optional(),
  video_cloudflareHlsUrl: z15.string().nullish(),
  video_cloudflareDashUrl: z15.string().nullish(),
  video_cloudflareUid: z15.string().optional(),
  video_cloudflareThumbnailUrl: z15.string().nullish(),
  videoComment_cloudflareStatus: cloudflareStatusSchema.optional(),
  videoComment_cloudflareHlsUrl: z15.string().nullish(),
  videoComment_cloudflareDashUrl: z15.string().nullish(),
  videoComment_cloudflareUid: z15.string().optional(),
  videoComment_cloudflareThumbnailUrl: z15.string().nullish()
});
var createFileDataSchema = fileDataSchema.omit({
  s3ObjectUrl: true,
  preview_s3ObjectUrl: true,
  thumbnail_s3ObjectUrl: true,
  customThumbnail_s3ObjectUrl: true
});
var updateFileDataSchema = createFileDataSchema.partial();
var linkDataSchema = z15.object({
  linkName: z15.string().optional(),
  url: z15.string().refine((val) => {
    if (isInternalLink(val)) return true;
    try {
      new URL(val);
      return true;
    } catch (e2) {
      return false;
    }
  }, {
    message: "Must be either a valid URL or an internal link (#page=xyz&block=xyz format)"
  }),
  thumbnail_s3ObjectKey: z15.string().optional(),
  thumbnail_s3ObjectUrl: z15.string().optional(),
  customThumbnail_s3ObjectKey: z15.string().optional(),
  customThumbnail_s3ObjectUrl: z15.string().optional()
});
var createLinkDataSchema = linkDataSchema.omit({
  thumbnail_s3ObjectUrl: true,
  customThumbnail_s3ObjectUrl: true
});
var updateLinkDataSchema = createLinkDataSchema.partial();
var embedDataSchema = z15.object({
  embedType: z15.literal("html"),
  payload: z15.string(),
  embedName: z15.string().optional()
});
var createEmbedDataSchema = embedDataSchema;
var updateEmbedSchema = createEmbedDataSchema.partial();
var embeddableLinkDataSchema = z15.object({
  embedType: z15.enum(embeddableLinkTypes),
  name: z15.string().optional(),
  url: z15.string().url(),
  thumbnail_s3ObjectKey: z15.string().optional(),
  thumbnail_s3ObjectUrl: z15.string().optional(),
  customThumbnail_s3ObjectKey: z15.string().optional(),
  customThumbnail_s3ObjectUrl: z15.string().optional()
});
var createEmbeddableLinkDataSchema = embeddableLinkDataSchema.omit({
  thumbnail_s3ObjectUrl: true
});
var updateEmbeddableLinkSchema = createEmbeddableLinkDataSchema.partial();
var aiEmbedDataSchema = z15.object({
  payload: z15.string(),
  embedType: z15.literal("html"),
  embedName: z15.string().optional(),
  refinementSuggestions: z15.array(z15.string()).optional(),
  suggestionsCreatedAt: z15.number().optional()
});
var createAiEmbedDataSchema = aiEmbedDataSchema;
var updateAiEmbedSchema = createAiEmbedDataSchema.partial();
var baseAssetSchema = z15.object({
  id: z15.string(),
  createdAt: dateOrDateString,
  createdBy: z15.string()
});
var baseEditAssetSchema = baseAssetSchema.omit({
  id: true,
  createdAt: true,
  createdBy: true
});
var assetSchema = z15.union([
  baseAssetSchema.extend({
    type: z15.literal("FILE"),
    data: fileDataSchema
  }),
  baseAssetSchema.extend({
    type: z15.literal("LINK"),
    data: linkDataSchema
  }),
  baseAssetSchema.extend({
    type: z15.literal("EMBED"),
    data: embedDataSchema
  }),
  baseAssetSchema.extend({
    type: z15.literal("EMBEDDABLE_LINK"),
    data: embeddableLinkDataSchema
  }),
  baseAssetSchema.extend({
    type: z15.literal("AI_EMBED"),
    data: aiEmbedDataSchema
  })
]);
var updateAssetSchema = z15.union([
  baseEditAssetSchema.extend({
    type: z15.literal("FILE"),
    data: updateFileDataSchema
  }),
  baseEditAssetSchema.extend({
    type: z15.literal("LINK"),
    data: updateLinkDataSchema
  }),
  baseEditAssetSchema.extend({
    type: z15.literal("EMBED"),
    data: updateEmbedSchema
  }),
  baseEditAssetSchema.extend({
    type: z15.literal("EMBEDDABLE_LINK"),
    data: updateEmbeddableLinkSchema
  }),
  baseEditAssetSchema.extend({
    type: z15.literal("AI_EMBED"),
    data: updateAiEmbedSchema
  })
]);
var createAssetSchema = z15.union([
  baseEditAssetSchema.extend({
    type: z15.literal("FILE"),
    data: createFileDataSchema
  }),
  baseEditAssetSchema.extend({
    type: z15.literal("LINK"),
    data: createLinkDataSchema
  }),
  baseEditAssetSchema.extend({
    type: z15.literal("EMBED"),
    data: createEmbedDataSchema
  }),
  baseEditAssetSchema.extend({
    type: z15.literal("EMBEDDABLE_LINK"),
    data: createEmbeddableLinkDataSchema
  }),
  baseEditAssetSchema.extend({
    type: z15.literal("AI_EMBED"),
    data: createAiEmbedDataSchema
  })
]);
var assetLibraryEntrySchema = z15.object({
  id: z15.string(),
  asset: assetSchema,
  name: z15.string(),
  description: z15.string().nullish(),
  createdAt: dateOrDateString,
  createdById: z15.string(),
  createdBy: z15.object({
    id: z15.string(),
    firstName: z15.string(),
    lastName: z15.string(),
    photo_s3ObjectKey: z15.string().nullish(),
    photo_s3ObjectUrl: z15.string().nullish()
  }),
  updatedAt: dateOrDateString,
  folderId: z15.string().nullish()
});
var editAssetLibraryEntrySchema = assetLibraryEntrySchema.omit({
  id: true,
  createdAt: true,
  createdById: true,
  updatedAt: true,
  asset: true,
  createdBy: true
});
var createAssetLibraryEntrySchema = editAssetLibraryEntrySchema.extend({
  asset: createAssetSchema
});
var updateAssetLibraryEntrySchema = editAssetLibraryEntrySchema.extend({
  asset: updateAssetSchema
});
var assetLibraryQuerySchema = z15.object({
  page: z15.number(),
  itemsPerPage: z15.number(),
  search: z15.string().optional(),
  types: z15.array(z15.enum(assetLibraryEntryAssetTypes)).optional(),
  mimeTypes: z15.array(z15.string()).optional(),
  folderId: z15.string().nullish()
});
var assetLibraryEntryPaginatedListSchema = createPaginationSchema(assetLibraryEntrySchema, z15.undefined());
var assetLibraryFolderSchema = z15.object({
  id: z15.string(),
  name: z15.string(),
  createdAt: dateOrDateString,
  createdById: z15.string(),
  parentFolderId: z15.string().nullish()
});
var createAssetLibraryFolderSchema = assetLibraryFolderSchema.pick({
  name: true,
  parentFolderId: true
});
var updateAssetLibraryFolderSchema = z15.object({
  name: z15.string().optional(),
  parentFolderId: z15.string().nullish()
});
var assetLibraryFolderListSchema = z15.array(assetLibraryFolderSchema);
var assetLibraryFolderQuerySchema = z15.object({
  parentFolderId: z15.string().nullish()
});

// src/asset/asset.types.ts
import { z as z16 } from "zod";
var assetSchema2 = z16.union([
  z16.object({
    type: z16.literal("FILE"),
    data: fileDataSchema
  }),
  z16.object({
    type: z16.literal("LINK"),
    data: linkDataSchema
  }),
  z16.object({
    type: z16.literal("EMBED"),
    data: embedDataSchema.omit({
      embedType: true
    }).extend({
      embedType: z16.enum(embedTypes)
    })
  }),
  z16.object({
    type: z16.literal("EMBEDDABLE_LINK"),
    data: embeddableLinkDataSchema
  }),
  z16.object({
    type: z16.literal("AI_EMBED"),
    data: aiEmbedDataSchema
  })
]);

// src/auth/ValuecaseAuth.ts
var _ValuecaseAuth = class _ValuecaseAuth {
  constructor(options) {
    __publicField(this, "options");
    __publicField(this, "sellerApiBasePath");
    __publicField(this, "authChangeListeners");
    __publicField(this, "refreshTimeout");
    __publicField(this, "refreshTimeBeforeExpiry");
    __publicField(this, "isRefreshing");
    __publicField(this, "refreshPromise");
    __publicField(this, "maxRetries");
    __publicField(this, "sentAuthToOpener");
    var _a6;
    this.options = options;
    this.authChangeListeners = /* @__PURE__ */ new Set();
    this.refreshTimeout = null;
    this.refreshTimeBeforeExpiry = 6e4;
    this.isRefreshing = false;
    this.refreshPromise = null;
    this.maxRetries = 3;
    this.sentAuthToOpener = false;
    const { sellerApiBasePath = "dashboard/api" } = (_a6 = this.options) != null ? _a6 : {};
    this.sellerApiBasePath = "/" + sellerApiBasePath.replace(/^\/+/, "").replace(/\/+$/, "");
    this.sendAuthUpdateToOpener();
    this.loadIframeAuth();
    this.initializeTokenRefresh();
    document.addEventListener("visibilitychange", this.handleVisibilityChange.bind(this));
    window.addEventListener("storage", (event) => {
      if (event.key === "valuecase-v2-auth-sub") {
        if (!event.newValue) {
          this.log("Other tab logged out - logging out too");
          this.logout();
        } else if (!event.oldValue && !!event.newValue) {
          this.log("Other tab logged in - refreshing");
          window.location.reload();
        }
      }
    });
  }
  // #################################
  //          Public methods
  // #################################
  getLoginUrl(customReturnToPath = window.location.pathname) {
    const url = new URL(window.location.href);
    url.pathname = this.assemblePath("auth/login");
    url.searchParams.set("returnToPath", customReturnToPath);
    return url.href;
  }
  getLogoutUrl(customReturnToPath = window.location.pathname) {
    const url = new URL(window.location.href);
    url.pathname = this.assemblePath("auth/logout");
    url.searchParams.set("returnToPath", customReturnToPath);
    return url.href;
  }
  login(customReturnToPath) {
    window.location.href = this.getLoginUrl(customReturnToPath);
  }
  logout(customReturnToPath) {
    window.location.href = this.getLogoutUrl(customReturnToPath);
  }
  listenForAuthChanges(listener) {
    this.authChangeListeners.add(listener);
    return () => {
      this.authChangeListeners.delete(listener);
    };
  }
  async getAccessToken() {
    const accessTokenExpiry = this.getAccessTokenExpiryTimestamp();
    if (accessTokenExpiry && accessTokenExpiry < Date.now() + this.refreshTimeBeforeExpiry) {
      if (this.isRefreshing && this.refreshPromise) {
        await this.refreshPromise;
      } else {
        await this.refreshToken();
      }
    }
    return sessionStorage.getItem("valuecase-v2-auth-accessToken");
  }
  getAuthState({ isCrossTenant } = {}) {
    try {
      return this.getAccessToken().then((accessToken) => {
        var _a6;
        const headers = {};
        if (accessToken) {
          headers["Authorization"] = "Bearer " + accessToken;
        } else if (((_a6 = this.options) == null ? void 0 : _a6.app) === "spaces" && this.isLoggedIntoSellerApp({
          isCrossTenant
        })) {
          this.login(window.location.pathname + window.location.search + window.location.hash);
          return Promise.resolve({
            authorized: false
          });
        }
        return window.fetch(this.assemblePath("auth/status"), {
          method: "GET",
          headers
        }).then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        }).then((json) => {
          var _a7;
          if ((json == null ? void 0 : json.success) && ((_a7 = json.payload) == null ? void 0 : _a7.authorized) === true) {
            return __spreadProps(__spreadValues({}, json.payload), {
              accessToken
            });
          }
          return {
            authorized: false
          };
        }).catch((error) => {
          console.error("Fetching auth status failed: " + error.message);
          return Promise.resolve({
            authorized: false
          });
        });
      }).catch((error) => {
        console.error("getAccessToken failed: " + error.message);
        return Promise.resolve({
          authorized: false
        });
      });
    } catch (e2) {
      console.error("getAuthState() failed: " + e2.message);
      console.error("Returning authorized = false.");
      return Promise.resolve({
        authorized: false
      });
    }
  }
  // #################################
  //          Internal methods
  // #################################
  assemblePath(subPath) {
    const normalizedSubPath = (subPath != null ? subPath : "").replace(/^\/+/, "").replace(/\/+$/, "");
    let path = this.sellerApiBasePath;
    if (!path.endsWith("/") && normalizedSubPath.length > 0) {
      path += "/" + normalizedSubPath;
    } else if (normalizedSubPath.length > 0) {
      path += normalizedSubPath;
    }
    return path;
  }
  isLoggedIntoSellerApp({ isCrossTenant } = {}) {
    if (isCrossTenant) {
      return false;
    }
    return !!window.localStorage.getItem("valuecase-v2-auth-sub");
  }
  getAccessTokenExpiryTimestamp() {
    const expiryDate = sessionStorage.getItem("valuecase-v2-auth-accessTokenExpiresAt");
    return expiryDate ? new Date(expiryDate).getTime() : null;
  }
  initializeTokenRefresh() {
    const accessTokenExpiry = this.getAccessTokenExpiryTimestamp();
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
    if (accessTokenExpiry) {
      const timeToExpiry = accessTokenExpiry - Date.now() - this.refreshTimeBeforeExpiry;
      if (timeToExpiry > 0) {
        this.log(`Token refresh in ${timeToExpiry}ms`);
        this.refreshTimeout = setTimeout(this.refreshToken.bind(this), timeToExpiry);
      } else {
        this.log("Token expired, refreshing now");
        this.refreshToken();
      }
    }
  }
  async refreshToken(retryCount = 0) {
    var _a6;
    if (this.isRefreshing) return (_a6 = this.refreshPromise) != null ? _a6 : Promise.resolve();
    this.isRefreshing = true;
    const refreshToken = sessionStorage.getItem("valuecase-v2-auth-refreshToken");
    if (!refreshToken) {
      this.logout();
      return Promise.resolve();
    }
    this.refreshPromise = (async () => {
      try {
        const response = await fetch(this.assemblePath(`auth/refresh/accessToken?refreshToken=${encodeURIComponent(refreshToken)}`));
        const json = await response.json();
        if (!response.ok || !json.success) {
          this.handleUnsuccessfulRefresh(json);
          return;
        }
        this.storeCredentials(json.payload);
        this.initializeTokenRefresh();
      } catch (error) {
        console.error("Error refreshing token:", error);
        if (retryCount < this.maxRetries) {
          console.log(`Retrying refresh token... Attempt ${retryCount + 1}`);
          setTimeout(() => this.refreshToken(retryCount + 1), 1e3);
        } else {
          this.logout();
        }
      } finally {
        this.isRefreshing = false;
        this.refreshPromise = null;
      }
    })();
    return this.refreshPromise;
  }
  handleUnsuccessfulRefresh(response) {
    if (response.type === "auth-refresh-token-invalid" || response.type === "auth-refresh-token-expired") {
      this.wipeCredentials();
    } else {
      console.error("Unknown token refresh error:", response);
      throw new Error("Failed to refresh token");
    }
  }
  handleVisibilityChange() {
    if (document.visibilityState === "visible") {
      this.initializeTokenRefresh();
    }
  }
  storeCredentials(data) {
    window.sessionStorage.setItem("valuecase-v2-auth-accessToken", data.accessToken);
    window.sessionStorage.setItem("valuecase-v2-auth-accessTokenExpiresAt", data.accessTokenExpiresAt);
    window.sessionStorage.setItem("valuecase-v2-auth-refreshToken", data.refreshToken);
    window.sessionStorage.setItem("valuecase-v2-auth-refreshTokenExpiresAt", data.refreshTokenExpiresAt);
    this.informAuthChangeListeners();
  }
  wipeCredentials() {
    window.localStorage.removeItem("valuecase-v2-auth-sub");
    window.localStorage.removeItem("valuecase-iframe-auth");
    window.sessionStorage.removeItem("valuecase-v2-auth-accessToken");
    window.sessionStorage.removeItem("valuecase-v2-auth-accessTokenExpiresAt");
    window.sessionStorage.removeItem("valuecase-v2-auth-refreshToken");
    window.sessionStorage.removeItem("valuecase-v2-auth-refreshTokenExpiresAt");
    this.informAuthChangeListeners();
  }
  informAuthChangeListeners() {
    for (const listener of this.authChangeListeners) {
      listener();
    }
  }
  log(message, ...args) {
    console.debug(`${(/* @__PURE__ */ new Date()).toISOString()} Valuecase v2 Auth: ${message}`, ...args);
  }
  loadIframeAuth() {
    const isInIframe = window !== window.parent;
    const iframeAuth = localStorage.getItem("valuecase-iframe-auth");
    const hasCrrentToken = !!sessionStorage.getItem("valuecase-v2-auth-accessToken");
    if (!hasCrrentToken && isInIframe && iframeAuth) {
      const auth = JSON.parse(iframeAuth);
      for (const key in auth) {
        if (key === "valuecase-v2-auth-sub") {
          window.localStorage.setItem(key, auth[key]);
        } else {
          window.sessionStorage.setItem(key, auth[key]);
        }
      }
      return;
    }
  }
  sendAuthUpdateToOpener() {
    if (!window.opener) {
      return;
    }
    if (!window.location.search.includes("iframeAuth=true")) {
      return;
    }
    if (this.sentAuthToOpener) {
      return;
    }
    const accessToken = sessionStorage.getItem("valuecase-v2-auth-accessToken");
    if (!accessToken) {
      return;
    }
    this.sentAuthToOpener = true;
    window.opener.postMessage({
      type: "gotValidAccessToken",
      payload: {
        "valuecase-used-dashboard-app": "v2",
        "valuecase-v2-auth-accessToken": sessionStorage.getItem("valuecase-v2-auth-accessToken"),
        "valuecase-v2-auth-accessTokenExpiresAt": sessionStorage.getItem("valuecase-v2-auth-accessTokenExpiresAt"),
        "valuecase-v2-auth-refreshToken": sessionStorage.getItem("valuecase-v2-auth-refreshToken"),
        "valuecase-v2-auth-refreshTokenExpiresAt": sessionStorage.getItem("valuecase-v2-auth-refreshTokenExpiresAt"),
        "valuecase-v2-auth-sub": window.localStorage.getItem("valuecase-v2-auth-sub")
      }
    }, window.location.origin);
    window.close();
  }
};
__name(_ValuecaseAuth, "ValuecaseAuth");
var ValuecaseAuth = _ValuecaseAuth;

// src/auth/utils.ts
function getCleanSub(sub) {
  return sub.replace("auth0|", "").replace("bubble|", "");
}
__name(getCleanSub, "getCleanSub");

// src/rules-engine.ts
var RULE_OPERATORS = {
  EQUALS: "eq",
  NOT_EQUALS: "neq",
  GREATER_THAN: "gt",
  LESS_THAN: "lt",
  CONTAINS: "contains",
  CONTAINS_AT_LEAST_ONE_OF: "contains_at_least_one_of",
  CONTAINS_ALL_OF: "contains_all_of",
  EQUALS_ONLY_ONE_OF: "equals_only_one_of",
  EQUALS_ALL_OF: "equals_all_of"
};
var RULE_SINGLE_VALUE_OPERATORS = [
  RULE_OPERATORS.EQUALS,
  RULE_OPERATORS.NOT_EQUALS,
  RULE_OPERATORS.GREATER_THAN,
  RULE_OPERATORS.LESS_THAN,
  RULE_OPERATORS.CONTAINS
];
var RULE_MULTI_VALUE_OPERATORS = [
  RULE_OPERATORS.CONTAINS_AT_LEAST_ONE_OF,
  RULE_OPERATORS.CONTAINS_ALL_OF,
  RULE_OPERATORS.EQUALS_ONLY_ONE_OF,
  RULE_OPERATORS.EQUALS_ALL_OF
];
function ruleOperatorToText(operator) {
  switch (operator) {
    case RULE_OPERATORS.EQUALS:
      return "is";
    case RULE_OPERATORS.NOT_EQUALS:
      return "is not";
    case RULE_OPERATORS.GREATER_THAN:
      return "is greater than";
    case RULE_OPERATORS.LESS_THAN:
      return "is less than";
    case RULE_OPERATORS.CONTAINS:
      return "contains";
    case RULE_OPERATORS.CONTAINS_ALL_OF:
      return "contains all of";
    case RULE_OPERATORS.CONTAINS_AT_LEAST_ONE_OF:
      return "contains at least one of";
    case RULE_OPERATORS.EQUALS_ALL_OF:
      return "is equal to all of";
    case RULE_OPERATORS.EQUALS_ONLY_ONE_OF:
      return "is equal to only one of";
    default:
      return operator;
  }
}
__name(ruleOperatorToText, "ruleOperatorToText");

// src/automation/node-visibility.ts
var VISIBILITY_OPERATORS = {
  EQUALS: RULE_OPERATORS.EQUALS,
  NOT_EQUALS: RULE_OPERATORS.NOT_EQUALS,
  CONTAINS_AT_LEAST_ONE_OF: RULE_OPERATORS.CONTAINS_AT_LEAST_ONE_OF,
  CONTAINS_ALL_OF: RULE_OPERATORS.CONTAINS_ALL_OF,
  EQUALS_ONLY_ONE_OF: RULE_OPERATORS.EQUALS_ONLY_ONE_OF,
  EQUALS_ALL_OF: RULE_OPERATORS.EQUALS_ALL_OF
};
var VISIBILITY_SINGLE_VALUE_OPERATORS = [
  VISIBILITY_OPERATORS.EQUALS,
  VISIBILITY_OPERATORS.NOT_EQUALS
];
var VISIBILITY_MULTI_VALUE_OPERATORS = [
  VISIBILITY_OPERATORS.CONTAINS_AT_LEAST_ONE_OF,
  VISIBILITY_OPERATORS.CONTAINS_ALL_OF,
  VISIBILITY_OPERATORS.EQUALS_ONLY_ONE_OF,
  VISIBILITY_OPERATORS.EQUALS_ALL_OF
];
function isObject(value) {
  return typeof value === "object" && value !== null;
}
__name(isObject, "isObject");
function isNodeVisibilityRule(value) {
  if (!isObject(value)) {
    return false;
  }
  if (typeof value.valueLocator !== "string") {
    return false;
  }
  if (typeof value.type !== "string") {
    return false;
  }
  if (value.type === ValueCardinality.SingleValue) {
    if (typeof value.operator !== "string" || !VISIBILITY_SINGLE_VALUE_OPERATORS.includes(value.operator)) {
      return false;
    }
    const compVal = value.comparisonValue;
    if (!(typeof compVal === "boolean" || typeof compVal === "string" || compVal instanceof Date || compVal === null || compVal === void 0)) {
      return false;
    }
    return true;
  } else if (value.type === ValueCardinality.MultiValue) {
    if (typeof value.operator !== "string" || !VISIBILITY_MULTI_VALUE_OPERATORS.includes(value.operator)) {
      return false;
    }
    if (!Array.isArray(value.comparisonValue)) {
      return false;
    }
    for (const item of value.comparisonValue) {
      if (typeof item !== "string") {
        return false;
      }
    }
    return true;
  } else {
    return false;
  }
}
__name(isNodeVisibilityRule, "isNodeVisibilityRule");

// src/automation/built-in-properties.ts
var contentAutomationBuiltInProperties = [
  "spaceOwnerId"
];

// src/automation/supported-blocks.ts
var blocksSupportingContentAutomation = [
  "BLOCK_COLLABORATIVE",
  "BLOCK_CONTENT",
  "BLOCK_FILES",
  "BLOCK_FORM",
  "BLOCK_FORM_QUESTION_FILE_UPLOAD",
  "BLOCK_FORM_QUESTION_LONG_TEXT",
  "BLOCK_FORM_QUESTION_MULTI_SELECT",
  "BLOCK_FORM_QUESTION_SHORT_TEXT",
  "BLOCK_FORM_QUESTION_SINGLE_SELECT",
  "BLOCK_GANTT",
  "BLOCK_INTERACTIVE_CALCULATOR",
  "BLOCK_INTERACTIVE_LIST_ITEM",
  "BLOCK_INTERACTIVE_LIST",
  "BLOCK_MAP_MILESTONE_TASK",
  "BLOCK_MAP_MILESTONE",
  "BLOCK_MAP",
  "BLOCK_MILESTONES_PROGRESS",
  "BLOCK_TABLE",
  "BLOCK_TESTIMONIALS_TESTIMONIAL",
  "BLOCK_TESTIMONIALS",
  "BLOCK_TITLE",
  "EMBED",
  "EMBEDDABLE_LINK",
  "FILE",
  "LINK",
  "PAGE"
];

// src/block-generator/editor-block-generator.ts
import { z as z17 } from "zod";
var EditorBlockGeneratorDtoSchema = z17.object({
  prompt: z17.string(),
  rootNodeId: z17.string()
});
var BlockGenerationRequestSchema = z17.object({
  id: z17.string(),
  createdAt: z17.string(),
  updatedAt: z17.string(),
  tenantId: z17.string(),
  sellerId: z17.string(),
  userInput: EditorBlockGeneratorDtoSchema,
  createdBlockIds: z17.array(z17.string()),
  blockCreatorResponse: z17.record(z17.string(), z17.string()).nullish(),
  error: z17.string().nullish(),
  rootNodeId: z17.string()
});

// src/comment/comment.ts
import { z as z18 } from "zod";
var CommentSchema = z18.object({
  id: z18.string(),
  message: z18.string(),
  firstName: z18.string().nullable().optional(),
  lastName: z18.string().nullable().optional(),
  email: z18.string().optional(),
  isAnonymous: z18.boolean().optional(),
  createdAt: z18.string(),
  read: z18.boolean().optional(),
  page: z18.any().optional(),
  node: z18.any().optional(),
  block: z18.any().optional(),
  nodeId: z18.string().optional(),
  rootNodeId: z18.string().optional(),
  pageId: z18.string().optional(),
  blockId: z18.string().optional(),
  updatedAt: z18.string().optional(),
  deletedAt: z18.string().nullable().optional(),
  whitelistedUserId: z18.string().optional(),
  sellerId: z18.string().nullable().optional()
});

// src/company-metadata/brand-fetch.ts
import { z as z19 } from "zod";
var CompanyInfoSchema = z19.object({
  name: z19.string().nullable(),
  employeeCount: z19.number().nullable(),
  industries: z19.array(z19.string()),
  location: z19.string().nullable(),
  description: z19.string().nullable(),
  images: z19.array(z19.object({
    type: z19.string(),
    src: z19.string().nullable()
  })),
  links: z19.array(z19.object({
    name: z19.string(),
    url: z19.string()
  })),
  logos: z19.array(z19.object({
    format: z19.string(),
    src: z19.string().nullable()
  })),
  accentColor: z19.object({
    hex: z19.string(),
    brightness: z19.number()
  }).nullable()
});

// src/crm-integrations/hubspot.ts
import { z as z20 } from "zod";
var HubSpotCRMSpaceCardSchema = z20.object({
  spaceId: z20.string(),
  createdAt: z20.coerce.date(),
  link: z20.string(),
  visitsCount: z20.number(),
  activitiesCount: z20.number(),
  companyName: z20.string().nullable(),
  lastVisit: z20.coerce.date().nullable()
});
var HubSpotCRMSpaceCardListSchema = z20.object({
  items: z20.array(HubSpotCRMSpaceCardSchema)
});
var parseHubSpotCRMSpaceCard = /* @__PURE__ */ __name((data) => {
  return HubSpotCRMSpaceCardSchema.parse(data);
}, "parseHubSpotCRMSpaceCard");
var parseHubSpotCRMSpaceCardList = /* @__PURE__ */ __name((data) => {
  return HubSpotCRMSpaceCardListSchema.parse(data);
}, "parseHubSpotCRMSpaceCardList");

// src/crm-integrations/integration-settings.types.ts
import { z as z21 } from "zod";
var integrationCustomPropertyMappingSchema = z21.object({
  id: z21.string().max(36),
  integrationSettingsId: z21.string().max(36),
  localPropertySource: z21.literal("SpaceCustomProperty"),
  localPropertyName: z21.string(),
  thirdPartyPropertyLabel: z21.string(),
  thirdPartyPropertyName: z21.string(),
  createdAt: z21.date(),
  updatedAt: z21.date(),
  createdById: z21.string().nullable(),
  updatedById: z21.string().nullable()
});
var integrationCustomPropertyMappingListSchema = z21.array(integrationCustomPropertyMappingSchema);
var createIntegrationCustomPropertyMappingDtoSchema = integrationCustomPropertyMappingSchema.pick({
  localPropertySource: true,
  localPropertyName: true,
  thirdPartyPropertyLabel: true,
  thirdPartyPropertyName: true
});
var entitySettingsBaseSchema = z21.object({
  entityName: z21.string(),
  customPropertiesEnabled: z21.boolean(),
  customActivitiesEnabled: z21.boolean(),
  label: z21.string().nullable(),
  labelPlural: z21.string().nullable()
});
var syncedThirdPartyEntitySettingsPublicSchema = entitySettingsBaseSchema;
var syncedThirdPartyEntitySettingsPublicListSchema = z21.array(syncedThirdPartyEntitySettingsPublicSchema);
var salesforceMetaSchema = z21.object({
  profilesWithAccess: z21.array(z21.string()).nullish()
});
var hubSpotMetaSchema = z21.object({});
var baseIntegrationSettingsSchema = z21.object({
  setupUserOAuth2Id: z21.string().nullable(),
  syncUserOAuth2Id: z21.string().nullable(),
  entitySettings: syncedThirdPartyEntitySettingsPublicListSchema,
  customPropertyMappings: z21.array(createIntegrationCustomPropertyMappingDtoSchema)
});
var hubSpotIntegrationSettingsSchema = baseIntegrationSettingsSchema.extend({
  thirdParty: z21.literal("HubSpot"),
  meta: hubSpotMetaSchema
});
var propertyKeyToSalesforceFieldName = /* @__PURE__ */ __name((key) => {
  const sanitized = key.replace(/[^a-zA-Z0-9_]/g, "").replace(/__+/g, "_");
  const prefixed = /^[A-Za-z]/.test(sanitized) ? sanitized : `F${sanitized}`;
  const capitalized = prefixed.charAt(0).toUpperCase() + prefixed.slice(1);
  const maxLength = 37 - "Valuecase".length;
  const truncated = capitalized.length > maxLength ? capitalized.slice(0, maxLength) : capitalized;
  return `{{entityType}}.Valuecase${truncated}__c`;
}, "propertyKeyToSalesforceFieldName");
var prefix = "{{entityType}}.Valuecase";
var suffix = "__c";
var createSalesforceIntegrationCustomPropertyMappingDtoSchema = createIntegrationCustomPropertyMappingDtoSchema.superRefine((data, ctx) => {
  const { thirdPartyPropertyName } = data;
  if (thirdPartyPropertyName.length > 55) {
    ctx.addIssue({
      code: z21.ZodIssueCode.custom,
      path: [
        "thirdPartyPropertyName"
      ],
      message: `Third-party property name must not exceed 55 characters.`
    });
  }
  if (!thirdPartyPropertyName.startsWith(prefix)) {
    ctx.addIssue({
      code: z21.ZodIssueCode.custom,
      path: [
        "thirdPartyPropertyName"
      ],
      message: `Third-party property name must start with '${prefix}'.`
    });
  }
  if (!thirdPartyPropertyName.endsWith(suffix)) {
    ctx.addIssue({
      code: z21.ZodIssueCode.custom,
      path: [
        "thirdPartyPropertyName"
      ],
      message: `Third-party property name must end with '${suffix}'.`
    });
  }
  const namePart = thirdPartyPropertyName.slice(prefix.length, -suffix.length);
  if (namePart.includes("__")) {
    ctx.addIssue({
      code: z21.ZodIssueCode.custom,
      path: [
        "thirdPartyPropertyName"
      ],
      message: `Third-party property name must not contain double underscores outside of suffix.`
    });
  }
  const invalidChars = /[^a-zA-Z0-9_]/;
  if (invalidChars.test(namePart)) {
    ctx.addIssue({
      code: z21.ZodIssueCode.custom,
      path: [
        "thirdPartyPropertyName"
      ],
      message: `Third-party property name must contain only alphanumeric characters and underscores.`
    });
  }
});
var salesforceIntegrationSettingsSchema = baseIntegrationSettingsSchema.extend({
  thirdParty: z21.literal("Salesforce"),
  meta: salesforceMetaSchema,
  customPropertyMappings: z21.array(createSalesforceIntegrationCustomPropertyMappingDtoSchema)
});
var integrationSettingsUpsertDtoSchema = z21.discriminatedUnion("thirdParty", [
  salesforceIntegrationSettingsSchema,
  hubSpotIntegrationSettingsSchema
]);
var integrationSettingsEntityBaseSchema = z21.object({
  id: z21.string(),
  tenantId: z21.string(),
  thirdPartyOrganizationId: z21.string().nullable().optional(),
  // TODO:SalesforceSetup: Remove this field once all tenants migrated to new settings
  isActivitySyncSetUp: z21.boolean().default(false),
  createdAt: z21.date().optional(),
  updatedAt: z21.date().optional(),
  createdById: z21.string().nullable().optional(),
  updatedById: z21.string().nullable().optional(),
  setupUserTokenId: z21.string().nullable().optional(),
  syncUserTokenId: z21.string().nullable().optional(),
  syncUserToken: z21.object({
    userId: z21.string().nullable()
  }).nullable().optional(),
  entitySettings: z21.array(entitySettingsBaseSchema.extend({
    id: z21.string(),
    customPropertiesAreSetUp: z21.boolean().default(false),
    customPropertiesLastSetUpAt: z21.date().nullable(),
    customPropertiesSetupError: z21.string().nullable(),
    customActivitiesAreSetUp: z21.boolean().default(false),
    customActivitiesLastSetUpAt: z21.date().nullable(),
    customActivitiesSetupError: z21.string().nullable(),
    createdAt: z21.date(),
    updatedAt: z21.date(),
    createdById: z21.string(),
    updatedById: z21.string()
  })),
  customPropertyMappings: integrationCustomPropertyMappingListSchema
});
var salesforceIntegrationSettingsEntitySchema = integrationSettingsEntityBaseSchema.extend({
  provider: z21.literal("Salesforce"),
  meta: salesforceMetaSchema.optional().default({
    profilesWithAccess: []
  })
});
var hubSpotIntegrationSettingsEntitySchema = integrationSettingsEntityBaseSchema.extend({
  provider: z21.literal("HubSpot"),
  meta: hubSpotMetaSchema.optional().default({})
});
var integrationSettingsEntitySchema = z21.discriminatedUnion("provider", [
  salesforceIntegrationSettingsEntitySchema,
  hubSpotIntegrationSettingsEntitySchema
]);
function parseIntegrationSettings(provider, data) {
  const result = integrationSettingsEntitySchema.parse(data);
  if (result.provider !== provider) {
    throw new Error(`Provider mismatch: expected ${provider}, but got ${result.provider}`);
  }
  return result;
}
__name(parseIntegrationSettings, "parseIntegrationSettings");
var salesforceObjectType = z21.object({
  name: z21.string(),
  label: z21.string(),
  labelPlural: z21.string()
});
var salesforceObjectTypes = z21.array(salesforceObjectType);

// src/crm-integrations/salesforce.ts
import { z as z22 } from "zod";
var targetSalesforceApiVersion = "v42.0";
var salesforceCoreObjectSchema = z22.object({
  Id: z22.string(),
  Name: z22.string().nullish(),
  CreatedDate: z22.coerce.date()
});
var salesforceOpportunitySchema = salesforceCoreObjectSchema.extend({
  Account: z22.object({
    Name: z22.string().nullish()
  }).nullish(),
  Owner: z22.object({
    Name: z22.string().nullish()
  }).nullish()
});
var salesforceCaseSchema = salesforceCoreObjectSchema.omit({
  Name: true
}).extend({
  Subject: z22.string().nullish(),
  Account: z22.object({
    Name: z22.string().nullish()
  }).nullish(),
  Contact: z22.object({
    Name: z22.string().nullish()
  }).nullish()
});
var salesforceAccountSchema = salesforceCoreObjectSchema.extend({
  Owner: z22.object({
    Name: z22.string().nullish()
  }).nullish()
});
var salesforceContactSchema = salesforceCoreObjectSchema.extend({
  Email: z22.string().nullish(),
  Account: z22.object({
    Name: z22.string().nullish()
  }).nullish()
});
var salesforceOpportunityListSchema = z22.array(salesforceOpportunitySchema);
var salesforceCaseListSchema = z22.array(salesforceCaseSchema);
var salesforceAccountListSchema = z22.array(salesforceAccountSchema);
var salesforceContactListSchema = z22.array(salesforceContactSchema);
var salesforceObjectListSchema = z22.array(salesforceCoreObjectSchema);
var defaultSalesforceEntityTypes = [
  "Opportunity",
  "Case",
  "Account",
  "Contact"
];
var defaultSalesforceProfiles = [
  "profiles/Standard.profile",
  "profiles/Admin.profile"
];

// src/crm-integrations/spaces.ts
import { z as z24 } from "zod";

// src/spaces/engagement.ts
import { z as z23 } from "zod";
var engagementScoreHighThreshold = 0.6666;
var engagementScoreMediumThreshold = 0.3333;
var engagementScoreLevelSchema = z23.union([
  z23.literal("N/A"),
  z23.literal("Low"),
  z23.literal("Medium"),
  z23.literal("High")
]).optional();
var mapScoreDescriptorToLabel = /* @__PURE__ */ __name((score) => {
  switch (score) {
    case "high":
      return "High";
    case "medium":
      return "Medium";
    case "low":
      return "Low";
    case "n/a":
    default:
      return "N/A";
  }
}, "mapScoreDescriptorToLabel");
var mapScoreToDescriptor = /* @__PURE__ */ __name((score, activityCountInLast14Days) => {
  if (score >= engagementScoreHighThreshold) {
    return "high";
  } else if (score >= engagementScoreMediumThreshold) {
    return "medium";
  } else if (activityCountInLast14Days === 0) {
    return "n/a";
  } else {
    return "low";
  }
}, "mapScoreToDescriptor");

// src/crm-integrations/spaces.ts
var spaceIntegrationSupportedThirdParties = [
  "HubSpot",
  "Salesforce"
];
var spaceIntegrationThirdPartyOptions = [
  ...spaceIntegrationSupportedThirdParties,
  "Custom"
];
var spaceIntegrationSupportedThirdPartiesSchema = z24.enum(spaceIntegrationSupportedThirdParties);
var spaceIntegrationIdMappingSchema = z24.object({
  id: z24.string(),
  thirdParty: z24.enum(spaceIntegrationThirdPartyOptions),
  thirdPartyEntityType: z24.string(),
  thirdPartyId: z24.string(),
  thirdPartyOrganizationId: z24.string().nullable().optional(),
  spaceId: z24.string(),
  customThirdPartyName: z24.string().nullable().optional(),
  createdById: z24.string().nullish(),
  createdAt: z24.coerce.date(),
  updatedAt: z24.coerce.date()
});
var spaceIntegrationIdMappingListSchema = z24.array(spaceIntegrationIdMappingSchema);
var actionPlanKeyDetailsSchema = z24.object({
  currentOpenTask: z24.string().nullable(),
  currentOpenTaskIsScheduled: z24.boolean().nullable(),
  nextDueDate: z24.coerce.date().nullable(),
  currentMilestone: z24.string().nullable(),
  mostRecentlyCompletedMilestone: z24.string().nullable(),
  mostRecentlyCompletedTask: z24.string().nullable(),
  mostRecentlyCompletedTaskDate: z24.coerce.date().nullable()
});
var IntegrationSpacesSearchResultSchema = z24.object(__spreadValues({
  spaceId: z24.string(),
  companyName: z24.string(),
  createdAt: z24.coerce.date(),
  link: z24.string().optional(),
  lastVisit: z24.coerce.date().nullable().optional(),
  visitsCount: z24.number(),
  activitiesCount: z24.number(),
  actionPlanStatus: z24.string(),
  actionPlanProgress: z24.number(),
  templateTitle: z24.string().nullable().optional(),
  ownerId: z24.string(),
  engagementScoreLevel: engagementScoreLevelSchema,
  integrationIdMappings: spaceIntegrationIdMappingListSchema,
  customProperties: z24.array(z24.object({
    id: z24.string(),
    name: z24.string(),
    value: z24.string().nullable()
  })).nullish()
}, actionPlanKeyDetailsSchema.shape));
var integrationSpacesSearchResultsSchema = z24.object({
  items: z24.array(IntegrationSpacesSearchResultSchema)
});

// src/date-utils.ts
function formatDateShort(date, locale = "en-GB") {
  return date.toLocaleString(DateTime.DATE_MED, {
    locale
  });
}
__name(formatDateShort, "formatDateShort");
function formatDateLong(date, locale = "en-GB") {
  return date.toLocaleString(DateTime.DATE_FULL, {
    locale
  });
}
__name(formatDateLong, "formatDateLong");
function formatDateTimeShort(date, locale = "en-GB") {
  return date.toLocaleString(DateTime.DATETIME_MED, {
    locale
  });
}
__name(formatDateTimeShort, "formatDateTimeShort");
function formatTime(date, locale = "en-GB") {
  return date.toLocaleString(DateTime.TIME_SIMPLE, {
    locale
  });
}
__name(formatTime, "formatTime");
function isToday(date) {
  return date.hasSame(DateTime.local(), "day");
}
__name(isToday, "isToday");
function isYesterday(date) {
  return date.hasSame(DateTime.local().minus({
    days: 1
  }), "day");
}
__name(isYesterday, "isYesterday");
function isTomorrow(date) {
  return date.hasSame(DateTime.local().plus({
    days: 1
  }), "day");
}
__name(isTomorrow, "isTomorrow");
function millisecondsUntilEndOfMonth() {
  return DateTime.local().plus({
    months: 1
  }).startOf("month").diffNow().as("milliseconds");
}
__name(millisecondsUntilEndOfMonth, "millisecondsUntilEndOfMonth");
function formatDateWithRelativeWords(date, dateFormatting = "short", locale = "en-GB") {
  if (isToday(date)) {
    return date.toRelativeCalendar({
      unit: "days",
      locale
    });
  }
  if (isYesterday(date)) {
    return date.toRelativeCalendar({
      unit: "days",
      locale
    });
  }
  if (isTomorrow(date)) {
    return date.toRelativeCalendar({
      unit: "days",
      locale
    });
  }
  return dateFormatting === "long" ? formatDateLong(date, locale) : formatDateShort(date, locale);
}
__name(formatDateWithRelativeWords, "formatDateWithRelativeWords");
function adjustForWeekend(date, relativeReferenceDateType) {
  if (date.weekday === 6) {
    return relativeReferenceDateType === START_DATE_REFERENCE_TYPE ? date.plus({
      days: 2
    }) : date.minus({
      days: 1
    });
  } else if (date.weekday === 7) {
    return relativeReferenceDateType === START_DATE_REFERENCE_TYPE ? date.plus({
      days: 1
    }) : date.minus({
      days: 2
    });
  }
  return date;
}
__name(adjustForWeekend, "adjustForWeekend");
function calculateAbsoluteDate({ baseDate, deltaDays, skipWeekends, relativeReferenceDateType }) {
  let absoluteDate = skipWeekends ? adjustForWeekend(baseDate, relativeReferenceDateType) : baseDate;
  if (relativeReferenceDateType === TARGET_DATE_REFERENCE_TYPE) {
    deltaDays = -deltaDays;
  }
  if (skipWeekends) {
    let daysToAdd = deltaDays;
    const increment = daysToAdd > 0 ? 1 : -1;
    while (daysToAdd !== 0) {
      absoluteDate = absoluteDate.plus({
        days: increment
      });
      if (absoluteDate.weekday !== 6 && absoluteDate.weekday !== 7) {
        daysToAdd -= increment;
      }
    }
  } else {
    absoluteDate = absoluteDate.plus({
      days: deltaDays
    });
  }
  return absoluteDate;
}
__name(calculateAbsoluteDate, "calculateAbsoluteDate");

// src/email.ts
var EMAIL_DOMAIN_REGEX = /@([^@]+)$/i;
function extractDomainFromEmail(email) {
  var _a6;
  if (!email) {
    return null;
  }
  const emailMatch = email.match(EMAIL_DOMAIN_REGEX);
  if (emailMatch) {
    return ((_a6 = emailMatch[1]) == null ? void 0 : _a6.toLowerCase()) || null;
  }
  return null;
}
__name(extractDomainFromEmail, "extractDomainFromEmail");

// src/forms/forms.types.ts
import { z as z25 } from "zod";
var fileAnswerSchema = z25.object({
  fileName: z25.string(),
  mimeType: z25.string(),
  s3ObjectKey: z25.string().optional(),
  s3ObjectUrl: z25.string().nullish()
});
var answerSchema = z25.union([
  z25.string(),
  z25.array(z25.string()),
  z25.array(fileAnswerSchema)
]);
var formQuestionSchema = z25.object({
  id: z25.string(),
  formId: z25.string(),
  question: z25.string(),
  description: z25.string().nullable(),
  type: z25.string(),
  options: z25.array(z25.string()).nullable(),
  sortOrder: z25.number(),
  createdAt: z25.coerce.date(),
  updatedAt: z25.coerce.date(),
  answer: answerSchema.nullable(),
  hidden: z25.boolean(),
  hiddenByAncestor: z25.boolean(),
  nodeId: z25.string()
});
var formListQuerySchema = createPaginationQuerySchema(z25.object({
  spaceIds: z25.array(z25.string()).nullish(),
  completedAfter: z25.coerce.date().optional(),
  includeDeleted: z25.string().optional().transform((val) => val === "true"),
  includeNotCompleted: z25.string().optional().transform((val) => val === "true"),
  includeCompleted: z25.string().optional().transform((val) => val === "true"),
  includeSubmissions: z25.string().optional().transform((val) => val === "true")
}));
var createOrUpdateFormSubmissionSchema = z25.object({
  questionAnswers: z25.array(z25.object({
    questionNodeId: z25.string(),
    answer: answerSchema
  })),
  isSubmitted: z25.boolean().optional()
});
var formQuestionAnswerSchema = z25.object({
  question: z25.string(),
  questionId: z25.string(),
  questionNodeId: z25.string(),
  questionType: z25.enum([
    "BLOCK_FORM_QUESTION_SHORT_TEXT",
    "BLOCK_FORM_QUESTION_LONG_TEXT",
    "BLOCK_FORM_QUESTION_SINGLE_SELECT",
    "BLOCK_FORM_QUESTION_MULTI_SELECT",
    "BLOCK_FORM_QUESTION_FILE_UPLOAD"
  ]),
  answer: answerSchema.nullable()
});
var formSubmissionSchema = z25.object({
  id: z25.string(),
  formId: z25.string(),
  formNodeId: z25.string(),
  completedAt: z25.coerce.date().nullable(),
  completedBy: z25.string().nullable(),
  completedByName: z25.string().nullable(),
  createdAt: z25.coerce.date(),
  updatedAt: z25.coerce.date(),
  questionAnswers: z25.array(formQuestionAnswerSchema)
});
var formSubmissionPaginatedListSchema = createPaginationSchema(formSubmissionSchema, z25.undefined());
var formSubmissionListQuerySchema = createPaginationQuerySchema(z25.object({
  formNodeId: z25.string()
}));
var formSchema = z25.object({
  id: z25.string(),
  tenantId: z25.string(),
  spaceId: z25.string(),
  title: z25.string(),
  description: z25.string().nullable(),
  deletedAt: z25.coerce.date().nullable(),
  createdAt: z25.coerce.date(),
  updatedAt: z25.coerce.date(),
  completedAt: z25.coerce.date().nullable(),
  completedBy: z25.string().nullable(),
  questions: z25.array(formQuestionSchema).nullable(),
  submissions: z25.array(formSubmissionSchema).nullable().optional(),
  hidden: z25.boolean().optional(),
  hiddenByAncestor: z25.boolean().optional(),
  nodeId: z25.string()
});
var formPaginatedListSchema = createPaginationSchema(formSchema, z25.undefined());

// src/helpers/schemas.ts
import { z as z26 } from "zod";
var commaSeparatedArraySchema = z26.preprocess(commaSeparatedArrayParamToArray, z26.array(z26.string()));

// src/helpers/sets.ts
function areSetsIdentical(set1, set2) {
  if (set1.size !== set2.size) {
    return false;
  }
  for (const item of set1) {
    if (!set2.has(item)) {
      return false;
    }
  }
  return true;
}
__name(areSetsIdentical, "areSetsIdentical");
function isSubSet(subset, superset) {
  for (const item of subset) {
    if (!superset.has(item)) {
      return false;
    }
  }
  return true;
}
__name(isSubSet, "isSubSet");
function intersectionOfSets(sets) {
  if (sets.length === 0) {
    return /* @__PURE__ */ new Set();
  }
  if (sets.length === 1) {
    return sets[0];
  }
  return sets.reduce((acc, set) => {
    return new Set([
      ...acc
    ].filter((item) => set.has(item)));
  });
}
__name(intersectionOfSets, "intersectionOfSets");

// src/helpers/sleep.ts
var sleep = /* @__PURE__ */ __name((ms) => new Promise((r2) => setTimeout(r2, ms)), "sleep");

// src/helpers/strings.ts
function isString2(value) {
  return typeof value === "string";
}
__name(isString2, "isString");

// src/iframely.ts
import { z as z27 } from "zod";
var iframelyResponseSchema = z27.object({
  url: z27.string().nullish(),
  type: z27.string().nullish(),
  version: z27.string().nullish(),
  title: z27.string().nullish(),
  description: z27.string().nullish(),
  author: z27.string().nullish(),
  author_url: z27.string().nullish(),
  provider_name: z27.string().nullish(),
  thumbnail_url: z27.string().nullish(),
  thumbnail_width: z27.number().nullish(),
  thumbnail_height: z27.number().nullish(),
  html: z27.string().nullish()
});

// src/invites/invites.ts
import { z as z28 } from "zod";
var InviteUserBodySchema = z28.object({
  email: z28.string().email(),
  firstName: z28.string().min(1),
  lastName: z28.string().min(1),
  roleId: z28.string().min(1),
  teamIds: z28.array(z28.string())
});

// src/name.ts
var splitFullName = /* @__PURE__ */ __name((value) => {
  const wordSplit = value.split(" ");
  const numberOfWords = wordSplit.length;
  if (numberOfWords === 1) return {
    firstName: value,
    lastName: void 0
  };
  if (numberOfWords === 2) return {
    firstName: wordSplit[0],
    lastName: wordSplit[1]
  };
  if ([
    "de",
    "von",
    "van"
  ].includes(wordSplit[numberOfWords - 2]) || [
    "Jr.",
    "Sr.",
    "II",
    "III",
    "IV",
    "V"
  ].includes(wordSplit[numberOfWords - 1])) {
    return {
      firstName: wordSplit.slice(0, numberOfWords - 2).join(" "),
      lastName: wordSplit.slice(numberOfWords - 2).join(" ")
    };
  }
  return {
    firstName: wordSplit.slice(0, numberOfWords - 1).join(" "),
    lastName: wordSplit[numberOfWords - 1]
  };
}, "splitFullName");

// src/notifications/TasksDueNotificationSetting.ts
import { z as z29 } from "zod";
var baseNotificationSettingSchema = z29.object({
  daysOffset: z29.number(),
  spaceId: z29.string().nullish(),
  templateId: z29.string().nullish()
});
var TasksDueNotificationSettingPayload = baseNotificationSettingSchema.refine((data) => !!data.spaceId !== !!data.templateId, {
  message: "Either spaceId or templateId must be provided, but not both."
});
var TasksDueNotificationSettingSchema = baseNotificationSettingSchema.extend({
  id: z29.string(),
  createdBySellerId: z29.string()
});

// src/notifications/default-notification-settings.types.ts
import { z as z31 } from "zod";

// src/notifications/notifications.types.ts
import { z as z30 } from "zod";
var createNotificationsSettingsSchema = z30.object({
  allComments: z30.boolean(),
  taskAssigned: z30.boolean(),
  dueToday: z30.boolean(),
  milestoneDone: z30.boolean()
});

// src/notifications/default-notification-settings.types.ts
var readDefaultNotificationSettingsSchema = z31.object(__spreadProps(__spreadValues({}, createNotificationsSettingsSchema.shape), {
  templateId: z31.string().nullish(),
  spaceId: z31.string().nullish(),
  tenantId: z31.string()
}));
var updateDefaultNotificationSettingsSchema = createNotificationsSettingsSchema.partial();
var readDefaultNotificationSettingsResponseSchema = z31.object({
  data: readDefaultNotificationSettingsSchema
});
var updateDefaultNotificationSettingsResponseSchema = z31.object({
  data: updateDefaultNotificationSettingsSchema
});

// src/placeholders/built-in-placeholders.ts
var BUILTIN_PLACEHOLDERS = [
  "companyName",
  "contactFirstName",
  "contactLastName"
];

// src/placeholders/quill.ts
var import_quill_delta_to_html = __toESM(require_main());

// ../../node_modules/.pnpm/domelementtype@2.3.0/node_modules/domelementtype/lib/esm/index.js
var esm_exports = {};
__export(esm_exports, {
  CDATA: () => CDATA,
  Comment: () => Comment,
  Directive: () => Directive,
  Doctype: () => Doctype,
  ElementType: () => ElementType,
  Root: () => Root,
  Script: () => Script,
  Style: () => Style,
  Tag: () => Tag,
  Text: () => Text,
  isTag: () => isTag
});
var ElementType;
(function(ElementType2) {
  ElementType2["Root"] = "root";
  ElementType2["Text"] = "text";
  ElementType2["Directive"] = "directive";
  ElementType2["Comment"] = "comment";
  ElementType2["Script"] = "script";
  ElementType2["Style"] = "style";
  ElementType2["Tag"] = "tag";
  ElementType2["CDATA"] = "cdata";
  ElementType2["Doctype"] = "doctype";
})(ElementType || (ElementType = {}));
function isTag(elem) {
  return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
}
__name(isTag, "isTag");
var Root = ElementType.Root;
var Text = ElementType.Text;
var Directive = ElementType.Directive;
var Comment = ElementType.Comment;
var Script = ElementType.Script;
var Style = ElementType.Style;
var Tag = ElementType.Tag;
var CDATA = ElementType.CDATA;
var Doctype = ElementType.Doctype;

// ../../node_modules/.pnpm/domhandler@5.0.3/node_modules/domhandler/lib/esm/node.js
var _Node = class _Node {
  constructor() {
    this.parent = null;
    this.prev = null;
    this.next = null;
    this.startIndex = null;
    this.endIndex = null;
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(parent) {
    this.parent = parent;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(prev) {
    this.prev = prev;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(next) {
    this.next = next;
  }
  /**
   * Clone this node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(recursive = false) {
    return cloneNode(this, recursive);
  }
};
__name(_Node, "Node");
var Node = _Node;
var _DataNode = class _DataNode extends Node {
  /**
   * @param data The content of the data node
   */
  constructor(data) {
    super();
    this.data = data;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(data) {
    this.data = data;
  }
};
__name(_DataNode, "DataNode");
var DataNode = _DataNode;
var _Text = class _Text extends DataNode {
  constructor() {
    super(...arguments);
    this.type = ElementType.Text;
  }
  get nodeType() {
    return 3;
  }
};
__name(_Text, "Text");
var Text2 = _Text;
var _Comment = class _Comment extends DataNode {
  constructor() {
    super(...arguments);
    this.type = ElementType.Comment;
  }
  get nodeType() {
    return 8;
  }
};
__name(_Comment, "Comment");
var Comment2 = _Comment;
var _ProcessingInstruction = class _ProcessingInstruction extends DataNode {
  constructor(name2, data) {
    super(data);
    this.name = name2;
    this.type = ElementType.Directive;
  }
  get nodeType() {
    return 1;
  }
};
__name(_ProcessingInstruction, "ProcessingInstruction");
var ProcessingInstruction = _ProcessingInstruction;
var _NodeWithChildren = class _NodeWithChildren extends Node {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(children) {
    super();
    this.children = children;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    var _a6;
    return (_a6 = this.children[0]) !== null && _a6 !== void 0 ? _a6 : null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(children) {
    this.children = children;
  }
};
__name(_NodeWithChildren, "NodeWithChildren");
var NodeWithChildren = _NodeWithChildren;
var _CDATA = class _CDATA extends NodeWithChildren {
  constructor() {
    super(...arguments);
    this.type = ElementType.CDATA;
  }
  get nodeType() {
    return 4;
  }
};
__name(_CDATA, "CDATA");
var CDATA2 = _CDATA;
var _Document = class _Document extends NodeWithChildren {
  constructor() {
    super(...arguments);
    this.type = ElementType.Root;
  }
  get nodeType() {
    return 9;
  }
};
__name(_Document, "Document");
var Document = _Document;
var _Element = class _Element extends NodeWithChildren {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  constructor(name2, attribs, children = [], type = name2 === "script" ? ElementType.Script : name2 === "style" ? ElementType.Style : ElementType.Tag) {
    super(children);
    this.name = name2;
    this.attribs = attribs;
    this.type = type;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(name2) {
    this.name = name2;
  }
  get attributes() {
    return Object.keys(this.attribs).map((name2) => {
      var _a6, _b;
      return {
        name: name2,
        value: this.attribs[name2],
        namespace: (_a6 = this["x-attribsNamespace"]) === null || _a6 === void 0 ? void 0 : _a6[name2],
        prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name2]
      };
    });
  }
};
__name(_Element, "Element");
var Element = _Element;
function isTag2(node) {
  return isTag(node);
}
__name(isTag2, "isTag");
function isCDATA(node) {
  return node.type === ElementType.CDATA;
}
__name(isCDATA, "isCDATA");
function isText(node) {
  return node.type === ElementType.Text;
}
__name(isText, "isText");
function isComment(node) {
  return node.type === ElementType.Comment;
}
__name(isComment, "isComment");
function isDirective(node) {
  return node.type === ElementType.Directive;
}
__name(isDirective, "isDirective");
function isDocument(node) {
  return node.type === ElementType.Root;
}
__name(isDocument, "isDocument");
function hasChildren(node) {
  return Object.prototype.hasOwnProperty.call(node, "children");
}
__name(hasChildren, "hasChildren");
function cloneNode(node, recursive = false) {
  let result;
  if (isText(node)) {
    result = new Text2(node.data);
  } else if (isComment(node)) {
    result = new Comment2(node.data);
  } else if (isTag2(node)) {
    const children = recursive ? cloneChildren(node.children) : [];
    const clone3 = new Element(node.name, __spreadValues({}, node.attribs), children);
    children.forEach((child) => child.parent = clone3);
    if (node.namespace != null) {
      clone3.namespace = node.namespace;
    }
    if (node["x-attribsNamespace"]) {
      clone3["x-attribsNamespace"] = __spreadValues({}, node["x-attribsNamespace"]);
    }
    if (node["x-attribsPrefix"]) {
      clone3["x-attribsPrefix"] = __spreadValues({}, node["x-attribsPrefix"]);
    }
    result = clone3;
  } else if (isCDATA(node)) {
    const children = recursive ? cloneChildren(node.children) : [];
    const clone3 = new CDATA2(children);
    children.forEach((child) => child.parent = clone3);
    result = clone3;
  } else if (isDocument(node)) {
    const children = recursive ? cloneChildren(node.children) : [];
    const clone3 = new Document(children);
    children.forEach((child) => child.parent = clone3);
    if (node["x-mode"]) {
      clone3["x-mode"] = node["x-mode"];
    }
    result = clone3;
  } else if (isDirective(node)) {
    const instruction = new ProcessingInstruction(node.name, node.data);
    if (node["x-name"] != null) {
      instruction["x-name"] = node["x-name"];
      instruction["x-publicId"] = node["x-publicId"];
      instruction["x-systemId"] = node["x-systemId"];
    }
    result = instruction;
  } else {
    throw new Error(`Not implemented yet: ${node.type}`);
  }
  result.startIndex = node.startIndex;
  result.endIndex = node.endIndex;
  if (node.sourceCodeLocation != null) {
    result.sourceCodeLocation = node.sourceCodeLocation;
  }
  return result;
}
__name(cloneNode, "cloneNode");
function cloneChildren(childs) {
  const children = childs.map((child) => cloneNode(child, true));
  for (let i = 1; i < children.length; i++) {
    children[i].prev = children[i - 1];
    children[i - 1].next = children[i];
  }
  return children;
}
__name(cloneChildren, "cloneChildren");

// ../../node_modules/.pnpm/domhandler@5.0.3/node_modules/domhandler/lib/esm/index.js
var defaultOpts = {
  withStartIndices: false,
  withEndIndices: false,
  xmlMode: false
};
var _DomHandler = class _DomHandler {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(callback, options, elementCB) {
    this.dom = [];
    this.root = new Document(this.dom);
    this.done = false;
    this.tagStack = [
      this.root
    ];
    this.lastNode = null;
    this.parser = null;
    if (typeof options === "function") {
      elementCB = options;
      options = defaultOpts;
    }
    if (typeof callback === "object") {
      options = callback;
      callback = void 0;
    }
    this.callback = callback !== null && callback !== void 0 ? callback : null;
    this.options = options !== null && options !== void 0 ? options : defaultOpts;
    this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
  }
  onparserinit(parser) {
    this.parser = parser;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [];
    this.root = new Document(this.dom);
    this.done = false;
    this.tagStack = [
      this.root
    ];
    this.lastNode = null;
    this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    if (this.done) return;
    this.done = true;
    this.parser = null;
    this.handleCallback(null);
  }
  onerror(error) {
    this.handleCallback(error);
  }
  onclosetag() {
    this.lastNode = null;
    const elem = this.tagStack.pop();
    if (this.options.withEndIndices) {
      elem.endIndex = this.parser.endIndex;
    }
    if (this.elementCB) this.elementCB(elem);
  }
  onopentag(name2, attribs) {
    const type = this.options.xmlMode ? ElementType.Tag : void 0;
    const element = new Element(name2, attribs, void 0, type);
    this.addNode(element);
    this.tagStack.push(element);
  }
  ontext(data) {
    const { lastNode } = this;
    if (lastNode && lastNode.type === ElementType.Text) {
      lastNode.data += data;
      if (this.options.withEndIndices) {
        lastNode.endIndex = this.parser.endIndex;
      }
    } else {
      const node = new Text2(data);
      this.addNode(node);
      this.lastNode = node;
    }
  }
  oncomment(data) {
    if (this.lastNode && this.lastNode.type === ElementType.Comment) {
      this.lastNode.data += data;
      return;
    }
    const node = new Comment2(data);
    this.addNode(node);
    this.lastNode = node;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const text = new Text2("");
    const node = new CDATA2([
      text
    ]);
    this.addNode(node);
    text.parent = node;
    this.lastNode = text;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(name2, data) {
    const node = new ProcessingInstruction(name2, data);
    this.addNode(node);
  }
  handleCallback(error) {
    if (typeof this.callback === "function") {
      this.callback(error, this.dom);
    } else if (error) {
      throw error;
    }
  }
  addNode(node) {
    const parent = this.tagStack[this.tagStack.length - 1];
    const previousSibling = parent.children[parent.children.length - 1];
    if (this.options.withStartIndices) {
      node.startIndex = this.parser.startIndex;
    }
    if (this.options.withEndIndices) {
      node.endIndex = this.parser.endIndex;
    }
    parent.children.push(node);
    if (previousSibling) {
      node.prev = previousSibling;
      previousSibling.next = node;
    }
    node.parent = parent;
    this.lastNode = null;
  }
};
__name(_DomHandler, "DomHandler");
var DomHandler = _DomHandler;

// ../../node_modules/.pnpm/leac@0.6.0/node_modules/leac/lib/leac.mjs
var e = /\n/g;
function n2(n3) {
  const o2 = [...n3.matchAll(e)].map((e2) => e2.index || 0);
  o2.unshift(-1);
  const s3 = t(o2, 0, o2.length);
  return (e2) => r(s3, e2);
}
__name(n2, "n");
function t(e2, n3, r2) {
  if (r2 - n3 == 1) return { offset: e2[n3], index: n3 + 1 };
  const o2 = Math.ceil((n3 + r2) / 2), s3 = t(e2, n3, o2), l3 = t(e2, o2, r2);
  return { offset: s3.offset, low: s3, high: l3 };
}
__name(t, "t");
function r(e2, n3) {
  return function(e3) {
    return Object.prototype.hasOwnProperty.call(e3, "index");
  }(e2) ? { line: e2.index, column: n3 - e2.offset } : r(e2.high.offset < n3 ? e2.high : e2.low, n3);
}
__name(r, "r");
function o(e2, t2 = "", r2 = {}) {
  const o2 = "string" != typeof t2 ? t2 : r2, l3 = "string" == typeof t2 ? t2 : "", c2 = e2.map(s2), f = !!o2.lineNumbers;
  return function(e3, t3 = 0) {
    const r3 = f ? n2(e3) : () => ({ line: 0, column: 0 });
    let o3 = t3;
    const s3 = [];
    e: for (; o3 < e3.length; ) {
      let n3 = false;
      for (const t4 of c2) {
        t4.regex.lastIndex = o3;
        const c3 = t4.regex.exec(e3);
        if (c3 && c3[0].length > 0) {
          if (!t4.discard) {
            const e4 = r3(o3), n4 = "string" == typeof t4.replace ? c3[0].replace(new RegExp(t4.regex.source, t4.regex.flags), t4.replace) : c3[0];
            s3.push({ state: l3, name: t4.name, text: n4, offset: o3, len: c3[0].length, line: e4.line, column: e4.column });
          }
          if (o3 = t4.regex.lastIndex, n3 = true, t4.push) {
            const n4 = t4.push(e3, o3);
            s3.push(...n4.tokens), o3 = n4.offset;
          }
          if (t4.pop) break e;
          break;
        }
      }
      if (!n3) break;
    }
    return { tokens: s3, offset: o3, complete: e3.length <= o3 };
  };
}
__name(o, "o");
function s2(e2, n3) {
  return __spreadProps(__spreadValues({}, e2), { regex: l2(e2, n3) });
}
__name(s2, "s");
function l2(e2, n3) {
  if (0 === e2.name.length) throw new Error(`Rule #${n3} has empty name, which is not allowed.`);
  if (function(e3) {
    return Object.prototype.hasOwnProperty.call(e3, "regex");
  }(e2)) return function(e3) {
    if (e3.global) throw new Error(`Regular expression /${e3.source}/${e3.flags} contains the global flag, which is not allowed.`);
    return e3.sticky ? e3 : new RegExp(e3.source, e3.flags + "y");
  }(e2.regex);
  if (function(e3) {
    return Object.prototype.hasOwnProperty.call(e3, "str");
  }(e2)) {
    if (0 === e2.str.length) throw new Error(`Rule #${n3} ("${e2.name}") has empty "str" property, which is not allowed.`);
    return new RegExp(c(e2.str), "y");
  }
  return new RegExp(c(e2.name), "y");
}
__name(l2, "l");
function c(e2) {
  return e2.replace(/[-[\]{}()*+!<=:?./\\^$|#\s,]/g, "\\$&");
}
__name(c, "c");

// ../../node_modules/.pnpm/peberminta@0.9.0/node_modules/peberminta/lib/core.mjs
function token(onToken, onEnd) {
  return (data, i) => {
    let position = i;
    let value = void 0;
    if (i < data.tokens.length) {
      value = onToken(data.tokens[i], data, i);
      if (value !== void 0) {
        position++;
      }
    } else {
      onEnd == null ? void 0 : onEnd(data, i);
    }
    return value === void 0 ? { matched: false } : {
      matched: true,
      position,
      value
    };
  };
}
__name(token, "token");
function mapInner(r2, f) {
  return r2.matched ? {
    matched: true,
    position: r2.position,
    value: f(r2.value, r2.position)
  } : r2;
}
__name(mapInner, "mapInner");
function mapOuter(r2, f) {
  return r2.matched ? f(r2) : r2;
}
__name(mapOuter, "mapOuter");
function map(p, mapper) {
  return (data, i) => mapInner(p(data, i), (v, j) => mapper(v, data, i, j));
}
__name(map, "map");
function option(p, def) {
  return (data, i) => {
    const r2 = p(data, i);
    return r2.matched ? r2 : {
      matched: true,
      position: i,
      value: def
    };
  };
}
__name(option, "option");
function choice(...ps) {
  return (data, i) => {
    for (const p of ps) {
      const result = p(data, i);
      if (result.matched) {
        return result;
      }
    }
    return { matched: false };
  };
}
__name(choice, "choice");
function otherwise(pa, pb) {
  return (data, i) => {
    const r1 = pa(data, i);
    return r1.matched ? r1 : pb(data, i);
  };
}
__name(otherwise, "otherwise");
function takeWhile(p, test) {
  return (data, i) => {
    const values = [];
    let success = true;
    do {
      const r2 = p(data, i);
      if (r2.matched && test(r2.value, values.length + 1, data, i, r2.position)) {
        values.push(r2.value);
        i = r2.position;
      } else {
        success = false;
      }
    } while (success);
    return {
      matched: true,
      position: i,
      value: values
    };
  };
}
__name(takeWhile, "takeWhile");
function many(p) {
  return takeWhile(p, () => true);
}
__name(many, "many");
function many1(p) {
  return ab(p, many(p), (head, tail) => [head, ...tail]);
}
__name(many1, "many1");
function ab(pa, pb, join) {
  return (data, i) => mapOuter(pa(data, i), (ma) => mapInner(pb(data, ma.position), (vb, j) => join(ma.value, vb, data, i, j)));
}
__name(ab, "ab");
function left(pa, pb) {
  return ab(pa, pb, (va) => va);
}
__name(left, "left");
function right(pa, pb) {
  return ab(pa, pb, (va, vb) => vb);
}
__name(right, "right");
function abc(pa, pb, pc, join) {
  return (data, i) => mapOuter(pa(data, i), (ma) => mapOuter(pb(data, ma.position), (mb) => mapInner(pc(data, mb.position), (vc, j) => join(ma.value, mb.value, vc, data, i, j))));
}
__name(abc, "abc");
function middle(pa, pb, pc) {
  return abc(pa, pb, pc, (ra, rb) => rb);
}
__name(middle, "middle");
function all(...ps) {
  return (data, i) => {
    const result = [];
    let position = i;
    for (const p of ps) {
      const r1 = p(data, position);
      if (r1.matched) {
        result.push(r1.value);
        position = r1.position;
      } else {
        return { matched: false };
      }
    }
    return {
      matched: true,
      position,
      value: result
    };
  };
}
__name(all, "all");
function flatten(...ps) {
  return flatten1(all(...ps));
}
__name(flatten, "flatten");
function flatten1(p) {
  return map(p, (vs) => vs.flatMap((v) => v));
}
__name(flatten1, "flatten1");
function chainReduce(acc, f) {
  return (data, i) => {
    let loop = true;
    let acc1 = acc;
    let pos = i;
    do {
      const r2 = f(acc1, data, pos)(data, pos);
      if (r2.matched) {
        acc1 = r2.value;
        pos = r2.position;
      } else {
        loop = false;
      }
    } while (loop);
    return {
      matched: true,
      position: pos,
      value: acc1
    };
  };
}
__name(chainReduce, "chainReduce");
function reduceLeft(acc, p, reducer) {
  return chainReduce(acc, (acc2) => map(p, (v, data, i, j) => reducer(acc2, v, data, i, j)));
}
__name(reduceLeft, "reduceLeft");
function leftAssoc2(pLeft, pOper, pRight) {
  return chain(pLeft, (v0) => reduceLeft(v0, ab(pOper, pRight, (f, y) => [f, y]), (acc, [f, y]) => f(acc, y)));
}
__name(leftAssoc2, "leftAssoc2");
function chain(p, f) {
  return (data, i) => mapOuter(p(data, i), (m1) => f(m1.value, data, i, m1.position)(data, m1.position));
}
__name(chain, "chain");

// ../../node_modules/.pnpm/parseley@0.12.1/node_modules/parseley/lib/parseley.mjs
var ws = `(?:[ \\t\\r\\n\\f]*)`;
var nl = `(?:\\n|\\r\\n|\\r|\\f)`;
var nonascii = `[^\\x00-\\x7F]`;
var unicode = `(?:\\\\[0-9a-f]{1,6}(?:\\r\\n|[ \\n\\r\\t\\f])?)`;
var escape = `(?:\\\\[^\\n\\r\\f0-9a-f])`;
var nmstart = `(?:[_a-z]|${nonascii}|${unicode}|${escape})`;
var nmchar = `(?:[_a-z0-9-]|${nonascii}|${unicode}|${escape})`;
var name = `(?:${nmchar}+)`;
var ident = `(?:[-]?${nmstart}${nmchar}*)`;
var string1 = `'([^\\n\\r\\f\\\\']|\\\\${nl}|${nonascii}|${unicode}|${escape})*'`;
var string2 = `"([^\\n\\r\\f\\\\"]|\\\\${nl}|${nonascii}|${unicode}|${escape})*"`;
var lexSelector = o([
  { name: "ws", regex: new RegExp(ws) },
  { name: "hash", regex: new RegExp(`#${name}`, "i") },
  { name: "ident", regex: new RegExp(ident, "i") },
  { name: "str1", regex: new RegExp(string1, "i") },
  { name: "str2", regex: new RegExp(string2, "i") },
  { name: "*" },
  { name: "." },
  { name: "," },
  { name: "[" },
  { name: "]" },
  { name: "=" },
  { name: ">" },
  { name: "|" },
  { name: "+" },
  { name: "~" },
  { name: "^" },
  { name: "$" }
]);
var lexEscapedString = o([
  { name: "unicode", regex: new RegExp(unicode, "i") },
  { name: "escape", regex: new RegExp(escape, "i") },
  { name: "any", regex: new RegExp("[\\s\\S]", "i") }
]);
function sumSpec([a0, a1, a2], [b0, b1, b2]) {
  return [a0 + b0, a1 + b1, a2 + b2];
}
__name(sumSpec, "sumSpec");
function sumAllSpec(ss) {
  return ss.reduce(sumSpec, [0, 0, 0]);
}
__name(sumAllSpec, "sumAllSpec");
var unicodeEscapedSequence_ = token((t2) => t2.name === "unicode" ? String.fromCodePoint(parseInt(t2.text.slice(1), 16)) : void 0);
var escapedSequence_ = token((t2) => t2.name === "escape" ? t2.text.slice(1) : void 0);
var anyChar_ = token((t2) => t2.name === "any" ? t2.text : void 0);
var escapedString_ = map(many(choice(unicodeEscapedSequence_, escapedSequence_, anyChar_)), (cs) => cs.join(""));
function unescape(escapedString) {
  const lexerResult = lexEscapedString(escapedString);
  const result = escapedString_({ tokens: lexerResult.tokens, options: void 0 }, 0);
  return result.value;
}
__name(unescape, "unescape");
function literal(name2) {
  return token((t2) => t2.name === name2 ? true : void 0);
}
__name(literal, "literal");
var whitespace_ = token((t2) => t2.name === "ws" ? null : void 0);
var optionalWhitespace_ = option(whitespace_, null);
function optionallySpaced(parser) {
  return middle(optionalWhitespace_, parser, optionalWhitespace_);
}
__name(optionallySpaced, "optionallySpaced");
var identifier_ = token((t2) => t2.name === "ident" ? unescape(t2.text) : void 0);
var hashId_ = token((t2) => t2.name === "hash" ? unescape(t2.text.slice(1)) : void 0);
var string_ = token((t2) => t2.name.startsWith("str") ? unescape(t2.text.slice(1, -1)) : void 0);
var namespace_ = left(option(identifier_, ""), literal("|"));
var qualifiedName_ = otherwise(ab(namespace_, identifier_, (ns, name2) => ({ name: name2, namespace: ns })), map(identifier_, (name2) => ({ name: name2, namespace: null })));
var uniSelector_ = otherwise(ab(namespace_, literal("*"), (ns) => ({ type: "universal", namespace: ns, specificity: [0, 0, 0] })), map(literal("*"), () => ({ type: "universal", namespace: null, specificity: [0, 0, 0] })));
var tagSelector_ = map(qualifiedName_, ({ name: name2, namespace }) => ({
  type: "tag",
  name: name2,
  namespace,
  specificity: [0, 0, 1]
}));
var classSelector_ = ab(literal("."), identifier_, (fullstop, name2) => ({
  type: "class",
  name: name2,
  specificity: [0, 1, 0]
}));
var idSelector_ = map(hashId_, (name2) => ({
  type: "id",
  name: name2,
  specificity: [1, 0, 0]
}));
var attrModifier_ = token((t2) => {
  if (t2.name === "ident") {
    if (t2.text === "i" || t2.text === "I") {
      return "i";
    }
    if (t2.text === "s" || t2.text === "S") {
      return "s";
    }
  }
  return void 0;
});
var attrValue_ = otherwise(ab(string_, option(right(optionalWhitespace_, attrModifier_), null), (v, mod) => ({ value: v, modifier: mod })), ab(identifier_, option(right(whitespace_, attrModifier_), null), (v, mod) => ({ value: v, modifier: mod })));
var attrMatcher_ = choice(map(literal("="), () => "="), ab(literal("~"), literal("="), () => "~="), ab(literal("|"), literal("="), () => "|="), ab(literal("^"), literal("="), () => "^="), ab(literal("$"), literal("="), () => "$="), ab(literal("*"), literal("="), () => "*="));
var attrPresenceSelector_ = abc(literal("["), optionallySpaced(qualifiedName_), literal("]"), (lbr, { name: name2, namespace }) => ({
  type: "attrPresence",
  name: name2,
  namespace,
  specificity: [0, 1, 0]
}));
var attrValueSelector_ = middle(literal("["), abc(optionallySpaced(qualifiedName_), attrMatcher_, optionallySpaced(attrValue_), ({ name: name2, namespace }, matcher, { value, modifier }) => ({
  type: "attrValue",
  name: name2,
  namespace,
  matcher,
  value,
  modifier,
  specificity: [0, 1, 0]
})), literal("]"));
var attrSelector_ = otherwise(attrPresenceSelector_, attrValueSelector_);
var typeSelector_ = otherwise(uniSelector_, tagSelector_);
var subclassSelector_ = choice(idSelector_, classSelector_, attrSelector_);
var compoundSelector_ = map(otherwise(flatten(typeSelector_, many(subclassSelector_)), many1(subclassSelector_)), (ss) => {
  return {
    type: "compound",
    list: ss,
    specificity: sumAllSpec(ss.map((s3) => s3.specificity))
  };
});
var combinator_ = choice(map(literal(">"), () => ">"), map(literal("+"), () => "+"), map(literal("~"), () => "~"), ab(literal("|"), literal("|"), () => "||"));
var combinatorSeparator_ = otherwise(optionallySpaced(combinator_), map(whitespace_, () => " "));
var complexSelector_ = leftAssoc2(compoundSelector_, map(combinatorSeparator_, (c2) => (left2, right2) => ({
  type: "compound",
  list: [...right2.list, { type: "combinator", combinator: c2, left: left2, specificity: left2.specificity }],
  specificity: sumSpec(left2.specificity, right2.specificity)
})), compoundSelector_);
var listSelector_ = leftAssoc2(map(complexSelector_, (s3) => ({ type: "list", list: [s3] })), map(optionallySpaced(literal(",")), () => (acc, next) => ({ type: "list", list: [...acc.list, next] })), complexSelector_);
function parse_(parser, str) {
  if (!(typeof str === "string" || str instanceof String)) {
    throw new Error("Expected a selector string. Actual input is not a string!");
  }
  const lexerResult = lexSelector(str);
  if (!lexerResult.complete) {
    throw new Error(`The input "${str}" was only partially tokenized, stopped at offset ${lexerResult.offset}!
` + prettyPrintPosition(str, lexerResult.offset));
  }
  const result = optionallySpaced(parser)({ tokens: lexerResult.tokens, options: void 0 }, 0);
  if (!result.matched) {
    throw new Error(`No match for "${str}" input!`);
  }
  if (result.position < lexerResult.tokens.length) {
    const token2 = lexerResult.tokens[result.position];
    throw new Error(`The input "${str}" was only partially parsed, stopped at offset ${token2.offset}!
` + prettyPrintPosition(str, token2.offset, token2.len));
  }
  return result.value;
}
__name(parse_, "parse_");
function prettyPrintPosition(str, offset2, len = 1) {
  return `${str.replace(/(\t)|(\r)|(\n)/g, (m, t2, r2) => t2 ? "\u2409" : r2 ? "\u240D" : "\u240A")}
${"".padEnd(offset2)}${"^".repeat(len)}`;
}
__name(prettyPrintPosition, "prettyPrintPosition");
function parse1(str) {
  return parse_(complexSelector_, str);
}
__name(parse1, "parse1");
function serialize(selector) {
  if (!selector.type) {
    throw new Error("This is not an AST node.");
  }
  switch (selector.type) {
    case "universal":
      return _serNs(selector.namespace) + "*";
    case "tag":
      return _serNs(selector.namespace) + _serIdent(selector.name);
    case "class":
      return "." + _serIdent(selector.name);
    case "id":
      return "#" + _serIdent(selector.name);
    case "attrPresence":
      return `[${_serNs(selector.namespace)}${_serIdent(selector.name)}]`;
    case "attrValue":
      return `[${_serNs(selector.namespace)}${_serIdent(selector.name)}${selector.matcher}"${_serStr(selector.value)}"${selector.modifier ? selector.modifier : ""}]`;
    case "combinator":
      return serialize(selector.left) + selector.combinator;
    case "compound":
      return selector.list.reduce((acc, node) => {
        if (node.type === "combinator") {
          return serialize(node) + acc;
        } else {
          return acc + serialize(node);
        }
      }, "");
    case "list":
      return selector.list.map(serialize).join(",");
  }
}
__name(serialize, "serialize");
function _serNs(ns) {
  return ns || ns === "" ? _serIdent(ns) + "|" : "";
}
__name(_serNs, "_serNs");
function _codePoint(char) {
  return `\\${char.codePointAt(0).toString(16)} `;
}
__name(_codePoint, "_codePoint");
function _serIdent(str) {
  return str.replace(
    /(^[0-9])|(^-[0-9])|(^-$)|([-0-9a-zA-Z_]|[^\x00-\x7F])|(\x00)|([\x01-\x1f]|\x7f)|([\s\S])/g,
    (m, d1, d2, hy, safe, nl2, ctrl, other) => d1 ? _codePoint(d1) : d2 ? "-" + _codePoint(d2.slice(1)) : hy ? "\\-" : safe ? safe : nl2 ? "\uFFFD" : ctrl ? _codePoint(ctrl) : "\\" + other
  );
}
__name(_serIdent, "_serIdent");
function _serStr(str) {
  return str.replace(
    /(")|(\\)|(\x00)|([\x01-\x1f]|\x7f)/g,
    (m, dq, bs, nl2, ctrl) => dq ? '\\"' : bs ? "\\\\" : nl2 ? "\uFFFD" : _codePoint(ctrl)
  );
}
__name(_serStr, "_serStr");
function normalize(selector) {
  if (!selector.type) {
    throw new Error("This is not an AST node.");
  }
  switch (selector.type) {
    case "compound": {
      selector.list.forEach(normalize);
      selector.list.sort((a, b) => _compareArrays(_getSelectorPriority(a), _getSelectorPriority(b)));
      break;
    }
    case "combinator": {
      normalize(selector.left);
      break;
    }
    case "list": {
      selector.list.forEach(normalize);
      selector.list.sort((a, b) => serialize(a) < serialize(b) ? -1 : 1);
      break;
    }
  }
  return selector;
}
__name(normalize, "normalize");
function _getSelectorPriority(selector) {
  switch (selector.type) {
    case "universal":
      return [1];
    case "tag":
      return [1];
    case "id":
      return [2];
    case "class":
      return [3, selector.name];
    case "attrPresence":
      return [4, serialize(selector)];
    case "attrValue":
      return [5, serialize(selector)];
    case "combinator":
      return [15, serialize(selector)];
  }
}
__name(_getSelectorPriority, "_getSelectorPriority");
function compareSpecificity(a, b) {
  return _compareArrays(a, b);
}
__name(compareSpecificity, "compareSpecificity");
function _compareArrays(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) {
    throw new Error("Arguments must be arrays.");
  }
  const shorter = a.length < b.length ? a.length : b.length;
  for (let i = 0; i < shorter; i++) {
    if (a[i] === b[i]) {
      continue;
    }
    return a[i] < b[i] ? -1 : 1;
  }
  return a.length - b.length;
}
__name(_compareArrays, "_compareArrays");

// ../../node_modules/.pnpm/selderee@0.11.0/node_modules/selderee/lib/selderee.mjs
var _DecisionTree = class _DecisionTree {
  constructor(input) {
    this.branches = weave(toAstTerminalPairs(input));
  }
  build(builder) {
    return builder(this.branches);
  }
};
__name(_DecisionTree, "DecisionTree");
var DecisionTree = _DecisionTree;
function toAstTerminalPairs(array2) {
  const len = array2.length;
  const results = new Array(len);
  for (let i = 0; i < len; i++) {
    const [selectorString, val] = array2[i];
    const ast = preprocess(parse1(selectorString));
    results[i] = {
      ast,
      terminal: {
        type: "terminal",
        valueContainer: { index: i, value: val, specificity: ast.specificity }
      }
    };
  }
  return results;
}
__name(toAstTerminalPairs, "toAstTerminalPairs");
function preprocess(ast) {
  reduceSelectorVariants(ast);
  normalize(ast);
  return ast;
}
__name(preprocess, "preprocess");
function reduceSelectorVariants(ast) {
  const newList = [];
  ast.list.forEach((sel) => {
    switch (sel.type) {
      case "class":
        newList.push({
          matcher: "~=",
          modifier: null,
          name: "class",
          namespace: null,
          specificity: sel.specificity,
          type: "attrValue",
          value: sel.name
        });
        break;
      case "id":
        newList.push({
          matcher: "=",
          modifier: null,
          name: "id",
          namespace: null,
          specificity: sel.specificity,
          type: "attrValue",
          value: sel.name
        });
        break;
      case "combinator":
        reduceSelectorVariants(sel.left);
        newList.push(sel);
        break;
      case "universal":
        break;
      default:
        newList.push(sel);
        break;
    }
  });
  ast.list = newList;
}
__name(reduceSelectorVariants, "reduceSelectorVariants");
function weave(items) {
  const branches = [];
  while (items.length) {
    const topKind = findTopKey(items, (sel) => true, getSelectorKind);
    const { matches, nonmatches, empty } = breakByKind(items, topKind);
    items = nonmatches;
    if (matches.length) {
      branches.push(branchOfKind(topKind, matches));
    }
    if (empty.length) {
      branches.push(...terminate(empty));
    }
  }
  return branches;
}
__name(weave, "weave");
function terminate(items) {
  const results = [];
  for (const item of items) {
    const terminal = item.terminal;
    if (terminal.type === "terminal") {
      results.push(terminal);
    } else {
      const { matches, rest } = partition(terminal.cont, (node) => node.type === "terminal");
      matches.forEach((node) => results.push(node));
      if (rest.length) {
        terminal.cont = rest;
        results.push(terminal);
      }
    }
  }
  return results;
}
__name(terminate, "terminate");
function breakByKind(items, selectedKind) {
  const matches = [];
  const nonmatches = [];
  const empty = [];
  for (const item of items) {
    const simpsels = item.ast.list;
    if (simpsels.length) {
      const isMatch = simpsels.some((node) => getSelectorKind(node) === selectedKind);
      (isMatch ? matches : nonmatches).push(item);
    } else {
      empty.push(item);
    }
  }
  return { matches, nonmatches, empty };
}
__name(breakByKind, "breakByKind");
function getSelectorKind(sel) {
  switch (sel.type) {
    case "attrPresence":
      return `attrPresence ${sel.name}`;
    case "attrValue":
      return `attrValue ${sel.name}`;
    case "combinator":
      return `combinator ${sel.combinator}`;
    default:
      return sel.type;
  }
}
__name(getSelectorKind, "getSelectorKind");
function branchOfKind(kind, items) {
  if (kind === "tag") {
    return tagNameBranch(items);
  }
  if (kind.startsWith("attrValue ")) {
    return attrValueBranch(kind.substring(10), items);
  }
  if (kind.startsWith("attrPresence ")) {
    return attrPresenceBranch(kind.substring(13), items);
  }
  if (kind === "combinator >") {
    return combinatorBranch(">", items);
  }
  if (kind === "combinator +") {
    return combinatorBranch("+", items);
  }
  throw new Error(`Unsupported selector kind: ${kind}`);
}
__name(branchOfKind, "branchOfKind");
function tagNameBranch(items) {
  const groups = spliceAndGroup(items, (x) => x.type === "tag", (x) => x.name);
  const variants = Object.entries(groups).map(([name2, group]) => ({
    type: "variant",
    value: name2,
    cont: weave(group.items)
  }));
  return {
    type: "tagName",
    variants
  };
}
__name(tagNameBranch, "tagNameBranch");
function attrPresenceBranch(name2, items) {
  for (const item of items) {
    spliceSimpleSelector(item, (x) => x.type === "attrPresence" && x.name === name2);
  }
  return {
    type: "attrPresence",
    name: name2,
    cont: weave(items)
  };
}
__name(attrPresenceBranch, "attrPresenceBranch");
function attrValueBranch(name2, items) {
  const groups = spliceAndGroup(items, (x) => x.type === "attrValue" && x.name === name2, (x) => `${x.matcher} ${x.modifier || ""} ${x.value}`);
  const matchers = [];
  for (const group of Object.values(groups)) {
    const sel = group.oneSimpleSelector;
    const predicate = getAttrPredicate(sel);
    const continuation = weave(group.items);
    matchers.push({
      type: "matcher",
      matcher: sel.matcher,
      modifier: sel.modifier,
      value: sel.value,
      predicate,
      cont: continuation
    });
  }
  return {
    type: "attrValue",
    name: name2,
    matchers
  };
}
__name(attrValueBranch, "attrValueBranch");
function getAttrPredicate(sel) {
  if (sel.modifier === "i") {
    const expected = sel.value.toLowerCase();
    switch (sel.matcher) {
      case "=":
        return (actual) => expected === actual.toLowerCase();
      case "~=":
        return (actual) => actual.toLowerCase().split(/[ \t]+/).includes(expected);
      case "^=":
        return (actual) => actual.toLowerCase().startsWith(expected);
      case "$=":
        return (actual) => actual.toLowerCase().endsWith(expected);
      case "*=":
        return (actual) => actual.toLowerCase().includes(expected);
      case "|=":
        return (actual) => {
          const lower = actual.toLowerCase();
          return expected === lower || lower.startsWith(expected) && lower[expected.length] === "-";
        };
    }
  } else {
    const expected = sel.value;
    switch (sel.matcher) {
      case "=":
        return (actual) => expected === actual;
      case "~=":
        return (actual) => actual.split(/[ \t]+/).includes(expected);
      case "^=":
        return (actual) => actual.startsWith(expected);
      case "$=":
        return (actual) => actual.endsWith(expected);
      case "*=":
        return (actual) => actual.includes(expected);
      case "|=":
        return (actual) => expected === actual || actual.startsWith(expected) && actual[expected.length] === "-";
    }
  }
}
__name(getAttrPredicate, "getAttrPredicate");
function combinatorBranch(combinator, items) {
  const groups = spliceAndGroup(items, (x) => x.type === "combinator" && x.combinator === combinator, (x) => serialize(x.left));
  const leftItems = [];
  for (const group of Object.values(groups)) {
    const rightCont = weave(group.items);
    const leftAst = group.oneSimpleSelector.left;
    leftItems.push({
      ast: leftAst,
      terminal: { type: "popElement", cont: rightCont }
    });
  }
  return {
    type: "pushElement",
    combinator,
    cont: weave(leftItems)
  };
}
__name(combinatorBranch, "combinatorBranch");
function spliceAndGroup(items, predicate, keyCallback) {
  const groups = {};
  while (items.length) {
    const bestKey = findTopKey(items, predicate, keyCallback);
    const bestKeyPredicate = /* @__PURE__ */ __name((sel) => predicate(sel) && keyCallback(sel) === bestKey, "bestKeyPredicate");
    const hasBestKeyPredicate = /* @__PURE__ */ __name((item) => item.ast.list.some(bestKeyPredicate), "hasBestKeyPredicate");
    const { matches, rest } = partition1(items, hasBestKeyPredicate);
    let oneSimpleSelector = null;
    for (const item of matches) {
      const splicedNode = spliceSimpleSelector(item, bestKeyPredicate);
      if (!oneSimpleSelector) {
        oneSimpleSelector = splicedNode;
      }
    }
    if (oneSimpleSelector == null) {
      throw new Error("No simple selector is found.");
    }
    groups[bestKey] = { oneSimpleSelector, items: matches };
    items = rest;
  }
  return groups;
}
__name(spliceAndGroup, "spliceAndGroup");
function spliceSimpleSelector(item, predicate) {
  const simpsels = item.ast.list;
  const matches = new Array(simpsels.length);
  let firstIndex = -1;
  for (let i = simpsels.length; i-- > 0; ) {
    if (predicate(simpsels[i])) {
      matches[i] = true;
      firstIndex = i;
    }
  }
  if (firstIndex == -1) {
    throw new Error(`Couldn't find the required simple selector.`);
  }
  const result = simpsels[firstIndex];
  item.ast.list = simpsels.filter((sel, i) => !matches[i]);
  return result;
}
__name(spliceSimpleSelector, "spliceSimpleSelector");
function findTopKey(items, predicate, keyCallback) {
  const candidates = {};
  for (const item of items) {
    const candidates1 = {};
    for (const node of item.ast.list.filter(predicate)) {
      candidates1[keyCallback(node)] = true;
    }
    for (const key of Object.keys(candidates1)) {
      if (candidates[key]) {
        candidates[key]++;
      } else {
        candidates[key] = 1;
      }
    }
  }
  let topKind = "";
  let topCounter = 0;
  for (const entry of Object.entries(candidates)) {
    if (entry[1] > topCounter) {
      topKind = entry[0];
      topCounter = entry[1];
    }
  }
  return topKind;
}
__name(findTopKey, "findTopKey");
function partition(src, predicate) {
  const matches = [];
  const rest = [];
  for (const x of src) {
    if (predicate(x)) {
      matches.push(x);
    } else {
      rest.push(x);
    }
  }
  return { matches, rest };
}
__name(partition, "partition");
function partition1(src, predicate) {
  const matches = [];
  const rest = [];
  for (const x of src) {
    if (predicate(x)) {
      matches.push(x);
    } else {
      rest.push(x);
    }
  }
  return { matches, rest };
}
__name(partition1, "partition1");
var _Picker = class _Picker {
  constructor(f) {
    this.f = f;
  }
  pickAll(el) {
    return this.f(el);
  }
  pick1(el, preferFirst = false) {
    const results = this.f(el);
    const len = results.length;
    if (len === 0) {
      return null;
    }
    if (len === 1) {
      return results[0].value;
    }
    const comparator = preferFirst ? comparatorPreferFirst : comparatorPreferLast;
    let result = results[0];
    for (let i = 1; i < len; i++) {
      const next = results[i];
      if (comparator(result, next)) {
        result = next;
      }
    }
    return result.value;
  }
};
__name(_Picker, "Picker");
var Picker = _Picker;
function comparatorPreferFirst(acc, next) {
  const diff = compareSpecificity(next.specificity, acc.specificity);
  return diff > 0 || diff === 0 && next.index < acc.index;
}
__name(comparatorPreferFirst, "comparatorPreferFirst");
function comparatorPreferLast(acc, next) {
  const diff = compareSpecificity(next.specificity, acc.specificity);
  return diff > 0 || diff === 0 && next.index > acc.index;
}
__name(comparatorPreferLast, "comparatorPreferLast");

// ../../node_modules/.pnpm/@selderee+plugin-htmlparser2@0.11.0/node_modules/@selderee/plugin-htmlparser2/lib/hp2-builder.mjs
function hp2Builder(nodes) {
  return new Picker(handleArray(nodes));
}
__name(hp2Builder, "hp2Builder");
function handleArray(nodes) {
  const matchers = nodes.map(handleNode);
  return (el, ...tail) => matchers.flatMap((m) => m(el, ...tail));
}
__name(handleArray, "handleArray");
function handleNode(node) {
  switch (node.type) {
    case "terminal": {
      const result = [node.valueContainer];
      return (el, ...tail) => result;
    }
    case "tagName":
      return handleTagName(node);
    case "attrValue":
      return handleAttrValueName(node);
    case "attrPresence":
      return handleAttrPresenceName(node);
    case "pushElement":
      return handlePushElementNode(node);
    case "popElement":
      return handlePopElementNode(node);
  }
}
__name(handleNode, "handleNode");
function handleTagName(node) {
  const variants = {};
  for (const variant of node.variants) {
    variants[variant.value] = handleArray(variant.cont);
  }
  return (el, ...tail) => {
    const continuation = variants[el.name];
    return continuation ? continuation(el, ...tail) : [];
  };
}
__name(handleTagName, "handleTagName");
function handleAttrPresenceName(node) {
  const attrName = node.name;
  const continuation = handleArray(node.cont);
  return (el, ...tail) => Object.prototype.hasOwnProperty.call(el.attribs, attrName) ? continuation(el, ...tail) : [];
}
__name(handleAttrPresenceName, "handleAttrPresenceName");
function handleAttrValueName(node) {
  const callbacks = [];
  for (const matcher of node.matchers) {
    const predicate = matcher.predicate;
    const continuation = handleArray(matcher.cont);
    callbacks.push((attr, el, ...tail) => predicate(attr) ? continuation(el, ...tail) : []);
  }
  const attrName = node.name;
  return (el, ...tail) => {
    const attr = el.attribs[attrName];
    return attr || attr === "" ? callbacks.flatMap((cb) => cb(attr, el, ...tail)) : [];
  };
}
__name(handleAttrValueName, "handleAttrValueName");
function handlePushElementNode(node) {
  const continuation = handleArray(node.cont);
  const leftElementGetter = node.combinator === "+" ? getPrecedingElement : getParentElement;
  return (el, ...tail) => {
    const next = leftElementGetter(el);
    if (next === null) {
      return [];
    }
    return continuation(next, el, ...tail);
  };
}
__name(handlePushElementNode, "handlePushElementNode");
var getPrecedingElement = /* @__PURE__ */ __name((el) => {
  const prev = el.prev;
  if (prev === null) {
    return null;
  }
  return isTag2(prev) ? prev : getPrecedingElement(prev);
}, "getPrecedingElement");
var getParentElement = /* @__PURE__ */ __name((el) => {
  const parent = el.parent;
  return parent && isTag2(parent) ? parent : null;
}, "getParentElement");
function handlePopElementNode(node) {
  const continuation = handleArray(node.cont);
  return (el, next, ...tail) => continuation(next, ...tail);
}
__name(handlePopElementNode, "handlePopElementNode");

// ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/generated/decode-data-html.js
var decode_data_html_default = new Uint16Array(
  // prettier-ignore
  '\u1D41<\xD5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7F\x84\x8B\x90\x95\x98\xA6\xB3\xB9\xC8\xCFlig\u803B\xC6\u40C6P\u803B&\u4026cute\u803B\xC1\u40C1reve;\u4102\u0100iyx}rc\u803B\xC2\u40C2;\u4410r;\uC000\u{1D504}rave\u803B\xC0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9D\xA1on;\u4104f;\uC000\u{1D538}plyFunction;\u6061ing\u803B\xC5\u40C5\u0100cs\xBE\xC3r;\uC000\u{1D49C}ign;\u6254ilde\u803B\xC3\u40C3ml\u803B\xC4\u40C4\u0400aceforsu\xE5\xFB\xFE\u0117\u011C\u0122\u0127\u012A\u0100cr\xEA\xF2kslash;\u6216\u0176\xF6\xF8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\u{1D505}pf;\uC000\u{1D539}eve;\u42D8c\xF2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xA9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xC7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xF2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\u{1D49E}p\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\u{1D507}\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\u{1D53B}\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xEC\u0239o\u0274\u0379\0\0\u037B\xBB\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xE5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\u{1D49F}rok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xD0\u40D0cute\u803B\xC9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xCA\u40CA;\u442Dot;\u4116r;\uC000\u{1D508}rave\u803B\xC8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\u{1D53C}silon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xCB\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\u{1D509}lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\u{1D53D}All;\u6200riertrf;\u6131c\xF2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\u{1D50A};\u62D9pf;\uC000\u{1D53E}eater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\u{1D4A2};\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xF2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xF0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xCD\u40CD\u0100iy\u0713\u0718rc\u803B\xCE\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xCC\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xF3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\u{1D540}a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xCF\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\u{1D50D}pf;\uC000\u{1D541}\u01E3\u07C7\0\u07CCr;\uC000\u{1D4A5}rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\u{1D50E}pf;\uC000\u{1D542}cr;\uC000\u{1D4A6}\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xE1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\u{1D50F}\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xE1\u03BFight\xE1\u03CAf;\uC000\u{1D543}er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xF2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\u{1D510}nusPlus;\u6213pf;\uC000\u{1D544}c\xF2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xEB\u0AD9eryThi\xEE\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xF2\u0673essLes\xF3\u0A48Line;\u400Ar;\uC000\u{1D511}\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\u{1D4A9}ilde\u803B\xD1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xD3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xD4\u40D4;\u441Eblac;\u4150r;\uC000\u{1D512}rave\u803B\xD2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\u{1D546}enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\u{1D4AA}ash\u803B\xD8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xD5\u40D5es;\u6A37ml\u803B\xD6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\u{1D513}i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xE5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\u{1D4AB};\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\u{1D514}pf;\u611Acr;\uC000\u{1D4AC}\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xAE\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xBB\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\u{1D516}ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xBB\u041EeftArrow\xBB\u089AightArrow\xBB\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\u{1D54A}\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\u{1D4AE}ar;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xE1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xBB\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xDE\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\u{1D517}\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\u{1D54B}ipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\u{1D4AF}rok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xDA\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xDB\u40DB;\u4423blac;\u4170r;\uC000\u{1D518}rave\u803B\xD9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\u{1D54C}\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xE1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\u{1D4B0}ilde;\u4168ml\u803B\xDC\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\u{1D519}pf;\uC000\u{1D54D}cr;\uC000\u{1D4B1}dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\u{1D51A}pf;\uC000\u{1D54E}cr;\uC000\u{1D4B2}\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\u{1D51B};\u439Epf;\uC000\u{1D54F}cr;\uC000\u{1D4B3}\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xDD\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\u{1D51C}pf;\uC000\u{1D550}cr;\uC000\u{1D4B4}ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xE8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\u{1D4B5}\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xE1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xE2\u40E2te\u80BB\xB4\u0306;\u4430lig\u803B\xE6\u40E6\u0100;r\xB2\u15BA;\uC000\u{1D51E}rave\u803B\xE0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xE8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xBB\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xBB\xB9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\u{1D552}\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xF1\u1683ing\u803B\xE5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\u{1D4B6};\u402Amp\u0100;e\u12C1\u16AF\xF1\u0288ilde\u803B\xE3\u40E3ml\u803B\xE4\u40E4\u0100ci\u16C2\u16C8onin\xF4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xBB\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xE9\u170Cno\xF5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\u{1D51F}g\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xF0\u0760rc;\u65EFp\xBB\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xE5\u1444\xE5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\u{1D553}\u0100;t\u13CB\u1863om\xBB\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xA6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\u{1D4B7}mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xBB\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xEE\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xE7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xB8\u01ADptyv;\u69B2t\u8100\xA2;e\u1A2D\u1A2E\u40A2r\xE4\u01B2r;\uC000\u{1D520}\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xBB\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xBB\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xBB\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xC7\xC6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xEE\u1160e\u0100mx\u1AF1\u1AF6ent\xBB\u1AE9e\xF3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xF4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\u{1D554}o\xE4\u0254\u8100\xA9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\u{1D4B8}\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xE3\u1B73u\xE3\u1B75ee;\u62CEedge;\u62CFen\u803B\xA4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xBB\u1B80ight\xBB\u1BBDe\xE4\u1BDD\u0100ci\u1C01\u1C07onin\xF4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xF2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xF2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xBB\u090A\u016B\u1C61\u1C67arow;\u690Fa\xE3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xB0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\u{1D521}ar\u0100lr\u1CB3\u1CB5\xBB\u08DC\xBB\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xF7;o\u1CE7\u1CF0ntimes;\u62C7n\xF8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\u{1D555}\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xE5\xFAn\u0180adh\u112E\u1D5D\u1D67ownarrow\xF3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xF4\u1CB4igh\xF4\u1CB6\u0162\u1D7F\u1D85karo\xF7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\u{1D4B9};\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xF2\u0429a\xF2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xF4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xE9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xEA\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\u{1D522}\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xE8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xBB\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\u{1D556}\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xBB\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xBB\u1E2E\u0269\u1EF9\0\0\u1EFB\xED\u0548ant\u0100gl\u1F02\u1F06tr\xBB\u1E5Dess\xBB\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xF4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xF0\u40F0\u0100mr\u1F53\u1F57l\u803B\xEB\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xF4\u056E\u0100eo\u1F6C\u1F74ctatio\xEE\u0559nential\xE5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xF1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\u{1D523}lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\u{1D557}\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xBD\u40BD;\u6153\u803B\xBC\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xBE\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\u{1D4BB}\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xF4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\u{1D524}\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xBB\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\u{1D558}\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xF8\u209Er;\u6978q\u0100lq\u063F\u2196les\xF3\u2088i\xED\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xC5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xF2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xF0\u1484f\xBB\u2024il\xF4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xBB\u220Alip;\u6026con;\u62B9r;\uC000\u{1D525}s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\u{1D559}bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\u{1D4BD}as\xE8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xBB\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xED\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xEE\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xA1\u40A1\u0100fr\u039F\u22C9;\uC000\u{1D526}rave\u803B\xEC\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xE5\u078Ear\xF4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xF4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xF3\u1563\xE3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\u{1D55A}a;\u43B9uest\u803B\xBF\u40BF\u0100ci\u238A\u238Fr;\uC000\u{1D4BE}n\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xEF\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\u{1D527}ath;\u4237pf;\uC000\u{1D55B}\u01E3\u23EC\0\u23F1r;\uC000\u{1D4BF}rcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\u{1D528}reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\u{1D55C}cr;\uC000\u{1D4C0}\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xF2\u09C6\xF2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xEE\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xE5\u088E;\u6A85uo\u803B\xAB\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xEB\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xEC\u08B0\xE2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xE9\u24F6arpoon\u0100du\u25AF\u25B4own\xBB\u045Ap\xBB\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xF3\u0F98quigarro\xF7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xF4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xF8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xF4\u0989gt\xF2\u248C\xF4\u099Bi\xED\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\u{1D529}\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xF2\u25C1orne\xF2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xBB\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xBB\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xEB\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xE1\u09F2apsto;\u67FCight\xE1\u09FDparrow\u0100lr\u2725\u2729ef\xF4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\u{1D55D}us;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xE1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xBB\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xF2\u08A8orne\xF2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\u{1D4C1}m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xE5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xC5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xAF\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xBB\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xEE\u048Cef\xF4\u090F\xF0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xBB\u1626r;\uC000\u{1D52A}o;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xB5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xF4\u16A7ir;\u6AF0ot\u80BB\xB7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xF2\u2212\xF0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\u{1D55E}\u0100ct\u28F8\u28FDr;\uC000\u{1D4C2}pos\xBB\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xBB\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xF8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xA0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xF6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xED\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\u{1D52B}\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xF4\u0BE2i\xED\u0BEA\u0100;r\u0BB6\u2A81\xBB\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xF2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xF2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xF7\u2AC1ightarro\xF7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xF4\u0C55\u0100;s\u0C55\u2AF4\xBB\u0C36i\xED\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xE4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\u{1D55F}\u8180\xAC;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xEC\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xE5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xF1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xF2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xBB\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xE5\u0D45;\uC000\u{1D4C3}ort\u026D\u2B05\0\0\u2BD6ar\xE1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xE5\u0CF8\xE5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xF1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xEC\u0BD7lde\u803B\xF1\u40F1\xE7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xF1\u0C26ight\u0100;e\u0CCB\u2C65\xF1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xF3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xF4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\u{1D52C}\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xF2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xF2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xE5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\u{1D560}\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xF2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xBB\u2DFF\u803B\xAA\u40AA\u803B\xBA\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xF2\u2E01ash\u803B\xF8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xF5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xF6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xB6;l\u2E6D\u2E6E\u40B6le\xEC\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\u{1D52D}\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xF4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xBB\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xF6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xB1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\u{1D561}nd\u803B\xA3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xE5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xF8\u2F43urlye\xF1\u0ED9\xF1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xED\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xF0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xEF\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\u{1D4C5};\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\u{1D52E}pf;\uC000\u{1D562}rime;\u6057cr;\uC000\u{1D4C6}\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xF3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xF1\u1F19\xF4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xF2\u10B3\xF2\u03DDail;\u691Car\xF2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xE3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xE5\u0FD1uo\u803B\xBB\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xEB\u225D\xF0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xF3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xF2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xEC\u0FF2\xE2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xE5\u10BBar\xF4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\u{1D52F}\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xBB\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xE9\u30C8arpoon\u0100du\u31BB\u31BFow\xEE\u317Ep\xBB\u1092eft\u0100ah\u31CA\u31D0rrow\xF3\u0FEAarpoon\xF3\u0551ightarrows;\u61C9quigarro\xF7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xF1\u1F32\u0180ahm\u320D\u3210\u3213r\xF2\u0FEAa\xF2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xBB\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xEB\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\u{1D563}us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xF2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\u{1D4C7}\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xE5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xEF\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xE5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xED\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xEB\u2228\u0100;o\u0A36\u0A34t\u803B\xA7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xF0nu\xF3\xF1t;\u6736r\u0100;o\u3376\u2055\uC000\u{1D530}\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xE4\u1464ara\xEC\u2E6F\u803B\xAD\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xF2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xE9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\u{1D564}a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xBB\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xF1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xF1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xBB\u117Car\xF2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\u{1D4C8}tm\xEE\xF1i\xEC\u3415ar\xE6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xEE\u1EE0h\xE9\u2EAFs\xBB\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xF8\u32FAurlye\xF1\u11FE\xF1\u11F3\u0180aes\u3582\u3588\u331Bppro\xF8\u331Aq\xF1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xB9\u40B9\u803B\xB2\u40B2\u803B\xB3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xEB\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xDF\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xEB\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\u{1D531}\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xF8\u12C1im\xBB\u12ACs\xF0\u129E\u0100as\u36BA\u36AE\xF0\u12C1rn\u803B\xFE\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xD7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xE1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\u{1D565}rk;\u6ADA\xE1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xE5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xBB\u1DBBeft\u0100;e\u2800\u373E\xF1\u092E;\u625Cight\u0100;e\u32AA\u374B\xF1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\u{1D4C9};\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xF4\u1777head\u0100lr\u3797\u37A0eftarro\xF7\u084Fightarrow\xBB\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xF2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xFA\u40FA\xF2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xFB\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xF2\u13ADlac;\u4171a\xF2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\u{1D532}rave\u803B\xF9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xBB\u0957\xBB\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xBB\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xA8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\u{1D566}\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xE1\u13B3arpoon\u0100lr\u3888\u388Cef\xF4\u382Digh\xF4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xBB\u13FAon\xBB\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xBB\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\u{1D4CA}\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xBB\u1813\u0100am\u38EF\u38F2r\xF2\u38A8l\u803B\xFC\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xF2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xE8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xE1\u2415othin\xE7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xF4\u2FB5\u0100;h\u13B7\u3962\xEF\u318D\u0100iu\u3969\u396Dgm\xE1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xE1\u369Ciangle\u0100lr\u39AA\u39AFeft\xBB\u0925ight\xBB\u1051y;\u4432ash\xBB\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xF2\u1469r;\uC000\u{1D533}tr\xE9\u39AEsu\u0100bp\u39EF\u39F1\xBB\u0D1C\xBB\u0D59pf;\uC000\u{1D567}ro\xF0\u0EFBtr\xE9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\u{1D4CB}\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xBB\u397En\u0100Ee\u3992\u3A1E\xBB\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\u{1D534}pf;\uC000\u{1D568}\u0100;e\u1479\u3A66at\xE8\u1479cr;\uC000\u{1D4CC}\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xE9\u17D1r;\uC000\u{1D535}\u0100Aa\u3A94\u3A97r\xF2\u03C3r\xF2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xF2\u03B8r\xF2\u09EBa\xF0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\u{1D569}im\xE5\u17B2\u0100Aa\u3AC7\u3ACAr\xF2\u03CEr\xF2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\u{1D4CD}\u0100pt\u17D6\u3ADCr\xE9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xFD\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xA5\u40A5r;\uC000\u{1D536}cy;\u4457pf;\uC000\u{1D56A}cr;\uC000\u{1D4CE}\u0100cm\u3B26\u3B29y;\u444El\u803B\xFF\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xE6\u155Fa;\u43B6r;\uC000\u{1D537}cy;\u4436grarr;\u61DDpf;\uC000\u{1D56B}cr;\uC000\u{1D4CF}\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((c2) => c2.charCodeAt(0))
);

// ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/generated/decode-data-xml.js
var decode_data_xml_default = new Uint16Array(
  // prettier-ignore
  "\u0200aglq	\x1B\u026D\0\0p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((c2) => c2.charCodeAt(0))
);

// ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/decode_codepoint.js
var _a5;
var decodeMap = /* @__PURE__ */ new Map([
  [
    0,
    65533
  ],
  // C1 Unicode control character reference replacements
  [
    128,
    8364
  ],
  [
    130,
    8218
  ],
  [
    131,
    402
  ],
  [
    132,
    8222
  ],
  [
    133,
    8230
  ],
  [
    134,
    8224
  ],
  [
    135,
    8225
  ],
  [
    136,
    710
  ],
  [
    137,
    8240
  ],
  [
    138,
    352
  ],
  [
    139,
    8249
  ],
  [
    140,
    338
  ],
  [
    142,
    381
  ],
  [
    145,
    8216
  ],
  [
    146,
    8217
  ],
  [
    147,
    8220
  ],
  [
    148,
    8221
  ],
  [
    149,
    8226
  ],
  [
    150,
    8211
  ],
  [
    151,
    8212
  ],
  [
    152,
    732
  ],
  [
    153,
    8482
  ],
  [
    154,
    353
  ],
  [
    155,
    8250
  ],
  [
    156,
    339
  ],
  [
    158,
    382
  ],
  [
    159,
    376
  ]
]);
var fromCodePoint = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (_a5 = String.fromCodePoint) !== null && _a5 !== void 0 ? _a5 : function(codePoint) {
    let output = "";
    if (codePoint > 65535) {
      codePoint -= 65536;
      output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
      codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
  }
);
function replaceCodePoint(codePoint) {
  var _a6;
  if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
    return 65533;
  }
  return (_a6 = decodeMap.get(codePoint)) !== null && _a6 !== void 0 ? _a6 : codePoint;
}
__name(replaceCodePoint, "replaceCodePoint");

// ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/decode.js
var CharCodes;
(function(CharCodes3) {
  CharCodes3[CharCodes3["NUM"] = 35] = "NUM";
  CharCodes3[CharCodes3["SEMI"] = 59] = "SEMI";
  CharCodes3[CharCodes3["EQUALS"] = 61] = "EQUALS";
  CharCodes3[CharCodes3["ZERO"] = 48] = "ZERO";
  CharCodes3[CharCodes3["NINE"] = 57] = "NINE";
  CharCodes3[CharCodes3["LOWER_A"] = 97] = "LOWER_A";
  CharCodes3[CharCodes3["LOWER_F"] = 102] = "LOWER_F";
  CharCodes3[CharCodes3["LOWER_X"] = 120] = "LOWER_X";
  CharCodes3[CharCodes3["LOWER_Z"] = 122] = "LOWER_Z";
  CharCodes3[CharCodes3["UPPER_A"] = 65] = "UPPER_A";
  CharCodes3[CharCodes3["UPPER_F"] = 70] = "UPPER_F";
  CharCodes3[CharCodes3["UPPER_Z"] = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
var TO_LOWER_BIT = 32;
var BinTrieFlags;
(function(BinTrieFlags2) {
  BinTrieFlags2[BinTrieFlags2["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
  BinTrieFlags2[BinTrieFlags2["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
  BinTrieFlags2[BinTrieFlags2["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags || (BinTrieFlags = {}));
function isNumber2(code) {
  return code >= CharCodes.ZERO && code <= CharCodes.NINE;
}
__name(isNumber2, "isNumber");
function isHexadecimalCharacter(code) {
  return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F;
}
__name(isHexadecimalCharacter, "isHexadecimalCharacter");
function isAsciiAlphaNumeric(code) {
  return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z || isNumber2(code);
}
__name(isAsciiAlphaNumeric, "isAsciiAlphaNumeric");
function isEntityInAttributeInvalidEnd(code) {
  return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
}
__name(isEntityInAttributeInvalidEnd, "isEntityInAttributeInvalidEnd");
var EntityDecoderState;
(function(EntityDecoderState2) {
  EntityDecoderState2[EntityDecoderState2["EntityStart"] = 0] = "EntityStart";
  EntityDecoderState2[EntityDecoderState2["NumericStart"] = 1] = "NumericStart";
  EntityDecoderState2[EntityDecoderState2["NumericDecimal"] = 2] = "NumericDecimal";
  EntityDecoderState2[EntityDecoderState2["NumericHex"] = 3] = "NumericHex";
  EntityDecoderState2[EntityDecoderState2["NamedEntity"] = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var DecodingMode;
(function(DecodingMode2) {
  DecodingMode2[DecodingMode2["Legacy"] = 0] = "Legacy";
  DecodingMode2[DecodingMode2["Strict"] = 1] = "Strict";
  DecodingMode2[DecodingMode2["Attribute"] = 2] = "Attribute";
})(DecodingMode || (DecodingMode = {}));
var _EntityDecoder = class _EntityDecoder {
  constructor(decodeTree, emitCodePoint, errors) {
    this.decodeTree = decodeTree;
    this.emitCodePoint = emitCodePoint;
    this.errors = errors;
    this.state = EntityDecoderState.EntityStart;
    this.consumed = 1;
    this.result = 0;
    this.treeIndex = 0;
    this.excess = 1;
    this.decodeMode = DecodingMode.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(decodeMode) {
    this.decodeMode = decodeMode;
    this.state = EntityDecoderState.EntityStart;
    this.result = 0;
    this.treeIndex = 0;
    this.excess = 1;
    this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(str, offset2) {
    switch (this.state) {
      case EntityDecoderState.EntityStart: {
        if (str.charCodeAt(offset2) === CharCodes.NUM) {
          this.state = EntityDecoderState.NumericStart;
          this.consumed += 1;
          return this.stateNumericStart(str, offset2 + 1);
        }
        this.state = EntityDecoderState.NamedEntity;
        return this.stateNamedEntity(str, offset2);
      }
      case EntityDecoderState.NumericStart: {
        return this.stateNumericStart(str, offset2);
      }
      case EntityDecoderState.NumericDecimal: {
        return this.stateNumericDecimal(str, offset2);
      }
      case EntityDecoderState.NumericHex: {
        return this.stateNumericHex(str, offset2);
      }
      case EntityDecoderState.NamedEntity: {
        return this.stateNamedEntity(str, offset2);
      }
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(str, offset2) {
    if (offset2 >= str.length) {
      return -1;
    }
    if ((str.charCodeAt(offset2) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
      this.state = EntityDecoderState.NumericHex;
      this.consumed += 1;
      return this.stateNumericHex(str, offset2 + 1);
    }
    this.state = EntityDecoderState.NumericDecimal;
    return this.stateNumericDecimal(str, offset2);
  }
  addToNumericResult(str, start, end, base) {
    if (start !== end) {
      const digitCount = end - start;
      this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
      this.consumed += digitCount;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(str, offset2) {
    const startIdx = offset2;
    while (offset2 < str.length) {
      const char = str.charCodeAt(offset2);
      if (isNumber2(char) || isHexadecimalCharacter(char)) {
        offset2 += 1;
      } else {
        this.addToNumericResult(str, startIdx, offset2, 16);
        return this.emitNumericEntity(char, 3);
      }
    }
    this.addToNumericResult(str, startIdx, offset2, 16);
    return -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(str, offset2) {
    const startIdx = offset2;
    while (offset2 < str.length) {
      const char = str.charCodeAt(offset2);
      if (isNumber2(char)) {
        offset2 += 1;
      } else {
        this.addToNumericResult(str, startIdx, offset2, 10);
        return this.emitNumericEntity(char, 2);
      }
    }
    this.addToNumericResult(str, startIdx, offset2, 10);
    return -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(lastCp, expectedLength) {
    var _a6;
    if (this.consumed <= expectedLength) {
      (_a6 = this.errors) === null || _a6 === void 0 ? void 0 : _a6.absenceOfDigitsInNumericCharacterReference(this.consumed);
      return 0;
    }
    if (lastCp === CharCodes.SEMI) {
      this.consumed += 1;
    } else if (this.decodeMode === DecodingMode.Strict) {
      return 0;
    }
    this.emitCodePoint(replaceCodePoint(this.result), this.consumed);
    if (this.errors) {
      if (lastCp !== CharCodes.SEMI) {
        this.errors.missingSemicolonAfterCharacterReference();
      }
      this.errors.validateNumericCharacterReference(this.result);
    }
    return this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(str, offset2) {
    const { decodeTree } = this;
    let current = decodeTree[this.treeIndex];
    let valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
    for (; offset2 < str.length; offset2++, this.excess++) {
      const char = str.charCodeAt(offset2);
      this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
      if (this.treeIndex < 0) {
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
        (valueLength === 0 || // And there should be no invalid characters.
        isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
      }
      current = decodeTree[this.treeIndex];
      valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
      if (valueLength !== 0) {
        if (char === CharCodes.SEMI) {
          return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
        }
        if (this.decodeMode !== DecodingMode.Strict) {
          this.result = this.treeIndex;
          this.consumed += this.excess;
          this.excess = 0;
        }
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var _a6;
    const { result, decodeTree } = this;
    const valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
    this.emitNamedEntityData(result, valueLength, this.consumed);
    (_a6 = this.errors) === null || _a6 === void 0 ? void 0 : _a6.missingSemicolonAfterCharacterReference();
    return this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(result, valueLength, consumed) {
    const { decodeTree } = this;
    this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
    if (valueLength === 3) {
      this.emitCodePoint(decodeTree[result + 2], consumed);
    }
    return consumed;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var _a6;
    switch (this.state) {
      case EntityDecoderState.NamedEntity: {
        return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      }
      // Otherwise, emit a numeric entity if we have one.
      case EntityDecoderState.NumericDecimal: {
        return this.emitNumericEntity(0, 2);
      }
      case EntityDecoderState.NumericHex: {
        return this.emitNumericEntity(0, 3);
      }
      case EntityDecoderState.NumericStart: {
        (_a6 = this.errors) === null || _a6 === void 0 ? void 0 : _a6.absenceOfDigitsInNumericCharacterReference(this.consumed);
        return 0;
      }
      case EntityDecoderState.EntityStart: {
        return 0;
      }
    }
  }
};
__name(_EntityDecoder, "EntityDecoder");
var EntityDecoder = _EntityDecoder;
function getDecoder(decodeTree) {
  let ret = "";
  const decoder = new EntityDecoder(decodeTree, (str) => ret += fromCodePoint(str));
  return /* @__PURE__ */ __name(function decodeWithTrie(str, decodeMode) {
    let lastIndex = 0;
    let offset2 = 0;
    while ((offset2 = str.indexOf("&", offset2)) >= 0) {
      ret += str.slice(lastIndex, offset2);
      decoder.startEntity(decodeMode);
      const len = decoder.write(
        str,
        // Skip the "&"
        offset2 + 1
      );
      if (len < 0) {
        lastIndex = offset2 + decoder.end();
        break;
      }
      lastIndex = offset2 + len;
      offset2 = len === 0 ? lastIndex + 1 : lastIndex;
    }
    const result = ret + str.slice(lastIndex);
    ret = "";
    return result;
  }, "decodeWithTrie");
}
__name(getDecoder, "getDecoder");
function determineBranch(decodeTree, current, nodeIdx, char) {
  const branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
  const jumpOffset = current & BinTrieFlags.JUMP_TABLE;
  if (branchCount === 0) {
    return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
  }
  if (jumpOffset) {
    const value = char - jumpOffset;
    return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
  }
  let lo = nodeIdx;
  let hi = lo + branchCount - 1;
  while (lo <= hi) {
    const mid = lo + hi >>> 1;
    const midVal = decodeTree[mid];
    if (midVal < char) {
      lo = mid + 1;
    } else if (midVal > char) {
      hi = mid - 1;
    } else {
      return decodeTree[mid + branchCount];
    }
  }
  return -1;
}
__name(determineBranch, "determineBranch");
var htmlDecoder = getDecoder(decode_data_html_default);
var xmlDecoder = getDecoder(decode_data_xml_default);

// ../../node_modules/.pnpm/htmlparser2@8.0.2/node_modules/htmlparser2/lib/esm/Tokenizer.js
var CharCodes2;
(function(CharCodes3) {
  CharCodes3[CharCodes3["Tab"] = 9] = "Tab";
  CharCodes3[CharCodes3["NewLine"] = 10] = "NewLine";
  CharCodes3[CharCodes3["FormFeed"] = 12] = "FormFeed";
  CharCodes3[CharCodes3["CarriageReturn"] = 13] = "CarriageReturn";
  CharCodes3[CharCodes3["Space"] = 32] = "Space";
  CharCodes3[CharCodes3["ExclamationMark"] = 33] = "ExclamationMark";
  CharCodes3[CharCodes3["Number"] = 35] = "Number";
  CharCodes3[CharCodes3["Amp"] = 38] = "Amp";
  CharCodes3[CharCodes3["SingleQuote"] = 39] = "SingleQuote";
  CharCodes3[CharCodes3["DoubleQuote"] = 34] = "DoubleQuote";
  CharCodes3[CharCodes3["Dash"] = 45] = "Dash";
  CharCodes3[CharCodes3["Slash"] = 47] = "Slash";
  CharCodes3[CharCodes3["Zero"] = 48] = "Zero";
  CharCodes3[CharCodes3["Nine"] = 57] = "Nine";
  CharCodes3[CharCodes3["Semi"] = 59] = "Semi";
  CharCodes3[CharCodes3["Lt"] = 60] = "Lt";
  CharCodes3[CharCodes3["Eq"] = 61] = "Eq";
  CharCodes3[CharCodes3["Gt"] = 62] = "Gt";
  CharCodes3[CharCodes3["Questionmark"] = 63] = "Questionmark";
  CharCodes3[CharCodes3["UpperA"] = 65] = "UpperA";
  CharCodes3[CharCodes3["LowerA"] = 97] = "LowerA";
  CharCodes3[CharCodes3["UpperF"] = 70] = "UpperF";
  CharCodes3[CharCodes3["LowerF"] = 102] = "LowerF";
  CharCodes3[CharCodes3["UpperZ"] = 90] = "UpperZ";
  CharCodes3[CharCodes3["LowerZ"] = 122] = "LowerZ";
  CharCodes3[CharCodes3["LowerX"] = 120] = "LowerX";
  CharCodes3[CharCodes3["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})(CharCodes2 || (CharCodes2 = {}));
var State;
(function(State2) {
  State2[State2["Text"] = 1] = "Text";
  State2[State2["BeforeTagName"] = 2] = "BeforeTagName";
  State2[State2["InTagName"] = 3] = "InTagName";
  State2[State2["InSelfClosingTag"] = 4] = "InSelfClosingTag";
  State2[State2["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
  State2[State2["InClosingTagName"] = 6] = "InClosingTagName";
  State2[State2["AfterClosingTagName"] = 7] = "AfterClosingTagName";
  State2[State2["BeforeAttributeName"] = 8] = "BeforeAttributeName";
  State2[State2["InAttributeName"] = 9] = "InAttributeName";
  State2[State2["AfterAttributeName"] = 10] = "AfterAttributeName";
  State2[State2["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
  State2[State2["InAttributeValueDq"] = 12] = "InAttributeValueDq";
  State2[State2["InAttributeValueSq"] = 13] = "InAttributeValueSq";
  State2[State2["InAttributeValueNq"] = 14] = "InAttributeValueNq";
  State2[State2["BeforeDeclaration"] = 15] = "BeforeDeclaration";
  State2[State2["InDeclaration"] = 16] = "InDeclaration";
  State2[State2["InProcessingInstruction"] = 17] = "InProcessingInstruction";
  State2[State2["BeforeComment"] = 18] = "BeforeComment";
  State2[State2["CDATASequence"] = 19] = "CDATASequence";
  State2[State2["InSpecialComment"] = 20] = "InSpecialComment";
  State2[State2["InCommentLike"] = 21] = "InCommentLike";
  State2[State2["BeforeSpecialS"] = 22] = "BeforeSpecialS";
  State2[State2["SpecialStartSequence"] = 23] = "SpecialStartSequence";
  State2[State2["InSpecialTag"] = 24] = "InSpecialTag";
  State2[State2["BeforeEntity"] = 25] = "BeforeEntity";
  State2[State2["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
  State2[State2["InNamedEntity"] = 27] = "InNamedEntity";
  State2[State2["InNumericEntity"] = 28] = "InNumericEntity";
  State2[State2["InHexEntity"] = 29] = "InHexEntity";
})(State || (State = {}));
function isWhitespace(c2) {
  return c2 === CharCodes2.Space || c2 === CharCodes2.NewLine || c2 === CharCodes2.Tab || c2 === CharCodes2.FormFeed || c2 === CharCodes2.CarriageReturn;
}
__name(isWhitespace, "isWhitespace");
function isEndOfTagSection(c2) {
  return c2 === CharCodes2.Slash || c2 === CharCodes2.Gt || isWhitespace(c2);
}
__name(isEndOfTagSection, "isEndOfTagSection");
function isNumber3(c2) {
  return c2 >= CharCodes2.Zero && c2 <= CharCodes2.Nine;
}
__name(isNumber3, "isNumber");
function isASCIIAlpha(c2) {
  return c2 >= CharCodes2.LowerA && c2 <= CharCodes2.LowerZ || c2 >= CharCodes2.UpperA && c2 <= CharCodes2.UpperZ;
}
__name(isASCIIAlpha, "isASCIIAlpha");
function isHexDigit(c2) {
  return c2 >= CharCodes2.UpperA && c2 <= CharCodes2.UpperF || c2 >= CharCodes2.LowerA && c2 <= CharCodes2.LowerF;
}
__name(isHexDigit, "isHexDigit");
var QuoteType;
(function(QuoteType2) {
  QuoteType2[QuoteType2["NoValue"] = 0] = "NoValue";
  QuoteType2[QuoteType2["Unquoted"] = 1] = "Unquoted";
  QuoteType2[QuoteType2["Single"] = 2] = "Single";
  QuoteType2[QuoteType2["Double"] = 3] = "Double";
})(QuoteType || (QuoteType = {}));
var Sequences = {
  Cdata: new Uint8Array([
    67,
    68,
    65,
    84,
    65,
    91
  ]),
  CdataEnd: new Uint8Array([
    93,
    93,
    62
  ]),
  CommentEnd: new Uint8Array([
    45,
    45,
    62
  ]),
  ScriptEnd: new Uint8Array([
    60,
    47,
    115,
    99,
    114,
    105,
    112,
    116
  ]),
  StyleEnd: new Uint8Array([
    60,
    47,
    115,
    116,
    121,
    108,
    101
  ]),
  TitleEnd: new Uint8Array([
    60,
    47,
    116,
    105,
    116,
    108,
    101
  ])
};
var _Tokenizer = class _Tokenizer {
  constructor({ xmlMode = false, decodeEntities = true }, cbs) {
    this.cbs = cbs;
    this.state = State.Text;
    this.buffer = "";
    this.sectionStart = 0;
    this.index = 0;
    this.baseState = State.Text;
    this.isSpecial = false;
    this.running = true;
    this.offset = 0;
    this.currentSequence = void 0;
    this.sequenceIndex = 0;
    this.trieIndex = 0;
    this.trieCurrent = 0;
    this.entityResult = 0;
    this.entityExcess = 0;
    this.xmlMode = xmlMode;
    this.decodeEntities = decodeEntities;
    this.entityTrie = xmlMode ? decode_data_xml_default : decode_data_html_default;
  }
  reset() {
    this.state = State.Text;
    this.buffer = "";
    this.sectionStart = 0;
    this.index = 0;
    this.baseState = State.Text;
    this.currentSequence = void 0;
    this.running = true;
    this.offset = 0;
  }
  write(chunk) {
    this.offset += this.buffer.length;
    this.buffer = chunk;
    this.parse();
  }
  end() {
    if (this.running) this.finish();
  }
  pause() {
    this.running = false;
  }
  resume() {
    this.running = true;
    if (this.index < this.buffer.length + this.offset) {
      this.parse();
    }
  }
  /**
   * The current index within all of the written data.
   */
  getIndex() {
    return this.index;
  }
  /**
   * The start of the current section.
   */
  getSectionStart() {
    return this.sectionStart;
  }
  stateText(c2) {
    if (c2 === CharCodes2.Lt || !this.decodeEntities && this.fastForwardTo(CharCodes2.Lt)) {
      if (this.index > this.sectionStart) {
        this.cbs.ontext(this.sectionStart, this.index);
      }
      this.state = State.BeforeTagName;
      this.sectionStart = this.index;
    } else if (this.decodeEntities && c2 === CharCodes2.Amp) {
      this.state = State.BeforeEntity;
    }
  }
  stateSpecialStartSequence(c2) {
    const isEnd = this.sequenceIndex === this.currentSequence.length;
    const isMatch = isEnd ? isEndOfTagSection(c2) : (c2 | 32) === this.currentSequence[this.sequenceIndex];
    if (!isMatch) {
      this.isSpecial = false;
    } else if (!isEnd) {
      this.sequenceIndex++;
      return;
    }
    this.sequenceIndex = 0;
    this.state = State.InTagName;
    this.stateInTagName(c2);
  }
  /** Look for an end tag. For <title> tags, also decode entities. */
  stateInSpecialTag(c2) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (c2 === CharCodes2.Gt || isWhitespace(c2)) {
        const endOfText = this.index - this.currentSequence.length;
        if (this.sectionStart < endOfText) {
          const actualIndex = this.index;
          this.index = endOfText;
          this.cbs.ontext(this.sectionStart, endOfText);
          this.index = actualIndex;
        }
        this.isSpecial = false;
        this.sectionStart = endOfText + 2;
        this.stateInClosingTagName(c2);
        return;
      }
      this.sequenceIndex = 0;
    }
    if ((c2 | 32) === this.currentSequence[this.sequenceIndex]) {
      this.sequenceIndex += 1;
    } else if (this.sequenceIndex === 0) {
      if (this.currentSequence === Sequences.TitleEnd) {
        if (this.decodeEntities && c2 === CharCodes2.Amp) {
          this.state = State.BeforeEntity;
        }
      } else if (this.fastForwardTo(CharCodes2.Lt)) {
        this.sequenceIndex = 1;
      }
    } else {
      this.sequenceIndex = Number(c2 === CharCodes2.Lt);
    }
  }
  stateCDATASequence(c2) {
    if (c2 === Sequences.Cdata[this.sequenceIndex]) {
      if (++this.sequenceIndex === Sequences.Cdata.length) {
        this.state = State.InCommentLike;
        this.currentSequence = Sequences.CdataEnd;
        this.sequenceIndex = 0;
        this.sectionStart = this.index + 1;
      }
    } else {
      this.sequenceIndex = 0;
      this.state = State.InDeclaration;
      this.stateInDeclaration(c2);
    }
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */
  fastForwardTo(c2) {
    while (++this.index < this.buffer.length + this.offset) {
      if (this.buffer.charCodeAt(this.index - this.offset) === c2) {
        return true;
      }
    }
    this.index = this.buffer.length + this.offset - 1;
    return false;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */
  stateInCommentLike(c2) {
    if (c2 === this.currentSequence[this.sequenceIndex]) {
      if (++this.sequenceIndex === this.currentSequence.length) {
        if (this.currentSequence === Sequences.CdataEnd) {
          this.cbs.oncdata(this.sectionStart, this.index, 2);
        } else {
          this.cbs.oncomment(this.sectionStart, this.index, 2);
        }
        this.sequenceIndex = 0;
        this.sectionStart = this.index + 1;
        this.state = State.Text;
      }
    } else if (this.sequenceIndex === 0) {
      if (this.fastForwardTo(this.currentSequence[0])) {
        this.sequenceIndex = 1;
      }
    } else if (c2 !== this.currentSequence[this.sequenceIndex - 1]) {
      this.sequenceIndex = 0;
    }
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   */
  isTagStartChar(c2) {
    return this.xmlMode ? !isEndOfTagSection(c2) : isASCIIAlpha(c2);
  }
  startSpecial(sequence, offset2) {
    this.isSpecial = true;
    this.currentSequence = sequence;
    this.sequenceIndex = offset2;
    this.state = State.SpecialStartSequence;
  }
  stateBeforeTagName(c2) {
    if (c2 === CharCodes2.ExclamationMark) {
      this.state = State.BeforeDeclaration;
      this.sectionStart = this.index + 1;
    } else if (c2 === CharCodes2.Questionmark) {
      this.state = State.InProcessingInstruction;
      this.sectionStart = this.index + 1;
    } else if (this.isTagStartChar(c2)) {
      const lower = c2 | 32;
      this.sectionStart = this.index;
      if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
        this.startSpecial(Sequences.TitleEnd, 3);
      } else {
        this.state = !this.xmlMode && lower === Sequences.ScriptEnd[2] ? State.BeforeSpecialS : State.InTagName;
      }
    } else if (c2 === CharCodes2.Slash) {
      this.state = State.BeforeClosingTagName;
    } else {
      this.state = State.Text;
      this.stateText(c2);
    }
  }
  stateInTagName(c2) {
    if (isEndOfTagSection(c2)) {
      this.cbs.onopentagname(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c2);
    }
  }
  stateBeforeClosingTagName(c2) {
    if (isWhitespace(c2)) {
    } else if (c2 === CharCodes2.Gt) {
      this.state = State.Text;
    } else {
      this.state = this.isTagStartChar(c2) ? State.InClosingTagName : State.InSpecialComment;
      this.sectionStart = this.index;
    }
  }
  stateInClosingTagName(c2) {
    if (c2 === CharCodes2.Gt || isWhitespace(c2)) {
      this.cbs.onclosetag(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = State.AfterClosingTagName;
      this.stateAfterClosingTagName(c2);
    }
  }
  stateAfterClosingTagName(c2) {
    if (c2 === CharCodes2.Gt || this.fastForwardTo(CharCodes2.Gt)) {
      this.state = State.Text;
      this.baseState = State.Text;
      this.sectionStart = this.index + 1;
    }
  }
  stateBeforeAttributeName(c2) {
    if (c2 === CharCodes2.Gt) {
      this.cbs.onopentagend(this.index);
      if (this.isSpecial) {
        this.state = State.InSpecialTag;
        this.sequenceIndex = 0;
      } else {
        this.state = State.Text;
      }
      this.baseState = this.state;
      this.sectionStart = this.index + 1;
    } else if (c2 === CharCodes2.Slash) {
      this.state = State.InSelfClosingTag;
    } else if (!isWhitespace(c2)) {
      this.state = State.InAttributeName;
      this.sectionStart = this.index;
    }
  }
  stateInSelfClosingTag(c2) {
    if (c2 === CharCodes2.Gt) {
      this.cbs.onselfclosingtag(this.index);
      this.state = State.Text;
      this.baseState = State.Text;
      this.sectionStart = this.index + 1;
      this.isSpecial = false;
    } else if (!isWhitespace(c2)) {
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c2);
    }
  }
  stateInAttributeName(c2) {
    if (c2 === CharCodes2.Eq || isEndOfTagSection(c2)) {
      this.cbs.onattribname(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = State.AfterAttributeName;
      this.stateAfterAttributeName(c2);
    }
  }
  stateAfterAttributeName(c2) {
    if (c2 === CharCodes2.Eq) {
      this.state = State.BeforeAttributeValue;
    } else if (c2 === CharCodes2.Slash || c2 === CharCodes2.Gt) {
      this.cbs.onattribend(QuoteType.NoValue, this.index);
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c2);
    } else if (!isWhitespace(c2)) {
      this.cbs.onattribend(QuoteType.NoValue, this.index);
      this.state = State.InAttributeName;
      this.sectionStart = this.index;
    }
  }
  stateBeforeAttributeValue(c2) {
    if (c2 === CharCodes2.DoubleQuote) {
      this.state = State.InAttributeValueDq;
      this.sectionStart = this.index + 1;
    } else if (c2 === CharCodes2.SingleQuote) {
      this.state = State.InAttributeValueSq;
      this.sectionStart = this.index + 1;
    } else if (!isWhitespace(c2)) {
      this.sectionStart = this.index;
      this.state = State.InAttributeValueNq;
      this.stateInAttributeValueNoQuotes(c2);
    }
  }
  handleInAttributeValue(c2, quote) {
    if (c2 === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
      this.cbs.onattribdata(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.cbs.onattribend(quote === CharCodes2.DoubleQuote ? QuoteType.Double : QuoteType.Single, this.index);
      this.state = State.BeforeAttributeName;
    } else if (this.decodeEntities && c2 === CharCodes2.Amp) {
      this.baseState = this.state;
      this.state = State.BeforeEntity;
    }
  }
  stateInAttributeValueDoubleQuotes(c2) {
    this.handleInAttributeValue(c2, CharCodes2.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(c2) {
    this.handleInAttributeValue(c2, CharCodes2.SingleQuote);
  }
  stateInAttributeValueNoQuotes(c2) {
    if (isWhitespace(c2) || c2 === CharCodes2.Gt) {
      this.cbs.onattribdata(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.cbs.onattribend(QuoteType.Unquoted, this.index);
      this.state = State.BeforeAttributeName;
      this.stateBeforeAttributeName(c2);
    } else if (this.decodeEntities && c2 === CharCodes2.Amp) {
      this.baseState = this.state;
      this.state = State.BeforeEntity;
    }
  }
  stateBeforeDeclaration(c2) {
    if (c2 === CharCodes2.OpeningSquareBracket) {
      this.state = State.CDATASequence;
      this.sequenceIndex = 0;
    } else {
      this.state = c2 === CharCodes2.Dash ? State.BeforeComment : State.InDeclaration;
    }
  }
  stateInDeclaration(c2) {
    if (c2 === CharCodes2.Gt || this.fastForwardTo(CharCodes2.Gt)) {
      this.cbs.ondeclaration(this.sectionStart, this.index);
      this.state = State.Text;
      this.sectionStart = this.index + 1;
    }
  }
  stateInProcessingInstruction(c2) {
    if (c2 === CharCodes2.Gt || this.fastForwardTo(CharCodes2.Gt)) {
      this.cbs.onprocessinginstruction(this.sectionStart, this.index);
      this.state = State.Text;
      this.sectionStart = this.index + 1;
    }
  }
  stateBeforeComment(c2) {
    if (c2 === CharCodes2.Dash) {
      this.state = State.InCommentLike;
      this.currentSequence = Sequences.CommentEnd;
      this.sequenceIndex = 2;
      this.sectionStart = this.index + 1;
    } else {
      this.state = State.InDeclaration;
    }
  }
  stateInSpecialComment(c2) {
    if (c2 === CharCodes2.Gt || this.fastForwardTo(CharCodes2.Gt)) {
      this.cbs.oncomment(this.sectionStart, this.index, 0);
      this.state = State.Text;
      this.sectionStart = this.index + 1;
    }
  }
  stateBeforeSpecialS(c2) {
    const lower = c2 | 32;
    if (lower === Sequences.ScriptEnd[3]) {
      this.startSpecial(Sequences.ScriptEnd, 4);
    } else if (lower === Sequences.StyleEnd[3]) {
      this.startSpecial(Sequences.StyleEnd, 4);
    } else {
      this.state = State.InTagName;
      this.stateInTagName(c2);
    }
  }
  stateBeforeEntity(c2) {
    this.entityExcess = 1;
    this.entityResult = 0;
    if (c2 === CharCodes2.Number) {
      this.state = State.BeforeNumericEntity;
    } else if (c2 === CharCodes2.Amp) {
    } else {
      this.trieIndex = 0;
      this.trieCurrent = this.entityTrie[0];
      this.state = State.InNamedEntity;
      this.stateInNamedEntity(c2);
    }
  }
  stateInNamedEntity(c2) {
    this.entityExcess += 1;
    this.trieIndex = determineBranch(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c2);
    if (this.trieIndex < 0) {
      this.emitNamedEntity();
      this.index--;
      return;
    }
    this.trieCurrent = this.entityTrie[this.trieIndex];
    const masked = this.trieCurrent & BinTrieFlags.VALUE_LENGTH;
    if (masked) {
      const valueLength = (masked >> 14) - 1;
      if (!this.allowLegacyEntity() && c2 !== CharCodes2.Semi) {
        this.trieIndex += valueLength;
      } else {
        const entityStart = this.index - this.entityExcess + 1;
        if (entityStart > this.sectionStart) {
          this.emitPartial(this.sectionStart, entityStart);
        }
        this.entityResult = this.trieIndex;
        this.trieIndex += valueLength;
        this.entityExcess = 0;
        this.sectionStart = this.index + 1;
        if (valueLength === 0) {
          this.emitNamedEntity();
        }
      }
    }
  }
  emitNamedEntity() {
    this.state = this.baseState;
    if (this.entityResult === 0) {
      return;
    }
    const valueLength = (this.entityTrie[this.entityResult] & BinTrieFlags.VALUE_LENGTH) >> 14;
    switch (valueLength) {
      case 1: {
        this.emitCodePoint(this.entityTrie[this.entityResult] & ~BinTrieFlags.VALUE_LENGTH);
        break;
      }
      case 2: {
        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
        break;
      }
      case 3: {
        this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
        this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
      }
    }
  }
  stateBeforeNumericEntity(c2) {
    if ((c2 | 32) === CharCodes2.LowerX) {
      this.entityExcess++;
      this.state = State.InHexEntity;
    } else {
      this.state = State.InNumericEntity;
      this.stateInNumericEntity(c2);
    }
  }
  emitNumericEntity(strict) {
    const entityStart = this.index - this.entityExcess - 1;
    const numberStart = entityStart + 2 + Number(this.state === State.InHexEntity);
    if (numberStart !== this.index) {
      if (entityStart > this.sectionStart) {
        this.emitPartial(this.sectionStart, entityStart);
      }
      this.sectionStart = this.index + Number(strict);
      this.emitCodePoint(replaceCodePoint(this.entityResult));
    }
    this.state = this.baseState;
  }
  stateInNumericEntity(c2) {
    if (c2 === CharCodes2.Semi) {
      this.emitNumericEntity(true);
    } else if (isNumber3(c2)) {
      this.entityResult = this.entityResult * 10 + (c2 - CharCodes2.Zero);
      this.entityExcess++;
    } else {
      if (this.allowLegacyEntity()) {
        this.emitNumericEntity(false);
      } else {
        this.state = this.baseState;
      }
      this.index--;
    }
  }
  stateInHexEntity(c2) {
    if (c2 === CharCodes2.Semi) {
      this.emitNumericEntity(true);
    } else if (isNumber3(c2)) {
      this.entityResult = this.entityResult * 16 + (c2 - CharCodes2.Zero);
      this.entityExcess++;
    } else if (isHexDigit(c2)) {
      this.entityResult = this.entityResult * 16 + ((c2 | 32) - CharCodes2.LowerA + 10);
      this.entityExcess++;
    } else {
      if (this.allowLegacyEntity()) {
        this.emitNumericEntity(false);
      } else {
        this.state = this.baseState;
      }
      this.index--;
    }
  }
  allowLegacyEntity() {
    return !this.xmlMode && (this.baseState === State.Text || this.baseState === State.InSpecialTag);
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    if (this.running && this.sectionStart !== this.index) {
      if (this.state === State.Text || this.state === State.InSpecialTag && this.sequenceIndex === 0) {
        this.cbs.ontext(this.sectionStart, this.index);
        this.sectionStart = this.index;
      } else if (this.state === State.InAttributeValueDq || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueNq) {
        this.cbs.onattribdata(this.sectionStart, this.index);
        this.sectionStart = this.index;
      }
    }
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    while (this.shouldContinue()) {
      const c2 = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case State.Text: {
          this.stateText(c2);
          break;
        }
        case State.SpecialStartSequence: {
          this.stateSpecialStartSequence(c2);
          break;
        }
        case State.InSpecialTag: {
          this.stateInSpecialTag(c2);
          break;
        }
        case State.CDATASequence: {
          this.stateCDATASequence(c2);
          break;
        }
        case State.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(c2);
          break;
        }
        case State.InAttributeName: {
          this.stateInAttributeName(c2);
          break;
        }
        case State.InCommentLike: {
          this.stateInCommentLike(c2);
          break;
        }
        case State.InSpecialComment: {
          this.stateInSpecialComment(c2);
          break;
        }
        case State.BeforeAttributeName: {
          this.stateBeforeAttributeName(c2);
          break;
        }
        case State.InTagName: {
          this.stateInTagName(c2);
          break;
        }
        case State.InClosingTagName: {
          this.stateInClosingTagName(c2);
          break;
        }
        case State.BeforeTagName: {
          this.stateBeforeTagName(c2);
          break;
        }
        case State.AfterAttributeName: {
          this.stateAfterAttributeName(c2);
          break;
        }
        case State.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(c2);
          break;
        }
        case State.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(c2);
          break;
        }
        case State.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(c2);
          break;
        }
        case State.AfterClosingTagName: {
          this.stateAfterClosingTagName(c2);
          break;
        }
        case State.BeforeSpecialS: {
          this.stateBeforeSpecialS(c2);
          break;
        }
        case State.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(c2);
          break;
        }
        case State.InSelfClosingTag: {
          this.stateInSelfClosingTag(c2);
          break;
        }
        case State.InDeclaration: {
          this.stateInDeclaration(c2);
          break;
        }
        case State.BeforeDeclaration: {
          this.stateBeforeDeclaration(c2);
          break;
        }
        case State.BeforeComment: {
          this.stateBeforeComment(c2);
          break;
        }
        case State.InProcessingInstruction: {
          this.stateInProcessingInstruction(c2);
          break;
        }
        case State.InNamedEntity: {
          this.stateInNamedEntity(c2);
          break;
        }
        case State.BeforeEntity: {
          this.stateBeforeEntity(c2);
          break;
        }
        case State.InHexEntity: {
          this.stateInHexEntity(c2);
          break;
        }
        case State.InNumericEntity: {
          this.stateInNumericEntity(c2);
          break;
        }
        default: {
          this.stateBeforeNumericEntity(c2);
        }
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    if (this.state === State.InNamedEntity) {
      this.emitNamedEntity();
    }
    if (this.sectionStart < this.index) {
      this.handleTrailingData();
    }
    this.cbs.onend();
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const endIndex = this.buffer.length + this.offset;
    if (this.state === State.InCommentLike) {
      if (this.currentSequence === Sequences.CdataEnd) {
        this.cbs.oncdata(this.sectionStart, endIndex, 0);
      } else {
        this.cbs.oncomment(this.sectionStart, endIndex, 0);
      }
    } else if (this.state === State.InNumericEntity && this.allowLegacyEntity()) {
      this.emitNumericEntity(false);
    } else if (this.state === State.InHexEntity && this.allowLegacyEntity()) {
      this.emitNumericEntity(false);
    } else if (this.state === State.InTagName || this.state === State.BeforeAttributeName || this.state === State.BeforeAttributeValue || this.state === State.AfterAttributeName || this.state === State.InAttributeName || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueDq || this.state === State.InAttributeValueNq || this.state === State.InClosingTagName) {
    } else {
      this.cbs.ontext(this.sectionStart, endIndex);
    }
  }
  emitPartial(start, endIndex) {
    if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
      this.cbs.onattribdata(start, endIndex);
    } else {
      this.cbs.ontext(start, endIndex);
    }
  }
  emitCodePoint(cp) {
    if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
      this.cbs.onattribentity(cp);
    } else {
      this.cbs.ontextentity(cp);
    }
  }
};
__name(_Tokenizer, "Tokenizer");
var Tokenizer = _Tokenizer;

// ../../node_modules/.pnpm/htmlparser2@8.0.2/node_modules/htmlparser2/lib/esm/Parser.js
var formTags = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]);
var pTag = /* @__PURE__ */ new Set([
  "p"
]);
var tableSectionTags = /* @__PURE__ */ new Set([
  "thead",
  "tbody"
]);
var ddtTags = /* @__PURE__ */ new Set([
  "dd",
  "dt"
]);
var rtpTags = /* @__PURE__ */ new Set([
  "rt",
  "rp"
]);
var openImpliesClose = /* @__PURE__ */ new Map([
  [
    "tr",
    /* @__PURE__ */ new Set([
      "tr",
      "th",
      "td"
    ])
  ],
  [
    "th",
    /* @__PURE__ */ new Set([
      "th"
    ])
  ],
  [
    "td",
    /* @__PURE__ */ new Set([
      "thead",
      "th",
      "td"
    ])
  ],
  [
    "body",
    /* @__PURE__ */ new Set([
      "head",
      "link",
      "script"
    ])
  ],
  [
    "li",
    /* @__PURE__ */ new Set([
      "li"
    ])
  ],
  [
    "p",
    pTag
  ],
  [
    "h1",
    pTag
  ],
  [
    "h2",
    pTag
  ],
  [
    "h3",
    pTag
  ],
  [
    "h4",
    pTag
  ],
  [
    "h5",
    pTag
  ],
  [
    "h6",
    pTag
  ],
  [
    "select",
    formTags
  ],
  [
    "input",
    formTags
  ],
  [
    "output",
    formTags
  ],
  [
    "button",
    formTags
  ],
  [
    "datalist",
    formTags
  ],
  [
    "textarea",
    formTags
  ],
  [
    "option",
    /* @__PURE__ */ new Set([
      "option"
    ])
  ],
  [
    "optgroup",
    /* @__PURE__ */ new Set([
      "optgroup",
      "option"
    ])
  ],
  [
    "dd",
    ddtTags
  ],
  [
    "dt",
    ddtTags
  ],
  [
    "address",
    pTag
  ],
  [
    "article",
    pTag
  ],
  [
    "aside",
    pTag
  ],
  [
    "blockquote",
    pTag
  ],
  [
    "details",
    pTag
  ],
  [
    "div",
    pTag
  ],
  [
    "dl",
    pTag
  ],
  [
    "fieldset",
    pTag
  ],
  [
    "figcaption",
    pTag
  ],
  [
    "figure",
    pTag
  ],
  [
    "footer",
    pTag
  ],
  [
    "form",
    pTag
  ],
  [
    "header",
    pTag
  ],
  [
    "hr",
    pTag
  ],
  [
    "main",
    pTag
  ],
  [
    "nav",
    pTag
  ],
  [
    "ol",
    pTag
  ],
  [
    "pre",
    pTag
  ],
  [
    "section",
    pTag
  ],
  [
    "table",
    pTag
  ],
  [
    "ul",
    pTag
  ],
  [
    "rt",
    rtpTags
  ],
  [
    "rp",
    rtpTags
  ],
  [
    "tbody",
    tableSectionTags
  ],
  [
    "tfoot",
    tableSectionTags
  ]
]);
var voidElements = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
var foreignContextElements = /* @__PURE__ */ new Set([
  "math",
  "svg"
]);
var htmlIntegrationElements = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]);
var reNameEnd = /\s|\//;
var _Parser = class _Parser {
  constructor(cbs, options = {}) {
    var _a6, _b, _c, _d, _e;
    this.options = options;
    this.startIndex = 0;
    this.endIndex = 0;
    this.openTagStart = 0;
    this.tagname = "";
    this.attribname = "";
    this.attribvalue = "";
    this.attribs = null;
    this.stack = [];
    this.foreignContext = [];
    this.buffers = [];
    this.bufferOffset = 0;
    this.writeIndex = 0;
    this.ended = false;
    this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
    this.lowerCaseTagNames = (_a6 = options.lowerCaseTags) !== null && _a6 !== void 0 ? _a6 : !options.xmlMode;
    this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
    this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer)(this.options, this);
    (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
  }
  // Tokenizer event handlers
  /** @internal */
  ontext(start, endIndex) {
    var _a6, _b;
    const data = this.getSlice(start, endIndex);
    this.endIndex = endIndex - 1;
    (_b = (_a6 = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a6, data);
    this.startIndex = endIndex;
  }
  /** @internal */
  ontextentity(cp) {
    var _a6, _b;
    const index = this.tokenizer.getSectionStart();
    this.endIndex = index - 1;
    (_b = (_a6 = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a6, fromCodePoint(cp));
    this.startIndex = index;
  }
  isVoidElement(name2) {
    return !this.options.xmlMode && voidElements.has(name2);
  }
  /** @internal */
  onopentagname(start, endIndex) {
    this.endIndex = endIndex;
    let name2 = this.getSlice(start, endIndex);
    if (this.lowerCaseTagNames) {
      name2 = name2.toLowerCase();
    }
    this.emitOpenTag(name2);
  }
  emitOpenTag(name2) {
    var _a6, _b, _c, _d;
    this.openTagStart = this.startIndex;
    this.tagname = name2;
    const impliesClose = !this.options.xmlMode && openImpliesClose.get(name2);
    if (impliesClose) {
      while (this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])) {
        const element = this.stack.pop();
        (_b = (_a6 = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a6, element, true);
      }
    }
    if (!this.isVoidElement(name2)) {
      this.stack.push(name2);
      if (foreignContextElements.has(name2)) {
        this.foreignContext.push(true);
      } else if (htmlIntegrationElements.has(name2)) {
        this.foreignContext.push(false);
      }
    }
    (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name2);
    if (this.cbs.onopentag) this.attribs = {};
  }
  endOpenTag(isImplied) {
    var _a6, _b;
    this.startIndex = this.openTagStart;
    if (this.attribs) {
      (_b = (_a6 = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a6, this.tagname, this.attribs, isImplied);
      this.attribs = null;
    }
    if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
      this.cbs.onclosetag(this.tagname, true);
    }
    this.tagname = "";
  }
  /** @internal */
  onopentagend(endIndex) {
    this.endIndex = endIndex;
    this.endOpenTag(false);
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  onclosetag(start, endIndex) {
    var _a6, _b, _c, _d, _e, _f;
    this.endIndex = endIndex;
    let name2 = this.getSlice(start, endIndex);
    if (this.lowerCaseTagNames) {
      name2 = name2.toLowerCase();
    }
    if (foreignContextElements.has(name2) || htmlIntegrationElements.has(name2)) {
      this.foreignContext.pop();
    }
    if (!this.isVoidElement(name2)) {
      const pos = this.stack.lastIndexOf(name2);
      if (pos !== -1) {
        if (this.cbs.onclosetag) {
          let count = this.stack.length - pos;
          while (count--) {
            this.cbs.onclosetag(this.stack.pop(), count !== 0);
          }
        } else this.stack.length = pos;
      } else if (!this.options.xmlMode && name2 === "p") {
        this.emitOpenTag("p");
        this.closeCurrentTag(true);
      }
    } else if (!this.options.xmlMode && name2 === "br") {
      (_b = (_a6 = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a6, "br");
      (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, "br", {}, true);
      (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", false);
    }
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  onselfclosingtag(endIndex) {
    this.endIndex = endIndex;
    if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
      this.closeCurrentTag(false);
      this.startIndex = endIndex + 1;
    } else {
      this.onopentagend(endIndex);
    }
  }
  closeCurrentTag(isOpenImplied) {
    var _a6, _b;
    const name2 = this.tagname;
    this.endOpenTag(isOpenImplied);
    if (this.stack[this.stack.length - 1] === name2) {
      (_b = (_a6 = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a6, name2, !isOpenImplied);
      this.stack.pop();
    }
  }
  /** @internal */
  onattribname(start, endIndex) {
    this.startIndex = start;
    const name2 = this.getSlice(start, endIndex);
    this.attribname = this.lowerCaseAttributeNames ? name2.toLowerCase() : name2;
  }
  /** @internal */
  onattribdata(start, endIndex) {
    this.attribvalue += this.getSlice(start, endIndex);
  }
  /** @internal */
  onattribentity(cp) {
    this.attribvalue += fromCodePoint(cp);
  }
  /** @internal */
  onattribend(quote, endIndex) {
    var _a6, _b;
    this.endIndex = endIndex;
    (_b = (_a6 = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a6, this.attribname, this.attribvalue, quote === QuoteType.Double ? '"' : quote === QuoteType.Single ? "'" : quote === QuoteType.NoValue ? void 0 : null);
    if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
      this.attribs[this.attribname] = this.attribvalue;
    }
    this.attribvalue = "";
  }
  getInstructionName(value) {
    const index = value.search(reNameEnd);
    let name2 = index < 0 ? value : value.substr(0, index);
    if (this.lowerCaseTagNames) {
      name2 = name2.toLowerCase();
    }
    return name2;
  }
  /** @internal */
  ondeclaration(start, endIndex) {
    this.endIndex = endIndex;
    const value = this.getSlice(start, endIndex);
    if (this.cbs.onprocessinginstruction) {
      const name2 = this.getInstructionName(value);
      this.cbs.onprocessinginstruction(`!${name2}`, `!${value}`);
    }
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  onprocessinginstruction(start, endIndex) {
    this.endIndex = endIndex;
    const value = this.getSlice(start, endIndex);
    if (this.cbs.onprocessinginstruction) {
      const name2 = this.getInstructionName(value);
      this.cbs.onprocessinginstruction(`?${name2}`, `?${value}`);
    }
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  oncomment(start, endIndex, offset2) {
    var _a6, _b, _c, _d;
    this.endIndex = endIndex;
    (_b = (_a6 = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a6, this.getSlice(start, endIndex - offset2));
    (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  oncdata(start, endIndex, offset2) {
    var _a6, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    this.endIndex = endIndex;
    const value = this.getSlice(start, endIndex - offset2);
    if (this.options.xmlMode || this.options.recognizeCDATA) {
      (_b = (_a6 = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a6);
      (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
      (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
    } else {
      (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, `[CDATA[${value}]]`);
      (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
    }
    this.startIndex = endIndex + 1;
  }
  /** @internal */
  onend() {
    var _a6, _b;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true)) ;
    }
    (_b = (_a6 = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a6);
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    var _a6, _b, _c, _d;
    (_b = (_a6 = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a6);
    this.tokenizer.reset();
    this.tagname = "";
    this.attribname = "";
    this.attribs = null;
    this.stack.length = 0;
    this.startIndex = 0;
    this.endIndex = 0;
    (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
    this.buffers.length = 0;
    this.bufferOffset = 0;
    this.writeIndex = 0;
    this.ended = false;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   *
   * @param data Document to parse.
   */
  parseComplete(data) {
    this.reset();
    this.end(data);
  }
  getSlice(start, end) {
    while (start - this.bufferOffset >= this.buffers[0].length) {
      this.shiftBuffer();
    }
    let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
    while (end - this.bufferOffset > this.buffers[0].length) {
      this.shiftBuffer();
      slice += this.buffers[0].slice(0, end - this.bufferOffset);
    }
    return slice;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length;
    this.writeIndex--;
    this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   *
   * @param chunk Chunk to parse.
   */
  write(chunk) {
    var _a6, _b;
    if (this.ended) {
      (_b = (_a6 = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a6, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(chunk);
    if (this.tokenizer.running) {
      this.tokenizer.write(chunk);
      this.writeIndex++;
    }
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   *
   * @param chunk Optional final chunk to parse.
   */
  end(chunk) {
    var _a6, _b;
    if (this.ended) {
      (_b = (_a6 = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a6, new Error(".end() after done!"));
      return;
    }
    if (chunk) this.write(chunk);
    this.ended = true;
    this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    this.tokenizer.resume();
    while (this.tokenizer.running && this.writeIndex < this.buffers.length) {
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    }
    if (this.ended) this.tokenizer.end();
  }
  /**
   * Alias of `write`, for backwards compatibility.
   *
   * @param chunk Chunk to parse.
   * @deprecated
   */
  parseChunk(chunk) {
    this.write(chunk);
  }
  /**
   * Alias of `end`, for backwards compatibility.
   *
   * @param chunk Optional final chunk to parse.
   * @deprecated
   */
  done(chunk) {
    this.end(chunk);
  }
};
__name(_Parser, "Parser");
var Parser = _Parser;

// ../../node_modules/.pnpm/domutils@3.1.0/node_modules/domutils/lib/esm/index.js
var esm_exports2 = {};
__export(esm_exports2, {
  DocumentPosition: () => DocumentPosition,
  append: () => append,
  appendChild: () => appendChild,
  compareDocumentPosition: () => compareDocumentPosition,
  existsOne: () => existsOne,
  filter: () => filter,
  find: () => find,
  findAll: () => findAll,
  findOne: () => findOne,
  findOneChild: () => findOneChild,
  getAttributeValue: () => getAttributeValue,
  getChildren: () => getChildren,
  getElementById: () => getElementById,
  getElements: () => getElements,
  getElementsByTagName: () => getElementsByTagName,
  getElementsByTagType: () => getElementsByTagType,
  getFeed: () => getFeed,
  getInnerHTML: () => getInnerHTML,
  getName: () => getName,
  getOuterHTML: () => getOuterHTML,
  getParent: () => getParent,
  getSiblings: () => getSiblings,
  getText: () => getText,
  hasAttrib: () => hasAttrib,
  hasChildren: () => hasChildren,
  innerText: () => innerText,
  isCDATA: () => isCDATA,
  isComment: () => isComment,
  isDocument: () => isDocument,
  isTag: () => isTag2,
  isText: () => isText,
  nextElementSibling: () => nextElementSibling,
  prepend: () => prepend,
  prependChild: () => prependChild,
  prevElementSibling: () => prevElementSibling,
  removeElement: () => removeElement,
  removeSubsets: () => removeSubsets,
  replaceElement: () => replaceElement,
  testElement: () => testElement,
  textContent: () => textContent,
  uniqueSort: () => uniqueSort
});

// ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/generated/encode-html.js
function restoreDiff(arr) {
  for (let i = 1; i < arr.length; i++) {
    arr[i][0] += arr[i - 1][0] + 1;
  }
  return arr;
}
__name(restoreDiff, "restoreDiff");
var encode_html_default = new Map(/* @__PURE__ */ restoreDiff([
  [
    9,
    "&Tab;"
  ],
  [
    0,
    "&NewLine;"
  ],
  [
    22,
    "&excl;"
  ],
  [
    0,
    "&quot;"
  ],
  [
    0,
    "&num;"
  ],
  [
    0,
    "&dollar;"
  ],
  [
    0,
    "&percnt;"
  ],
  [
    0,
    "&amp;"
  ],
  [
    0,
    "&apos;"
  ],
  [
    0,
    "&lpar;"
  ],
  [
    0,
    "&rpar;"
  ],
  [
    0,
    "&ast;"
  ],
  [
    0,
    "&plus;"
  ],
  [
    0,
    "&comma;"
  ],
  [
    1,
    "&period;"
  ],
  [
    0,
    "&sol;"
  ],
  [
    10,
    "&colon;"
  ],
  [
    0,
    "&semi;"
  ],
  [
    0,
    {
      v: "&lt;",
      n: 8402,
      o: "&nvlt;"
    }
  ],
  [
    0,
    {
      v: "&equals;",
      n: 8421,
      o: "&bne;"
    }
  ],
  [
    0,
    {
      v: "&gt;",
      n: 8402,
      o: "&nvgt;"
    }
  ],
  [
    0,
    "&quest;"
  ],
  [
    0,
    "&commat;"
  ],
  [
    26,
    "&lbrack;"
  ],
  [
    0,
    "&bsol;"
  ],
  [
    0,
    "&rbrack;"
  ],
  [
    0,
    "&Hat;"
  ],
  [
    0,
    "&lowbar;"
  ],
  [
    0,
    "&DiacriticalGrave;"
  ],
  [
    5,
    {
      n: 106,
      o: "&fjlig;"
    }
  ],
  [
    20,
    "&lbrace;"
  ],
  [
    0,
    "&verbar;"
  ],
  [
    0,
    "&rbrace;"
  ],
  [
    34,
    "&nbsp;"
  ],
  [
    0,
    "&iexcl;"
  ],
  [
    0,
    "&cent;"
  ],
  [
    0,
    "&pound;"
  ],
  [
    0,
    "&curren;"
  ],
  [
    0,
    "&yen;"
  ],
  [
    0,
    "&brvbar;"
  ],
  [
    0,
    "&sect;"
  ],
  [
    0,
    "&die;"
  ],
  [
    0,
    "&copy;"
  ],
  [
    0,
    "&ordf;"
  ],
  [
    0,
    "&laquo;"
  ],
  [
    0,
    "&not;"
  ],
  [
    0,
    "&shy;"
  ],
  [
    0,
    "&circledR;"
  ],
  [
    0,
    "&macr;"
  ],
  [
    0,
    "&deg;"
  ],
  [
    0,
    "&PlusMinus;"
  ],
  [
    0,
    "&sup2;"
  ],
  [
    0,
    "&sup3;"
  ],
  [
    0,
    "&acute;"
  ],
  [
    0,
    "&micro;"
  ],
  [
    0,
    "&para;"
  ],
  [
    0,
    "&centerdot;"
  ],
  [
    0,
    "&cedil;"
  ],
  [
    0,
    "&sup1;"
  ],
  [
    0,
    "&ordm;"
  ],
  [
    0,
    "&raquo;"
  ],
  [
    0,
    "&frac14;"
  ],
  [
    0,
    "&frac12;"
  ],
  [
    0,
    "&frac34;"
  ],
  [
    0,
    "&iquest;"
  ],
  [
    0,
    "&Agrave;"
  ],
  [
    0,
    "&Aacute;"
  ],
  [
    0,
    "&Acirc;"
  ],
  [
    0,
    "&Atilde;"
  ],
  [
    0,
    "&Auml;"
  ],
  [
    0,
    "&angst;"
  ],
  [
    0,
    "&AElig;"
  ],
  [
    0,
    "&Ccedil;"
  ],
  [
    0,
    "&Egrave;"
  ],
  [
    0,
    "&Eacute;"
  ],
  [
    0,
    "&Ecirc;"
  ],
  [
    0,
    "&Euml;"
  ],
  [
    0,
    "&Igrave;"
  ],
  [
    0,
    "&Iacute;"
  ],
  [
    0,
    "&Icirc;"
  ],
  [
    0,
    "&Iuml;"
  ],
  [
    0,
    "&ETH;"
  ],
  [
    0,
    "&Ntilde;"
  ],
  [
    0,
    "&Ograve;"
  ],
  [
    0,
    "&Oacute;"
  ],
  [
    0,
    "&Ocirc;"
  ],
  [
    0,
    "&Otilde;"
  ],
  [
    0,
    "&Ouml;"
  ],
  [
    0,
    "&times;"
  ],
  [
    0,
    "&Oslash;"
  ],
  [
    0,
    "&Ugrave;"
  ],
  [
    0,
    "&Uacute;"
  ],
  [
    0,
    "&Ucirc;"
  ],
  [
    0,
    "&Uuml;"
  ],
  [
    0,
    "&Yacute;"
  ],
  [
    0,
    "&THORN;"
  ],
  [
    0,
    "&szlig;"
  ],
  [
    0,
    "&agrave;"
  ],
  [
    0,
    "&aacute;"
  ],
  [
    0,
    "&acirc;"
  ],
  [
    0,
    "&atilde;"
  ],
  [
    0,
    "&auml;"
  ],
  [
    0,
    "&aring;"
  ],
  [
    0,
    "&aelig;"
  ],
  [
    0,
    "&ccedil;"
  ],
  [
    0,
    "&egrave;"
  ],
  [
    0,
    "&eacute;"
  ],
  [
    0,
    "&ecirc;"
  ],
  [
    0,
    "&euml;"
  ],
  [
    0,
    "&igrave;"
  ],
  [
    0,
    "&iacute;"
  ],
  [
    0,
    "&icirc;"
  ],
  [
    0,
    "&iuml;"
  ],
  [
    0,
    "&eth;"
  ],
  [
    0,
    "&ntilde;"
  ],
  [
    0,
    "&ograve;"
  ],
  [
    0,
    "&oacute;"
  ],
  [
    0,
    "&ocirc;"
  ],
  [
    0,
    "&otilde;"
  ],
  [
    0,
    "&ouml;"
  ],
  [
    0,
    "&div;"
  ],
  [
    0,
    "&oslash;"
  ],
  [
    0,
    "&ugrave;"
  ],
  [
    0,
    "&uacute;"
  ],
  [
    0,
    "&ucirc;"
  ],
  [
    0,
    "&uuml;"
  ],
  [
    0,
    "&yacute;"
  ],
  [
    0,
    "&thorn;"
  ],
  [
    0,
    "&yuml;"
  ],
  [
    0,
    "&Amacr;"
  ],
  [
    0,
    "&amacr;"
  ],
  [
    0,
    "&Abreve;"
  ],
  [
    0,
    "&abreve;"
  ],
  [
    0,
    "&Aogon;"
  ],
  [
    0,
    "&aogon;"
  ],
  [
    0,
    "&Cacute;"
  ],
  [
    0,
    "&cacute;"
  ],
  [
    0,
    "&Ccirc;"
  ],
  [
    0,
    "&ccirc;"
  ],
  [
    0,
    "&Cdot;"
  ],
  [
    0,
    "&cdot;"
  ],
  [
    0,
    "&Ccaron;"
  ],
  [
    0,
    "&ccaron;"
  ],
  [
    0,
    "&Dcaron;"
  ],
  [
    0,
    "&dcaron;"
  ],
  [
    0,
    "&Dstrok;"
  ],
  [
    0,
    "&dstrok;"
  ],
  [
    0,
    "&Emacr;"
  ],
  [
    0,
    "&emacr;"
  ],
  [
    2,
    "&Edot;"
  ],
  [
    0,
    "&edot;"
  ],
  [
    0,
    "&Eogon;"
  ],
  [
    0,
    "&eogon;"
  ],
  [
    0,
    "&Ecaron;"
  ],
  [
    0,
    "&ecaron;"
  ],
  [
    0,
    "&Gcirc;"
  ],
  [
    0,
    "&gcirc;"
  ],
  [
    0,
    "&Gbreve;"
  ],
  [
    0,
    "&gbreve;"
  ],
  [
    0,
    "&Gdot;"
  ],
  [
    0,
    "&gdot;"
  ],
  [
    0,
    "&Gcedil;"
  ],
  [
    1,
    "&Hcirc;"
  ],
  [
    0,
    "&hcirc;"
  ],
  [
    0,
    "&Hstrok;"
  ],
  [
    0,
    "&hstrok;"
  ],
  [
    0,
    "&Itilde;"
  ],
  [
    0,
    "&itilde;"
  ],
  [
    0,
    "&Imacr;"
  ],
  [
    0,
    "&imacr;"
  ],
  [
    2,
    "&Iogon;"
  ],
  [
    0,
    "&iogon;"
  ],
  [
    0,
    "&Idot;"
  ],
  [
    0,
    "&imath;"
  ],
  [
    0,
    "&IJlig;"
  ],
  [
    0,
    "&ijlig;"
  ],
  [
    0,
    "&Jcirc;"
  ],
  [
    0,
    "&jcirc;"
  ],
  [
    0,
    "&Kcedil;"
  ],
  [
    0,
    "&kcedil;"
  ],
  [
    0,
    "&kgreen;"
  ],
  [
    0,
    "&Lacute;"
  ],
  [
    0,
    "&lacute;"
  ],
  [
    0,
    "&Lcedil;"
  ],
  [
    0,
    "&lcedil;"
  ],
  [
    0,
    "&Lcaron;"
  ],
  [
    0,
    "&lcaron;"
  ],
  [
    0,
    "&Lmidot;"
  ],
  [
    0,
    "&lmidot;"
  ],
  [
    0,
    "&Lstrok;"
  ],
  [
    0,
    "&lstrok;"
  ],
  [
    0,
    "&Nacute;"
  ],
  [
    0,
    "&nacute;"
  ],
  [
    0,
    "&Ncedil;"
  ],
  [
    0,
    "&ncedil;"
  ],
  [
    0,
    "&Ncaron;"
  ],
  [
    0,
    "&ncaron;"
  ],
  [
    0,
    "&napos;"
  ],
  [
    0,
    "&ENG;"
  ],
  [
    0,
    "&eng;"
  ],
  [
    0,
    "&Omacr;"
  ],
  [
    0,
    "&omacr;"
  ],
  [
    2,
    "&Odblac;"
  ],
  [
    0,
    "&odblac;"
  ],
  [
    0,
    "&OElig;"
  ],
  [
    0,
    "&oelig;"
  ],
  [
    0,
    "&Racute;"
  ],
  [
    0,
    "&racute;"
  ],
  [
    0,
    "&Rcedil;"
  ],
  [
    0,
    "&rcedil;"
  ],
  [
    0,
    "&Rcaron;"
  ],
  [
    0,
    "&rcaron;"
  ],
  [
    0,
    "&Sacute;"
  ],
  [
    0,
    "&sacute;"
  ],
  [
    0,
    "&Scirc;"
  ],
  [
    0,
    "&scirc;"
  ],
  [
    0,
    "&Scedil;"
  ],
  [
    0,
    "&scedil;"
  ],
  [
    0,
    "&Scaron;"
  ],
  [
    0,
    "&scaron;"
  ],
  [
    0,
    "&Tcedil;"
  ],
  [
    0,
    "&tcedil;"
  ],
  [
    0,
    "&Tcaron;"
  ],
  [
    0,
    "&tcaron;"
  ],
  [
    0,
    "&Tstrok;"
  ],
  [
    0,
    "&tstrok;"
  ],
  [
    0,
    "&Utilde;"
  ],
  [
    0,
    "&utilde;"
  ],
  [
    0,
    "&Umacr;"
  ],
  [
    0,
    "&umacr;"
  ],
  [
    0,
    "&Ubreve;"
  ],
  [
    0,
    "&ubreve;"
  ],
  [
    0,
    "&Uring;"
  ],
  [
    0,
    "&uring;"
  ],
  [
    0,
    "&Udblac;"
  ],
  [
    0,
    "&udblac;"
  ],
  [
    0,
    "&Uogon;"
  ],
  [
    0,
    "&uogon;"
  ],
  [
    0,
    "&Wcirc;"
  ],
  [
    0,
    "&wcirc;"
  ],
  [
    0,
    "&Ycirc;"
  ],
  [
    0,
    "&ycirc;"
  ],
  [
    0,
    "&Yuml;"
  ],
  [
    0,
    "&Zacute;"
  ],
  [
    0,
    "&zacute;"
  ],
  [
    0,
    "&Zdot;"
  ],
  [
    0,
    "&zdot;"
  ],
  [
    0,
    "&Zcaron;"
  ],
  [
    0,
    "&zcaron;"
  ],
  [
    19,
    "&fnof;"
  ],
  [
    34,
    "&imped;"
  ],
  [
    63,
    "&gacute;"
  ],
  [
    65,
    "&jmath;"
  ],
  [
    142,
    "&circ;"
  ],
  [
    0,
    "&caron;"
  ],
  [
    16,
    "&breve;"
  ],
  [
    0,
    "&DiacriticalDot;"
  ],
  [
    0,
    "&ring;"
  ],
  [
    0,
    "&ogon;"
  ],
  [
    0,
    "&DiacriticalTilde;"
  ],
  [
    0,
    "&dblac;"
  ],
  [
    51,
    "&DownBreve;"
  ],
  [
    127,
    "&Alpha;"
  ],
  [
    0,
    "&Beta;"
  ],
  [
    0,
    "&Gamma;"
  ],
  [
    0,
    "&Delta;"
  ],
  [
    0,
    "&Epsilon;"
  ],
  [
    0,
    "&Zeta;"
  ],
  [
    0,
    "&Eta;"
  ],
  [
    0,
    "&Theta;"
  ],
  [
    0,
    "&Iota;"
  ],
  [
    0,
    "&Kappa;"
  ],
  [
    0,
    "&Lambda;"
  ],
  [
    0,
    "&Mu;"
  ],
  [
    0,
    "&Nu;"
  ],
  [
    0,
    "&Xi;"
  ],
  [
    0,
    "&Omicron;"
  ],
  [
    0,
    "&Pi;"
  ],
  [
    0,
    "&Rho;"
  ],
  [
    1,
    "&Sigma;"
  ],
  [
    0,
    "&Tau;"
  ],
  [
    0,
    "&Upsilon;"
  ],
  [
    0,
    "&Phi;"
  ],
  [
    0,
    "&Chi;"
  ],
  [
    0,
    "&Psi;"
  ],
  [
    0,
    "&ohm;"
  ],
  [
    7,
    "&alpha;"
  ],
  [
    0,
    "&beta;"
  ],
  [
    0,
    "&gamma;"
  ],
  [
    0,
    "&delta;"
  ],
  [
    0,
    "&epsi;"
  ],
  [
    0,
    "&zeta;"
  ],
  [
    0,
    "&eta;"
  ],
  [
    0,
    "&theta;"
  ],
  [
    0,
    "&iota;"
  ],
  [
    0,
    "&kappa;"
  ],
  [
    0,
    "&lambda;"
  ],
  [
    0,
    "&mu;"
  ],
  [
    0,
    "&nu;"
  ],
  [
    0,
    "&xi;"
  ],
  [
    0,
    "&omicron;"
  ],
  [
    0,
    "&pi;"
  ],
  [
    0,
    "&rho;"
  ],
  [
    0,
    "&sigmaf;"
  ],
  [
    0,
    "&sigma;"
  ],
  [
    0,
    "&tau;"
  ],
  [
    0,
    "&upsi;"
  ],
  [
    0,
    "&phi;"
  ],
  [
    0,
    "&chi;"
  ],
  [
    0,
    "&psi;"
  ],
  [
    0,
    "&omega;"
  ],
  [
    7,
    "&thetasym;"
  ],
  [
    0,
    "&Upsi;"
  ],
  [
    2,
    "&phiv;"
  ],
  [
    0,
    "&piv;"
  ],
  [
    5,
    "&Gammad;"
  ],
  [
    0,
    "&digamma;"
  ],
  [
    18,
    "&kappav;"
  ],
  [
    0,
    "&rhov;"
  ],
  [
    3,
    "&epsiv;"
  ],
  [
    0,
    "&backepsilon;"
  ],
  [
    10,
    "&IOcy;"
  ],
  [
    0,
    "&DJcy;"
  ],
  [
    0,
    "&GJcy;"
  ],
  [
    0,
    "&Jukcy;"
  ],
  [
    0,
    "&DScy;"
  ],
  [
    0,
    "&Iukcy;"
  ],
  [
    0,
    "&YIcy;"
  ],
  [
    0,
    "&Jsercy;"
  ],
  [
    0,
    "&LJcy;"
  ],
  [
    0,
    "&NJcy;"
  ],
  [
    0,
    "&TSHcy;"
  ],
  [
    0,
    "&KJcy;"
  ],
  [
    1,
    "&Ubrcy;"
  ],
  [
    0,
    "&DZcy;"
  ],
  [
    0,
    "&Acy;"
  ],
  [
    0,
    "&Bcy;"
  ],
  [
    0,
    "&Vcy;"
  ],
  [
    0,
    "&Gcy;"
  ],
  [
    0,
    "&Dcy;"
  ],
  [
    0,
    "&IEcy;"
  ],
  [
    0,
    "&ZHcy;"
  ],
  [
    0,
    "&Zcy;"
  ],
  [
    0,
    "&Icy;"
  ],
  [
    0,
    "&Jcy;"
  ],
  [
    0,
    "&Kcy;"
  ],
  [
    0,
    "&Lcy;"
  ],
  [
    0,
    "&Mcy;"
  ],
  [
    0,
    "&Ncy;"
  ],
  [
    0,
    "&Ocy;"
  ],
  [
    0,
    "&Pcy;"
  ],
  [
    0,
    "&Rcy;"
  ],
  [
    0,
    "&Scy;"
  ],
  [
    0,
    "&Tcy;"
  ],
  [
    0,
    "&Ucy;"
  ],
  [
    0,
    "&Fcy;"
  ],
  [
    0,
    "&KHcy;"
  ],
  [
    0,
    "&TScy;"
  ],
  [
    0,
    "&CHcy;"
  ],
  [
    0,
    "&SHcy;"
  ],
  [
    0,
    "&SHCHcy;"
  ],
  [
    0,
    "&HARDcy;"
  ],
  [
    0,
    "&Ycy;"
  ],
  [
    0,
    "&SOFTcy;"
  ],
  [
    0,
    "&Ecy;"
  ],
  [
    0,
    "&YUcy;"
  ],
  [
    0,
    "&YAcy;"
  ],
  [
    0,
    "&acy;"
  ],
  [
    0,
    "&bcy;"
  ],
  [
    0,
    "&vcy;"
  ],
  [
    0,
    "&gcy;"
  ],
  [
    0,
    "&dcy;"
  ],
  [
    0,
    "&iecy;"
  ],
  [
    0,
    "&zhcy;"
  ],
  [
    0,
    "&zcy;"
  ],
  [
    0,
    "&icy;"
  ],
  [
    0,
    "&jcy;"
  ],
  [
    0,
    "&kcy;"
  ],
  [
    0,
    "&lcy;"
  ],
  [
    0,
    "&mcy;"
  ],
  [
    0,
    "&ncy;"
  ],
  [
    0,
    "&ocy;"
  ],
  [
    0,
    "&pcy;"
  ],
  [
    0,
    "&rcy;"
  ],
  [
    0,
    "&scy;"
  ],
  [
    0,
    "&tcy;"
  ],
  [
    0,
    "&ucy;"
  ],
  [
    0,
    "&fcy;"
  ],
  [
    0,
    "&khcy;"
  ],
  [
    0,
    "&tscy;"
  ],
  [
    0,
    "&chcy;"
  ],
  [
    0,
    "&shcy;"
  ],
  [
    0,
    "&shchcy;"
  ],
  [
    0,
    "&hardcy;"
  ],
  [
    0,
    "&ycy;"
  ],
  [
    0,
    "&softcy;"
  ],
  [
    0,
    "&ecy;"
  ],
  [
    0,
    "&yucy;"
  ],
  [
    0,
    "&yacy;"
  ],
  [
    1,
    "&iocy;"
  ],
  [
    0,
    "&djcy;"
  ],
  [
    0,
    "&gjcy;"
  ],
  [
    0,
    "&jukcy;"
  ],
  [
    0,
    "&dscy;"
  ],
  [
    0,
    "&iukcy;"
  ],
  [
    0,
    "&yicy;"
  ],
  [
    0,
    "&jsercy;"
  ],
  [
    0,
    "&ljcy;"
  ],
  [
    0,
    "&njcy;"
  ],
  [
    0,
    "&tshcy;"
  ],
  [
    0,
    "&kjcy;"
  ],
  [
    1,
    "&ubrcy;"
  ],
  [
    0,
    "&dzcy;"
  ],
  [
    7074,
    "&ensp;"
  ],
  [
    0,
    "&emsp;"
  ],
  [
    0,
    "&emsp13;"
  ],
  [
    0,
    "&emsp14;"
  ],
  [
    1,
    "&numsp;"
  ],
  [
    0,
    "&puncsp;"
  ],
  [
    0,
    "&ThinSpace;"
  ],
  [
    0,
    "&hairsp;"
  ],
  [
    0,
    "&NegativeMediumSpace;"
  ],
  [
    0,
    "&zwnj;"
  ],
  [
    0,
    "&zwj;"
  ],
  [
    0,
    "&lrm;"
  ],
  [
    0,
    "&rlm;"
  ],
  [
    0,
    "&dash;"
  ],
  [
    2,
    "&ndash;"
  ],
  [
    0,
    "&mdash;"
  ],
  [
    0,
    "&horbar;"
  ],
  [
    0,
    "&Verbar;"
  ],
  [
    1,
    "&lsquo;"
  ],
  [
    0,
    "&CloseCurlyQuote;"
  ],
  [
    0,
    "&lsquor;"
  ],
  [
    1,
    "&ldquo;"
  ],
  [
    0,
    "&CloseCurlyDoubleQuote;"
  ],
  [
    0,
    "&bdquo;"
  ],
  [
    1,
    "&dagger;"
  ],
  [
    0,
    "&Dagger;"
  ],
  [
    0,
    "&bull;"
  ],
  [
    2,
    "&nldr;"
  ],
  [
    0,
    "&hellip;"
  ],
  [
    9,
    "&permil;"
  ],
  [
    0,
    "&pertenk;"
  ],
  [
    0,
    "&prime;"
  ],
  [
    0,
    "&Prime;"
  ],
  [
    0,
    "&tprime;"
  ],
  [
    0,
    "&backprime;"
  ],
  [
    3,
    "&lsaquo;"
  ],
  [
    0,
    "&rsaquo;"
  ],
  [
    3,
    "&oline;"
  ],
  [
    2,
    "&caret;"
  ],
  [
    1,
    "&hybull;"
  ],
  [
    0,
    "&frasl;"
  ],
  [
    10,
    "&bsemi;"
  ],
  [
    7,
    "&qprime;"
  ],
  [
    7,
    {
      v: "&MediumSpace;",
      n: 8202,
      o: "&ThickSpace;"
    }
  ],
  [
    0,
    "&NoBreak;"
  ],
  [
    0,
    "&af;"
  ],
  [
    0,
    "&InvisibleTimes;"
  ],
  [
    0,
    "&ic;"
  ],
  [
    72,
    "&euro;"
  ],
  [
    46,
    "&tdot;"
  ],
  [
    0,
    "&DotDot;"
  ],
  [
    37,
    "&complexes;"
  ],
  [
    2,
    "&incare;"
  ],
  [
    4,
    "&gscr;"
  ],
  [
    0,
    "&hamilt;"
  ],
  [
    0,
    "&Hfr;"
  ],
  [
    0,
    "&Hopf;"
  ],
  [
    0,
    "&planckh;"
  ],
  [
    0,
    "&hbar;"
  ],
  [
    0,
    "&imagline;"
  ],
  [
    0,
    "&Ifr;"
  ],
  [
    0,
    "&lagran;"
  ],
  [
    0,
    "&ell;"
  ],
  [
    1,
    "&naturals;"
  ],
  [
    0,
    "&numero;"
  ],
  [
    0,
    "&copysr;"
  ],
  [
    0,
    "&weierp;"
  ],
  [
    0,
    "&Popf;"
  ],
  [
    0,
    "&Qopf;"
  ],
  [
    0,
    "&realine;"
  ],
  [
    0,
    "&real;"
  ],
  [
    0,
    "&reals;"
  ],
  [
    0,
    "&rx;"
  ],
  [
    3,
    "&trade;"
  ],
  [
    1,
    "&integers;"
  ],
  [
    2,
    "&mho;"
  ],
  [
    0,
    "&zeetrf;"
  ],
  [
    0,
    "&iiota;"
  ],
  [
    2,
    "&bernou;"
  ],
  [
    0,
    "&Cayleys;"
  ],
  [
    1,
    "&escr;"
  ],
  [
    0,
    "&Escr;"
  ],
  [
    0,
    "&Fouriertrf;"
  ],
  [
    1,
    "&Mellintrf;"
  ],
  [
    0,
    "&order;"
  ],
  [
    0,
    "&alefsym;"
  ],
  [
    0,
    "&beth;"
  ],
  [
    0,
    "&gimel;"
  ],
  [
    0,
    "&daleth;"
  ],
  [
    12,
    "&CapitalDifferentialD;"
  ],
  [
    0,
    "&dd;"
  ],
  [
    0,
    "&ee;"
  ],
  [
    0,
    "&ii;"
  ],
  [
    10,
    "&frac13;"
  ],
  [
    0,
    "&frac23;"
  ],
  [
    0,
    "&frac15;"
  ],
  [
    0,
    "&frac25;"
  ],
  [
    0,
    "&frac35;"
  ],
  [
    0,
    "&frac45;"
  ],
  [
    0,
    "&frac16;"
  ],
  [
    0,
    "&frac56;"
  ],
  [
    0,
    "&frac18;"
  ],
  [
    0,
    "&frac38;"
  ],
  [
    0,
    "&frac58;"
  ],
  [
    0,
    "&frac78;"
  ],
  [
    49,
    "&larr;"
  ],
  [
    0,
    "&ShortUpArrow;"
  ],
  [
    0,
    "&rarr;"
  ],
  [
    0,
    "&darr;"
  ],
  [
    0,
    "&harr;"
  ],
  [
    0,
    "&updownarrow;"
  ],
  [
    0,
    "&nwarr;"
  ],
  [
    0,
    "&nearr;"
  ],
  [
    0,
    "&LowerRightArrow;"
  ],
  [
    0,
    "&LowerLeftArrow;"
  ],
  [
    0,
    "&nlarr;"
  ],
  [
    0,
    "&nrarr;"
  ],
  [
    1,
    {
      v: "&rarrw;",
      n: 824,
      o: "&nrarrw;"
    }
  ],
  [
    0,
    "&Larr;"
  ],
  [
    0,
    "&Uarr;"
  ],
  [
    0,
    "&Rarr;"
  ],
  [
    0,
    "&Darr;"
  ],
  [
    0,
    "&larrtl;"
  ],
  [
    0,
    "&rarrtl;"
  ],
  [
    0,
    "&LeftTeeArrow;"
  ],
  [
    0,
    "&mapstoup;"
  ],
  [
    0,
    "&map;"
  ],
  [
    0,
    "&DownTeeArrow;"
  ],
  [
    1,
    "&hookleftarrow;"
  ],
  [
    0,
    "&hookrightarrow;"
  ],
  [
    0,
    "&larrlp;"
  ],
  [
    0,
    "&looparrowright;"
  ],
  [
    0,
    "&harrw;"
  ],
  [
    0,
    "&nharr;"
  ],
  [
    1,
    "&lsh;"
  ],
  [
    0,
    "&rsh;"
  ],
  [
    0,
    "&ldsh;"
  ],
  [
    0,
    "&rdsh;"
  ],
  [
    1,
    "&crarr;"
  ],
  [
    0,
    "&cularr;"
  ],
  [
    0,
    "&curarr;"
  ],
  [
    2,
    "&circlearrowleft;"
  ],
  [
    0,
    "&circlearrowright;"
  ],
  [
    0,
    "&leftharpoonup;"
  ],
  [
    0,
    "&DownLeftVector;"
  ],
  [
    0,
    "&RightUpVector;"
  ],
  [
    0,
    "&LeftUpVector;"
  ],
  [
    0,
    "&rharu;"
  ],
  [
    0,
    "&DownRightVector;"
  ],
  [
    0,
    "&dharr;"
  ],
  [
    0,
    "&dharl;"
  ],
  [
    0,
    "&RightArrowLeftArrow;"
  ],
  [
    0,
    "&udarr;"
  ],
  [
    0,
    "&LeftArrowRightArrow;"
  ],
  [
    0,
    "&leftleftarrows;"
  ],
  [
    0,
    "&upuparrows;"
  ],
  [
    0,
    "&rightrightarrows;"
  ],
  [
    0,
    "&ddarr;"
  ],
  [
    0,
    "&leftrightharpoons;"
  ],
  [
    0,
    "&Equilibrium;"
  ],
  [
    0,
    "&nlArr;"
  ],
  [
    0,
    "&nhArr;"
  ],
  [
    0,
    "&nrArr;"
  ],
  [
    0,
    "&DoubleLeftArrow;"
  ],
  [
    0,
    "&DoubleUpArrow;"
  ],
  [
    0,
    "&DoubleRightArrow;"
  ],
  [
    0,
    "&dArr;"
  ],
  [
    0,
    "&DoubleLeftRightArrow;"
  ],
  [
    0,
    "&DoubleUpDownArrow;"
  ],
  [
    0,
    "&nwArr;"
  ],
  [
    0,
    "&neArr;"
  ],
  [
    0,
    "&seArr;"
  ],
  [
    0,
    "&swArr;"
  ],
  [
    0,
    "&lAarr;"
  ],
  [
    0,
    "&rAarr;"
  ],
  [
    1,
    "&zigrarr;"
  ],
  [
    6,
    "&larrb;"
  ],
  [
    0,
    "&rarrb;"
  ],
  [
    15,
    "&DownArrowUpArrow;"
  ],
  [
    7,
    "&loarr;"
  ],
  [
    0,
    "&roarr;"
  ],
  [
    0,
    "&hoarr;"
  ],
  [
    0,
    "&forall;"
  ],
  [
    0,
    "&comp;"
  ],
  [
    0,
    {
      v: "&part;",
      n: 824,
      o: "&npart;"
    }
  ],
  [
    0,
    "&exist;"
  ],
  [
    0,
    "&nexist;"
  ],
  [
    0,
    "&empty;"
  ],
  [
    1,
    "&Del;"
  ],
  [
    0,
    "&Element;"
  ],
  [
    0,
    "&NotElement;"
  ],
  [
    1,
    "&ni;"
  ],
  [
    0,
    "&notni;"
  ],
  [
    2,
    "&prod;"
  ],
  [
    0,
    "&coprod;"
  ],
  [
    0,
    "&sum;"
  ],
  [
    0,
    "&minus;"
  ],
  [
    0,
    "&MinusPlus;"
  ],
  [
    0,
    "&dotplus;"
  ],
  [
    1,
    "&Backslash;"
  ],
  [
    0,
    "&lowast;"
  ],
  [
    0,
    "&compfn;"
  ],
  [
    1,
    "&radic;"
  ],
  [
    2,
    "&prop;"
  ],
  [
    0,
    "&infin;"
  ],
  [
    0,
    "&angrt;"
  ],
  [
    0,
    {
      v: "&ang;",
      n: 8402,
      o: "&nang;"
    }
  ],
  [
    0,
    "&angmsd;"
  ],
  [
    0,
    "&angsph;"
  ],
  [
    0,
    "&mid;"
  ],
  [
    0,
    "&nmid;"
  ],
  [
    0,
    "&DoubleVerticalBar;"
  ],
  [
    0,
    "&NotDoubleVerticalBar;"
  ],
  [
    0,
    "&and;"
  ],
  [
    0,
    "&or;"
  ],
  [
    0,
    {
      v: "&cap;",
      n: 65024,
      o: "&caps;"
    }
  ],
  [
    0,
    {
      v: "&cup;",
      n: 65024,
      o: "&cups;"
    }
  ],
  [
    0,
    "&int;"
  ],
  [
    0,
    "&Int;"
  ],
  [
    0,
    "&iiint;"
  ],
  [
    0,
    "&conint;"
  ],
  [
    0,
    "&Conint;"
  ],
  [
    0,
    "&Cconint;"
  ],
  [
    0,
    "&cwint;"
  ],
  [
    0,
    "&ClockwiseContourIntegral;"
  ],
  [
    0,
    "&awconint;"
  ],
  [
    0,
    "&there4;"
  ],
  [
    0,
    "&becaus;"
  ],
  [
    0,
    "&ratio;"
  ],
  [
    0,
    "&Colon;"
  ],
  [
    0,
    "&dotminus;"
  ],
  [
    1,
    "&mDDot;"
  ],
  [
    0,
    "&homtht;"
  ],
  [
    0,
    {
      v: "&sim;",
      n: 8402,
      o: "&nvsim;"
    }
  ],
  [
    0,
    {
      v: "&backsim;",
      n: 817,
      o: "&race;"
    }
  ],
  [
    0,
    {
      v: "&ac;",
      n: 819,
      o: "&acE;"
    }
  ],
  [
    0,
    "&acd;"
  ],
  [
    0,
    "&VerticalTilde;"
  ],
  [
    0,
    "&NotTilde;"
  ],
  [
    0,
    {
      v: "&eqsim;",
      n: 824,
      o: "&nesim;"
    }
  ],
  [
    0,
    "&sime;"
  ],
  [
    0,
    "&NotTildeEqual;"
  ],
  [
    0,
    "&cong;"
  ],
  [
    0,
    "&simne;"
  ],
  [
    0,
    "&ncong;"
  ],
  [
    0,
    "&ap;"
  ],
  [
    0,
    "&nap;"
  ],
  [
    0,
    "&ape;"
  ],
  [
    0,
    {
      v: "&apid;",
      n: 824,
      o: "&napid;"
    }
  ],
  [
    0,
    "&backcong;"
  ],
  [
    0,
    {
      v: "&asympeq;",
      n: 8402,
      o: "&nvap;"
    }
  ],
  [
    0,
    {
      v: "&bump;",
      n: 824,
      o: "&nbump;"
    }
  ],
  [
    0,
    {
      v: "&bumpe;",
      n: 824,
      o: "&nbumpe;"
    }
  ],
  [
    0,
    {
      v: "&doteq;",
      n: 824,
      o: "&nedot;"
    }
  ],
  [
    0,
    "&doteqdot;"
  ],
  [
    0,
    "&efDot;"
  ],
  [
    0,
    "&erDot;"
  ],
  [
    0,
    "&Assign;"
  ],
  [
    0,
    "&ecolon;"
  ],
  [
    0,
    "&ecir;"
  ],
  [
    0,
    "&circeq;"
  ],
  [
    1,
    "&wedgeq;"
  ],
  [
    0,
    "&veeeq;"
  ],
  [
    1,
    "&triangleq;"
  ],
  [
    2,
    "&equest;"
  ],
  [
    0,
    "&ne;"
  ],
  [
    0,
    {
      v: "&Congruent;",
      n: 8421,
      o: "&bnequiv;"
    }
  ],
  [
    0,
    "&nequiv;"
  ],
  [
    1,
    {
      v: "&le;",
      n: 8402,
      o: "&nvle;"
    }
  ],
  [
    0,
    {
      v: "&ge;",
      n: 8402,
      o: "&nvge;"
    }
  ],
  [
    0,
    {
      v: "&lE;",
      n: 824,
      o: "&nlE;"
    }
  ],
  [
    0,
    {
      v: "&gE;",
      n: 824,
      o: "&ngE;"
    }
  ],
  [
    0,
    {
      v: "&lnE;",
      n: 65024,
      o: "&lvertneqq;"
    }
  ],
  [
    0,
    {
      v: "&gnE;",
      n: 65024,
      o: "&gvertneqq;"
    }
  ],
  [
    0,
    {
      v: "&ll;",
      n: new Map(/* @__PURE__ */ restoreDiff([
        [
          824,
          "&nLtv;"
        ],
        [
          7577,
          "&nLt;"
        ]
      ]))
    }
  ],
  [
    0,
    {
      v: "&gg;",
      n: new Map(/* @__PURE__ */ restoreDiff([
        [
          824,
          "&nGtv;"
        ],
        [
          7577,
          "&nGt;"
        ]
      ]))
    }
  ],
  [
    0,
    "&between;"
  ],
  [
    0,
    "&NotCupCap;"
  ],
  [
    0,
    "&nless;"
  ],
  [
    0,
    "&ngt;"
  ],
  [
    0,
    "&nle;"
  ],
  [
    0,
    "&nge;"
  ],
  [
    0,
    "&lesssim;"
  ],
  [
    0,
    "&GreaterTilde;"
  ],
  [
    0,
    "&nlsim;"
  ],
  [
    0,
    "&ngsim;"
  ],
  [
    0,
    "&LessGreater;"
  ],
  [
    0,
    "&gl;"
  ],
  [
    0,
    "&NotLessGreater;"
  ],
  [
    0,
    "&NotGreaterLess;"
  ],
  [
    0,
    "&pr;"
  ],
  [
    0,
    "&sc;"
  ],
  [
    0,
    "&prcue;"
  ],
  [
    0,
    "&sccue;"
  ],
  [
    0,
    "&PrecedesTilde;"
  ],
  [
    0,
    {
      v: "&scsim;",
      n: 824,
      o: "&NotSucceedsTilde;"
    }
  ],
  [
    0,
    "&NotPrecedes;"
  ],
  [
    0,
    "&NotSucceeds;"
  ],
  [
    0,
    {
      v: "&sub;",
      n: 8402,
      o: "&NotSubset;"
    }
  ],
  [
    0,
    {
      v: "&sup;",
      n: 8402,
      o: "&NotSuperset;"
    }
  ],
  [
    0,
    "&nsub;"
  ],
  [
    0,
    "&nsup;"
  ],
  [
    0,
    "&sube;"
  ],
  [
    0,
    "&supe;"
  ],
  [
    0,
    "&NotSubsetEqual;"
  ],
  [
    0,
    "&NotSupersetEqual;"
  ],
  [
    0,
    {
      v: "&subne;",
      n: 65024,
      o: "&varsubsetneq;"
    }
  ],
  [
    0,
    {
      v: "&supne;",
      n: 65024,
      o: "&varsupsetneq;"
    }
  ],
  [
    1,
    "&cupdot;"
  ],
  [
    0,
    "&UnionPlus;"
  ],
  [
    0,
    {
      v: "&sqsub;",
      n: 824,
      o: "&NotSquareSubset;"
    }
  ],
  [
    0,
    {
      v: "&sqsup;",
      n: 824,
      o: "&NotSquareSuperset;"
    }
  ],
  [
    0,
    "&sqsube;"
  ],
  [
    0,
    "&sqsupe;"
  ],
  [
    0,
    {
      v: "&sqcap;",
      n: 65024,
      o: "&sqcaps;"
    }
  ],
  [
    0,
    {
      v: "&sqcup;",
      n: 65024,
      o: "&sqcups;"
    }
  ],
  [
    0,
    "&CirclePlus;"
  ],
  [
    0,
    "&CircleMinus;"
  ],
  [
    0,
    "&CircleTimes;"
  ],
  [
    0,
    "&osol;"
  ],
  [
    0,
    "&CircleDot;"
  ],
  [
    0,
    "&circledcirc;"
  ],
  [
    0,
    "&circledast;"
  ],
  [
    1,
    "&circleddash;"
  ],
  [
    0,
    "&boxplus;"
  ],
  [
    0,
    "&boxminus;"
  ],
  [
    0,
    "&boxtimes;"
  ],
  [
    0,
    "&dotsquare;"
  ],
  [
    0,
    "&RightTee;"
  ],
  [
    0,
    "&dashv;"
  ],
  [
    0,
    "&DownTee;"
  ],
  [
    0,
    "&bot;"
  ],
  [
    1,
    "&models;"
  ],
  [
    0,
    "&DoubleRightTee;"
  ],
  [
    0,
    "&Vdash;"
  ],
  [
    0,
    "&Vvdash;"
  ],
  [
    0,
    "&VDash;"
  ],
  [
    0,
    "&nvdash;"
  ],
  [
    0,
    "&nvDash;"
  ],
  [
    0,
    "&nVdash;"
  ],
  [
    0,
    "&nVDash;"
  ],
  [
    0,
    "&prurel;"
  ],
  [
    1,
    "&LeftTriangle;"
  ],
  [
    0,
    "&RightTriangle;"
  ],
  [
    0,
    {
      v: "&LeftTriangleEqual;",
      n: 8402,
      o: "&nvltrie;"
    }
  ],
  [
    0,
    {
      v: "&RightTriangleEqual;",
      n: 8402,
      o: "&nvrtrie;"
    }
  ],
  [
    0,
    "&origof;"
  ],
  [
    0,
    "&imof;"
  ],
  [
    0,
    "&multimap;"
  ],
  [
    0,
    "&hercon;"
  ],
  [
    0,
    "&intcal;"
  ],
  [
    0,
    "&veebar;"
  ],
  [
    1,
    "&barvee;"
  ],
  [
    0,
    "&angrtvb;"
  ],
  [
    0,
    "&lrtri;"
  ],
  [
    0,
    "&bigwedge;"
  ],
  [
    0,
    "&bigvee;"
  ],
  [
    0,
    "&bigcap;"
  ],
  [
    0,
    "&bigcup;"
  ],
  [
    0,
    "&diam;"
  ],
  [
    0,
    "&sdot;"
  ],
  [
    0,
    "&sstarf;"
  ],
  [
    0,
    "&divideontimes;"
  ],
  [
    0,
    "&bowtie;"
  ],
  [
    0,
    "&ltimes;"
  ],
  [
    0,
    "&rtimes;"
  ],
  [
    0,
    "&leftthreetimes;"
  ],
  [
    0,
    "&rightthreetimes;"
  ],
  [
    0,
    "&backsimeq;"
  ],
  [
    0,
    "&curlyvee;"
  ],
  [
    0,
    "&curlywedge;"
  ],
  [
    0,
    "&Sub;"
  ],
  [
    0,
    "&Sup;"
  ],
  [
    0,
    "&Cap;"
  ],
  [
    0,
    "&Cup;"
  ],
  [
    0,
    "&fork;"
  ],
  [
    0,
    "&epar;"
  ],
  [
    0,
    "&lessdot;"
  ],
  [
    0,
    "&gtdot;"
  ],
  [
    0,
    {
      v: "&Ll;",
      n: 824,
      o: "&nLl;"
    }
  ],
  [
    0,
    {
      v: "&Gg;",
      n: 824,
      o: "&nGg;"
    }
  ],
  [
    0,
    {
      v: "&leg;",
      n: 65024,
      o: "&lesg;"
    }
  ],
  [
    0,
    {
      v: "&gel;",
      n: 65024,
      o: "&gesl;"
    }
  ],
  [
    2,
    "&cuepr;"
  ],
  [
    0,
    "&cuesc;"
  ],
  [
    0,
    "&NotPrecedesSlantEqual;"
  ],
  [
    0,
    "&NotSucceedsSlantEqual;"
  ],
  [
    0,
    "&NotSquareSubsetEqual;"
  ],
  [
    0,
    "&NotSquareSupersetEqual;"
  ],
  [
    2,
    "&lnsim;"
  ],
  [
    0,
    "&gnsim;"
  ],
  [
    0,
    "&precnsim;"
  ],
  [
    0,
    "&scnsim;"
  ],
  [
    0,
    "&nltri;"
  ],
  [
    0,
    "&NotRightTriangle;"
  ],
  [
    0,
    "&nltrie;"
  ],
  [
    0,
    "&NotRightTriangleEqual;"
  ],
  [
    0,
    "&vellip;"
  ],
  [
    0,
    "&ctdot;"
  ],
  [
    0,
    "&utdot;"
  ],
  [
    0,
    "&dtdot;"
  ],
  [
    0,
    "&disin;"
  ],
  [
    0,
    "&isinsv;"
  ],
  [
    0,
    "&isins;"
  ],
  [
    0,
    {
      v: "&isindot;",
      n: 824,
      o: "&notindot;"
    }
  ],
  [
    0,
    "&notinvc;"
  ],
  [
    0,
    "&notinvb;"
  ],
  [
    1,
    {
      v: "&isinE;",
      n: 824,
      o: "&notinE;"
    }
  ],
  [
    0,
    "&nisd;"
  ],
  [
    0,
    "&xnis;"
  ],
  [
    0,
    "&nis;"
  ],
  [
    0,
    "&notnivc;"
  ],
  [
    0,
    "&notnivb;"
  ],
  [
    6,
    "&barwed;"
  ],
  [
    0,
    "&Barwed;"
  ],
  [
    1,
    "&lceil;"
  ],
  [
    0,
    "&rceil;"
  ],
  [
    0,
    "&LeftFloor;"
  ],
  [
    0,
    "&rfloor;"
  ],
  [
    0,
    "&drcrop;"
  ],
  [
    0,
    "&dlcrop;"
  ],
  [
    0,
    "&urcrop;"
  ],
  [
    0,
    "&ulcrop;"
  ],
  [
    0,
    "&bnot;"
  ],
  [
    1,
    "&profline;"
  ],
  [
    0,
    "&profsurf;"
  ],
  [
    1,
    "&telrec;"
  ],
  [
    0,
    "&target;"
  ],
  [
    5,
    "&ulcorn;"
  ],
  [
    0,
    "&urcorn;"
  ],
  [
    0,
    "&dlcorn;"
  ],
  [
    0,
    "&drcorn;"
  ],
  [
    2,
    "&frown;"
  ],
  [
    0,
    "&smile;"
  ],
  [
    9,
    "&cylcty;"
  ],
  [
    0,
    "&profalar;"
  ],
  [
    7,
    "&topbot;"
  ],
  [
    6,
    "&ovbar;"
  ],
  [
    1,
    "&solbar;"
  ],
  [
    60,
    "&angzarr;"
  ],
  [
    51,
    "&lmoustache;"
  ],
  [
    0,
    "&rmoustache;"
  ],
  [
    2,
    "&OverBracket;"
  ],
  [
    0,
    "&bbrk;"
  ],
  [
    0,
    "&bbrktbrk;"
  ],
  [
    37,
    "&OverParenthesis;"
  ],
  [
    0,
    "&UnderParenthesis;"
  ],
  [
    0,
    "&OverBrace;"
  ],
  [
    0,
    "&UnderBrace;"
  ],
  [
    2,
    "&trpezium;"
  ],
  [
    4,
    "&elinters;"
  ],
  [
    59,
    "&blank;"
  ],
  [
    164,
    "&circledS;"
  ],
  [
    55,
    "&boxh;"
  ],
  [
    1,
    "&boxv;"
  ],
  [
    9,
    "&boxdr;"
  ],
  [
    3,
    "&boxdl;"
  ],
  [
    3,
    "&boxur;"
  ],
  [
    3,
    "&boxul;"
  ],
  [
    3,
    "&boxvr;"
  ],
  [
    7,
    "&boxvl;"
  ],
  [
    7,
    "&boxhd;"
  ],
  [
    7,
    "&boxhu;"
  ],
  [
    7,
    "&boxvh;"
  ],
  [
    19,
    "&boxH;"
  ],
  [
    0,
    "&boxV;"
  ],
  [
    0,
    "&boxdR;"
  ],
  [
    0,
    "&boxDr;"
  ],
  [
    0,
    "&boxDR;"
  ],
  [
    0,
    "&boxdL;"
  ],
  [
    0,
    "&boxDl;"
  ],
  [
    0,
    "&boxDL;"
  ],
  [
    0,
    "&boxuR;"
  ],
  [
    0,
    "&boxUr;"
  ],
  [
    0,
    "&boxUR;"
  ],
  [
    0,
    "&boxuL;"
  ],
  [
    0,
    "&boxUl;"
  ],
  [
    0,
    "&boxUL;"
  ],
  [
    0,
    "&boxvR;"
  ],
  [
    0,
    "&boxVr;"
  ],
  [
    0,
    "&boxVR;"
  ],
  [
    0,
    "&boxvL;"
  ],
  [
    0,
    "&boxVl;"
  ],
  [
    0,
    "&boxVL;"
  ],
  [
    0,
    "&boxHd;"
  ],
  [
    0,
    "&boxhD;"
  ],
  [
    0,
    "&boxHD;"
  ],
  [
    0,
    "&boxHu;"
  ],
  [
    0,
    "&boxhU;"
  ],
  [
    0,
    "&boxHU;"
  ],
  [
    0,
    "&boxvH;"
  ],
  [
    0,
    "&boxVh;"
  ],
  [
    0,
    "&boxVH;"
  ],
  [
    19,
    "&uhblk;"
  ],
  [
    3,
    "&lhblk;"
  ],
  [
    3,
    "&block;"
  ],
  [
    8,
    "&blk14;"
  ],
  [
    0,
    "&blk12;"
  ],
  [
    0,
    "&blk34;"
  ],
  [
    13,
    "&square;"
  ],
  [
    8,
    "&blacksquare;"
  ],
  [
    0,
    "&EmptyVerySmallSquare;"
  ],
  [
    1,
    "&rect;"
  ],
  [
    0,
    "&marker;"
  ],
  [
    2,
    "&fltns;"
  ],
  [
    1,
    "&bigtriangleup;"
  ],
  [
    0,
    "&blacktriangle;"
  ],
  [
    0,
    "&triangle;"
  ],
  [
    2,
    "&blacktriangleright;"
  ],
  [
    0,
    "&rtri;"
  ],
  [
    3,
    "&bigtriangledown;"
  ],
  [
    0,
    "&blacktriangledown;"
  ],
  [
    0,
    "&dtri;"
  ],
  [
    2,
    "&blacktriangleleft;"
  ],
  [
    0,
    "&ltri;"
  ],
  [
    6,
    "&loz;"
  ],
  [
    0,
    "&cir;"
  ],
  [
    32,
    "&tridot;"
  ],
  [
    2,
    "&bigcirc;"
  ],
  [
    8,
    "&ultri;"
  ],
  [
    0,
    "&urtri;"
  ],
  [
    0,
    "&lltri;"
  ],
  [
    0,
    "&EmptySmallSquare;"
  ],
  [
    0,
    "&FilledSmallSquare;"
  ],
  [
    8,
    "&bigstar;"
  ],
  [
    0,
    "&star;"
  ],
  [
    7,
    "&phone;"
  ],
  [
    49,
    "&female;"
  ],
  [
    1,
    "&male;"
  ],
  [
    29,
    "&spades;"
  ],
  [
    2,
    "&clubs;"
  ],
  [
    1,
    "&hearts;"
  ],
  [
    0,
    "&diamondsuit;"
  ],
  [
    3,
    "&sung;"
  ],
  [
    2,
    "&flat;"
  ],
  [
    0,
    "&natural;"
  ],
  [
    0,
    "&sharp;"
  ],
  [
    163,
    "&check;"
  ],
  [
    3,
    "&cross;"
  ],
  [
    8,
    "&malt;"
  ],
  [
    21,
    "&sext;"
  ],
  [
    33,
    "&VerticalSeparator;"
  ],
  [
    25,
    "&lbbrk;"
  ],
  [
    0,
    "&rbbrk;"
  ],
  [
    84,
    "&bsolhsub;"
  ],
  [
    0,
    "&suphsol;"
  ],
  [
    28,
    "&LeftDoubleBracket;"
  ],
  [
    0,
    "&RightDoubleBracket;"
  ],
  [
    0,
    "&lang;"
  ],
  [
    0,
    "&rang;"
  ],
  [
    0,
    "&Lang;"
  ],
  [
    0,
    "&Rang;"
  ],
  [
    0,
    "&loang;"
  ],
  [
    0,
    "&roang;"
  ],
  [
    7,
    "&longleftarrow;"
  ],
  [
    0,
    "&longrightarrow;"
  ],
  [
    0,
    "&longleftrightarrow;"
  ],
  [
    0,
    "&DoubleLongLeftArrow;"
  ],
  [
    0,
    "&DoubleLongRightArrow;"
  ],
  [
    0,
    "&DoubleLongLeftRightArrow;"
  ],
  [
    1,
    "&longmapsto;"
  ],
  [
    2,
    "&dzigrarr;"
  ],
  [
    258,
    "&nvlArr;"
  ],
  [
    0,
    "&nvrArr;"
  ],
  [
    0,
    "&nvHarr;"
  ],
  [
    0,
    "&Map;"
  ],
  [
    6,
    "&lbarr;"
  ],
  [
    0,
    "&bkarow;"
  ],
  [
    0,
    "&lBarr;"
  ],
  [
    0,
    "&dbkarow;"
  ],
  [
    0,
    "&drbkarow;"
  ],
  [
    0,
    "&DDotrahd;"
  ],
  [
    0,
    "&UpArrowBar;"
  ],
  [
    0,
    "&DownArrowBar;"
  ],
  [
    2,
    "&Rarrtl;"
  ],
  [
    2,
    "&latail;"
  ],
  [
    0,
    "&ratail;"
  ],
  [
    0,
    "&lAtail;"
  ],
  [
    0,
    "&rAtail;"
  ],
  [
    0,
    "&larrfs;"
  ],
  [
    0,
    "&rarrfs;"
  ],
  [
    0,
    "&larrbfs;"
  ],
  [
    0,
    "&rarrbfs;"
  ],
  [
    2,
    "&nwarhk;"
  ],
  [
    0,
    "&nearhk;"
  ],
  [
    0,
    "&hksearow;"
  ],
  [
    0,
    "&hkswarow;"
  ],
  [
    0,
    "&nwnear;"
  ],
  [
    0,
    "&nesear;"
  ],
  [
    0,
    "&seswar;"
  ],
  [
    0,
    "&swnwar;"
  ],
  [
    8,
    {
      v: "&rarrc;",
      n: 824,
      o: "&nrarrc;"
    }
  ],
  [
    1,
    "&cudarrr;"
  ],
  [
    0,
    "&ldca;"
  ],
  [
    0,
    "&rdca;"
  ],
  [
    0,
    "&cudarrl;"
  ],
  [
    0,
    "&larrpl;"
  ],
  [
    2,
    "&curarrm;"
  ],
  [
    0,
    "&cularrp;"
  ],
  [
    7,
    "&rarrpl;"
  ],
  [
    2,
    "&harrcir;"
  ],
  [
    0,
    "&Uarrocir;"
  ],
  [
    0,
    "&lurdshar;"
  ],
  [
    0,
    "&ldrushar;"
  ],
  [
    2,
    "&LeftRightVector;"
  ],
  [
    0,
    "&RightUpDownVector;"
  ],
  [
    0,
    "&DownLeftRightVector;"
  ],
  [
    0,
    "&LeftUpDownVector;"
  ],
  [
    0,
    "&LeftVectorBar;"
  ],
  [
    0,
    "&RightVectorBar;"
  ],
  [
    0,
    "&RightUpVectorBar;"
  ],
  [
    0,
    "&RightDownVectorBar;"
  ],
  [
    0,
    "&DownLeftVectorBar;"
  ],
  [
    0,
    "&DownRightVectorBar;"
  ],
  [
    0,
    "&LeftUpVectorBar;"
  ],
  [
    0,
    "&LeftDownVectorBar;"
  ],
  [
    0,
    "&LeftTeeVector;"
  ],
  [
    0,
    "&RightTeeVector;"
  ],
  [
    0,
    "&RightUpTeeVector;"
  ],
  [
    0,
    "&RightDownTeeVector;"
  ],
  [
    0,
    "&DownLeftTeeVector;"
  ],
  [
    0,
    "&DownRightTeeVector;"
  ],
  [
    0,
    "&LeftUpTeeVector;"
  ],
  [
    0,
    "&LeftDownTeeVector;"
  ],
  [
    0,
    "&lHar;"
  ],
  [
    0,
    "&uHar;"
  ],
  [
    0,
    "&rHar;"
  ],
  [
    0,
    "&dHar;"
  ],
  [
    0,
    "&luruhar;"
  ],
  [
    0,
    "&ldrdhar;"
  ],
  [
    0,
    "&ruluhar;"
  ],
  [
    0,
    "&rdldhar;"
  ],
  [
    0,
    "&lharul;"
  ],
  [
    0,
    "&llhard;"
  ],
  [
    0,
    "&rharul;"
  ],
  [
    0,
    "&lrhard;"
  ],
  [
    0,
    "&udhar;"
  ],
  [
    0,
    "&duhar;"
  ],
  [
    0,
    "&RoundImplies;"
  ],
  [
    0,
    "&erarr;"
  ],
  [
    0,
    "&simrarr;"
  ],
  [
    0,
    "&larrsim;"
  ],
  [
    0,
    "&rarrsim;"
  ],
  [
    0,
    "&rarrap;"
  ],
  [
    0,
    "&ltlarr;"
  ],
  [
    1,
    "&gtrarr;"
  ],
  [
    0,
    "&subrarr;"
  ],
  [
    1,
    "&suplarr;"
  ],
  [
    0,
    "&lfisht;"
  ],
  [
    0,
    "&rfisht;"
  ],
  [
    0,
    "&ufisht;"
  ],
  [
    0,
    "&dfisht;"
  ],
  [
    5,
    "&lopar;"
  ],
  [
    0,
    "&ropar;"
  ],
  [
    4,
    "&lbrke;"
  ],
  [
    0,
    "&rbrke;"
  ],
  [
    0,
    "&lbrkslu;"
  ],
  [
    0,
    "&rbrksld;"
  ],
  [
    0,
    "&lbrksld;"
  ],
  [
    0,
    "&rbrkslu;"
  ],
  [
    0,
    "&langd;"
  ],
  [
    0,
    "&rangd;"
  ],
  [
    0,
    "&lparlt;"
  ],
  [
    0,
    "&rpargt;"
  ],
  [
    0,
    "&gtlPar;"
  ],
  [
    0,
    "&ltrPar;"
  ],
  [
    3,
    "&vzigzag;"
  ],
  [
    1,
    "&vangrt;"
  ],
  [
    0,
    "&angrtvbd;"
  ],
  [
    6,
    "&ange;"
  ],
  [
    0,
    "&range;"
  ],
  [
    0,
    "&dwangle;"
  ],
  [
    0,
    "&uwangle;"
  ],
  [
    0,
    "&angmsdaa;"
  ],
  [
    0,
    "&angmsdab;"
  ],
  [
    0,
    "&angmsdac;"
  ],
  [
    0,
    "&angmsdad;"
  ],
  [
    0,
    "&angmsdae;"
  ],
  [
    0,
    "&angmsdaf;"
  ],
  [
    0,
    "&angmsdag;"
  ],
  [
    0,
    "&angmsdah;"
  ],
  [
    0,
    "&bemptyv;"
  ],
  [
    0,
    "&demptyv;"
  ],
  [
    0,
    "&cemptyv;"
  ],
  [
    0,
    "&raemptyv;"
  ],
  [
    0,
    "&laemptyv;"
  ],
  [
    0,
    "&ohbar;"
  ],
  [
    0,
    "&omid;"
  ],
  [
    0,
    "&opar;"
  ],
  [
    1,
    "&operp;"
  ],
  [
    1,
    "&olcross;"
  ],
  [
    0,
    "&odsold;"
  ],
  [
    1,
    "&olcir;"
  ],
  [
    0,
    "&ofcir;"
  ],
  [
    0,
    "&olt;"
  ],
  [
    0,
    "&ogt;"
  ],
  [
    0,
    "&cirscir;"
  ],
  [
    0,
    "&cirE;"
  ],
  [
    0,
    "&solb;"
  ],
  [
    0,
    "&bsolb;"
  ],
  [
    3,
    "&boxbox;"
  ],
  [
    3,
    "&trisb;"
  ],
  [
    0,
    "&rtriltri;"
  ],
  [
    0,
    {
      v: "&LeftTriangleBar;",
      n: 824,
      o: "&NotLeftTriangleBar;"
    }
  ],
  [
    0,
    {
      v: "&RightTriangleBar;",
      n: 824,
      o: "&NotRightTriangleBar;"
    }
  ],
  [
    11,
    "&iinfin;"
  ],
  [
    0,
    "&infintie;"
  ],
  [
    0,
    "&nvinfin;"
  ],
  [
    4,
    "&eparsl;"
  ],
  [
    0,
    "&smeparsl;"
  ],
  [
    0,
    "&eqvparsl;"
  ],
  [
    5,
    "&blacklozenge;"
  ],
  [
    8,
    "&RuleDelayed;"
  ],
  [
    1,
    "&dsol;"
  ],
  [
    9,
    "&bigodot;"
  ],
  [
    0,
    "&bigoplus;"
  ],
  [
    0,
    "&bigotimes;"
  ],
  [
    1,
    "&biguplus;"
  ],
  [
    1,
    "&bigsqcup;"
  ],
  [
    5,
    "&iiiint;"
  ],
  [
    0,
    "&fpartint;"
  ],
  [
    2,
    "&cirfnint;"
  ],
  [
    0,
    "&awint;"
  ],
  [
    0,
    "&rppolint;"
  ],
  [
    0,
    "&scpolint;"
  ],
  [
    0,
    "&npolint;"
  ],
  [
    0,
    "&pointint;"
  ],
  [
    0,
    "&quatint;"
  ],
  [
    0,
    "&intlarhk;"
  ],
  [
    10,
    "&pluscir;"
  ],
  [
    0,
    "&plusacir;"
  ],
  [
    0,
    "&simplus;"
  ],
  [
    0,
    "&plusdu;"
  ],
  [
    0,
    "&plussim;"
  ],
  [
    0,
    "&plustwo;"
  ],
  [
    1,
    "&mcomma;"
  ],
  [
    0,
    "&minusdu;"
  ],
  [
    2,
    "&loplus;"
  ],
  [
    0,
    "&roplus;"
  ],
  [
    0,
    "&Cross;"
  ],
  [
    0,
    "&timesd;"
  ],
  [
    0,
    "&timesbar;"
  ],
  [
    1,
    "&smashp;"
  ],
  [
    0,
    "&lotimes;"
  ],
  [
    0,
    "&rotimes;"
  ],
  [
    0,
    "&otimesas;"
  ],
  [
    0,
    "&Otimes;"
  ],
  [
    0,
    "&odiv;"
  ],
  [
    0,
    "&triplus;"
  ],
  [
    0,
    "&triminus;"
  ],
  [
    0,
    "&tritime;"
  ],
  [
    0,
    "&intprod;"
  ],
  [
    2,
    "&amalg;"
  ],
  [
    0,
    "&capdot;"
  ],
  [
    1,
    "&ncup;"
  ],
  [
    0,
    "&ncap;"
  ],
  [
    0,
    "&capand;"
  ],
  [
    0,
    "&cupor;"
  ],
  [
    0,
    "&cupcap;"
  ],
  [
    0,
    "&capcup;"
  ],
  [
    0,
    "&cupbrcap;"
  ],
  [
    0,
    "&capbrcup;"
  ],
  [
    0,
    "&cupcup;"
  ],
  [
    0,
    "&capcap;"
  ],
  [
    0,
    "&ccups;"
  ],
  [
    0,
    "&ccaps;"
  ],
  [
    2,
    "&ccupssm;"
  ],
  [
    2,
    "&And;"
  ],
  [
    0,
    "&Or;"
  ],
  [
    0,
    "&andand;"
  ],
  [
    0,
    "&oror;"
  ],
  [
    0,
    "&orslope;"
  ],
  [
    0,
    "&andslope;"
  ],
  [
    1,
    "&andv;"
  ],
  [
    0,
    "&orv;"
  ],
  [
    0,
    "&andd;"
  ],
  [
    0,
    "&ord;"
  ],
  [
    1,
    "&wedbar;"
  ],
  [
    6,
    "&sdote;"
  ],
  [
    3,
    "&simdot;"
  ],
  [
    2,
    {
      v: "&congdot;",
      n: 824,
      o: "&ncongdot;"
    }
  ],
  [
    0,
    "&easter;"
  ],
  [
    0,
    "&apacir;"
  ],
  [
    0,
    {
      v: "&apE;",
      n: 824,
      o: "&napE;"
    }
  ],
  [
    0,
    "&eplus;"
  ],
  [
    0,
    "&pluse;"
  ],
  [
    0,
    "&Esim;"
  ],
  [
    0,
    "&Colone;"
  ],
  [
    0,
    "&Equal;"
  ],
  [
    1,
    "&ddotseq;"
  ],
  [
    0,
    "&equivDD;"
  ],
  [
    0,
    "&ltcir;"
  ],
  [
    0,
    "&gtcir;"
  ],
  [
    0,
    "&ltquest;"
  ],
  [
    0,
    "&gtquest;"
  ],
  [
    0,
    {
      v: "&leqslant;",
      n: 824,
      o: "&nleqslant;"
    }
  ],
  [
    0,
    {
      v: "&geqslant;",
      n: 824,
      o: "&ngeqslant;"
    }
  ],
  [
    0,
    "&lesdot;"
  ],
  [
    0,
    "&gesdot;"
  ],
  [
    0,
    "&lesdoto;"
  ],
  [
    0,
    "&gesdoto;"
  ],
  [
    0,
    "&lesdotor;"
  ],
  [
    0,
    "&gesdotol;"
  ],
  [
    0,
    "&lap;"
  ],
  [
    0,
    "&gap;"
  ],
  [
    0,
    "&lne;"
  ],
  [
    0,
    "&gne;"
  ],
  [
    0,
    "&lnap;"
  ],
  [
    0,
    "&gnap;"
  ],
  [
    0,
    "&lEg;"
  ],
  [
    0,
    "&gEl;"
  ],
  [
    0,
    "&lsime;"
  ],
  [
    0,
    "&gsime;"
  ],
  [
    0,
    "&lsimg;"
  ],
  [
    0,
    "&gsiml;"
  ],
  [
    0,
    "&lgE;"
  ],
  [
    0,
    "&glE;"
  ],
  [
    0,
    "&lesges;"
  ],
  [
    0,
    "&gesles;"
  ],
  [
    0,
    "&els;"
  ],
  [
    0,
    "&egs;"
  ],
  [
    0,
    "&elsdot;"
  ],
  [
    0,
    "&egsdot;"
  ],
  [
    0,
    "&el;"
  ],
  [
    0,
    "&eg;"
  ],
  [
    2,
    "&siml;"
  ],
  [
    0,
    "&simg;"
  ],
  [
    0,
    "&simlE;"
  ],
  [
    0,
    "&simgE;"
  ],
  [
    0,
    {
      v: "&LessLess;",
      n: 824,
      o: "&NotNestedLessLess;"
    }
  ],
  [
    0,
    {
      v: "&GreaterGreater;",
      n: 824,
      o: "&NotNestedGreaterGreater;"
    }
  ],
  [
    1,
    "&glj;"
  ],
  [
    0,
    "&gla;"
  ],
  [
    0,
    "&ltcc;"
  ],
  [
    0,
    "&gtcc;"
  ],
  [
    0,
    "&lescc;"
  ],
  [
    0,
    "&gescc;"
  ],
  [
    0,
    "&smt;"
  ],
  [
    0,
    "&lat;"
  ],
  [
    0,
    {
      v: "&smte;",
      n: 65024,
      o: "&smtes;"
    }
  ],
  [
    0,
    {
      v: "&late;",
      n: 65024,
      o: "&lates;"
    }
  ],
  [
    0,
    "&bumpE;"
  ],
  [
    0,
    {
      v: "&PrecedesEqual;",
      n: 824,
      o: "&NotPrecedesEqual;"
    }
  ],
  [
    0,
    {
      v: "&sce;",
      n: 824,
      o: "&NotSucceedsEqual;"
    }
  ],
  [
    2,
    "&prE;"
  ],
  [
    0,
    "&scE;"
  ],
  [
    0,
    "&precneqq;"
  ],
  [
    0,
    "&scnE;"
  ],
  [
    0,
    "&prap;"
  ],
  [
    0,
    "&scap;"
  ],
  [
    0,
    "&precnapprox;"
  ],
  [
    0,
    "&scnap;"
  ],
  [
    0,
    "&Pr;"
  ],
  [
    0,
    "&Sc;"
  ],
  [
    0,
    "&subdot;"
  ],
  [
    0,
    "&supdot;"
  ],
  [
    0,
    "&subplus;"
  ],
  [
    0,
    "&supplus;"
  ],
  [
    0,
    "&submult;"
  ],
  [
    0,
    "&supmult;"
  ],
  [
    0,
    "&subedot;"
  ],
  [
    0,
    "&supedot;"
  ],
  [
    0,
    {
      v: "&subE;",
      n: 824,
      o: "&nsubE;"
    }
  ],
  [
    0,
    {
      v: "&supE;",
      n: 824,
      o: "&nsupE;"
    }
  ],
  [
    0,
    "&subsim;"
  ],
  [
    0,
    "&supsim;"
  ],
  [
    2,
    {
      v: "&subnE;",
      n: 65024,
      o: "&varsubsetneqq;"
    }
  ],
  [
    0,
    {
      v: "&supnE;",
      n: 65024,
      o: "&varsupsetneqq;"
    }
  ],
  [
    2,
    "&csub;"
  ],
  [
    0,
    "&csup;"
  ],
  [
    0,
    "&csube;"
  ],
  [
    0,
    "&csupe;"
  ],
  [
    0,
    "&subsup;"
  ],
  [
    0,
    "&supsub;"
  ],
  [
    0,
    "&subsub;"
  ],
  [
    0,
    "&supsup;"
  ],
  [
    0,
    "&suphsub;"
  ],
  [
    0,
    "&supdsub;"
  ],
  [
    0,
    "&forkv;"
  ],
  [
    0,
    "&topfork;"
  ],
  [
    0,
    "&mlcp;"
  ],
  [
    8,
    "&Dashv;"
  ],
  [
    1,
    "&Vdashl;"
  ],
  [
    0,
    "&Barv;"
  ],
  [
    0,
    "&vBar;"
  ],
  [
    0,
    "&vBarv;"
  ],
  [
    1,
    "&Vbar;"
  ],
  [
    0,
    "&Not;"
  ],
  [
    0,
    "&bNot;"
  ],
  [
    0,
    "&rnmid;"
  ],
  [
    0,
    "&cirmid;"
  ],
  [
    0,
    "&midcir;"
  ],
  [
    0,
    "&topcir;"
  ],
  [
    0,
    "&nhpar;"
  ],
  [
    0,
    "&parsim;"
  ],
  [
    9,
    {
      v: "&parsl;",
      n: 8421,
      o: "&nparsl;"
    }
  ],
  [
    44343,
    {
      n: new Map(/* @__PURE__ */ restoreDiff([
        [
          56476,
          "&Ascr;"
        ],
        [
          1,
          "&Cscr;"
        ],
        [
          0,
          "&Dscr;"
        ],
        [
          2,
          "&Gscr;"
        ],
        [
          2,
          "&Jscr;"
        ],
        [
          0,
          "&Kscr;"
        ],
        [
          2,
          "&Nscr;"
        ],
        [
          0,
          "&Oscr;"
        ],
        [
          0,
          "&Pscr;"
        ],
        [
          0,
          "&Qscr;"
        ],
        [
          1,
          "&Sscr;"
        ],
        [
          0,
          "&Tscr;"
        ],
        [
          0,
          "&Uscr;"
        ],
        [
          0,
          "&Vscr;"
        ],
        [
          0,
          "&Wscr;"
        ],
        [
          0,
          "&Xscr;"
        ],
        [
          0,
          "&Yscr;"
        ],
        [
          0,
          "&Zscr;"
        ],
        [
          0,
          "&ascr;"
        ],
        [
          0,
          "&bscr;"
        ],
        [
          0,
          "&cscr;"
        ],
        [
          0,
          "&dscr;"
        ],
        [
          1,
          "&fscr;"
        ],
        [
          1,
          "&hscr;"
        ],
        [
          0,
          "&iscr;"
        ],
        [
          0,
          "&jscr;"
        ],
        [
          0,
          "&kscr;"
        ],
        [
          0,
          "&lscr;"
        ],
        [
          0,
          "&mscr;"
        ],
        [
          0,
          "&nscr;"
        ],
        [
          1,
          "&pscr;"
        ],
        [
          0,
          "&qscr;"
        ],
        [
          0,
          "&rscr;"
        ],
        [
          0,
          "&sscr;"
        ],
        [
          0,
          "&tscr;"
        ],
        [
          0,
          "&uscr;"
        ],
        [
          0,
          "&vscr;"
        ],
        [
          0,
          "&wscr;"
        ],
        [
          0,
          "&xscr;"
        ],
        [
          0,
          "&yscr;"
        ],
        [
          0,
          "&zscr;"
        ],
        [
          52,
          "&Afr;"
        ],
        [
          0,
          "&Bfr;"
        ],
        [
          1,
          "&Dfr;"
        ],
        [
          0,
          "&Efr;"
        ],
        [
          0,
          "&Ffr;"
        ],
        [
          0,
          "&Gfr;"
        ],
        [
          2,
          "&Jfr;"
        ],
        [
          0,
          "&Kfr;"
        ],
        [
          0,
          "&Lfr;"
        ],
        [
          0,
          "&Mfr;"
        ],
        [
          0,
          "&Nfr;"
        ],
        [
          0,
          "&Ofr;"
        ],
        [
          0,
          "&Pfr;"
        ],
        [
          0,
          "&Qfr;"
        ],
        [
          1,
          "&Sfr;"
        ],
        [
          0,
          "&Tfr;"
        ],
        [
          0,
          "&Ufr;"
        ],
        [
          0,
          "&Vfr;"
        ],
        [
          0,
          "&Wfr;"
        ],
        [
          0,
          "&Xfr;"
        ],
        [
          0,
          "&Yfr;"
        ],
        [
          1,
          "&afr;"
        ],
        [
          0,
          "&bfr;"
        ],
        [
          0,
          "&cfr;"
        ],
        [
          0,
          "&dfr;"
        ],
        [
          0,
          "&efr;"
        ],
        [
          0,
          "&ffr;"
        ],
        [
          0,
          "&gfr;"
        ],
        [
          0,
          "&hfr;"
        ],
        [
          0,
          "&ifr;"
        ],
        [
          0,
          "&jfr;"
        ],
        [
          0,
          "&kfr;"
        ],
        [
          0,
          "&lfr;"
        ],
        [
          0,
          "&mfr;"
        ],
        [
          0,
          "&nfr;"
        ],
        [
          0,
          "&ofr;"
        ],
        [
          0,
          "&pfr;"
        ],
        [
          0,
          "&qfr;"
        ],
        [
          0,
          "&rfr;"
        ],
        [
          0,
          "&sfr;"
        ],
        [
          0,
          "&tfr;"
        ],
        [
          0,
          "&ufr;"
        ],
        [
          0,
          "&vfr;"
        ],
        [
          0,
          "&wfr;"
        ],
        [
          0,
          "&xfr;"
        ],
        [
          0,
          "&yfr;"
        ],
        [
          0,
          "&zfr;"
        ],
        [
          0,
          "&Aopf;"
        ],
        [
          0,
          "&Bopf;"
        ],
        [
          1,
          "&Dopf;"
        ],
        [
          0,
          "&Eopf;"
        ],
        [
          0,
          "&Fopf;"
        ],
        [
          0,
          "&Gopf;"
        ],
        [
          1,
          "&Iopf;"
        ],
        [
          0,
          "&Jopf;"
        ],
        [
          0,
          "&Kopf;"
        ],
        [
          0,
          "&Lopf;"
        ],
        [
          0,
          "&Mopf;"
        ],
        [
          1,
          "&Oopf;"
        ],
        [
          3,
          "&Sopf;"
        ],
        [
          0,
          "&Topf;"
        ],
        [
          0,
          "&Uopf;"
        ],
        [
          0,
          "&Vopf;"
        ],
        [
          0,
          "&Wopf;"
        ],
        [
          0,
          "&Xopf;"
        ],
        [
          0,
          "&Yopf;"
        ],
        [
          1,
          "&aopf;"
        ],
        [
          0,
          "&bopf;"
        ],
        [
          0,
          "&copf;"
        ],
        [
          0,
          "&dopf;"
        ],
        [
          0,
          "&eopf;"
        ],
        [
          0,
          "&fopf;"
        ],
        [
          0,
          "&gopf;"
        ],
        [
          0,
          "&hopf;"
        ],
        [
          0,
          "&iopf;"
        ],
        [
          0,
          "&jopf;"
        ],
        [
          0,
          "&kopf;"
        ],
        [
          0,
          "&lopf;"
        ],
        [
          0,
          "&mopf;"
        ],
        [
          0,
          "&nopf;"
        ],
        [
          0,
          "&oopf;"
        ],
        [
          0,
          "&popf;"
        ],
        [
          0,
          "&qopf;"
        ],
        [
          0,
          "&ropf;"
        ],
        [
          0,
          "&sopf;"
        ],
        [
          0,
          "&topf;"
        ],
        [
          0,
          "&uopf;"
        ],
        [
          0,
          "&vopf;"
        ],
        [
          0,
          "&wopf;"
        ],
        [
          0,
          "&xopf;"
        ],
        [
          0,
          "&yopf;"
        ],
        [
          0,
          "&zopf;"
        ]
      ]))
    }
  ],
  [
    8906,
    "&fflig;"
  ],
  [
    0,
    "&filig;"
  ],
  [
    0,
    "&fllig;"
  ],
  [
    0,
    "&ffilig;"
  ],
  [
    0,
    "&ffllig;"
  ]
]));

// ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/escape.js
var xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
var xmlCodeMap = /* @__PURE__ */ new Map([
  [
    34,
    "&quot;"
  ],
  [
    38,
    "&amp;"
  ],
  [
    39,
    "&apos;"
  ],
  [
    60,
    "&lt;"
  ],
  [
    62,
    "&gt;"
  ]
]);
var getCodePoint = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (str, index) => str.codePointAt(index) : (c2, index) => (c2.charCodeAt(index) & 64512) === 55296 ? (c2.charCodeAt(index) - 55296) * 1024 + c2.charCodeAt(index + 1) - 56320 + 65536 : c2.charCodeAt(index)
);
function encodeXML(str) {
  let ret = "";
  let lastIdx = 0;
  let match2;
  while ((match2 = xmlReplacer.exec(str)) !== null) {
    const i = match2.index;
    const char = str.charCodeAt(i);
    const next = xmlCodeMap.get(char);
    if (next !== void 0) {
      ret += str.substring(lastIdx, i) + next;
      lastIdx = i + 1;
    } else {
      ret += `${str.substring(lastIdx, i)}&#x${getCodePoint(str, i).toString(16)};`;
      lastIdx = xmlReplacer.lastIndex += Number((char & 64512) === 55296);
    }
  }
  return ret + str.substr(lastIdx);
}
__name(encodeXML, "encodeXML");
function getEscaper(regex, map2) {
  return /* @__PURE__ */ __name(function escape3(data) {
    let match2;
    let lastIdx = 0;
    let result = "";
    while (match2 = regex.exec(data)) {
      if (lastIdx !== match2.index) {
        result += data.substring(lastIdx, match2.index);
      }
      result += map2.get(match2[0].charCodeAt(0));
      lastIdx = match2.index + 1;
    }
    return result + data.substring(lastIdx);
  }, "escape");
}
__name(getEscaper, "getEscaper");
var escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
var escapeAttribute = getEscaper(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [
    34,
    "&quot;"
  ],
  [
    38,
    "&amp;"
  ],
  [
    160,
    "&nbsp;"
  ]
]));
var escapeText = getEscaper(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [
    38,
    "&amp;"
  ],
  [
    60,
    "&lt;"
  ],
  [
    62,
    "&gt;"
  ],
  [
    160,
    "&nbsp;"
  ]
]));

// ../../node_modules/.pnpm/entities@4.5.0/node_modules/entities/lib/esm/index.js
var EntityLevel;
(function(EntityLevel2) {
  EntityLevel2[EntityLevel2["XML"] = 0] = "XML";
  EntityLevel2[EntityLevel2["HTML"] = 1] = "HTML";
})(EntityLevel || (EntityLevel = {}));
var EncodingMode;
(function(EncodingMode2) {
  EncodingMode2[EncodingMode2["UTF8"] = 0] = "UTF8";
  EncodingMode2[EncodingMode2["ASCII"] = 1] = "ASCII";
  EncodingMode2[EncodingMode2["Extensive"] = 2] = "Extensive";
  EncodingMode2[EncodingMode2["Attribute"] = 3] = "Attribute";
  EncodingMode2[EncodingMode2["Text"] = 4] = "Text";
})(EncodingMode || (EncodingMode = {}));

// ../../node_modules/.pnpm/dom-serializer@2.0.0/node_modules/dom-serializer/lib/esm/foreignNames.js
var elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((val) => [
  val.toLowerCase(),
  val
]));
var attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((val) => [
  val.toLowerCase(),
  val
]));

// ../../node_modules/.pnpm/dom-serializer@2.0.0/node_modules/dom-serializer/lib/esm/index.js
var unencodedElements = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function replaceQuotes(value) {
  return value.replace(/"/g, "&quot;");
}
__name(replaceQuotes, "replaceQuotes");
function formatAttributes(attributes, opts) {
  var _a6;
  if (!attributes) return;
  const encode = ((_a6 = opts.encodeEntities) !== null && _a6 !== void 0 ? _a6 : opts.decodeEntities) === false ? replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? encodeXML : escapeAttribute;
  return Object.keys(attributes).map((key) => {
    var _a7, _b;
    const value = (_a7 = attributes[key]) !== null && _a7 !== void 0 ? _a7 : "";
    if (opts.xmlMode === "foreign") {
      key = (_b = attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
    }
    if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
      return key;
    }
    return `${key}="${encode(value)}"`;
  }).join(" ");
}
__name(formatAttributes, "formatAttributes");
var singleTag = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function render(node, options = {}) {
  const nodes = "length" in node ? node : [
    node
  ];
  let output = "";
  for (let i = 0; i < nodes.length; i++) {
    output += renderNode(nodes[i], options);
  }
  return output;
}
__name(render, "render");
var esm_default = render;
function renderNode(node, options) {
  switch (node.type) {
    case Root:
      return render(node.children, options);
    // @ts-expect-error We don't use `Doctype` yet
    case Doctype:
    case Directive:
      return renderDirective(node);
    case Comment:
      return renderComment(node);
    case CDATA:
      return renderCdata(node);
    case Script:
    case Style:
    case Tag:
      return renderTag(node, options);
    case Text:
      return renderText(node, options);
  }
}
__name(renderNode, "renderNode");
var foreignModeIntegrationPoints = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]);
var foreignElements = /* @__PURE__ */ new Set([
  "svg",
  "math"
]);
function renderTag(elem, opts) {
  var _a6;
  if (opts.xmlMode === "foreign") {
    elem.name = (_a6 = elementNames.get(elem.name)) !== null && _a6 !== void 0 ? _a6 : elem.name;
    if (elem.parent && foreignModeIntegrationPoints.has(elem.parent.name)) {
      opts = __spreadProps(__spreadValues({}, opts), {
        xmlMode: false
      });
    }
  }
  if (!opts.xmlMode && foreignElements.has(elem.name)) {
    opts = __spreadProps(__spreadValues({}, opts), {
      xmlMode: "foreign"
    });
  }
  let tag = `<${elem.name}`;
  const attribs = formatAttributes(elem.attribs, opts);
  if (attribs) {
    tag += ` ${attribs}`;
  }
  if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && singleTag.has(elem.name))) {
    if (!opts.xmlMode) tag += " ";
    tag += "/>";
  } else {
    tag += ">";
    if (elem.children.length > 0) {
      tag += render(elem.children, opts);
    }
    if (opts.xmlMode || !singleTag.has(elem.name)) {
      tag += `</${elem.name}>`;
    }
  }
  return tag;
}
__name(renderTag, "renderTag");
function renderDirective(elem) {
  return `<${elem.data}>`;
}
__name(renderDirective, "renderDirective");
function renderText(elem, opts) {
  var _a6;
  let data = elem.data || "";
  if (((_a6 = opts.encodeEntities) !== null && _a6 !== void 0 ? _a6 : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && unencodedElements.has(elem.parent.name))) {
    data = opts.xmlMode || opts.encodeEntities !== "utf8" ? encodeXML(data) : escapeText(data);
  }
  return data;
}
__name(renderText, "renderText");
function renderCdata(elem) {
  return `<![CDATA[${elem.children[0].data}]]>`;
}
__name(renderCdata, "renderCdata");
function renderComment(elem) {
  return `<!--${elem.data}-->`;
}
__name(renderComment, "renderComment");

// ../../node_modules/.pnpm/domutils@3.1.0/node_modules/domutils/lib/esm/stringify.js
function getOuterHTML(node, options) {
  return esm_default(node, options);
}
__name(getOuterHTML, "getOuterHTML");
function getInnerHTML(node, options) {
  return hasChildren(node) ? node.children.map((node2) => getOuterHTML(node2, options)).join("") : "";
}
__name(getInnerHTML, "getInnerHTML");
function getText(node) {
  if (Array.isArray(node)) return node.map(getText).join("");
  if (isTag2(node)) return node.name === "br" ? "\n" : getText(node.children);
  if (isCDATA(node)) return getText(node.children);
  if (isText(node)) return node.data;
  return "";
}
__name(getText, "getText");
function textContent(node) {
  if (Array.isArray(node)) return node.map(textContent).join("");
  if (hasChildren(node) && !isComment(node)) {
    return textContent(node.children);
  }
  if (isText(node)) return node.data;
  return "";
}
__name(textContent, "textContent");
function innerText(node) {
  if (Array.isArray(node)) return node.map(innerText).join("");
  if (hasChildren(node) && (node.type === ElementType.Tag || isCDATA(node))) {
    return innerText(node.children);
  }
  if (isText(node)) return node.data;
  return "";
}
__name(innerText, "innerText");

// ../../node_modules/.pnpm/domutils@3.1.0/node_modules/domutils/lib/esm/traversal.js
function getChildren(elem) {
  return hasChildren(elem) ? elem.children : [];
}
__name(getChildren, "getChildren");
function getParent(elem) {
  return elem.parent || null;
}
__name(getParent, "getParent");
function getSiblings(elem) {
  const parent = getParent(elem);
  if (parent != null) return getChildren(parent);
  const siblings = [
    elem
  ];
  let { prev, next } = elem;
  while (prev != null) {
    siblings.unshift(prev);
    ({ prev } = prev);
  }
  while (next != null) {
    siblings.push(next);
    ({ next } = next);
  }
  return siblings;
}
__name(getSiblings, "getSiblings");
function getAttributeValue(elem, name2) {
  var _a6;
  return (_a6 = elem.attribs) === null || _a6 === void 0 ? void 0 : _a6[name2];
}
__name(getAttributeValue, "getAttributeValue");
function hasAttrib(elem, name2) {
  return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name2) && elem.attribs[name2] != null;
}
__name(hasAttrib, "hasAttrib");
function getName(elem) {
  return elem.name;
}
__name(getName, "getName");
function nextElementSibling(elem) {
  let { next } = elem;
  while (next !== null && !isTag2(next)) ({ next } = next);
  return next;
}
__name(nextElementSibling, "nextElementSibling");
function prevElementSibling(elem) {
  let { prev } = elem;
  while (prev !== null && !isTag2(prev)) ({ prev } = prev);
  return prev;
}
__name(prevElementSibling, "prevElementSibling");

// ../../node_modules/.pnpm/domutils@3.1.0/node_modules/domutils/lib/esm/manipulation.js
function removeElement(elem) {
  if (elem.prev) elem.prev.next = elem.next;
  if (elem.next) elem.next.prev = elem.prev;
  if (elem.parent) {
    const childs = elem.parent.children;
    const childsIndex = childs.lastIndexOf(elem);
    if (childsIndex >= 0) {
      childs.splice(childsIndex, 1);
    }
  }
  elem.next = null;
  elem.prev = null;
  elem.parent = null;
}
__name(removeElement, "removeElement");
function replaceElement(elem, replacement) {
  const prev = replacement.prev = elem.prev;
  if (prev) {
    prev.next = replacement;
  }
  const next = replacement.next = elem.next;
  if (next) {
    next.prev = replacement;
  }
  const parent = replacement.parent = elem.parent;
  if (parent) {
    const childs = parent.children;
    childs[childs.lastIndexOf(elem)] = replacement;
    elem.parent = null;
  }
}
__name(replaceElement, "replaceElement");
function appendChild(parent, child) {
  removeElement(child);
  child.next = null;
  child.parent = parent;
  if (parent.children.push(child) > 1) {
    const sibling = parent.children[parent.children.length - 2];
    sibling.next = child;
    child.prev = sibling;
  } else {
    child.prev = null;
  }
}
__name(appendChild, "appendChild");
function append(elem, next) {
  removeElement(next);
  const { parent } = elem;
  const currNext = elem.next;
  next.next = currNext;
  next.prev = elem;
  elem.next = next;
  next.parent = parent;
  if (currNext) {
    currNext.prev = next;
    if (parent) {
      const childs = parent.children;
      childs.splice(childs.lastIndexOf(currNext), 0, next);
    }
  } else if (parent) {
    parent.children.push(next);
  }
}
__name(append, "append");
function prependChild(parent, child) {
  removeElement(child);
  child.parent = parent;
  child.prev = null;
  if (parent.children.unshift(child) !== 1) {
    const sibling = parent.children[1];
    sibling.prev = child;
    child.next = sibling;
  } else {
    child.next = null;
  }
}
__name(prependChild, "prependChild");
function prepend(elem, prev) {
  removeElement(prev);
  const { parent } = elem;
  if (parent) {
    const childs = parent.children;
    childs.splice(childs.indexOf(elem), 0, prev);
  }
  if (elem.prev) {
    elem.prev.next = prev;
  }
  prev.parent = parent;
  prev.prev = elem.prev;
  prev.next = elem;
  elem.prev = prev;
}
__name(prepend, "prepend");

// ../../node_modules/.pnpm/domutils@3.1.0/node_modules/domutils/lib/esm/querying.js
function filter(test, node, recurse = true, limit = Infinity) {
  return find(test, Array.isArray(node) ? node : [
    node
  ], recurse, limit);
}
__name(filter, "filter");
function find(test, nodes, recurse, limit) {
  const result = [];
  const nodeStack = [
    nodes
  ];
  const indexStack = [
    0
  ];
  for (; ; ) {
    if (indexStack[0] >= nodeStack[0].length) {
      if (indexStack.length === 1) {
        return result;
      }
      nodeStack.shift();
      indexStack.shift();
      continue;
    }
    const elem = nodeStack[0][indexStack[0]++];
    if (test(elem)) {
      result.push(elem);
      if (--limit <= 0) return result;
    }
    if (recurse && hasChildren(elem) && elem.children.length > 0) {
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
__name(find, "find");
function findOneChild(test, nodes) {
  return nodes.find(test);
}
__name(findOneChild, "findOneChild");
function findOne(test, nodes, recurse = true) {
  let elem = null;
  for (let i = 0; i < nodes.length && !elem; i++) {
    const node = nodes[i];
    if (!isTag2(node)) {
      continue;
    } else if (test(node)) {
      elem = node;
    } else if (recurse && node.children.length > 0) {
      elem = findOne(test, node.children, true);
    }
  }
  return elem;
}
__name(findOne, "findOne");
function existsOne(test, nodes) {
  return nodes.some((checked) => isTag2(checked) && (test(checked) || existsOne(test, checked.children)));
}
__name(existsOne, "existsOne");
function findAll(test, nodes) {
  const result = [];
  const nodeStack = [
    nodes
  ];
  const indexStack = [
    0
  ];
  for (; ; ) {
    if (indexStack[0] >= nodeStack[0].length) {
      if (nodeStack.length === 1) {
        return result;
      }
      nodeStack.shift();
      indexStack.shift();
      continue;
    }
    const elem = nodeStack[0][indexStack[0]++];
    if (!isTag2(elem)) continue;
    if (test(elem)) result.push(elem);
    if (elem.children.length > 0) {
      indexStack.unshift(0);
      nodeStack.unshift(elem.children);
    }
  }
}
__name(findAll, "findAll");

// ../../node_modules/.pnpm/domutils@3.1.0/node_modules/domutils/lib/esm/legacy.js
var Checks = {
  tag_name(name2) {
    if (typeof name2 === "function") {
      return (elem) => isTag2(elem) && name2(elem.name);
    } else if (name2 === "*") {
      return isTag2;
    }
    return (elem) => isTag2(elem) && elem.name === name2;
  },
  tag_type(type) {
    if (typeof type === "function") {
      return (elem) => type(elem.type);
    }
    return (elem) => elem.type === type;
  },
  tag_contains(data) {
    if (typeof data === "function") {
      return (elem) => isText(elem) && data(elem.data);
    }
    return (elem) => isText(elem) && elem.data === data;
  }
};
function getAttribCheck(attrib, value) {
  if (typeof value === "function") {
    return (elem) => isTag2(elem) && value(elem.attribs[attrib]);
  }
  return (elem) => isTag2(elem) && elem.attribs[attrib] === value;
}
__name(getAttribCheck, "getAttribCheck");
function combineFuncs(a, b) {
  return (elem) => a(elem) || b(elem);
}
__name(combineFuncs, "combineFuncs");
function compileTest(options) {
  const funcs = Object.keys(options).map((key) => {
    const value = options[key];
    return Object.prototype.hasOwnProperty.call(Checks, key) ? Checks[key](value) : getAttribCheck(key, value);
  });
  return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
__name(compileTest, "compileTest");
function testElement(options, node) {
  const test = compileTest(options);
  return test ? test(node) : true;
}
__name(testElement, "testElement");
function getElements(options, nodes, recurse, limit = Infinity) {
  const test = compileTest(options);
  return test ? filter(test, nodes, recurse, limit) : [];
}
__name(getElements, "getElements");
function getElementById(id, nodes, recurse = true) {
  if (!Array.isArray(nodes)) nodes = [
    nodes
  ];
  return findOne(getAttribCheck("id", id), nodes, recurse);
}
__name(getElementById, "getElementById");
function getElementsByTagName(tagName, nodes, recurse = true, limit = Infinity) {
  return filter(Checks["tag_name"](tagName), nodes, recurse, limit);
}
__name(getElementsByTagName, "getElementsByTagName");
function getElementsByTagType(type, nodes, recurse = true, limit = Infinity) {
  return filter(Checks["tag_type"](type), nodes, recurse, limit);
}
__name(getElementsByTagType, "getElementsByTagType");

// ../../node_modules/.pnpm/domutils@3.1.0/node_modules/domutils/lib/esm/helpers.js
function removeSubsets(nodes) {
  let idx = nodes.length;
  while (--idx >= 0) {
    const node = nodes[idx];
    if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
      nodes.splice(idx, 1);
      continue;
    }
    for (let ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
      if (nodes.includes(ancestor)) {
        nodes.splice(idx, 1);
        break;
      }
    }
  }
  return nodes;
}
__name(removeSubsets, "removeSubsets");
var DocumentPosition;
(function(DocumentPosition2) {
  DocumentPosition2[DocumentPosition2["DISCONNECTED"] = 1] = "DISCONNECTED";
  DocumentPosition2[DocumentPosition2["PRECEDING"] = 2] = "PRECEDING";
  DocumentPosition2[DocumentPosition2["FOLLOWING"] = 4] = "FOLLOWING";
  DocumentPosition2[DocumentPosition2["CONTAINS"] = 8] = "CONTAINS";
  DocumentPosition2[DocumentPosition2["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})(DocumentPosition || (DocumentPosition = {}));
function compareDocumentPosition(nodeA, nodeB) {
  const aParents = [];
  const bParents = [];
  if (nodeA === nodeB) {
    return 0;
  }
  let current = hasChildren(nodeA) ? nodeA : nodeA.parent;
  while (current) {
    aParents.unshift(current);
    current = current.parent;
  }
  current = hasChildren(nodeB) ? nodeB : nodeB.parent;
  while (current) {
    bParents.unshift(current);
    current = current.parent;
  }
  const maxIdx = Math.min(aParents.length, bParents.length);
  let idx = 0;
  while (idx < maxIdx && aParents[idx] === bParents[idx]) {
    idx++;
  }
  if (idx === 0) {
    return DocumentPosition.DISCONNECTED;
  }
  const sharedParent = aParents[idx - 1];
  const siblings = sharedParent.children;
  const aSibling = aParents[idx];
  const bSibling = bParents[idx];
  if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
    if (sharedParent === nodeB) {
      return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
    }
    return DocumentPosition.FOLLOWING;
  }
  if (sharedParent === nodeA) {
    return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
  }
  return DocumentPosition.PRECEDING;
}
__name(compareDocumentPosition, "compareDocumentPosition");
function uniqueSort(nodes) {
  nodes = nodes.filter((node, i, arr) => !arr.includes(node, i + 1));
  nodes.sort((a, b) => {
    const relative = compareDocumentPosition(a, b);
    if (relative & DocumentPosition.PRECEDING) {
      return -1;
    } else if (relative & DocumentPosition.FOLLOWING) {
      return 1;
    }
    return 0;
  });
  return nodes;
}
__name(uniqueSort, "uniqueSort");

// ../../node_modules/.pnpm/domutils@3.1.0/node_modules/domutils/lib/esm/feeds.js
function getFeed(doc) {
  const feedRoot = getOneElement(isValidFeed, doc);
  return !feedRoot ? null : feedRoot.name === "feed" ? getAtomFeed(feedRoot) : getRssFeed(feedRoot);
}
__name(getFeed, "getFeed");
function getAtomFeed(feedRoot) {
  var _a6;
  const childs = feedRoot.children;
  const feed = {
    type: "atom",
    items: getElementsByTagName("entry", childs).map((item) => {
      var _a7;
      const { children } = item;
      const entry = {
        media: getMediaElements(children)
      };
      addConditionally(entry, "id", "id", children);
      addConditionally(entry, "title", "title", children);
      const href2 = (_a7 = getOneElement("link", children)) === null || _a7 === void 0 ? void 0 : _a7.attribs["href"];
      if (href2) {
        entry.link = href2;
      }
      const description = fetch2("summary", children) || fetch2("content", children);
      if (description) {
        entry.description = description;
      }
      const pubDate = fetch2("updated", children);
      if (pubDate) {
        entry.pubDate = new Date(pubDate);
      }
      return entry;
    })
  };
  addConditionally(feed, "id", "id", childs);
  addConditionally(feed, "title", "title", childs);
  const href = (_a6 = getOneElement("link", childs)) === null || _a6 === void 0 ? void 0 : _a6.attribs["href"];
  if (href) {
    feed.link = href;
  }
  addConditionally(feed, "description", "subtitle", childs);
  const updated = fetch2("updated", childs);
  if (updated) {
    feed.updated = new Date(updated);
  }
  addConditionally(feed, "author", "email", childs, true);
  return feed;
}
__name(getAtomFeed, "getAtomFeed");
function getRssFeed(feedRoot) {
  var _a6, _b;
  const childs = (_b = (_a6 = getOneElement("channel", feedRoot.children)) === null || _a6 === void 0 ? void 0 : _a6.children) !== null && _b !== void 0 ? _b : [];
  const feed = {
    type: feedRoot.name.substr(0, 3),
    id: "",
    items: getElementsByTagName("item", feedRoot.children).map((item) => {
      const { children } = item;
      const entry = {
        media: getMediaElements(children)
      };
      addConditionally(entry, "id", "guid", children);
      addConditionally(entry, "title", "title", children);
      addConditionally(entry, "link", "link", children);
      addConditionally(entry, "description", "description", children);
      const pubDate = fetch2("pubDate", children) || fetch2("dc:date", children);
      if (pubDate) entry.pubDate = new Date(pubDate);
      return entry;
    })
  };
  addConditionally(feed, "title", "title", childs);
  addConditionally(feed, "link", "link", childs);
  addConditionally(feed, "description", "description", childs);
  const updated = fetch2("lastBuildDate", childs);
  if (updated) {
    feed.updated = new Date(updated);
  }
  addConditionally(feed, "author", "managingEditor", childs, true);
  return feed;
}
__name(getRssFeed, "getRssFeed");
var MEDIA_KEYS_STRING = [
  "url",
  "type",
  "lang"
];
var MEDIA_KEYS_INT = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function getMediaElements(where) {
  return getElementsByTagName("media:content", where).map((elem) => {
    const { attribs } = elem;
    const media = {
      medium: attribs["medium"],
      isDefault: !!attribs["isDefault"]
    };
    for (const attrib of MEDIA_KEYS_STRING) {
      if (attribs[attrib]) {
        media[attrib] = attribs[attrib];
      }
    }
    for (const attrib of MEDIA_KEYS_INT) {
      if (attribs[attrib]) {
        media[attrib] = parseInt(attribs[attrib], 10);
      }
    }
    if (attribs["expression"]) {
      media.expression = attribs["expression"];
    }
    return media;
  });
}
__name(getMediaElements, "getMediaElements");
function getOneElement(tagName, node) {
  return getElementsByTagName(tagName, node, true, 1)[0];
}
__name(getOneElement, "getOneElement");
function fetch2(tagName, where, recurse = false) {
  return textContent(getElementsByTagName(tagName, where, recurse, 1)).trim();
}
__name(fetch2, "fetch");
function addConditionally(obj, prop, tagName, where, recurse = false) {
  const val = fetch2(tagName, where, recurse);
  if (val) obj[prop] = val;
}
__name(addConditionally, "addConditionally");
function isValidFeed(value) {
  return value === "rss" || value === "feed" || value === "rdf:RDF";
}
__name(isValidFeed, "isValidFeed");

// ../../node_modules/.pnpm/htmlparser2@8.0.2/node_modules/htmlparser2/lib/esm/index.js
function parseDocument(data, options) {
  const handler = new DomHandler(void 0, options);
  new Parser(handler, options).end(data);
  return handler.root;
}
__name(parseDocument, "parseDocument");

// ../../node_modules/.pnpm/html-to-text@9.0.5/node_modules/html-to-text/lib/html-to-text.mjs
var import_deepmerge = __toESM(require_cjs(), 1);
function limitedDepthRecursive(n3, f, g = () => void 0) {
  if (n3 === void 0) {
    const f1 = /* @__PURE__ */ __name(function(...args) {
      return f(f1, ...args);
    }, "f1");
    return f1;
  }
  if (n3 >= 0) {
    return function(...args) {
      return f(limitedDepthRecursive(n3 - 1, f, g), ...args);
    };
  }
  return g;
}
__name(limitedDepthRecursive, "limitedDepthRecursive");
function trimCharacter(str, char) {
  let start = 0;
  let end = str.length;
  while (start < end && str[start] === char) {
    ++start;
  }
  while (end > start && str[end - 1] === char) {
    --end;
  }
  return start > 0 || end < str.length ? str.substring(start, end) : str;
}
__name(trimCharacter, "trimCharacter");
function trimCharacterEnd(str, char) {
  let end = str.length;
  while (end > 0 && str[end - 1] === char) {
    --end;
  }
  return end < str.length ? str.substring(0, end) : str;
}
__name(trimCharacterEnd, "trimCharacterEnd");
function unicodeEscape(str) {
  return str.replace(/[\s\S]/g, (c2) => "\\u" + c2.charCodeAt().toString(16).padStart(4, "0"));
}
__name(unicodeEscape, "unicodeEscape");
function mergeDuplicatesPreferLast(items, getKey) {
  const map2 = /* @__PURE__ */ new Map();
  for (let i = items.length; i-- > 0; ) {
    const item = items[i];
    const key = getKey(item);
    map2.set(
      key,
      map2.has(key) ? (0, import_deepmerge.default)(item, map2.get(key), { arrayMerge: overwriteMerge$1 }) : item
    );
  }
  return [...map2.values()].reverse();
}
__name(mergeDuplicatesPreferLast, "mergeDuplicatesPreferLast");
var overwriteMerge$1 = /* @__PURE__ */ __name((acc, src, options) => [...src], "overwriteMerge$1");
function get(obj, path) {
  for (const key of path) {
    if (!obj) {
      return void 0;
    }
    obj = obj[key];
  }
  return obj;
}
__name(get, "get");
function numberToLetterSequence(num, baseChar = "a", base = 26) {
  const digits = [];
  do {
    num -= 1;
    digits.push(num % base);
    num = num / base >> 0;
  } while (num > 0);
  const baseCode = baseChar.charCodeAt(0);
  return digits.reverse().map((n3) => String.fromCharCode(baseCode + n3)).join("");
}
__name(numberToLetterSequence, "numberToLetterSequence");
var I = ["I", "X", "C", "M"];
var V = ["V", "L", "D"];
function numberToRoman(num) {
  return [...num + ""].map((n3) => +n3).reverse().map((v, i) => v % 5 < 4 ? (v < 5 ? "" : V[i]) + I[i].repeat(v % 5) : I[i] + (v < 5 ? V[i] : I[i + 1])).reverse().join("");
}
__name(numberToRoman, "numberToRoman");
var _InlineTextBuilder = class _InlineTextBuilder {
  /**
   * Creates an instance of InlineTextBuilder.
   *
   * If `maxLineLength` is not provided then it is either `options.wordwrap` or unlimited.
   *
   * @param { Options } options           HtmlToText options.
   * @param { number }  [ maxLineLength ] This builder will try to wrap text to fit this line length.
   */
  constructor(options, maxLineLength = void 0) {
    this.lines = [];
    this.nextLineWords = [];
    this.maxLineLength = maxLineLength || options.wordwrap || Number.MAX_VALUE;
    this.nextLineAvailableChars = this.maxLineLength;
    this.wrapCharacters = get(options, ["longWordSplit", "wrapCharacters"]) || [];
    this.forceWrapOnLimit = get(options, ["longWordSplit", "forceWrapOnLimit"]) || false;
    this.stashedSpace = false;
    this.wordBreakOpportunity = false;
  }
  /**
   * Add a new word.
   *
   * @param { string } word A word to add.
   * @param { boolean } [noWrap] Don't wrap text even if the line is too long.
   */
  pushWord(word, noWrap = false) {
    if (this.nextLineAvailableChars <= 0 && !noWrap) {
      this.startNewLine();
    }
    const isLineStart = this.nextLineWords.length === 0;
    const cost = word.length + (isLineStart ? 0 : 1);
    if (cost <= this.nextLineAvailableChars || noWrap) {
      this.nextLineWords.push(word);
      this.nextLineAvailableChars -= cost;
    } else {
      const [first, ...rest] = this.splitLongWord(word);
      if (!isLineStart) {
        this.startNewLine();
      }
      this.nextLineWords.push(first);
      this.nextLineAvailableChars -= first.length;
      for (const part of rest) {
        this.startNewLine();
        this.nextLineWords.push(part);
        this.nextLineAvailableChars -= part.length;
      }
    }
  }
  /**
   * Pop a word from the currently built line.
   * This doesn't affect completed lines.
   *
   * @returns { string }
   */
  popWord() {
    const lastWord = this.nextLineWords.pop();
    if (lastWord !== void 0) {
      const isLineStart = this.nextLineWords.length === 0;
      const cost = lastWord.length + (isLineStart ? 0 : 1);
      this.nextLineAvailableChars += cost;
    }
    return lastWord;
  }
  /**
   * Concat a word to the last word already in the builder.
   * Adds a new word in case there are no words yet in the last line.
   *
   * @param { string } word A word to be concatenated.
   * @param { boolean } [noWrap] Don't wrap text even if the line is too long.
   */
  concatWord(word, noWrap = false) {
    if (this.wordBreakOpportunity && word.length > this.nextLineAvailableChars) {
      this.pushWord(word, noWrap);
      this.wordBreakOpportunity = false;
    } else {
      const lastWord = this.popWord();
      this.pushWord(lastWord ? lastWord.concat(word) : word, noWrap);
    }
  }
  /**
   * Add current line (and more empty lines if provided argument > 1) to the list of complete lines and start a new one.
   *
   * @param { number } n Number of line breaks that will be added to the resulting string.
   */
  startNewLine(n3 = 1) {
    this.lines.push(this.nextLineWords);
    if (n3 > 1) {
      this.lines.push(...Array.from({ length: n3 - 1 }, () => []));
    }
    this.nextLineWords = [];
    this.nextLineAvailableChars = this.maxLineLength;
  }
  /**
   * No words in this builder.
   *
   * @returns { boolean }
   */
  isEmpty() {
    return this.lines.length === 0 && this.nextLineWords.length === 0;
  }
  clear() {
    this.lines.length = 0;
    this.nextLineWords.length = 0;
    this.nextLineAvailableChars = this.maxLineLength;
  }
  /**
   * Join all lines of words inside the InlineTextBuilder into a complete string.
   *
   * @returns { string }
   */
  toString() {
    return [...this.lines, this.nextLineWords].map((words) => words.join(" ")).join("\n");
  }
  /**
   * Split a long word up to fit within the word wrap limit.
   * Use either a character to split looking back from the word wrap limit,
   * or truncate to the word wrap limit.
   *
   * @param   { string }   word Input word.
   * @returns { string[] }      Parts of the word.
   */
  splitLongWord(word) {
    const parts = [];
    let idx = 0;
    while (word.length > this.maxLineLength) {
      const firstLine = word.substring(0, this.maxLineLength);
      const remainingChars = word.substring(this.maxLineLength);
      const splitIndex = firstLine.lastIndexOf(this.wrapCharacters[idx]);
      if (splitIndex > -1) {
        word = firstLine.substring(splitIndex + 1) + remainingChars;
        parts.push(firstLine.substring(0, splitIndex + 1));
      } else {
        idx++;
        if (idx < this.wrapCharacters.length) {
          word = firstLine + remainingChars;
        } else {
          if (this.forceWrapOnLimit) {
            parts.push(firstLine);
            word = remainingChars;
            if (word.length > this.maxLineLength) {
              continue;
            }
          } else {
            word = firstLine + remainingChars;
          }
          break;
        }
      }
    }
    parts.push(word);
    return parts;
  }
};
__name(_InlineTextBuilder, "InlineTextBuilder");
var InlineTextBuilder = _InlineTextBuilder;
var _StackItem = class _StackItem {
  constructor(next = null) {
    this.next = next;
  }
  getRoot() {
    return this.next ? this.next : this;
  }
};
__name(_StackItem, "StackItem");
var StackItem = _StackItem;
var _BlockStackItem = class _BlockStackItem extends StackItem {
  constructor(options, next = null, leadingLineBreaks = 1, maxLineLength = void 0) {
    super(next);
    this.leadingLineBreaks = leadingLineBreaks;
    this.inlineTextBuilder = new InlineTextBuilder(options, maxLineLength);
    this.rawText = "";
    this.stashedLineBreaks = 0;
    this.isPre = next && next.isPre;
    this.isNoWrap = next && next.isNoWrap;
  }
};
__name(_BlockStackItem, "BlockStackItem");
var BlockStackItem = _BlockStackItem;
var _ListStackItem = class _ListStackItem extends BlockStackItem {
  constructor(options, next = null, {
    interRowLineBreaks = 1,
    leadingLineBreaks = 2,
    maxLineLength = void 0,
    maxPrefixLength = 0,
    prefixAlign = "left"
  } = {}) {
    super(options, next, leadingLineBreaks, maxLineLength);
    this.maxPrefixLength = maxPrefixLength;
    this.prefixAlign = prefixAlign;
    this.interRowLineBreaks = interRowLineBreaks;
  }
};
__name(_ListStackItem, "ListStackItem");
var ListStackItem = _ListStackItem;
var _ListItemStackItem = class _ListItemStackItem extends BlockStackItem {
  constructor(options, next = null, {
    leadingLineBreaks = 1,
    maxLineLength = void 0,
    prefix: prefix2 = ""
  } = {}) {
    super(options, next, leadingLineBreaks, maxLineLength);
    this.prefix = prefix2;
  }
};
__name(_ListItemStackItem, "ListItemStackItem");
var ListItemStackItem = _ListItemStackItem;
var _TableStackItem = class _TableStackItem extends StackItem {
  constructor(next = null) {
    super(next);
    this.rows = [];
    this.isPre = next && next.isPre;
    this.isNoWrap = next && next.isNoWrap;
  }
};
__name(_TableStackItem, "TableStackItem");
var TableStackItem = _TableStackItem;
var _TableRowStackItem = class _TableRowStackItem extends StackItem {
  constructor(next = null) {
    super(next);
    this.cells = [];
    this.isPre = next && next.isPre;
    this.isNoWrap = next && next.isNoWrap;
  }
};
__name(_TableRowStackItem, "TableRowStackItem");
var TableRowStackItem = _TableRowStackItem;
var _TableCellStackItem = class _TableCellStackItem extends StackItem {
  constructor(options, next = null, maxColumnWidth = void 0) {
    super(next);
    this.inlineTextBuilder = new InlineTextBuilder(options, maxColumnWidth);
    this.rawText = "";
    this.stashedLineBreaks = 0;
    this.isPre = next && next.isPre;
    this.isNoWrap = next && next.isNoWrap;
  }
};
__name(_TableCellStackItem, "TableCellStackItem");
var TableCellStackItem = _TableCellStackItem;
var _TransformerStackItem = class _TransformerStackItem extends StackItem {
  constructor(next = null, transform) {
    super(next);
    this.transform = transform;
  }
};
__name(_TransformerStackItem, "TransformerStackItem");
var TransformerStackItem = _TransformerStackItem;
function charactersToCodes(str) {
  return [...str].map((c2) => "\\u" + c2.charCodeAt(0).toString(16).padStart(4, "0")).join("");
}
__name(charactersToCodes, "charactersToCodes");
var _WhitespaceProcessor = class _WhitespaceProcessor {
  /**
   * Creates an instance of WhitespaceProcessor.
   *
   * @param { Options } options    HtmlToText options.
   * @memberof WhitespaceProcessor
   */
  constructor(options) {
    this.whitespaceChars = options.preserveNewlines ? options.whitespaceCharacters.replace(/\n/g, "") : options.whitespaceCharacters;
    const whitespaceCodes = charactersToCodes(this.whitespaceChars);
    this.leadingWhitespaceRe = new RegExp(`^[${whitespaceCodes}]`);
    this.trailingWhitespaceRe = new RegExp(`[${whitespaceCodes}]$`);
    this.allWhitespaceOrEmptyRe = new RegExp(`^[${whitespaceCodes}]*$`);
    this.newlineOrNonWhitespaceRe = new RegExp(`(\\n|[^\\n${whitespaceCodes}])`, "g");
    this.newlineOrNonNewlineStringRe = new RegExp(`(\\n|[^\\n]+)`, "g");
    if (options.preserveNewlines) {
      const wordOrNewlineRe = new RegExp(`\\n|[^\\n${whitespaceCodes}]+`, "gm");
      this.shrinkWrapAdd = function(text, inlineTextBuilder, transform = (str) => str, noWrap = false) {
        if (!text) {
          return;
        }
        const previouslyStashedSpace = inlineTextBuilder.stashedSpace;
        let anyMatch = false;
        let m = wordOrNewlineRe.exec(text);
        if (m) {
          anyMatch = true;
          if (m[0] === "\n") {
            inlineTextBuilder.startNewLine();
          } else if (previouslyStashedSpace || this.testLeadingWhitespace(text)) {
            inlineTextBuilder.pushWord(transform(m[0]), noWrap);
          } else {
            inlineTextBuilder.concatWord(transform(m[0]), noWrap);
          }
          while ((m = wordOrNewlineRe.exec(text)) !== null) {
            if (m[0] === "\n") {
              inlineTextBuilder.startNewLine();
            } else {
              inlineTextBuilder.pushWord(transform(m[0]), noWrap);
            }
          }
        }
        inlineTextBuilder.stashedSpace = previouslyStashedSpace && !anyMatch || this.testTrailingWhitespace(text);
      };
    } else {
      const wordRe = new RegExp(`[^${whitespaceCodes}]+`, "g");
      this.shrinkWrapAdd = function(text, inlineTextBuilder, transform = (str) => str, noWrap = false) {
        if (!text) {
          return;
        }
        const previouslyStashedSpace = inlineTextBuilder.stashedSpace;
        let anyMatch = false;
        let m = wordRe.exec(text);
        if (m) {
          anyMatch = true;
          if (previouslyStashedSpace || this.testLeadingWhitespace(text)) {
            inlineTextBuilder.pushWord(transform(m[0]), noWrap);
          } else {
            inlineTextBuilder.concatWord(transform(m[0]), noWrap);
          }
          while ((m = wordRe.exec(text)) !== null) {
            inlineTextBuilder.pushWord(transform(m[0]), noWrap);
          }
        }
        inlineTextBuilder.stashedSpace = previouslyStashedSpace && !anyMatch || this.testTrailingWhitespace(text);
      };
    }
  }
  /**
   * Add text with only minimal processing.
   * Everything between newlines considered a single word.
   * No whitespace is trimmed.
   * Not affected by preserveNewlines option - `\n` always starts a new line.
   *
   * `noWrap` argument is `true` by default - this won't start a new line
   * even if there is not enough space left in the current line.
   *
   * @param { string }            text              Input text.
   * @param { InlineTextBuilder } inlineTextBuilder A builder to receive processed text.
   * @param { boolean }           [noWrap] Don't wrap text even if the line is too long.
   */
  addLiteral(text, inlineTextBuilder, noWrap = true) {
    if (!text) {
      return;
    }
    const previouslyStashedSpace = inlineTextBuilder.stashedSpace;
    let anyMatch = false;
    let m = this.newlineOrNonNewlineStringRe.exec(text);
    if (m) {
      anyMatch = true;
      if (m[0] === "\n") {
        inlineTextBuilder.startNewLine();
      } else if (previouslyStashedSpace) {
        inlineTextBuilder.pushWord(m[0], noWrap);
      } else {
        inlineTextBuilder.concatWord(m[0], noWrap);
      }
      while ((m = this.newlineOrNonNewlineStringRe.exec(text)) !== null) {
        if (m[0] === "\n") {
          inlineTextBuilder.startNewLine();
        } else {
          inlineTextBuilder.pushWord(m[0], noWrap);
        }
      }
    }
    inlineTextBuilder.stashedSpace = previouslyStashedSpace && !anyMatch;
  }
  /**
   * Test whether the given text starts with HTML whitespace character.
   *
   * @param   { string }  text  The string to test.
   * @returns { boolean }
   */
  testLeadingWhitespace(text) {
    return this.leadingWhitespaceRe.test(text);
  }
  /**
   * Test whether the given text ends with HTML whitespace character.
   *
   * @param   { string }  text  The string to test.
   * @returns { boolean }
   */
  testTrailingWhitespace(text) {
    return this.trailingWhitespaceRe.test(text);
  }
  /**
   * Test whether the given text contains any non-whitespace characters.
   *
   * @param   { string }  text  The string to test.
   * @returns { boolean }
   */
  testContainsWords(text) {
    return !this.allWhitespaceOrEmptyRe.test(text);
  }
  /**
   * Return the number of newlines if there are no words.
   *
   * If any word is found then return zero regardless of the actual number of newlines.
   *
   * @param   { string }  text  Input string.
   * @returns { number }
   */
  countNewlinesNoWords(text) {
    this.newlineOrNonWhitespaceRe.lastIndex = 0;
    let counter = 0;
    let match2;
    while ((match2 = this.newlineOrNonWhitespaceRe.exec(text)) !== null) {
      if (match2[0] === "\n") {
        counter++;
      } else {
        return 0;
      }
    }
    return counter;
  }
};
__name(_WhitespaceProcessor, "WhitespaceProcessor");
var WhitespaceProcessor = _WhitespaceProcessor;
var _BlockTextBuilder = class _BlockTextBuilder {
  /**
   * Creates an instance of BlockTextBuilder.
   *
   * @param { Options } options HtmlToText options.
   * @param { import('selderee').Picker<DomNode, TagDefinition> } picker Selectors decision tree picker.
   * @param { any} [metadata] Optional metadata for HTML document, for use in formatters.
   */
  constructor(options, picker, metadata = void 0) {
    this.options = options;
    this.picker = picker;
    this.metadata = metadata;
    this.whitespaceProcessor = new WhitespaceProcessor(options);
    this._stackItem = new BlockStackItem(options);
    this._wordTransformer = void 0;
  }
  /**
   * Put a word-by-word transform function onto the transformations stack.
   *
   * Mainly used for uppercasing. Can be bypassed to add unformatted text such as URLs.
   *
   * Word transformations applied before wrapping.
   *
   * @param { (str: string) => string } wordTransform Word transformation function.
   */
  pushWordTransform(wordTransform) {
    this._wordTransformer = new TransformerStackItem(this._wordTransformer, wordTransform);
  }
  /**
   * Remove a function from the word transformations stack.
   *
   * @returns { (str: string) => string } A function that was removed.
   */
  popWordTransform() {
    if (!this._wordTransformer) {
      return void 0;
    }
    const transform = this._wordTransformer.transform;
    this._wordTransformer = this._wordTransformer.next;
    return transform;
  }
  /**
   * Ignore wordwrap option in followup inline additions and disable automatic wrapping.
   */
  startNoWrap() {
    this._stackItem.isNoWrap = true;
  }
  /**
   * Return automatic wrapping to behavior defined by options.
   */
  stopNoWrap() {
    this._stackItem.isNoWrap = false;
  }
  /** @returns { (str: string) => string } */
  _getCombinedWordTransformer() {
    const wt = this._wordTransformer ? (str) => applyTransformer(str, this._wordTransformer) : void 0;
    const ce = this.options.encodeCharacters;
    return wt ? ce ? (str) => ce(wt(str)) : wt : ce;
  }
  _popStackItem() {
    const item = this._stackItem;
    this._stackItem = item.next;
    return item;
  }
  /**
   * Add a line break into currently built block.
   */
  addLineBreak() {
    if (!(this._stackItem instanceof BlockStackItem || this._stackItem instanceof ListItemStackItem || this._stackItem instanceof TableCellStackItem)) {
      return;
    }
    if (this._stackItem.isPre) {
      this._stackItem.rawText += "\n";
    } else {
      this._stackItem.inlineTextBuilder.startNewLine();
    }
  }
  /**
   * Allow to break line in case directly following text will not fit.
   */
  addWordBreakOpportunity() {
    if (this._stackItem instanceof BlockStackItem || this._stackItem instanceof ListItemStackItem || this._stackItem instanceof TableCellStackItem) {
      this._stackItem.inlineTextBuilder.wordBreakOpportunity = true;
    }
  }
  /**
   * Add a node inline into the currently built block.
   *
   * @param { string } str
   * Text content of a node to add.
   *
   * @param { object } [param1]
   * Object holding the parameters of the operation.
   *
   * @param { boolean } [param1.noWordTransform]
   * Ignore word transformers if there are any.
   * Don't encode characters as well.
   * (Use this for things like URL addresses).
   */
  addInline(str, { noWordTransform = false } = {}) {
    if (!(this._stackItem instanceof BlockStackItem || this._stackItem instanceof ListItemStackItem || this._stackItem instanceof TableCellStackItem)) {
      return;
    }
    if (this._stackItem.isPre) {
      this._stackItem.rawText += str;
      return;
    }
    if (str.length === 0 || // empty string
    this._stackItem.stashedLineBreaks && // stashed linebreaks make whitespace irrelevant
    !this.whitespaceProcessor.testContainsWords(str)) {
      return;
    }
    if (this.options.preserveNewlines) {
      const newlinesNumber = this.whitespaceProcessor.countNewlinesNoWords(str);
      if (newlinesNumber > 0) {
        this._stackItem.inlineTextBuilder.startNewLine(newlinesNumber);
        return;
      }
    }
    if (this._stackItem.stashedLineBreaks) {
      this._stackItem.inlineTextBuilder.startNewLine(this._stackItem.stashedLineBreaks);
    }
    this.whitespaceProcessor.shrinkWrapAdd(
      str,
      this._stackItem.inlineTextBuilder,
      noWordTransform ? void 0 : this._getCombinedWordTransformer(),
      this._stackItem.isNoWrap
    );
    this._stackItem.stashedLineBreaks = 0;
  }
  /**
   * Add a string inline into the currently built block.
   *
   * Use this for markup elements that don't have to adhere
   * to text layout rules.
   *
   * @param { string } str Text to add.
   */
  addLiteral(str) {
    if (!(this._stackItem instanceof BlockStackItem || this._stackItem instanceof ListItemStackItem || this._stackItem instanceof TableCellStackItem)) {
      return;
    }
    if (str.length === 0) {
      return;
    }
    if (this._stackItem.isPre) {
      this._stackItem.rawText += str;
      return;
    }
    if (this._stackItem.stashedLineBreaks) {
      this._stackItem.inlineTextBuilder.startNewLine(this._stackItem.stashedLineBreaks);
    }
    this.whitespaceProcessor.addLiteral(
      str,
      this._stackItem.inlineTextBuilder,
      this._stackItem.isNoWrap
    );
    this._stackItem.stashedLineBreaks = 0;
  }
  /**
   * Start building a new block.
   *
   * @param { object } [param0]
   * Object holding the parameters of the block.
   *
   * @param { number } [param0.leadingLineBreaks]
   * This block should have at least this number of line breaks to separate it from any preceding block.
   *
   * @param { number }  [param0.reservedLineLength]
   * Reserve this number of characters on each line for block markup.
   *
   * @param { boolean } [param0.isPre]
   * Should HTML whitespace be preserved inside this block.
   */
  openBlock({ leadingLineBreaks = 1, reservedLineLength = 0, isPre = false } = {}) {
    const maxLineLength = Math.max(20, this._stackItem.inlineTextBuilder.maxLineLength - reservedLineLength);
    this._stackItem = new BlockStackItem(
      this.options,
      this._stackItem,
      leadingLineBreaks,
      maxLineLength
    );
    if (isPre) {
      this._stackItem.isPre = true;
    }
  }
  /**
   * Finalize currently built block, add it's content to the parent block.
   *
   * @param { object } [param0]
   * Object holding the parameters of the block.
   *
   * @param { number } [param0.trailingLineBreaks]
   * This block should have at least this number of line breaks to separate it from any following block.
   *
   * @param { (str: string) => string } [param0.blockTransform]
   * A function to transform the block text before adding to the parent block.
   * This happens after word wrap and should be used in combination with reserved line length
   * in order to keep line lengths correct.
   * Used for whole block markup.
   */
  closeBlock({ trailingLineBreaks = 1, blockTransform = void 0 } = {}) {
    const block = this._popStackItem();
    const blockText = blockTransform ? blockTransform(getText2(block)) : getText2(block);
    addText(this._stackItem, blockText, block.leadingLineBreaks, Math.max(block.stashedLineBreaks, trailingLineBreaks));
  }
  /**
   * Start building a new list.
   *
   * @param { object } [param0]
   * Object holding the parameters of the list.
   *
   * @param { number } [param0.maxPrefixLength]
   * Length of the longest list item prefix.
   * If not supplied or too small then list items won't be aligned properly.
   *
   * @param { 'left' | 'right' } [param0.prefixAlign]
   * Specify how prefixes of different lengths have to be aligned
   * within a column.
   *
   * @param { number } [param0.interRowLineBreaks]
   * Minimum number of line breaks between list items.
   *
   * @param { number } [param0.leadingLineBreaks]
   * This list should have at least this number of line breaks to separate it from any preceding block.
   */
  openList({ maxPrefixLength = 0, prefixAlign = "left", interRowLineBreaks = 1, leadingLineBreaks = 2 } = {}) {
    this._stackItem = new ListStackItem(this.options, this._stackItem, {
      interRowLineBreaks,
      leadingLineBreaks,
      maxLineLength: this._stackItem.inlineTextBuilder.maxLineLength,
      maxPrefixLength,
      prefixAlign
    });
  }
  /**
   * Start building a new list item.
   *
   * @param {object} param0
   * Object holding the parameters of the list item.
   *
   * @param { string } [param0.prefix]
   * Prefix for this list item (item number, bullet point, etc).
   */
  openListItem({ prefix: prefix2 = "" } = {}) {
    if (!(this._stackItem instanceof ListStackItem)) {
      throw new Error("Can't add a list item to something that is not a list! Check the formatter.");
    }
    const list = this._stackItem;
    const prefixLength = Math.max(prefix2.length, list.maxPrefixLength);
    const maxLineLength = Math.max(20, list.inlineTextBuilder.maxLineLength - prefixLength);
    this._stackItem = new ListItemStackItem(this.options, list, {
      prefix: prefix2,
      maxLineLength,
      leadingLineBreaks: list.interRowLineBreaks
    });
  }
  /**
   * Finalize currently built list item, add it's content to the parent list.
   */
  closeListItem() {
    const listItem = this._popStackItem();
    const list = listItem.next;
    const prefixLength = Math.max(listItem.prefix.length, list.maxPrefixLength);
    const spacing = "\n" + " ".repeat(prefixLength);
    const prefix2 = list.prefixAlign === "right" ? listItem.prefix.padStart(prefixLength) : listItem.prefix.padEnd(prefixLength);
    const text = prefix2 + getText2(listItem).replace(/\n/g, spacing);
    addText(
      list,
      text,
      listItem.leadingLineBreaks,
      Math.max(listItem.stashedLineBreaks, list.interRowLineBreaks)
    );
  }
  /**
   * Finalize currently built list, add it's content to the parent block.
   *
   * @param { object } param0
   * Object holding the parameters of the list.
   *
   * @param { number } [param0.trailingLineBreaks]
   * This list should have at least this number of line breaks to separate it from any following block.
   */
  closeList({ trailingLineBreaks = 2 } = {}) {
    const list = this._popStackItem();
    const text = getText2(list);
    if (text) {
      addText(this._stackItem, text, list.leadingLineBreaks, trailingLineBreaks);
    }
  }
  /**
   * Start building a table.
   */
  openTable() {
    this._stackItem = new TableStackItem(this._stackItem);
  }
  /**
   * Start building a table row.
   */
  openTableRow() {
    if (!(this._stackItem instanceof TableStackItem)) {
      throw new Error("Can't add a table row to something that is not a table! Check the formatter.");
    }
    this._stackItem = new TableRowStackItem(this._stackItem);
  }
  /**
   * Start building a table cell.
   *
   * @param { object } [param0]
   * Object holding the parameters of the cell.
   *
   * @param { number } [param0.maxColumnWidth]
   * Wrap cell content to this width. Fall back to global wordwrap value if undefined.
   */
  openTableCell({ maxColumnWidth = void 0 } = {}) {
    if (!(this._stackItem instanceof TableRowStackItem)) {
      throw new Error("Can't add a table cell to something that is not a table row! Check the formatter.");
    }
    this._stackItem = new TableCellStackItem(this.options, this._stackItem, maxColumnWidth);
  }
  /**
   * Finalize currently built table cell and add it to parent table row's cells.
   *
   * @param { object } [param0]
   * Object holding the parameters of the cell.
   *
   * @param { number } [param0.colspan] How many columns this cell should occupy.
   * @param { number } [param0.rowspan] How many rows this cell should occupy.
   */
  closeTableCell({ colspan = 1, rowspan = 1 } = {}) {
    const cell = this._popStackItem();
    const text = trimCharacter(getText2(cell), "\n");
    cell.next.cells.push({ colspan, rowspan, text });
  }
  /**
   * Finalize currently built table row and add it to parent table's rows.
   */
  closeTableRow() {
    const row = this._popStackItem();
    row.next.rows.push(row.cells);
  }
  /**
   * Finalize currently built table and add the rendered text to the parent block.
   *
   * @param { object } param0
   * Object holding the parameters of the table.
   *
   * @param { TablePrinter } param0.tableToString
   * A function to convert a table of stringified cells into a complete table.
   *
   * @param { number } [param0.leadingLineBreaks]
   * This table should have at least this number of line breaks to separate if from any preceding block.
   *
   * @param { number } [param0.trailingLineBreaks]
   * This table should have at least this number of line breaks to separate it from any following block.
   */
  closeTable({ tableToString: tableToString2, leadingLineBreaks = 2, trailingLineBreaks = 2 }) {
    const table = this._popStackItem();
    const output = tableToString2(table.rows);
    if (output) {
      addText(this._stackItem, output, leadingLineBreaks, trailingLineBreaks);
    }
  }
  /**
   * Return the rendered text content of this builder.
   *
   * @returns { string }
   */
  toString() {
    return getText2(this._stackItem.getRoot());
  }
};
__name(_BlockTextBuilder, "BlockTextBuilder");
var BlockTextBuilder = _BlockTextBuilder;
function getText2(stackItem) {
  if (!(stackItem instanceof BlockStackItem || stackItem instanceof ListItemStackItem || stackItem instanceof TableCellStackItem)) {
    throw new Error("Only blocks, list items and table cells can be requested for text contents.");
  }
  return stackItem.inlineTextBuilder.isEmpty() ? stackItem.rawText : stackItem.rawText + stackItem.inlineTextBuilder.toString();
}
__name(getText2, "getText");
function addText(stackItem, text, leadingLineBreaks, trailingLineBreaks) {
  if (!(stackItem instanceof BlockStackItem || stackItem instanceof ListItemStackItem || stackItem instanceof TableCellStackItem)) {
    throw new Error("Only blocks, list items and table cells can contain text.");
  }
  const parentText = getText2(stackItem);
  const lineBreaks = Math.max(stackItem.stashedLineBreaks, leadingLineBreaks);
  stackItem.inlineTextBuilder.clear();
  if (parentText) {
    stackItem.rawText = parentText + "\n".repeat(lineBreaks) + text;
  } else {
    stackItem.rawText = text;
    stackItem.leadingLineBreaks = lineBreaks;
  }
  stackItem.stashedLineBreaks = trailingLineBreaks;
}
__name(addText, "addText");
function applyTransformer(str, transformer) {
  return transformer ? applyTransformer(transformer.transform(str), transformer.next) : str;
}
__name(applyTransformer, "applyTransformer");
function compile$1(options = {}) {
  const selectorsWithoutFormat = options.selectors.filter((s3) => !s3.format);
  if (selectorsWithoutFormat.length) {
    throw new Error(
      "Following selectors have no specified format: " + selectorsWithoutFormat.map((s3) => `\`${s3.selector}\``).join(", ")
    );
  }
  const picker = new DecisionTree(
    options.selectors.map((s3) => [s3.selector, s3])
  ).build(hp2Builder);
  if (typeof options.encodeCharacters !== "function") {
    options.encodeCharacters = makeReplacerFromDict(options.encodeCharacters);
  }
  const baseSelectorsPicker = new DecisionTree(
    options.baseElements.selectors.map((s3, i) => [s3, i + 1])
  ).build(hp2Builder);
  function findBaseElements(dom) {
    return findBases(dom, options, baseSelectorsPicker);
  }
  __name(findBaseElements, "findBaseElements");
  const limitedWalk = limitedDepthRecursive(
    options.limits.maxDepth,
    recursiveWalk,
    function(dom, builder) {
      builder.addInline(options.limits.ellipsis || "");
    }
  );
  return function(html, metadata = void 0) {
    return process(html, metadata, options, picker, findBaseElements, limitedWalk);
  };
}
__name(compile$1, "compile$1");
function process(html, metadata, options, picker, findBaseElements, walk) {
  const maxInputLength = options.limits.maxInputLength;
  if (maxInputLength && html && html.length > maxInputLength) {
    console.warn(
      `Input length ${html.length} is above allowed limit of ${maxInputLength}. Truncating without ellipsis.`
    );
    html = html.substring(0, maxInputLength);
  }
  const document2 = parseDocument(html, { decodeEntities: options.decodeEntities });
  const bases = findBaseElements(document2.children);
  const builder = new BlockTextBuilder(options, picker, metadata);
  walk(bases, builder);
  return builder.toString();
}
__name(process, "process");
function findBases(dom, options, baseSelectorsPicker) {
  const results = [];
  function recursiveWalk2(walk, dom2) {
    dom2 = dom2.slice(0, options.limits.maxChildNodes);
    for (const elem of dom2) {
      if (elem.type !== "tag") {
        continue;
      }
      const pickedSelectorIndex = baseSelectorsPicker.pick1(elem);
      if (pickedSelectorIndex > 0) {
        results.push({ selectorIndex: pickedSelectorIndex, element: elem });
      } else if (elem.children) {
        walk(elem.children);
      }
      if (results.length >= options.limits.maxBaseElements) {
        return;
      }
    }
  }
  __name(recursiveWalk2, "recursiveWalk");
  const limitedWalk = limitedDepthRecursive(
    options.limits.maxDepth,
    recursiveWalk2
  );
  limitedWalk(dom);
  if (options.baseElements.orderBy !== "occurrence") {
    results.sort((a, b) => a.selectorIndex - b.selectorIndex);
  }
  return options.baseElements.returnDomByDefault && results.length === 0 ? dom : results.map((x) => x.element);
}
__name(findBases, "findBases");
function recursiveWalk(walk, dom, builder) {
  if (!dom) {
    return;
  }
  const options = builder.options;
  const tooManyChildNodes = dom.length > options.limits.maxChildNodes;
  if (tooManyChildNodes) {
    dom = dom.slice(0, options.limits.maxChildNodes);
    dom.push({
      data: options.limits.ellipsis,
      type: "text"
    });
  }
  for (const elem of dom) {
    switch (elem.type) {
      case "text": {
        builder.addInline(elem.data);
        break;
      }
      case "tag": {
        const tagDefinition = builder.picker.pick1(elem);
        const format = options.formatters[tagDefinition.format];
        format(elem, walk, builder, tagDefinition.options || {});
        break;
      }
    }
  }
  return;
}
__name(recursiveWalk, "recursiveWalk");
function makeReplacerFromDict(dict) {
  if (!dict || Object.keys(dict).length === 0) {
    return void 0;
  }
  const entries = Object.entries(dict).filter(([, v]) => v !== false);
  const regex = new RegExp(
    entries.map(([c2]) => `(${unicodeEscape([...c2][0])})`).join("|"),
    "g"
  );
  const values = entries.map(([, v]) => v);
  const replacer = /* @__PURE__ */ __name((m, ...cgs) => values[cgs.findIndex((cg) => cg)], "replacer");
  return (str) => str.replace(regex, replacer);
}
__name(makeReplacerFromDict, "makeReplacerFromDict");
function formatSkip(elem, walk, builder, formatOptions) {
}
__name(formatSkip, "formatSkip");
function formatInlineString(elem, walk, builder, formatOptions) {
  builder.addLiteral(formatOptions.string || "");
}
__name(formatInlineString, "formatInlineString");
function formatBlockString(elem, walk, builder, formatOptions) {
  builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks || 2 });
  builder.addLiteral(formatOptions.string || "");
  builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 2 });
}
__name(formatBlockString, "formatBlockString");
function formatInline(elem, walk, builder, formatOptions) {
  walk(elem.children, builder);
}
__name(formatInline, "formatInline");
function formatBlock$1(elem, walk, builder, formatOptions) {
  builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks || 2 });
  walk(elem.children, builder);
  builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 2 });
}
__name(formatBlock$1, "formatBlock$1");
function renderOpenTag(elem) {
  const attrs = elem.attribs && elem.attribs.length ? " " + Object.entries(elem.attribs).map(([k, v]) => v === "" ? k : `${k}=${v.replace(/"/g, "&quot;")}`).join(" ") : "";
  return `<${elem.name}${attrs}>`;
}
__name(renderOpenTag, "renderOpenTag");
function renderCloseTag(elem) {
  return `</${elem.name}>`;
}
__name(renderCloseTag, "renderCloseTag");
function formatInlineTag(elem, walk, builder, formatOptions) {
  builder.startNoWrap();
  builder.addLiteral(renderOpenTag(elem));
  builder.stopNoWrap();
  walk(elem.children, builder);
  builder.startNoWrap();
  builder.addLiteral(renderCloseTag(elem));
  builder.stopNoWrap();
}
__name(formatInlineTag, "formatInlineTag");
function formatBlockTag(elem, walk, builder, formatOptions) {
  builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks || 2 });
  builder.startNoWrap();
  builder.addLiteral(renderOpenTag(elem));
  builder.stopNoWrap();
  walk(elem.children, builder);
  builder.startNoWrap();
  builder.addLiteral(renderCloseTag(elem));
  builder.stopNoWrap();
  builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 2 });
}
__name(formatBlockTag, "formatBlockTag");
function formatInlineHtml(elem, walk, builder, formatOptions) {
  builder.startNoWrap();
  builder.addLiteral(
    render(elem, { decodeEntities: builder.options.decodeEntities })
  );
  builder.stopNoWrap();
}
__name(formatInlineHtml, "formatInlineHtml");
function formatBlockHtml(elem, walk, builder, formatOptions) {
  builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks || 2 });
  builder.startNoWrap();
  builder.addLiteral(
    render(elem, { decodeEntities: builder.options.decodeEntities })
  );
  builder.stopNoWrap();
  builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 2 });
}
__name(formatBlockHtml, "formatBlockHtml");
function formatInlineSurround(elem, walk, builder, formatOptions) {
  builder.addLiteral(formatOptions.prefix || "");
  walk(elem.children, builder);
  builder.addLiteral(formatOptions.suffix || "");
}
__name(formatInlineSurround, "formatInlineSurround");
var genericFormatters = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  block: formatBlock$1,
  blockHtml: formatBlockHtml,
  blockString: formatBlockString,
  blockTag: formatBlockTag,
  inline: formatInline,
  inlineHtml: formatInlineHtml,
  inlineString: formatInlineString,
  inlineSurround: formatInlineSurround,
  inlineTag: formatInlineTag,
  skip: formatSkip
});
function getRow(matrix, j) {
  if (!matrix[j]) {
    matrix[j] = [];
  }
  return matrix[j];
}
__name(getRow, "getRow");
function findFirstVacantIndex(row, x = 0) {
  while (row[x]) {
    x++;
  }
  return x;
}
__name(findFirstVacantIndex, "findFirstVacantIndex");
function transposeInPlace(matrix, maxSize) {
  for (let i = 0; i < maxSize; i++) {
    const rowI = getRow(matrix, i);
    for (let j = 0; j < i; j++) {
      const rowJ = getRow(matrix, j);
      if (rowI[j] || rowJ[i]) {
        const temp = rowI[j];
        rowI[j] = rowJ[i];
        rowJ[i] = temp;
      }
    }
  }
}
__name(transposeInPlace, "transposeInPlace");
function putCellIntoLayout(cell, layout, baseRow, baseCol) {
  for (let r2 = 0; r2 < cell.rowspan; r2++) {
    const layoutRow = getRow(layout, baseRow + r2);
    for (let c2 = 0; c2 < cell.colspan; c2++) {
      layoutRow[baseCol + c2] = cell;
    }
  }
}
__name(putCellIntoLayout, "putCellIntoLayout");
function getOrInitOffset(offsets, index) {
  if (offsets[index] === void 0) {
    offsets[index] = index === 0 ? 0 : 1 + getOrInitOffset(offsets, index - 1);
  }
  return offsets[index];
}
__name(getOrInitOffset, "getOrInitOffset");
function updateOffset(offsets, base, span, value) {
  offsets[base + span] = Math.max(
    getOrInitOffset(offsets, base + span),
    getOrInitOffset(offsets, base) + value
  );
}
__name(updateOffset, "updateOffset");
function tableToString(tableRows, rowSpacing, colSpacing) {
  const layout = [];
  let colNumber = 0;
  const rowNumber = tableRows.length;
  const rowOffsets = [0];
  for (let j = 0; j < rowNumber; j++) {
    const layoutRow = getRow(layout, j);
    const cells = tableRows[j];
    let x = 0;
    for (let i = 0; i < cells.length; i++) {
      const cell = cells[i];
      x = findFirstVacantIndex(layoutRow, x);
      putCellIntoLayout(cell, layout, j, x);
      x += cell.colspan;
      cell.lines = cell.text.split("\n");
      const cellHeight = cell.lines.length;
      updateOffset(rowOffsets, j, cell.rowspan, cellHeight + rowSpacing);
    }
    colNumber = layoutRow.length > colNumber ? layoutRow.length : colNumber;
  }
  transposeInPlace(layout, rowNumber > colNumber ? rowNumber : colNumber);
  const outputLines = [];
  const colOffsets = [0];
  for (let x = 0; x < colNumber; x++) {
    let y = 0;
    let cell;
    const rowsInThisColumn = Math.min(rowNumber, layout[x].length);
    while (y < rowsInThisColumn) {
      cell = layout[x][y];
      if (cell) {
        if (!cell.rendered) {
          let cellWidth = 0;
          for (let j = 0; j < cell.lines.length; j++) {
            const line = cell.lines[j];
            const lineOffset = rowOffsets[y] + j;
            outputLines[lineOffset] = (outputLines[lineOffset] || "").padEnd(colOffsets[x]) + line;
            cellWidth = line.length > cellWidth ? line.length : cellWidth;
          }
          updateOffset(colOffsets, x, cell.colspan, cellWidth + colSpacing);
          cell.rendered = true;
        }
        y += cell.rowspan;
      } else {
        const lineOffset = rowOffsets[y];
        outputLines[lineOffset] = outputLines[lineOffset] || "";
        y++;
      }
    }
  }
  return outputLines.join("\n");
}
__name(tableToString, "tableToString");
function formatLineBreak(elem, walk, builder, formatOptions) {
  builder.addLineBreak();
}
__name(formatLineBreak, "formatLineBreak");
function formatWbr(elem, walk, builder, formatOptions) {
  builder.addWordBreakOpportunity();
}
__name(formatWbr, "formatWbr");
function formatHorizontalLine(elem, walk, builder, formatOptions) {
  builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks || 2 });
  builder.addInline("-".repeat(formatOptions.length || builder.options.wordwrap || 40));
  builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 2 });
}
__name(formatHorizontalLine, "formatHorizontalLine");
function formatParagraph(elem, walk, builder, formatOptions) {
  builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks || 2 });
  walk(elem.children, builder);
  builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 2 });
}
__name(formatParagraph, "formatParagraph");
function formatPre(elem, walk, builder, formatOptions) {
  builder.openBlock({
    isPre: true,
    leadingLineBreaks: formatOptions.leadingLineBreaks || 2
  });
  walk(elem.children, builder);
  builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 2 });
}
__name(formatPre, "formatPre");
function formatHeading(elem, walk, builder, formatOptions) {
  builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks || 2 });
  if (formatOptions.uppercase !== false) {
    builder.pushWordTransform((str) => str.toUpperCase());
    walk(elem.children, builder);
    builder.popWordTransform();
  } else {
    walk(elem.children, builder);
  }
  builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks || 2 });
}
__name(formatHeading, "formatHeading");
function formatBlockquote(elem, walk, builder, formatOptions) {
  builder.openBlock({
    leadingLineBreaks: formatOptions.leadingLineBreaks || 2,
    reservedLineLength: 2
  });
  walk(elem.children, builder);
  builder.closeBlock({
    trailingLineBreaks: formatOptions.trailingLineBreaks || 2,
    blockTransform: /* @__PURE__ */ __name((str) => (formatOptions.trimEmptyLines !== false ? trimCharacter(str, "\n") : str).split("\n").map((line) => "> " + line).join("\n"), "blockTransform")
  });
}
__name(formatBlockquote, "formatBlockquote");
function withBrackets(str, brackets) {
  if (!brackets) {
    return str;
  }
  const lbr = typeof brackets[0] === "string" ? brackets[0] : "[";
  const rbr = typeof brackets[1] === "string" ? brackets[1] : "]";
  return lbr + str + rbr;
}
__name(withBrackets, "withBrackets");
function pathRewrite(path, rewriter, baseUrl, metadata, elem) {
  const modifiedPath = typeof rewriter === "function" ? rewriter(path, metadata, elem) : path;
  return modifiedPath[0] === "/" && baseUrl ? trimCharacterEnd(baseUrl, "/") + modifiedPath : modifiedPath;
}
__name(pathRewrite, "pathRewrite");
function formatImage(elem, walk, builder, formatOptions) {
  const attribs = elem.attribs || {};
  const alt = attribs.alt ? attribs.alt : "";
  const src = !attribs.src ? "" : pathRewrite(attribs.src, formatOptions.pathRewrite, formatOptions.baseUrl, builder.metadata, elem);
  const text = !src ? alt : !alt ? withBrackets(src, formatOptions.linkBrackets) : alt + " " + withBrackets(src, formatOptions.linkBrackets);
  builder.addInline(text, { noWordTransform: true });
}
__name(formatImage, "formatImage");
function formatAnchor(elem, walk, builder, formatOptions) {
  function getHref() {
    if (formatOptions.ignoreHref) {
      return "";
    }
    if (!elem.attribs || !elem.attribs.href) {
      return "";
    }
    let href2 = elem.attribs.href.replace(/^mailto:/, "");
    if (formatOptions.noAnchorUrl && href2[0] === "#") {
      return "";
    }
    href2 = pathRewrite(href2, formatOptions.pathRewrite, formatOptions.baseUrl, builder.metadata, elem);
    return href2;
  }
  __name(getHref, "getHref");
  const href = getHref();
  if (!href) {
    walk(elem.children, builder);
  } else {
    let text = "";
    builder.pushWordTransform(
      (str) => {
        if (str) {
          text += str;
        }
        return str;
      }
    );
    walk(elem.children, builder);
    builder.popWordTransform();
    const hideSameLink = formatOptions.hideLinkHrefIfSameAsText && href === text;
    if (!hideSameLink) {
      builder.addInline(
        !text ? href : " " + withBrackets(href, formatOptions.linkBrackets),
        { noWordTransform: true }
      );
    }
  }
}
__name(formatAnchor, "formatAnchor");
function formatList(elem, walk, builder, formatOptions, nextPrefixCallback) {
  const isNestedList = get(elem, ["parent", "name"]) === "li";
  let maxPrefixLength = 0;
  const listItems = (elem.children || []).filter((child) => child.type !== "text" || !/^\s*$/.test(child.data)).map(function(child) {
    if (child.name !== "li") {
      return { node: child, prefix: "" };
    }
    const prefix2 = isNestedList ? nextPrefixCallback().trimStart() : nextPrefixCallback();
    if (prefix2.length > maxPrefixLength) {
      maxPrefixLength = prefix2.length;
    }
    return { node: child, prefix: prefix2 };
  });
  if (!listItems.length) {
    return;
  }
  builder.openList({
    interRowLineBreaks: 1,
    leadingLineBreaks: isNestedList ? 1 : formatOptions.leadingLineBreaks || 2,
    maxPrefixLength,
    prefixAlign: "left"
  });
  for (const { node, prefix: prefix2 } of listItems) {
    builder.openListItem({ prefix: prefix2 });
    walk([node], builder);
    builder.closeListItem();
  }
  builder.closeList({ trailingLineBreaks: isNestedList ? 1 : formatOptions.trailingLineBreaks || 2 });
}
__name(formatList, "formatList");
function formatUnorderedList(elem, walk, builder, formatOptions) {
  const prefix2 = formatOptions.itemPrefix || " * ";
  return formatList(elem, walk, builder, formatOptions, () => prefix2);
}
__name(formatUnorderedList, "formatUnorderedList");
function formatOrderedList(elem, walk, builder, formatOptions) {
  let nextIndex = Number(elem.attribs.start || "1");
  const indexFunction = getOrderedListIndexFunction(elem.attribs.type);
  const nextPrefixCallback = /* @__PURE__ */ __name(() => " " + indexFunction(nextIndex++) + ". ", "nextPrefixCallback");
  return formatList(elem, walk, builder, formatOptions, nextPrefixCallback);
}
__name(formatOrderedList, "formatOrderedList");
function getOrderedListIndexFunction(olType = "1") {
  switch (olType) {
    case "a":
      return (i) => numberToLetterSequence(i, "a");
    case "A":
      return (i) => numberToLetterSequence(i, "A");
    case "i":
      return (i) => numberToRoman(i).toLowerCase();
    case "I":
      return (i) => numberToRoman(i);
    case "1":
    default:
      return (i) => i.toString();
  }
}
__name(getOrderedListIndexFunction, "getOrderedListIndexFunction");
function splitClassesAndIds(selectors) {
  const classes = [];
  const ids = [];
  for (const selector of selectors) {
    if (selector.startsWith(".")) {
      classes.push(selector.substring(1));
    } else if (selector.startsWith("#")) {
      ids.push(selector.substring(1));
    }
  }
  return { classes, ids };
}
__name(splitClassesAndIds, "splitClassesAndIds");
function isDataTable(attr, tables) {
  if (tables === true) {
    return true;
  }
  if (!attr) {
    return false;
  }
  const { classes, ids } = splitClassesAndIds(tables);
  const attrClasses = (attr["class"] || "").split(" ");
  const attrIds = (attr["id"] || "").split(" ");
  return attrClasses.some((x) => classes.includes(x)) || attrIds.some((x) => ids.includes(x));
}
__name(isDataTable, "isDataTable");
function formatTable(elem, walk, builder, formatOptions) {
  return isDataTable(elem.attribs, builder.options.tables) ? formatDataTable(elem, walk, builder, formatOptions) : formatBlock(elem, walk, builder, formatOptions);
}
__name(formatTable, "formatTable");
function formatBlock(elem, walk, builder, formatOptions) {
  builder.openBlock({ leadingLineBreaks: formatOptions.leadingLineBreaks });
  walk(elem.children, builder);
  builder.closeBlock({ trailingLineBreaks: formatOptions.trailingLineBreaks });
}
__name(formatBlock, "formatBlock");
function formatDataTable(elem, walk, builder, formatOptions) {
  builder.openTable();
  elem.children.forEach(walkTable);
  builder.closeTable({
    tableToString: /* @__PURE__ */ __name((rows) => {
      var _a6, _b;
      return tableToString(rows, (_a6 = formatOptions.rowSpacing) != null ? _a6 : 0, (_b = formatOptions.colSpacing) != null ? _b : 3);
    }, "tableToString"),
    leadingLineBreaks: formatOptions.leadingLineBreaks,
    trailingLineBreaks: formatOptions.trailingLineBreaks
  });
  function formatCell(cellNode) {
    const colspan = +get(cellNode, ["attribs", "colspan"]) || 1;
    const rowspan = +get(cellNode, ["attribs", "rowspan"]) || 1;
    builder.openTableCell({ maxColumnWidth: formatOptions.maxColumnWidth });
    walk(cellNode.children, builder);
    builder.closeTableCell({ colspan, rowspan });
  }
  __name(formatCell, "formatCell");
  function walkTable(elem2) {
    if (elem2.type !== "tag") {
      return;
    }
    const formatHeaderCell = formatOptions.uppercaseHeaderCells !== false ? (cellNode) => {
      builder.pushWordTransform((str) => str.toUpperCase());
      formatCell(cellNode);
      builder.popWordTransform();
    } : formatCell;
    switch (elem2.name) {
      case "thead":
      case "tbody":
      case "tfoot":
      case "center":
        elem2.children.forEach(walkTable);
        return;
      case "tr": {
        builder.openTableRow();
        for (const childOfTr of elem2.children) {
          if (childOfTr.type !== "tag") {
            continue;
          }
          switch (childOfTr.name) {
            case "th": {
              formatHeaderCell(childOfTr);
              break;
            }
            case "td": {
              formatCell(childOfTr);
              break;
            }
          }
        }
        builder.closeTableRow();
        break;
      }
    }
  }
  __name(walkTable, "walkTable");
}
__name(formatDataTable, "formatDataTable");
var textFormatters = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  anchor: formatAnchor,
  blockquote: formatBlockquote,
  dataTable: formatDataTable,
  heading: formatHeading,
  horizontalLine: formatHorizontalLine,
  image: formatImage,
  lineBreak: formatLineBreak,
  orderedList: formatOrderedList,
  paragraph: formatParagraph,
  pre: formatPre,
  table: formatTable,
  unorderedList: formatUnorderedList,
  wbr: formatWbr
});
var DEFAULT_OPTIONS = {
  baseElements: {
    selectors: ["body"],
    orderBy: "selectors",
    // 'selectors' | 'occurrence'
    returnDomByDefault: true
  },
  decodeEntities: true,
  encodeCharacters: {},
  formatters: {},
  limits: {
    ellipsis: "...",
    maxBaseElements: void 0,
    maxChildNodes: void 0,
    maxDepth: void 0,
    maxInputLength: 1 << 24
    // 16_777_216
  },
  longWordSplit: {
    forceWrapOnLimit: false,
    wrapCharacters: []
  },
  preserveNewlines: false,
  selectors: [
    { selector: "*", format: "inline" },
    {
      selector: "a",
      format: "anchor",
      options: {
        baseUrl: null,
        hideLinkHrefIfSameAsText: false,
        ignoreHref: false,
        linkBrackets: ["[", "]"],
        noAnchorUrl: true
      }
    },
    { selector: "article", format: "block", options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
    { selector: "aside", format: "block", options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
    {
      selector: "blockquote",
      format: "blockquote",
      options: { leadingLineBreaks: 2, trailingLineBreaks: 2, trimEmptyLines: true }
    },
    { selector: "br", format: "lineBreak" },
    { selector: "div", format: "block", options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
    { selector: "footer", format: "block", options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
    { selector: "form", format: "block", options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
    { selector: "h1", format: "heading", options: { leadingLineBreaks: 3, trailingLineBreaks: 2, uppercase: true } },
    { selector: "h2", format: "heading", options: { leadingLineBreaks: 3, trailingLineBreaks: 2, uppercase: true } },
    { selector: "h3", format: "heading", options: { leadingLineBreaks: 3, trailingLineBreaks: 2, uppercase: true } },
    { selector: "h4", format: "heading", options: { leadingLineBreaks: 2, trailingLineBreaks: 2, uppercase: true } },
    { selector: "h5", format: "heading", options: { leadingLineBreaks: 2, trailingLineBreaks: 2, uppercase: true } },
    { selector: "h6", format: "heading", options: { leadingLineBreaks: 2, trailingLineBreaks: 2, uppercase: true } },
    { selector: "header", format: "block", options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
    {
      selector: "hr",
      format: "horizontalLine",
      options: { leadingLineBreaks: 2, length: void 0, trailingLineBreaks: 2 }
    },
    {
      selector: "img",
      format: "image",
      options: { baseUrl: null, linkBrackets: ["[", "]"] }
    },
    { selector: "main", format: "block", options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
    { selector: "nav", format: "block", options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
    {
      selector: "ol",
      format: "orderedList",
      options: { leadingLineBreaks: 2, trailingLineBreaks: 2 }
    },
    { selector: "p", format: "paragraph", options: { leadingLineBreaks: 2, trailingLineBreaks: 2 } },
    { selector: "pre", format: "pre", options: { leadingLineBreaks: 2, trailingLineBreaks: 2 } },
    { selector: "section", format: "block", options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
    {
      selector: "table",
      format: "table",
      options: {
        colSpacing: 3,
        leadingLineBreaks: 2,
        maxColumnWidth: 60,
        rowSpacing: 0,
        trailingLineBreaks: 2,
        uppercaseHeaderCells: true
      }
    },
    {
      selector: "ul",
      format: "unorderedList",
      options: { itemPrefix: " * ", leadingLineBreaks: 2, trailingLineBreaks: 2 }
    },
    { selector: "wbr", format: "wbr" }
  ],
  tables: [],
  // deprecated
  whitespaceCharacters: " 	\r\n\f\u200B",
  wordwrap: 80
};
var concatMerge = /* @__PURE__ */ __name((acc, src, options) => [...acc, ...src], "concatMerge");
var overwriteMerge = /* @__PURE__ */ __name((acc, src, options) => [...src], "overwriteMerge");
var selectorsMerge = /* @__PURE__ */ __name((acc, src, options) => acc.some((s3) => typeof s3 === "object") ? concatMerge(acc, src) : overwriteMerge(acc, src), "selectorsMerge");
function compile(options = {}) {
  options = (0, import_deepmerge.default)(
    DEFAULT_OPTIONS,
    options,
    {
      arrayMerge: overwriteMerge,
      customMerge: /* @__PURE__ */ __name((key) => key === "selectors" ? selectorsMerge : void 0, "customMerge")
    }
  );
  options.formatters = Object.assign({}, genericFormatters, textFormatters, options.formatters);
  options.selectors = mergeDuplicatesPreferLast(options.selectors, (s3) => s3.selector);
  handleDeprecatedOptions(options);
  return compile$1(options);
}
__name(compile, "compile");
function convert(html, options = {}, metadata = void 0) {
  return compile(options)(html, metadata);
}
__name(convert, "convert");
function handleDeprecatedOptions(options) {
  if (options.tags) {
    const tagDefinitions = Object.entries(options.tags).map(
      ([selector, definition]) => __spreadProps(__spreadValues({}, definition), { selector: selector || "*" })
    );
    options.selectors.push(...tagDefinitions);
    options.selectors = mergeDuplicatesPreferLast(options.selectors, (s3) => s3.selector);
  }
  function set(obj, path, value) {
    const valueKey = path.pop();
    for (const key of path) {
      let nested = obj[key];
      if (!nested) {
        nested = {};
        obj[key] = nested;
      }
      obj = nested;
    }
    obj[valueKey] = value;
  }
  __name(set, "set");
  if (options["baseElement"]) {
    const baseElement = options["baseElement"];
    set(
      options,
      ["baseElements", "selectors"],
      Array.isArray(baseElement) ? baseElement : [baseElement]
    );
  }
  if (options["returnDomByDefault"] !== void 0) {
    set(options, ["baseElements", "returnDomByDefault"], options["returnDomByDefault"]);
  }
  for (const definition of options.selectors) {
    if (definition.format === "anchor" && get(definition, ["options", "noLinkBrackets"])) {
      set(definition, ["options", "linkBrackets"], false);
    }
  }
}
__name(handleDeprecatedOptions, "handleDeprecatedOptions");

// src/placeholders/quill.ts
function renderQuill(delta, substitutions) {
  const jsonRaw = JSON.parse(delta);
  const ops = jsonRaw.ops.map((op) => {
    if (typeof op.insert === "string") {
      return op;
    }
    const mention = op.insert.mention.id;
    return {
      insert: substitutions[mention]
    };
  });
  const cfg = {};
  const converter = new import_quill_delta_to_html.QuillDeltaToHtmlConverter(ops, cfg);
  const html = converter.convert();
  let text = convert(html, {});
  text = text.replace("\n", "");
  return text;
}
__name(renderQuill, "renderQuill");

// src/spaces/custom-properties.ts
var customPropertyPlaceholderOpener = "{{";
var customPropertyPlaceholderCloser = "}}";
var customPropertyKeyPattern = "[-a-zA-Z0-9_]+";
var customPropertyPlaceholderPattern = `${customPropertyPlaceholderOpener}${customPropertyKeyPattern}${customPropertyPlaceholderCloser}`;
var customPropertyKeyRegexMatch = new RegExp(`^${customPropertyKeyPattern}$`);
var customPropertyKeyRegexContains = new RegExp(customPropertyKeyPattern);
var customPropertyPlaceholderRegexMatch = new RegExp(`^${customPropertyPlaceholderPattern}$`);
var customPropertyPlaceholderRegexContains = new RegExp(customPropertyPlaceholderPattern);

// src/spaces/space-helpers.ts
function getCompanyInitials(companyName) {
  const split = companyName.split(" ");
  if (split.length >= 2) {
    return `${split[0].charAt(0)}${split[1].charAt(0)}`;
  } else {
    return `${split[0].charAt(0)}${split[0].charAt(1)}`;
  }
}
__name(getCompanyInitials, "getCompanyInitials");
var httpRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
var isValidCompanyWebsiteUrl = /* @__PURE__ */ __name((url) => {
  if (!url) {
    return true;
  }
  let _url = url;
  if (!_url.includes("http://") && !_url.includes("https://")) {
    _url = `https://${_url}`;
  }
  return httpRegex.test(_url);
}, "isValidCompanyWebsiteUrl");

// src/spaces/space.types.ts
import { z as z32 } from "zod";
var spaceEntitySchema = z32.object({
  id: z32.string(),
  rootNodeId: z32.string()
});

// src/spaces/space-filters.ts
import { z as z33 } from "zod";
var spacesQueryFiltersSchema = z33.object({
  viewId: z33.string().nullish(),
  spaceIds: z33.array(z33.string()).nullish(),
  spaceName: z33.string().nullish(),
  spaceType: z33.enum([
    "all",
    "active",
    "archived"
  ]).default("active"),
  ownerIds: z33.array(z33.string()).optional(),
  mapStatus: z33.array(z33.enum([
    "notCreated",
    "notStarted",
    "stalled",
    "inProgress",
    "overdue",
    "completed"
  ])).nullish(),
  templateIds: z33.array(z33.string()).nullish(),
  teamIds: z33.array(z33.string()).nullish(),
  collaboratorAccess: z33.boolean().nullish(),
  myTeamAccess: z33.boolean().nullish(),
  companyTeamAccess: z33.boolean().nullish(),
  createdAfter: z33.date().nullish(),
  sortBy: z33.enum([
    "companyName",
    "mapProgress",
    "createdAt",
    "updatedAt",
    "ownerId",
    "lastVisit",
    "activitiesCount",
    "score",
    "visits"
  ]).nullish(),
  sortDirection: z33.enum([
    "asc",
    "desc"
  ]).nullish(),
  page: z33.number().nullish(),
  pageSize: z33.number().nullish()
});

// src/spaces/batch-actions.dto.ts
import { z as z34 } from "zod";
var MAX_BATCH_SIZE = 100;
var SpaceRootNodeIdsSchema = z34.array(z34.string()).min(1, "At least one space root node ID is required").max(MAX_BATCH_SIZE, `Maximum ${MAX_BATCH_SIZE} spaces can be processed in a single batch`).refine((ids) => new Set(ids).size === ids.length, "Space root node IDs must be unique");
var BatchDeleteSpacesSchema = z34.object({
  spaceRootNodeIds: SpaceRootNodeIdsSchema
});
var BatchArchiveSpacesSchema = z34.object({
  spaceRootNodeIds: SpaceRootNodeIdsSchema,
  archived: z34.boolean()
});
var BatchChangeOwnerSchema = z34.object({
  spaceRootNodeIds: SpaceRootNodeIdsSchema,
  ownerId: z34.string().min(1, "Owner ID is required")
});

// src/templates/template-generation-request.ts
import { z as z35 } from "zod";
var templateGenerationSpaceCreationSchema = z35.object({
  companyName: z35.string(),
  contactFirstName: z35.string(),
  contactLastName: z35.string(),
  logo: z35.string().nullable(),
  spaceId: z35.string().nullish(),
  authToken: z35.string().nullish()
});
var TTemplateGenerationRequestStatus = /* @__PURE__ */ function(TTemplateGenerationRequestStatus2) {
  TTemplateGenerationRequestStatus2["PREVIEW"] = "PREVIEW";
  TTemplateGenerationRequestStatus2["STARTED"] = "STARTED";
  TTemplateGenerationRequestStatus2["TEMPLATE_GENERATOR_RESPONSE_RECEIVED"] = "TEMPLATE_GENERATOR_RESPONSE_RECEIVED";
  TTemplateGenerationRequestStatus2["BLOCK_CREATOR_RESPONSE_RECEIVED"] = "BLOCK_CREATOR_RESPONSE_RECEIVED";
  TTemplateGenerationRequestStatus2["OUTPUT_VALIDATION"] = "OUTPUT_VALIDATION";
  TTemplateGenerationRequestStatus2["COMPLETED"] = "COMPLETED";
  TTemplateGenerationRequestStatus2["FALLBACK_USED"] = "FALLBACK_USED";
  TTemplateGenerationRequestStatus2["ERROR"] = "ERROR";
  TTemplateGenerationRequestStatus2["SPACE_CREATION_STARTED"] = "SPACE_CREATION_STARTED";
  TTemplateGenerationRequestStatus2["SPACE_CREATION_COMPLETED"] = "SPACE_CREATION_COMPLETED";
  TTemplateGenerationRequestStatus2["SPACE_CREATION_FAILED"] = "SPACE_CREATION_FAILED";
  return TTemplateGenerationRequestStatus2;
}({});
var TemplateGenerationRequestStatus = z35.nativeEnum(TTemplateGenerationRequestStatus);
var TemplateGenerationRequestSchema = z35.object({
  id: z35.string().uuid(),
  createdAt: z35.date(),
  updatedAt: z35.date(),
  tenantId: z35.string(),
  sellerId: z35.string(),
  createdTemplateRootNodeId: z35.string().nullable(),
  userInput: z35.record(z35.any()),
  previewResponse: z35.record(z35.any()).nullable(),
  templateBuilderResponse: z35.string().nullable(),
  blockCreatorResponse: z35.record(z35.any()).nullable(),
  fallbackIsEnabled: z35.boolean(),
  spaceCreationProperties: templateGenerationSpaceCreationSchema.nullish(),
  status: TemplateGenerationRequestStatus,
  error: z35.string().nullable()
});

// src/templates/template-generation-creation.dto.ts
import { z as z36 } from "zod";
var GenerateTemplateSchema = z36.object({
  context: z36.string().optional(),
  useCase: z36.enum([
    "sales",
    "onboarding",
    "other"
  ]),
  spaceCreationProperties: templateGenerationSpaceCreationSchema.omit({
    spaceId: true,
    authToken: true
  }).nullish()
});

// src/templates/open-restriction.ts
var OpenRestriction = /* @__PURE__ */ function(OpenRestriction2) {
  OpenRestriction2["OPEN"] = "OPEN";
  OpenRestriction2["OPEN_WITH_EMAIL"] = "OPEN_WITH_EMAIL";
  OpenRestriction2["RESTRICTED"] = "RESTRICTED";
  return OpenRestriction2;
}({});

// src/tenant/tenant.ts
import { z as z38 } from "zod";

// src/tenant/CompanyDetails.ts
import { z as z37 } from "zod";
var companyDetailsSchema = z37.object({
  employeeCount: z37.number().nullable(),
  industries: z37.array(z37.string()).nullable(),
  location: z37.string().nullable(),
  description: z37.string().nullable(),
  images: z37.array(z37.string()).nullable(),
  links: z37.array(z37.string()).nullable(),
  logos: z37.array(z37.string()).nullable()
});

// src/tenant/tenant.ts
var tenantSchema = z38.object({
  name: z38.string(),
  subdomain: z38.string().nullable(),
  theme: z38.enum([
    "Dark"
  ]),
  color: z38.string().regex(/^#(?:[0-9a-fA-F]{3}){1,2}$/),
  logo_s3ObjectKey: z38.string(),
  logo_s3ObjectUrl: z38.string().url(),
  background_s3ObjectKey: z38.string(),
  background_s3ObjectUrl: z38.string().url(),
  favicon_s3ObjectKey: z38.string().nullable(),
  favicon_s3ObjectUrl: z38.string().nullable(),
  imprint: z38.string().url(),
  privacyPolicy: z38.string().url(),
  customDomain: z38.string().nullable(),
  intercomApiBase: z38.enum([
    "https://api.eu.intercom.io",
    "https://api.intercom.io"
  ]).nullable(),
  intercomId: z38.string().nullable(),
  aiWritingAssistantIsEnabled: z38.boolean(),
  aiWritingAssistantOptOut: z38.boolean(),
  id: z38.string(),
  companyDetails: companyDetailsSchema.nullable()
});

// src/tenant/createTenantInputSchema.ts
import { z as z40 } from "zod";

// src/tenant/tenantFieldSchemas.ts
var import_isFQDN = __toESM(require_isFQDN());
import { z as z39 } from "zod";
var imageSourceSchema = z39.object({
  source: z39.string().regex(/^S3$/),
  s3Key: z39.string().min(1).max(255)
});
var subdomainSchema = z39.string().regex(/^[a-z0-9\-]*$/).max(200);
var fullyQualifiedDomainNameSchema = z39.string().refine((value) => (0, import_isFQDN.default)(value), {
  message: "Invalid fully qualified domain name"
});
var themeSchema = z39.enum([
  "Light",
  "Dark"
]);
var primaryColorSchema = z39.string().regex(/^#[a-fA-F0-9]{6}$/);
var customColorsSchema = z39.array(primaryColorSchema).nullish();
var tenantNameSchema = z39.string().min(1).max(200);
var imprintSchema = z39.string();
var privacyPolicySchema = z39.string();
var logoImageSchema = imageSourceSchema;
var backgroundImageSchema = imageSourceSchema;
var firstUserSchema = z39.object({
  email: z39.string().email(),
  firstName: z39.string().min(1),
  lastName: z39.string().min(1)
});

// src/tenant/createTenantInputSchema.ts
var createTenantInputSchema = z40.object({
  subdomain: subdomainSchema,
  customDomain: fullyQualifiedDomainNameSchema.nullish(),
  theme: themeSchema,
  primaryColor: primaryColorSchema,
  tenantName: tenantNameSchema,
  websiteUrl: z40.string().nullish(),
  imprint: imprintSchema.optional(),
  privacyPolicy: privacyPolicySchema.optional(),
  logoImage: logoImageSchema.optional(),
  backgroundImage: backgroundImageSchema.optional(),
  firstUser: firstUserSchema,
  seatAllowance: z40.number().nullish(),
  onboardingSharedPageUrl: z40.string().optional(),
  whitelabelTenantLogoUrl: z40.string().nullish()
});
var selfSignupTenantInputSchema = createTenantInputSchema.pick({
  tenantName: true,
  firstUser: true
});

// src/tenant/createTenantResponseSchema.ts
import { z as z41 } from "zod";
var createTenantResponseSchema = createTenantInputSchema.extend({
  id: z41.string(),
  createdAt: z41.date(),
  updatedAt: z41.date(),
  status: z41.string()
});

// src/tenant/TenantListItem.ts
import { z as z42 } from "zod";
var tenantListItemSchema = z42.object({
  id: z42.string(),
  createdAt: z42.date(),
  updatedAt: z42.date(),
  status: z42.string(),
  tenantName: z42.string(),
  subdomain: z42.string().nullish(),
  customDomain: z42.string().nullish(),
  theme: z42.string().nullish(),
  primaryColor: z42.string().nullish(),
  firstUserEmail: z42.string().nullish(),
  seatAllowance: z42.number().nullish(),
  stripeCustomerId: z42.string().nullish(),
  trialDays: z42.number().nullish(),
  isOnboarded: z42.boolean(),
  isSelfSignup: z42.boolean()
});

// src/tenant/getAllTenantsResponseSchema.ts
var getAllTenantsResponseSchema = tenantListItemSchema.array();

// src/tenant/UpdateTenantDto.ts
import { z as z43 } from "zod";
var UpdateTenantImprintSchema = z43.object({
  content: z43.string()
});
var UpdateTenantPrivacyPolicySchema = z43.object({
  content: z43.string()
});
var UpdateTenantDefaultSpaceSettingsSchema = z43.object({
  primaryColor: z43.nullable(z43.string().min(7).max(7)).optional(),
  customColors: customColorsSchema.optional(),
  theme: z43.enum([
    "Dark",
    "Light"
  ]).optional(),
  logoImage: z43.nullable(z43.object({
    source: z43.literal("S3"),
    s3Key: z43.string()
  })).optional(),
  backgroundImage: z43.nullable(z43.object({
    source: z43.literal("S3"),
    s3Key: z43.string()
  })).optional(),
  spacePreviewImageUrl: z43.string().nullish(),
  spacePreviewTitle: z43.string().nullish(),
  favicon: z43.nullable(z43.object({
    source: z43.literal("S3"),
    s3Key: z43.string()
  })).optional(),
  intercomId: z43.nullable(z43.string()).optional(),
  intercomApiBase: z43.enum([
    "https://api.eu.intercom.io",
    "https://api.intercom.io"
  ]).nullish().optional(),
  fontFamily: z43.enum([
    "Roboto Slab",
    "Montserrat",
    "Alexandria",
    "Space Grotesk",
    "Roboto",
    "Inter",
    "Poppins"
  ]).nullish(),
  fontFamilySpec: z43.string().nullish(),
  aiWritingAssistantIsEnabled: z43.boolean().optional(),
  aiWritingAssistantOptOut: z43.boolean().optional()
});

// src/tenant/updateTenantInputSchema.ts
import { z as z44 } from "zod";
var updateTenantInputSchema = z44.object({
  subdomain: subdomainSchema.optional(),
  customDomain: fullyQualifiedDomainNameSchema.nullish(),
  theme: themeSchema.optional(),
  primaryColor: primaryColorSchema.optional(),
  customColors: customColorsSchema.optional(),
  tenantName: tenantNameSchema.optional(),
  imprint: imprintSchema.optional(),
  privacyPolicy: privacyPolicySchema.optional(),
  logoImage: logoImageSchema.optional(),
  backgroundImage: backgroundImageSchema.optional(),
  firstUser: firstUserSchema.optional(),
  websiteUrl: z44.string().optional(),
  seatAllowance: z44.number().nullish(),
  onboardingSharedPageUrl: z44.string().nullish(),
  whitelabelTenantLogoUrl: z44.string().nullish(),
  isOnboarded: z44.boolean().optional(),
  isSelfSignup: z44.boolean().optional()
});

// src/tenant/updateTenantResponseSchema.ts
var updateTenantResponseSchema = createTenantResponseSchema.extend({});

// src/tenant/Onboarding.ts
import { z as z45 } from "zod";
var onboardingFieldsSchema = z45.object({
  websiteUrl: z45.string(),
  tenantName: tenantNameSchema,
  primaryColor: primaryColorSchema,
  logoImage: logoImageSchema.nullish(),
  backgroundImage: backgroundImageSchema.nullish()
});
var onboardTenantSchema = z45.union([
  onboardingFieldsSchema,
  z45.object({
    isOnboarded: z45.literal(true),
    error: z45.boolean().nullish()
  })
]);

// src/time.ts
var convertMillisecondsToNanoseconds = /* @__PURE__ */ __name((milliseconds) => milliseconds * 1e6, "convertMillisecondsToNanoseconds");

// src/url.ts
var withProtocolRegex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
var withoutProtocolRegex = new RegExp("^([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
var _UrlHelper = class _UrlHelper {
  static isURL(possibleUrl, withProtocol) {
    if (withProtocol) {
      return withProtocolRegex.test(possibleUrl);
    }
    return withProtocolRegex.test(possibleUrl) || withoutProtocolRegex.test(possibleUrl);
  }
  static hasProtocol(url) {
    return url.includes("://");
  }
  static appendProtocol(url) {
    try {
      new URL(url);
      return url;
    } catch (e2) {
    }
    if (_UrlHelper.isURL(url, true) && _UrlHelper.hasProtocol(url)) {
      return url;
    }
    return `https://${url}`;
  }
};
__name(_UrlHelper, "UrlHelper");
var UrlHelper = _UrlHelper;
var STARTS_WITH_HTTP_PROTOCOL_REGEX = /^https?:\/\//i;
function extractDomainFromUrl(url) {
  if (!url) {
    return null;
  }
  try {
    const urlObject = new URL(STARTS_WITH_HTTP_PROTOCOL_REGEX.test(url) ? url : `https://${url}`);
    const domain = urlObject.hostname.toLowerCase();
    if (!domain) {
      return null;
    }
    if (domain.startsWith("www.")) {
      return domain.slice(4);
    }
    return domain;
  } catch (error) {
    return null;
  }
}
__name(extractDomainFromUrl, "extractDomainFromUrl");

// src/user/updateUserTeamsPayload.ts
import { z as z46 } from "zod";
var UpdateUserTeamsPayload = z46.object({
  teamIds: z46.array(z46.string())
});

// src/user/user.ts
import { z as z47 } from "zod";
var BaseUserSchema = z47.object({
  id: z47.string().min(1),
  tenant: z47.string().min(1),
  email: z47.string().email(),
  name: z47.string().min(1).optional(),
  fullName: z47.string().optional(),
  profilePictureUrl: z47.string().url().optional(),
  roleId: z47.string().optional()
});
var InvitedUserSchema = BaseUserSchema.extend({
  invited: z47.literal(true)
});
var ApprovedUserSchema = BaseUserSchema.extend({
  invited: z47.literal(false),
  active: z47.boolean()
});
var GetUserSchema = z47.discriminatedUnion("invited", [
  ApprovedUserSchema,
  InvitedUserSchema
]);

// src/user/whitelisted-user.ts
var getDealSide = /* @__PURE__ */ __name(({ email, tenantWebsiteUrl, spaceOwnerEmail, spaceOwnerContactEmail, autoDetectSellerStakeholdersFeatureFlag }) => {
  const tenantDomain = extractDomainFromUrl(tenantWebsiteUrl);
  const ownerEmailDomain = extractDomainFromEmail(spaceOwnerEmail);
  const ownerContactEmailDomain = extractDomainFromEmail(spaceOwnerContactEmail);
  if (!autoDetectSellerStakeholdersFeatureFlag) {
    return WhitelistedUserDealSide.BUYER;
  }
  if (!email) {
    return WhitelistedUserDealSide.BUYER;
  }
  const domainInEmail = extractDomainFromEmail(email);
  if (!domainInEmail) {
    return WhitelistedUserDealSide.BUYER;
  }
  if (tenantDomain && domainInEmail === tenantDomain) {
    return WhitelistedUserDealSide.SELLER;
  }
  if (ownerEmailDomain && domainInEmail === ownerEmailDomain) {
    return WhitelistedUserDealSide.SELLER;
  }
  if (ownerContactEmailDomain && domainInEmail === ownerContactEmailDomain) {
    return WhitelistedUserDealSide.SELLER;
  }
  return WhitelistedUserDealSide.BUYER;
}, "getDealSide");

// src/user/whitelisted-user-notification-settings.ts
import { z as z48 } from "zod";
var WhitelistedUserNotificationSettingsSchema = z48.object({
  id: z48.string(),
  whitelistedUserId: z48.string(),
  milestoneDone: z48.boolean().default(false),
  dueToday: z48.boolean().default(false),
  taskAssigned: z48.boolean().default(false),
  allComments: z48.boolean().default(false),
  unsubscribed: z48.boolean().default(false)
});
var MonitorableNotificationSettings = z48.enum([
  "dueToday",
  "taskAssigned",
  "allComments",
  "unsubscribed",
  "milestoneDone"
]);

// src/websocket-notifications/websocket-notification.ts
import { z as z49 } from "zod";
var EWebSocketNotificationType = /* @__PURE__ */ function(EWebSocketNotificationType2) {
  EWebSocketNotificationType2["taskWatchersUpdated"] = "taskWatchersUpdated";
  EWebSocketNotificationType2["nodesUpdated"] = "nodesUpdated";
  EWebSocketNotificationType2["formSubmissionUpdated"] = "formSubmissionUpdated";
  return EWebSocketNotificationType2;
}({});
var WebSocketNodesUpdatedNotificationPayload = z49.object({
  type: z49.literal("nodesUpdated"),
  title: z49.string().nullable(),
  message: z49.string().nullable(),
  updatedNodeIds: z49.array(z49.string()).nullable()
});
var WebSocketTaskWatcherNotificationPayload = z49.object({
  type: z49.literal("taskWatchersUpdated"),
  taskNodeId: z49.string()
});
var WebSocketFormSubmissionNotificationPayload = z49.object({
  type: z49.literal("formSubmissionUpdated"),
  formNodeId: z49.string()
});
var WebSocketNotificationPayload = z49.union([
  WebSocketNodesUpdatedNotificationPayload,
  WebSocketTaskWatcherNotificationPayload,
  WebSocketFormSubmissionNotificationPayload
]);

// src/workflows/workflow-action.types.ts
import { z as z50 } from "zod";
var WorkflowActionType = /* @__PURE__ */ function(WorkflowActionType2) {
  WorkflowActionType2["UPDATE_TASK_STATUS"] = "UPDATE_TASK_STATUS";
  WorkflowActionType2["SET_SPACE_VARIABLE"] = "SET_SPACE_VARIABLE";
  WorkflowActionType2["SEND_NOTIFICATION"] = "SEND_NOTIFICATION";
  return WorkflowActionType2;
}({});
var WORKFLOW_ACTION_TYPES = WorkflowActionType;
var updateTaskStatusConfigSchema = z50.object({
  taskNodeId: z50.string(),
  status: z50.boolean(),
  setCompletedAt: z50.boolean().default(true),
  showDefaultInAppNotification: z50.boolean().default(true)
});
var setSpaceVariableConfigSchema = z50.discriminatedUnion("type", [
  z50.object({
    name: z50.string(),
    type: z50.literal(ValueCardinality.SingleValue),
    value: z50.string().nullable(),
    hidden: z50.boolean().default(false),
    showDefaultInAppNotification: z50.boolean().default(true)
  }),
  z50.object({
    name: z50.string(),
    type: z50.literal(ValueCardinality.MultiValue),
    value: z50.array(z50.string()).nullable(),
    hidden: z50.boolean().default(false),
    showDefaultInAppNotification: z50.boolean().default(true)
  })
]);
var NotificationRecipientType = /* @__PURE__ */ function(NotificationRecipientType2) {
  NotificationRecipientType2["SPACE_OWNER"] = "SPACE_OWNER";
  NotificationRecipientType2["ALL_WHITELISTED_USERS"] = "ALL_WHITELISTED_USERS";
  NotificationRecipientType2["SELECTED_USERS"] = "SELECTED_USERS";
  return NotificationRecipientType2;
}({});
var notificationRecipientTypeSchema = z50.nativeEnum(NotificationRecipientType);
var NotificationType = /* @__PURE__ */ function(NotificationType2) {
  NotificationType2["EMAIL"] = "EMAIL";
  NotificationType2["IN_APP"] = "IN_APP";
  return NotificationType2;
}({});
var notificationTypeSchema = z50.nativeEnum(NotificationType);
var emailNotificationConfigSchema = z50.object({
  type: z50.literal("EMAIL"),
  recipientType: notificationRecipientTypeSchema,
  subject: z50.string(),
  message: z50.string(),
  selectedUserIds: z50.array(z50.string()).optional()
});
var inAppNotificationConfigSchema = z50.object({
  type: z50.literal("IN_APP"),
  subject: z50.string(),
  message: z50.string()
});
var sendNotificationConfigSchema = z50.discriminatedUnion("type", [
  emailNotificationConfigSchema,
  inAppNotificationConfigSchema
]);
var workflowActionConfigSchema = z50.union([
  updateTaskStatusConfigSchema,
  setSpaceVariableConfigSchema,
  sendNotificationConfigSchema
]);
var workflowActionValidationSchema = z50.discriminatedUnion("type", [
  z50.object({
    type: z50.literal("UPDATE_TASK_STATUS"),
    metadata: updateTaskStatusConfigSchema
  }),
  z50.object({
    type: z50.literal("SET_SPACE_VARIABLE"),
    metadata: setSpaceVariableConfigSchema
  }),
  z50.object({
    type: z50.literal("SEND_NOTIFICATION"),
    metadata: sendNotificationConfigSchema
  })
]);
function validateActionMetadata(data, ctx) {
  if (!workflowActionValidationSchema.safeParse({
    type: data.actionType,
    metadata: data.actionMetadata
  }).success) {
    ctx.addIssue({
      code: z50.ZodIssueCode.invalid_type,
      expected: "object",
      received: typeof data.actionMetadata,
      path: [
        "actionMetadata"
      ],
      message: "actionMetadata must match the structure for UPDATE_TASK_STATUS, SET_SPACE_VARIABLE or SEND_NOTIFICATION"
    });
  }
}
__name(validateActionMetadata, "validateActionMetadata");

// src/workflows/workflow-trigger.types.ts
import { z as z51 } from "zod";
var WorkflowTriggerType = /* @__PURE__ */ function(WorkflowTriggerType2) {
  WorkflowTriggerType2["FORM_COMPLETED"] = "FORM_COMPLETED";
  WorkflowTriggerType2["TASK_COMPLETED"] = "TASK_COMPLETED";
  WorkflowTriggerType2["SPACE_INACTIVE"] = "SPACE_INACTIVE";
  WorkflowTriggerType2["SET_SPACE_VARIABLE"] = "SET_SPACE_VARIABLE";
  WorkflowTriggerType2["MILESTONE_COMPLETED"] = "MILESTONE_COMPLETED";
  WorkflowTriggerType2["ACTION_PLAN_COMPLETED"] = "ACTION_PLAN_COMPLETED";
  return WorkflowTriggerType2;
}({});
var WORKFLOW_TRIGGER_TYPES = WorkflowTriggerType;
var formCompletedTriggerMetadataSchema = z51.object({
  formNodeId: z51.string()
});
var taskCompletedTriggerMetadataSchema = z51.object({
  taskNodeId: z51.string()
});
var spaceInactiveTriggerMetadataSchema = z51.object({
  inactiveDays: z51.number()
});
var setSpaceVariableTriggerMetadataSchema = z51.object({
  name: z51.string()
});
var milestoneCompletedTriggerMetadataSchema = z51.object({
  milestoneNodeId: z51.string()
});
var actionPlanCompletedTriggerMetadataSchema = z51.object({
  actionPlanNodeId: z51.string()
});
var workflowTriggerMetadataSchema = z51.union([
  formCompletedTriggerMetadataSchema,
  taskCompletedTriggerMetadataSchema,
  spaceInactiveTriggerMetadataSchema,
  setSpaceVariableTriggerMetadataSchema,
  milestoneCompletedTriggerMetadataSchema,
  actionPlanCompletedTriggerMetadataSchema
]);
var workflowTriggerValidationSchema = z51.discriminatedUnion("type", [
  z51.object({
    type: z51.literal("FORM_COMPLETED"),
    metadata: formCompletedTriggerMetadataSchema
  }),
  z51.object({
    type: z51.literal("TASK_COMPLETED"),
    metadata: taskCompletedTriggerMetadataSchema
  }),
  z51.object({
    type: z51.literal("SPACE_INACTIVE"),
    metadata: spaceInactiveTriggerMetadataSchema
  }),
  z51.object({
    type: z51.literal("SET_SPACE_VARIABLE"),
    metadata: setSpaceVariableTriggerMetadataSchema
  }),
  z51.object({
    type: z51.literal("MILESTONE_COMPLETED"),
    metadata: milestoneCompletedTriggerMetadataSchema
  }),
  z51.object({
    type: z51.literal("ACTION_PLAN_COMPLETED"),
    metadata: actionPlanCompletedTriggerMetadataSchema
  })
]);
function validateTriggerMetadata(data, ctx) {
  if (!workflowTriggerValidationSchema.safeParse({
    type: data.triggerType,
    metadata: data.triggerMetadata
  }).success) {
    ctx.addIssue({
      code: z51.ZodIssueCode.invalid_type,
      expected: "object",
      received: typeof data.triggerMetadata,
      path: [
        "triggerMetadata"
      ],
      message: "triggerMetadata must match the structure for FORM_COMPLETED, TASK_COMPLETED, SPACE_INACTIVE, SET_SPACE_VARIABLE, MILESTONE_COMPLETED, or ACTION_PLAN_COMPLETED"
    });
  }
}
__name(validateTriggerMetadata, "validateTriggerMetadata");

// src/workflows/workflow.types.ts
import { z as z52 } from "zod";
var notifiableUserSchema = z52.object({
  id: z52.string(),
  email: z52.string(),
  fullName: z52.string().optional(),
  firstName: z52.string().optional(),
  lastName: z52.string().optional(),
  isSeller: z52.boolean(),
  unsubscribed: z52.boolean()
});
var WORKFLOW_OPERATORS = {
  EQUALS: RULE_OPERATORS.EQUALS,
  NOT_EQUALS: RULE_OPERATORS.NOT_EQUALS,
  GREATER_THAN: RULE_OPERATORS.GREATER_THAN,
  LESS_THAN: RULE_OPERATORS.LESS_THAN,
  CONTAINS: RULE_OPERATORS.CONTAINS,
  CONTAINS_AT_LEAST_ONE_OF: RULE_OPERATORS.CONTAINS_AT_LEAST_ONE_OF,
  CONTAINS_ALL_OF: RULE_OPERATORS.CONTAINS_ALL_OF,
  EQUALS_ONLY_ONE_OF: RULE_OPERATORS.EQUALS_ONLY_ONE_OF,
  EQUALS_ALL_OF: RULE_OPERATORS.EQUALS_ALL_OF
};
var WORKFLOW_SINGLE_VALUE_OPERATORS = [
  WORKFLOW_OPERATORS.EQUALS,
  WORKFLOW_OPERATORS.NOT_EQUALS,
  WORKFLOW_OPERATORS.GREATER_THAN,
  WORKFLOW_OPERATORS.LESS_THAN,
  WORKFLOW_OPERATORS.CONTAINS
];
var WORKFLOW_MULTI_VALUE_OPERATORS = [
  WORKFLOW_OPERATORS.CONTAINS_AT_LEAST_ONE_OF,
  WORKFLOW_OPERATORS.CONTAINS_ALL_OF,
  WORKFLOW_OPERATORS.EQUALS_ONLY_ONE_OF,
  WORKFLOW_OPERATORS.EQUALS_ALL_OF
];
var workflowFilterRuleSchema = z52.preprocess((input) => {
  if (input && typeof input === "object" && !("type" in input)) {
    return __spreadProps(__spreadValues({}, input), {
      type: ValueCardinality.SingleValue
    });
  }
  return input;
}, z52.discriminatedUnion("type", [
  z52.object({
    type: z52.literal(ValueCardinality.SingleValue),
    valueLocator: z52.string(),
    operator: z52.enum(WORKFLOW_SINGLE_VALUE_OPERATORS),
    comparisonValue: z52.preprocess((val) => {
      if (val instanceof Date) {
        return val;
      }
      if (typeof val === "string") {
        const date = new Date(val);
        if (!isNaN(date.getTime())) {
          return date;
        }
      }
      return val;
    }, z52.union([
      z52.date(),
      z52.string(),
      z52.number(),
      z52.boolean(),
      z52.null()
    ]))
  }),
  z52.object({
    type: z52.literal(ValueCardinality.MultiValue),
    valueLocator: z52.string(),
    operator: z52.enum(WORKFLOW_MULTI_VALUE_OPERATORS),
    comparisonValue: z52.array(z52.string())
  })
]));
var baseWorkflowSchema = z52.object({
  id: z52.string().optional(),
  tenantId: z52.string(),
  spaceId: z52.string().nullish(),
  templateId: z52.string().nullish(),
  name: z52.string(),
  description: z52.string().nullish(),
  isEnabled: z52.boolean(),
  triggerType: z52.nativeEnum(WorkflowTriggerType),
  triggerMetadata: workflowTriggerMetadataSchema,
  actionType: z52.nativeEnum(WorkflowActionType),
  actionMetadata: workflowActionConfigSchema,
  filters: z52.array(workflowFilterRuleSchema).optional(),
  createdById: z52.string().nullable(),
  createdAt: z52.coerce.date(),
  updatedAt: z52.coerce.date()
});
var workflowCreatorSchema = z52.object({
  id: z52.string(),
  firstName: z52.string(),
  lastName: z52.string(),
  fullName: z52.string().nullish(),
  photo_s3ObjectKey: z52.string().nullish(),
  photo_s3ObjectUrl: z52.string().nullish()
});
var workflowListItemSchema = baseWorkflowSchema.omit({
  triggerMetadata: true,
  actionMetadata: true,
  filters: true
}).required({
  id: true,
  isEnabled: true
}).extend({
  template: z52.object({
    id: z52.string(),
    title: z52.string()
  }).nullish(),
  createdBy: workflowCreatorSchema.optional()
});
var createWorkflowSchema = baseWorkflowSchema.omit({
  id: true,
  spaceId: true,
  createdById: true,
  createdAt: true,
  updatedAt: true
}).required({
  tenantId: true,
  templateId: true
}).superRefine((data, ctx) => {
  validateTriggerMetadata(data, ctx);
  validateActionMetadata(data, ctx);
});
var updateWorkflowSchema = baseWorkflowSchema.partial().omit({
  id: true,
  templateId: true,
  createdById: true,
  createdAt: true,
  updatedAt: true
}).required({
  tenantId: true
}).superRefine((data, ctx) => {
  if (data.triggerType && data.triggerMetadata) {
    validateTriggerMetadata(data, ctx);
  }
  if (data.actionType && data.actionMetadata) {
    validateActionMetadata(data, ctx);
  }
});
var workflowQuerySchema = createPaginationQuerySchema(z52.object({
  tenantId: z52.string(),
  spaceIds: z52.array(z52.string()).nullish(),
  templateIds: z52.array(z52.string()).nullish(),
  templateOnly: z52.boolean().optional(),
  sortBy: z52.string().optional(),
  sortOrder: z52.enum([
    "asc",
    "desc"
  ]).optional()
}));
var workflowPaginatedListSchema = createPaginationSchema(workflowListItemSchema, z52.undefined());

// src/workflows/workflow-event.types.ts
import { z as z53 } from "zod";
var baseEventSchema = z53.object({
  tenantId: z53.string(),
  spaceId: z53.string(),
  triggeredBy: z53.string(),
  timestamp: z53.date()
});
var formCompletedEventSchema = baseEventSchema.extend({
  type: z53.literal(WorkflowTriggerType.FORM_COMPLETED),
  metadata: z53.object({
    formId: z53.string()
  })
});
var taskCompletedEventSchema = baseEventSchema.extend({
  type: z53.literal(WorkflowTriggerType.TASK_COMPLETED),
  metadata: z53.object({
    taskNodeId: z53.string()
  })
});
var spaceInactiveEventSchema = baseEventSchema.extend({
  type: z53.literal(WorkflowTriggerType.SPACE_INACTIVE),
  metadata: z53.object({
    daysSinceCreation: z53.number()
  })
});
var setSpaceVariableEventSchema = baseEventSchema.extend({
  type: z53.literal(WorkflowTriggerType.SET_SPACE_VARIABLE),
  metadata: z53.object({
    name: z53.string()
  })
});
var milestoneCompletedEventSchema = baseEventSchema.extend({
  type: z53.literal(WorkflowTriggerType.MILESTONE_COMPLETED),
  metadata: z53.object({
    milestoneNodeId: z53.string()
  })
});
var actionPlanCompletedEventSchema = baseEventSchema.extend({
  type: z53.literal(WorkflowTriggerType.ACTION_PLAN_COMPLETED),
  metadata: z53.object({
    actionPlanNodeId: z53.string()
  })
});
var workflowTriggerEventSchema = z53.discriminatedUnion("type", [
  formCompletedEventSchema,
  taskCompletedEventSchema,
  spaceInactiveEventSchema,
  setSpaceVariableEventSchema,
  milestoneCompletedEventSchema,
  actionPlanCompletedEventSchema
]);
function createWorkflowTriggerEvent(event) {
  return __spreadProps(__spreadValues({}, event), {
    timestamp: event.timestamp || /* @__PURE__ */ new Date()
  });
}
__name(createWorkflowTriggerEvent, "createWorkflowTriggerEvent");

// src/view-settings/view-settings.ts
import { z as z54 } from "zod";
var ViewTypeEnum = z54.enum([
  "SPACE_SIDEBAR",
  "SPACE_LIST"
]);
var SpaceSidebarColumns = [
  "tasks",
  "comments",
  "activities",
  "forms"
];
var SpaceListColumns = [
  // Exclude 'companyName' (always first) and 'actions' (always last)
  "score",
  "templateName",
  "mapStatus",
  "mapProgress",
  "currentMilestone",
  "lastCompletedMilestone",
  "currentOpenTask",
  "currentOpenTaskScheduled",
  "nextDueDate",
  "lastCompletedTaskDate",
  "lastCompletedTask",
  "createdAt",
  "updatedAt",
  "ownerId",
  "lastVisit",
  "visits",
  "activitiesCount",
  "teams"
];
var createColumnSettingsSchema = /* @__PURE__ */ __name((columns) => {
  return z54.object({
    order: z54.array(z54.enum(columns)),
    visible: z54.record(z54.enum(columns), z54.boolean())
  });
}, "createColumnSettingsSchema");
var SpaceSidebarColumnSettingsSchema = createColumnSettingsSchema(SpaceSidebarColumns);
var SpaceListColumnSettingsSchema = createColumnSettingsSchema(SpaceListColumns).extend({
  name: z54.string().optional(),
  emoji: z54.string().optional(),
  isDefault: z54.boolean().optional(),
  filters: z54.object(spacesQueryFiltersSchema.shape).nullable().optional()
});
var ViewSettingsBaseSchema = z54.object({
  id: z54.string(),
  userId: z54.string(),
  tenantId: z54.string(),
  viewType: ViewTypeEnum,
  settings: z54.union([
    SpaceSidebarColumnSettingsSchema,
    SpaceListColumnSettingsSchema
  ]),
  createdAt: z54.coerce.string(),
  updatedAt: z54.coerce.string()
});
var ViewSettingsSchema = z54.discriminatedUnion("viewType", [
  z54.object(__spreadProps(__spreadValues({}, ViewSettingsBaseSchema.shape), {
    viewType: z54.literal("SPACE_SIDEBAR"),
    settings: SpaceSidebarColumnSettingsSchema
  })),
  z54.object(__spreadProps(__spreadValues({}, ViewSettingsBaseSchema.shape), {
    viewType: z54.literal("SPACE_LIST"),
    settings: SpaceListColumnSettingsSchema
  }))
]);
var SpaceListViewSettingsSchema = z54.object(__spreadProps(__spreadValues({}, ViewSettingsBaseSchema.shape), {
  viewType: z54.literal("SPACE_LIST"),
  settings: SpaceListColumnSettingsSchema
}));
var DEFAULT_SPACE_SIDEBAR_SETTINGS = {
  order: [
    "tasks",
    "comments",
    "activities",
    "forms"
  ],
  visible: {
    tasks: true,
    comments: true,
    activities: true,
    forms: true
  }
};
var DEFAULT_SPACE_LIST_SETTINGS = {
  order: [
    "score",
    "createdAt",
    "ownerId",
    "lastVisit",
    "visits",
    "activitiesCount",
    "teams",
    "mapStatus",
    "mapProgress",
    "currentMilestone",
    "nextDueDate",
    "lastCompletedMilestone",
    "currentOpenTask",
    "currentOpenTaskScheduled",
    "lastCompletedTaskDate",
    "lastCompletedTask",
    "templateName",
    "updatedAt"
  ],
  visible: {
    score: true,
    templateName: false,
    mapStatus: true,
    mapProgress: true,
    currentMilestone: false,
    lastCompletedMilestone: false,
    currentOpenTask: false,
    currentOpenTaskScheduled: false,
    nextDueDate: false,
    lastCompletedTaskDate: false,
    lastCompletedTask: false,
    createdAt: true,
    updatedAt: false,
    ownerId: true,
    lastVisit: true,
    visits: true,
    activitiesCount: true,
    teams: true
  },
  name: "My Spaces",
  emoji: "",
  isDefault: false,
  filters: {
    spaceType: "active"
  }
};
export {
  ActionPlanAnalyticsGroupingLevel,
  ActionPlanAnalyticsGroupingPeriod,
  ActionPlanAnalyticsTimeRangePeriod,
  BUILTIN_PLACEHOLDERS,
  BatchArchiveSpacesSchema,
  BatchChangeOwnerSchema,
  BatchDeleteSpacesSchema,
  BlockGenerationRequestSchema,
  CommentSchema,
  CompanyInfoSchema,
  DEFAULT_SPACE_LIST_SETTINGS,
  DEFAULT_SPACE_SIDEBAR_SETTINGS,
  EWebSocketNotificationType,
  EditorBlockGeneratorDtoSchema,
  EngagementScoreSummarySchema,
  GenerateTemplateSchema,
  GetUserSchema,
  HtmlEmbedAIResponseSchema,
  HubSpotCRMSpaceCardListSchema,
  HubSpotCRMSpaceCardSchema,
  IntegrationSpacesSearchResultSchema,
  InviteUserBodySchema,
  MonitorableNotificationSettings,
  NotificationRecipientType,
  NotificationType,
  OpenRestriction,
  RELATIVE_TO_MAP_START_DATE,
  RELATIVE_TO_MAP_TARGET_DATE,
  RULE_MULTI_VALUE_OPERATORS,
  RULE_OPERATORS,
  RULE_SINGLE_VALUE_OPERATORS,
  START_DATE_REFERENCE_TYPE,
  SpaceListColumnSettingsSchema,
  SpaceListColumns,
  SpaceListViewSettingsSchema,
  SpaceScoringInputSchema,
  SpaceSidebarColumnSettingsSchema,
  SpaceSidebarColumns,
  TARGET_DATE_REFERENCE_TYPE,
  TTemplateGenerationRequestStatus,
  TasksDueNotificationSettingPayload,
  TasksDueNotificationSettingSchema,
  TemplateGenerationRequestSchema,
  TemplateGenerationRequestStatus,
  UpdateTenantDefaultSpaceSettingsSchema,
  UpdateTenantImprintSchema,
  UpdateTenantPrivacyPolicySchema,
  UpdateUserTeamsPayload,
  UrlHelper,
  VISIBILITY_MULTI_VALUE_OPERATORS,
  VISIBILITY_OPERATORS,
  VISIBILITY_SINGLE_VALUE_OPERATORS,
  ValueCardinality,
  ValuecaseAuth,
  ViewSettingsBaseSchema,
  ViewSettingsSchema,
  ViewTypeEnum,
  WORKFLOW_ACTION_TYPES,
  WORKFLOW_MULTI_VALUE_OPERATORS,
  WORKFLOW_OPERATORS,
  WORKFLOW_SINGLE_VALUE_OPERATORS,
  WORKFLOW_TRIGGER_TYPES,
  WebSocketFormSubmissionNotificationPayload,
  WebSocketNodesUpdatedNotificationPayload,
  WebSocketNotificationPayload,
  WebSocketTaskWatcherNotificationPayload,
  WhitelistedUserDealSide,
  WhitelistedUserNotificationSettingsSchema,
  WhitelistingMethod,
  WorkflowActionType,
  WorkflowTriggerType,
  WritingAssistantDtoSchema,
  actionPlanAnalyticsGroupingLevelSchema,
  actionPlanAnalyticsRecordSchema,
  actionPlanAnalyticsResponseSchema,
  actionPlanCompletedTriggerMetadataSchema,
  actionPlanKeyDetailsSchema,
  actionPlanMilestoneAnalyticsRecordSchema,
  actionPlanMilestoneSchema,
  actionPlanPaginatedListSchema,
  actionPlanQuerySchema,
  actionPlanSchema,
  actionPlanTaskAnalyticsRecordSchema,
  actionPlanTaskExpandedSchema,
  actionPlanTaskPaginatedListSchema,
  actionPlanTaskPaginatedListWithMetaSchema,
  actionPlanTaskSchema,
  actionPlanTaskSchemaWithAssignedUsers,
  actionPlanTaskUpdateSchema,
  actionPlanTasksAggregatedByTemplateSchema,
  actionPlanTasksQuerySchema,
  activitesAcrossTenantPaginatedListSchema,
  activitiesAcrossTenantQuerySchema,
  activitySchema,
  activitySchemaArray,
  activityTypeFilterGroups,
  activityTypes,
  adjustForWeekend,
  aiEmbedDataSchema,
  areSetsIdentical,
  assetLibraryEntryAssetTypes,
  assetLibraryEntryPaginatedListSchema,
  assetLibraryEntrySchema,
  assetLibraryFolderListSchema,
  assetLibraryFolderQuerySchema,
  assetLibraryFolderSchema,
  assetLibraryQuerySchema,
  assetSchema2 as assetSchema,
  backgroundImageSchema,
  baseIntegrationSettingsSchema,
  baseNotificationSettingSchema,
  billingDetailsSchema,
  blocksSupportingContentAutomation,
  calculateAbsoluteDate,
  cloudflareStatusSchema,
  cloudflareStatuses,
  commaSeparatedArraySchema,
  companyDetailsSchema,
  contentAutomationBuiltInProperties,
  convertMillisecondsToNanoseconds,
  createAssetLibraryEntrySchema,
  createAssetLibraryFolderSchema,
  createColumnSettingsSchema,
  createIntegrationCustomPropertyMappingDtoSchema,
  createNotificationsSettingsSchema,
  createOrUpdateFormSubmissionSchema,
  createPaginationQuerySchema,
  createPaginationSchema,
  createSalesforceIntegrationCustomPropertyMappingDtoSchema,
  createSpaceSchema,
  createTeamSchema,
  createTeamWithMembersSchema,
  createTenantInputSchema,
  createTenantResponseSchema,
  createWorkflowSchema,
  createWorkflowTriggerEvent,
  customColorsSchema,
  customPropertiesResponseSchema,
  customPropertyKeyPattern,
  customPropertyKeyRegexContains,
  customPropertyKeyRegexMatch,
  customPropertyPlaceholderCloser,
  customPropertyPlaceholderOpener,
  customPropertyPlaceholderPattern,
  customPropertyPlaceholderRegexContains,
  customPropertyPlaceholderRegexMatch,
  customPropertySchema,
  dateOrDateString,
  defaultSalesforceEntityTypes,
  defaultSalesforceProfiles,
  digestNotificationSchema,
  dueTaskItemSchema,
  emailNotificationConfigSchema,
  embedDataSchema,
  embedTypes,
  embeddableLinkDataSchema,
  embeddableLinkTypes,
  engagementScoreHighThreshold,
  engagementScoreLevelSchema,
  engagementScoreMediumThreshold,
  expectNonNullable,
  extractDomainFromEmail,
  extractDomainFromUrl,
  fileAnswerSchema,
  fileDataSchema,
  firstUserSchema,
  formCompletedTriggerMetadataSchema,
  formListQuerySchema,
  formPaginatedListSchema,
  formQuestionAnswerSchema,
  formSchema,
  formSubmissionListQuerySchema,
  formSubmissionPaginatedListSchema,
  formSubmissionSchema,
  formatDateLong,
  formatDateShort,
  formatDateTimeShort,
  formatDateWithRelativeWords,
  formatTime,
  fullyQualifiedDomainNameSchema,
  getAllTenantsResponseSchema,
  getCleanSub,
  getCompanyInitials,
  getDealSide,
  groupActivitiesByDate,
  hubSpotIntegrationSettingsEntitySchema,
  hubSpotIntegrationSettingsSchema,
  hubSpotMetaSchema,
  iconForActivityType,
  iframelyResponseSchema,
  imageSourceSchema,
  imprintSchema,
  inAppNotificationConfigSchema,
  integrationCustomPropertyMappingListSchema,
  integrationCustomPropertyMappingSchema,
  integrationSettingsEntityBaseSchema,
  integrationSettingsEntitySchema,
  integrationSettingsUpsertDtoSchema,
  integrationSpacesSearchResultsSchema,
  intersectionOfSets,
  isCardinalValue,
  isInternalLink,
  isNodeVisibilityRule,
  isString2 as isString,
  isSubSet,
  isTaskAnalyticsSearch,
  isToday,
  isTomorrow,
  isValidCompanyWebsiteUrl,
  isYesterday,
  legacyMetadataSchema,
  linkDataSchema,
  logoImageSchema,
  mapScoreDescriptorToLabel,
  mapScoreToDescriptor,
  milestoneCompletedTriggerMetadataSchema,
  millisecondsUntilEndOfMonth,
  notifiableUserSchema,
  notificationRecipientTypeSchema,
  notificationTypeSchema,
  onboardTenantSchema,
  onboardingFieldsSchema,
  parseHubSpotCRMSpaceCard,
  parseHubSpotCRMSpaceCardList,
  parseIntegrationSettings,
  primaryColorSchema,
  privacyPolicySchema,
  propertyKeyToSalesforceFieldName,
  readCardinalValue,
  readDefaultNotificationSettingsResponseSchema,
  readDefaultNotificationSettingsSchema,
  relativeDateSchema,
  renderQuill,
  ruleOperatorToText,
  salesforceAccountListSchema,
  salesforceAccountSchema,
  salesforceCaseListSchema,
  salesforceCaseSchema,
  salesforceContactListSchema,
  salesforceContactSchema,
  salesforceCoreObjectSchema,
  salesforceIntegrationSettingsEntitySchema,
  salesforceIntegrationSettingsSchema,
  salesforceMetaSchema,
  salesforceObjectListSchema,
  salesforceObjectType,
  salesforceObjectTypes,
  salesforceOpportunityListSchema,
  salesforceOpportunitySchema,
  selfSignupTenantInputSchema,
  sellerNotificationsSettingsSchema,
  sellerQueueDeleteSchema,
  sellerQueueUpsertSchema,
  sellerSchema,
  sellersResponseSchema,
  sendNotificationConfigSchema,
  sessionSchema,
  sessionsArray,
  setSpaceVariableConfigSchema,
  setSpaceVariableTriggerMetadataSchema,
  sleep,
  spaceActionPlanStatusSchema,
  spaceEntitySchema,
  spaceInactiveTriggerMetadataSchema,
  spaceIntegrationIdMappingSchema,
  spaceIntegrationSupportedThirdParties,
  spaceIntegrationSupportedThirdPartiesSchema,
  spaceIntegrationThirdPartyOptions,
  spaceSummaryQuerySchema,
  spaceSummaryRecordSchema,
  spaceSummaryResponseSchema,
  spacesQueryFiltersSchema,
  splitFullName,
  subdomainSchema,
  subscriptionInfoSchema,
  syncedThirdPartyEntitySettingsPublicListSchema,
  syncedThirdPartyEntitySettingsPublicSchema,
  targetSalesforceApiVersion,
  taskAnalyticsSearchSchema,
  taskCompletedTriggerMetadataSchema,
  tasksCompletedOverTimeGroupBySchema,
  tasksCompletedOverTimeQuerySchema,
  tasksCompletedOverTimeRecordSchema,
  tasksCompletedOverTimeResponseSchema,
  teamListSchema,
  teamSchema,
  teamWithMembersListSchema,
  teamWithMembersSchema,
  templateActionPlansAnalyticRecordSchema,
  templateGenerationSpaceCreationSchema,
  templateSummaryQuerySchema,
  templateSummarySpacesGroupTypeSchema,
  tenantListItemSchema,
  tenantNameSchema,
  tenantSchema,
  themeSchema,
  topSpaceItemSchema,
  updateAssetLibraryEntrySchema,
  updateAssetLibraryFolderSchema,
  updateDefaultNotificationSettingsResponseSchema,
  updateDefaultNotificationSettingsSchema,
  updateTaskStatusConfigSchema,
  updateTeamSchema,
  updateTeamWithMembersSchema,
  updateTenantInputSchema,
  updateTenantResponseSchema,
  updateWorkflowSchema,
  urlSchema,
  validateActionMetadata,
  validatePaginatedQueryParams,
  validateTriggerMetadata,
  whitelistedUserNotificationsSettingsSchema,
  whitelistedUserSchema,
  whitelistedUsersResponseSchema,
  workflowActionConfigSchema,
  workflowActionValidationSchema,
  workflowCreatorSchema,
  workflowFilterRuleSchema,
  workflowListItemSchema,
  workflowPaginatedListSchema,
  workflowQuerySchema,
  workflowTriggerEventSchema,
  workflowTriggerMetadataSchema,
  workflowTriggerValidationSchema
};
